export default {
  es: {
    enlaces: {
      home: "/",
      noticias: "noticias",
      noticia: "noticia",
      sala_de_prensa: "sala-de-prensa",
      contacto: "contacto",
      promociones: "promociones",
      distribuidores: "distribuidores",
      promocion: "promocion",
      pressroom: "pressroom",
      faqs: "faqs",
      bases_legales: "bases-legales",
      trabaja_con_nosotros: "trabaja-con-nosotros",
      politica_privacidad: "politica-de-proteccion-de-datos",
      politica_cookies: "politica-de-cookies",
      aviso_legal: "aviso-legal",
      snacks: "snacks",
      gusanitos: "snacks/gusanitos",
      palomitas: "snacks/palomitas",
      risketos: "snacks/risketos",
      mios: "snacks/mios",
      triskys: "snacks/triskys",
      matchBall: "snacks/match-ball",
      jummy: "snacks/jummy",
      otrosProductos: "snacks/otros-productos",
      surtis4u: "snacks/otros-productos/surtis",
      tejitas: "snacks/otros-productos/tejitas",
      buscalios: "snacks/otros-productos/buscalios",
      pajitas: "snacks/otros-productos/pajitas",
      trikers: "snacks/otros-productos/trikers",
      patatas: "patatas",
      originales: "patatas/originales",
      onduladas: "patatas/onduladas",
      selectas: "patatas/selectas",
      exportacion: "patatas/exportacion",
      detodalavida: "patatas/de-toda-la-vida",
      exportacion: "patatas/exportacion",
      galletas: "galletas",
      bsan: "galletas/b-san",
      chocolate: "galletas/b-san-0azucares-chocolate",
      maria: "galletas/b-san-0azucares-maria",
      adultas: "galletas/b-san-sin-gluten",
      desayuno: "galletas/b-san-plus/singluten",
      infantiles: "galletas/hello-kitty-doraemon",
      tradicionales: "galletas/sin-gluten",
      plus: "galletas/b-san-plus/congluten",
      fabs: "galletas/fabs",
      caramelos: "caramelos",
      azucares0: "caramelos/0-azucares",
      caramelosTradicionales: "caramelos/tradicionales",
      borges: "frutos-secos",
      frutossecos: "frutos-secos/frutos-secos",
      pipas: "frutos-secos/pipas",
      historia: "historia",
      nutririsi: "nutririsi",
      quienessomos: "quienes-somos",
      materialesprensa: "materiales-de-prensa",
      concursofulloftrickers: "fulloftrikersrandom",
      codigoconducta: "cumplimiento-normativo/codigo-de-conducta",
      cartapresidente:
        "cumplimiento-normativo/codigo-de-conducta/carta-del-presidente",
      principiosgenerales:
        "cumplimiento-normativo/codigo-de-conducta/principios-generales",
      risiempleados:
        "cumplimiento-normativo/codigo-de-conducta/risi-y-sus-empleados",
      risiconsumidores:
        "cumplimiento-normativo/codigo-de-conducta/risi-y-sus-consumidores",
      risiproveedores:
        "cumplimiento-normativo/codigo-de-conducta/risi-y-sus-proveedores",
      risisociedad:
        "cumplimiento-normativo/codigo-de-conducta/risi-y-la-sociedad",
      daganzo:
        "cumplimiento-normativo/codigo-de-conducta/risi-y-la-sociedad/risi-sa",
      loeches:
        "cumplimiento-normativo/codigo-de-conducta/risi-y-la-sociedad/loeches",
      matarile:
        "cumplimiento-normativo/codigo-de-conducta/risi-y-la-sociedad/matarile",
      cumplimientoetico:
        "cumplimiento-normativo/codigo-de-conducta/cumplimiento-y-canal-etico",
      bases_legales_risi: "bases-legales-risi",
      consultaComentario: "consulta-o-comentario",
      otro: "otro",
      mcdonals: "https://mcextreme.mcdonalds.es/",
      regulatory_compliance: "cumplimiento-normativo",
      values: "cumplimiento-normativo/valores",
      ethical_channel: "cumplimiento-normativo/canal-etico",
      sustainability: "cumplimiento-normativo/compromisos",
      seo: {
        home: {
          title: "Risi | Snacks, Patatas, Galletas, Caramelos y Frutos Secos",
          description:
            "Bienvenid@s a la casa de icónicas marcas como Gusanitos, Palomitas, Risketos, Triskys, Matchball, Pajitas, Tejitas … ¡y mucho más!"
        },
        noticias: {
          title: "Risi | Noticias y Promociones Risi",
          description:
            "No te pierdas nuestras útimas novedades  y las promociones más divertidas."
        },
        noticia: {
          title: "Risi | Noticias y Promociones Risi",
          description:
            "No te pierdas nuestras útimas novedades  y las promociones más divertidas."
        },
        contacto: {
          title: "Risi | Contacto",
          description:
            "Contacta con nosotros a través de nuestro formulario o llámanos a 900 909 013. ¡Estaremos encantados de atenderte!"
        },
        faqs: {
          title: "Preguntas frecuentes Risi",
          description:
            "Desde Risi respondemos a todas tus preguntas acerca de nosotros y nuestros productos para que tengas toda la información que necesitas"
        },
        nutririsi: {
          title: "Risi | NutriRisi",
          description:
            "Estamos firmemente comprometidos con la calidad, la mejora nutricional y el respeto al  medioambiente. ¡Conoce el compromiso de calidad Risi!"
        },
        historia: {
          title: "Risi | Historia",
          description:
            "El verde de Gusanitos, el rojo de Palomitas, el naranja de Risketos…¿quién no reconoce estos colores? En Risi, estamos a tu lado desde 1970. ¡Descubre nuestra fascinante historia!"
        },
        pressroom: {
          title: "Risi | Sala de Prensa",
          description:
            "¿Eres un profesional de prensa y necesitas información sobre Risi? En nuestra sala de prensa encontrarás toda la información que necesitas y una gran varieda de materiales para acompañar tus noticias."
        },
        distribuidores: {
          title: "Risi | Distribuidores",
          description:
            "¿Quieres vender nuestros productos? Accede a nuestro mapa virtual y contacta con nuestros distribuidores regionales."
        },
        snacks: {
          title: "Risi | Los Mejores Snacks y Aperitivos Risi",
          description:
            "Los Snacks más famosos y divertidos los encontrarás en Risi, Gusanitos, Palomitas, Risketos, Matchball…¿alguien conoce alguna persona que se haya resistido a probar los Snacks de Risi? "
        },
        otrosProductos: {
          familia: "snacks",
          title: "Risi | Productos",
          description:
            "Gusanitos, Palomitas, Risketos, Triskys, Matchball, Pajitas, Tejitas … ¡y mucho más!"
        },
        gusanitos: {
          familia: "snacks",
          title: "Risi | Los auténticos Gusanitos",
          description:
            "El snack horneado más famoso , delicioso e irresistible con el que la diversión esta asegurada. ¿Quién puede decir que no a una bolsa de Los Auténticos Gusanitos?"
        },
        matchBall: {
          familia: "snacks",
          title: "Match Ball Risi: bolitas ligeras llenas de sabor",
          description:
            "Las bolitas Match Ball Risi de siempre son deliciosas por su sabor a queso, pero también te sorprenderán sus nuevas recetas: Ketchup, Barbacoa y formato Mini"
        },
        mios: {
          familia: "snacks",
          title: "Míos Risi: el snack más sofisticado y original",
          description:
            "Míos es un snack pensando especialmente para los adultos y cuenta con sabores sorprendentes: Maíz&Chia, Maíz&Espinacas, Maíz&Cebolla"
        },
        palomitas: {
          familia: "snacks",
          title: "Risi | Las auténticas Palomitas",
          description:
            "Las Auténticas Palomitas  es el snack preferido para disfrutar al máximo de tus momentos de de peli y manta… ¡que no falten en casa!"
        },
        risketos: {
          familia: "snacks",
          title: "Risi | I Risketos",
          description:
            "Un irresistible snack que deja huella. Super crujientes, con el sabor a queso mas irresistible. Deliciosos y únicos. ¡A mancharse los dedos con Risketos!"
        },
        triskys: {
          familia: "snacks",
          title: "Risi | Triskys",
          description:
            "Deliciosos aritos de maiz, crujientes y redonditos que te harán reconectar con los mejores momentos. Elige el sabor original de tus Triskys de siempre o los deliciosos Triskys sabor jamón o barbacoa. ¡Irresistibles!"
        },
        jummy: {
          familia: "snacks",
          title: "Risi | Jummy",
          description:
            "Divertido y atrevido, así es Jummy. La estrella que ha nacido para quedarse y con la que prometemos no dejar indiferente a los amantes de lo auténtico e innovador. ¿Te lo vas a perder?"
        },
        exportacion: {
          familia: "patatas",
          title: "Risi | Patatas RISI",
          description:
            "En Risi llevamos toda la vida haciendo buenas patatas fritas, con los mejores ingredientes y sabores auténticos. ¡Descúbre nuestras patatas Originales, Onduladas y Selectas!"
        },
        galletas: {
          title: "Risi | Galletas BSAN  y FABS",
          description:
            "Deliciosas galletas premium para todos los gustos y necesidades: Galletas BSAN para cuidarte de forma integral y nuestras galletas FABS , con los sabores más auténticos y exclusivos de los mejores chocolates del mundo."
        },
        bsan: {
          familia: "galletas",
          title: "Risi | Galletas BSAN  y FABS",
          description:
            "Deliciosas galletas premium para todos los gustos y necesidades: Galletas BSAN para cuidarte de forma integral y nuestras galletas FABS , con los sabores más auténticos y exclusivos de los mejores chocolates del mundo."
        },
        chocolate: {
          familia: "galletas",
          title: "RISI | Galletas BSAN 0% Azúcares Añadidos, Chocolate",
          description:
            "Galletas BSAN bañadas en delicios chocolates: con leche, negro y blanco. Y lo mejor de todo deliciosas !0% azúcares!"
        },
        maria: {
          familia: "galletas",
          title: "RISI/ Galletas BSAN 0% Azúcares Añadidos María",
          description:
            "Las tradicionales BSAN tipo María 0% azúcares, perfectas para un desayuno saludable. Con semillas de sésamo o con espelta. ¿Con cuál te quedas?"
        },
        adultas: {
          familia: "galletas",
          title: "Risi | Galletas BSAN Sin Gluten para Adultos",
          description:
            "Deliciosa galleta BSAN sin gluten, bañada en intenso chocolate negro con 70% de cacao. Crujiente y con un sabor sorprendente."
        },
        desayuno: {
          familia: "galletas",
          title: "RISI | Galletas BSAN Sin Gluten para Niños",
          description:
            "Deliciosas galletas elaboradas con harinas de maiz y arroz que harán las delicias de los peques de la casa. ¡Con sus personajes favoritos, HelloKitty y Doraemon! Incluyen regalito."
        },
        infantiles: {
          familia: "galletas",
          title: "Virginias Infantiles: las mejores galletas para niños",
          description:
            "Galletas elaboradas con maíz, sin gluten y sin lactosa con las formas de los personajes preferidos de los más pequeños: Hello Kitty y Doraemon"
        },
        tradicionales: {
          familia: "galletas",
          title:
            "Virginias Tradicionales: el desayuno perfecto para toda la familia",
          description:
            "Galletas con un alto contenido en cereales y fibra, ideales para desayunar en familia. Elige entre las Super María 0% y las Digestiva Chocolate"
        },
        plus: {
          familia: "galletas",
          title: "Virginias Infantiles: las mejores galletas para niños",
          description:
            "Galletas elaboradas con maíz, sin gluten y sin lactosa con las formas de los personajes preferidos de los más pequeños: Hello Kitty y Doraemon"
        },
        fabs: {
          familia: "galletas",
          title: "RISI | Galletas FABS",
          description:
            "Las primeras galletas con el sabor auténtico y exclusivo de los mejores chocolates del mundo procedentes de Tanzania, Vietnam y México."
        },
        caramelos: {
          title: "Risi | Caramelos 0% Azúcares o con Azúcar",
          description:
            "En Risi tenemos una gran variedad de Caramelos sin gluten. Caramelos  0% azúcares y  caramelos con azúcar, con sabor a frutas , a cítricos y mentolados .¡De rechupete!"
        },
        azucares0: {
          familia: "caramelos",
          title: "RISI | Caramelos Sin Azúcares",
          description:
            "Los mejores caramelos con 0% azúcares añadidos y sin gluten. Conoce nuestros caramelos con zumo de frutas y nuestros Glassmint mentolados."
        },
        caramelosTradicionales: {
          familia: "caramelos",
          title: "Risi | Caramelos con Azúcar",
          description:
            "Los caramelos de siempre con el mejor sabor de las mejores  frutas. ¡Deliciosos!"
        },
        borges: {
          title: "Risi | Frutos Secos de Borges",
          description:
            "Clásicos que no pueden faltar en tu despensa del líder en frutos secos: Borges de la mano de RISI. Conoce nuestros deliciosas variedades de frutos secos: nueces, pistachos, cacahuetes…y por supuesto nuestras irresitibles pipas, para empezar y no parar.",
          familia: "frutos-secos"
        },
        frutossecos: {
          familia: "frutos-secos",
          title: "Risi | Frutos Secos de Borges",
          description:
            "Disfruta de los frutos secos de Borges con Risi: nueces, pistachos, cacahuetes, avellanas, almendras y nuestros deliciosos cócteles variados."
        },
        pipas: {
          familia: "frutos-secos",
          title: "Risi | Frutos Secos Pipas",
          description:
            "¿Quién puede resistirse a unas deliciosas pipas? Elije entre pipas saladas o aguasal."
        },
        promociones: {
          title: "Risi | Promociones",
          description:
            "En Risi nos gusta premiar tu fidelidad con diferentes promociones para que puedas disfrutar de los mejores premios y ventajas"
        },
        basesLegalesPromocion: {
          title: "Promociones de productos Risi",
          description:
            "En Risi nos gusta premiar tu fidelidad con diferentes promociones para que puedas disfrutar de los mejores premios y ventajas"
        },
        codigoconducta: {
          title: "Risi | Código de Conducta",
          description:
            "Risi cumple contigo y gracias a ti cumplimos con todos. Conoce los principios generales de nuestro código de conducta, en los que basamos nuestro desarrollo empresarial."
        },
        cartapresidente: {
          incodigoconducta: true,
          title: "Carta del presidente",
          description: ""
        },
        risiempleados: {
          incodigoconducta: true,
          title: "Risi y sus empleados",
          description: ""
        },
        risiproveedores: {
          incodigoconducta: true,
          title: "Risi y sus proveedores",
          description: ""
        },
        risisociedad: {
          incodigoconducta: true,
          title: "Risi y la sociedad",
          description: ""
        },
        daganzo: {
          title: "Risi y la sociedad - Daganzo",
          description: ""
        },
        loeches: {
          title: "Risi y la sociedad - Loeches",
          description: ""
        },
        patatas: {
          title: "Risi | Patatas RISI",
          description:
            "En Risi llevamos toda la vida haciendo buenas patatas fritas, con los mejores ingredientes y sabores auténticos. ¡Descúbre nuestras patatas Originales, Onduladas y Selectas!"
        },
        originales: {
          familia: "patatas",
          title: "Patatas Originales",
          description: ""
        },
        onduladas: {
          familia: "patatas",
          title: "Patatas onduladas",
          description: ""
        },
        selectas: {
          familia: "patatas",
          title: "Patatas selectas",
          description: ""
        },
        detodalavida: {
          familia: "patatas",
          title: "De toda la vida",
          description: ""
        },
        matarile: {
          title: "Risi y la sociedad - Matarile",
          description: ""
        },
        cumplimientoetico: {
          incodigoconducta: true,
          title: "Cumplimiento y canal ético",
          description: ""
        },
        risiconsumidores: {
          incodigoconducta: true,
          title: "Risi y sus consumidores",
          description: ""
        },
        principiosgenerales: {
          incodigoconducta: true,
          title: "Principios generales",
          description: ""
        },
        materialesprensa: {
          title: "Materiales de prensa",
          description: ""
        },
        concursofulloftrickers: {
          title: "Full of Trikers",
          description: ""
        },
        basesconcursofulloftrickers: {
          title: "Full of Trikers",
          description: ""
        },
        politica_privacidad: {
          title: "Protección de datos Risi",
          description:
            "En Risi garantizamos la privacidad y protección de tus datos"
        },
        politica_cookies: {
          title: "Política de Cookies Risi",
          description:
            "Descubre todos los detalles en información acerca de nuestra política de cookies"
        },
        aviso_legal: {
          title: "Aviso Legal de Risi",
          description: ""
        },
        bases_legales_risi: {
          title: "Bases Legales de Risi",
          description: ""
        },
        regulatory_compliance: {
          title: "Cumplimiento normativo"
        },
        values: {
          title: "Valores"
        },
        ethical_channel: {
          title: "Canal ético"
        },
        sustainability: {
          title: "Compromisos"
        }
      }
    },
    header: {
      patatas: "Patatas",
      snack: "Snacks",
      galletas: "Galletas",
      caramelos: "Caramelos",
      tradicionales: "Tradicionales",
      frutosSecos: "Frutos secos",
      pipas: "Pipas",
      atencionCliente: "Atención Cliente",
      cartapresidente: "Carta del presidente",
      principiosgenerales: "Principios generales",
      risiempleados: "Risi y sus </br> empleados",
      risiconsumidores: "Risi y sus </br> consumidores",
      risiproveedores: "Risi y sus </br> clientes y proveedores",
      risisociedad: "Risi y </br>la sociedad",
      risicumplimiento: "Cumplimiento y </br> canal ético",
      inicio: "Inicio",
      sobre_risi: "Sobre Risi",
      historia: "Historia",
      quienessomos: "¿Quiénes somos?​",
      codigoconducta: "Código de conducta",
      conoceNuestraHistoria: "Conoce nuestra fascinante historia",
      hoyYSiempreContigo: "Hoy y siempre contigo",
      blogPlacerosofia: "Blog Placerosofía",
      noticias: "Noticias",
      nutririsi: "NutriRisi",
      distribuidores: "Distribuidores",
      contacto: "Contacto",
      siguenos: "Síguenos",
      faqs: "FAQS"
    },
    vistas: {
      productos: "Productos",
      snacks: "Snacks",
      galletas: "Galletas",
      caramelos: "Caramelos",
      promociones: "Promociones",
      sobre_risi: "Sobre Risi",
      historia: "Historia",
      quienessomos: "¿Quiénes somos?​",
      nutririsi: "Nutririsi",
      noticias_risi: "Noticias Risi",
      faqs: "Faqs",
      contacto: "Contacto",
      profesionales: "Profesionales",
      distribuidores: "Distribuidores",
      press_room: "Press Room",
      legal: "Legal",
      politica_cookies: "Política de Cookies",
      aviso_legal: "Aviso Legal",
      proteccion_datos: "Protección de datos",
      bases_legales_risi: "Bases Legales RISI",
      materialesprensa: "Materiales de prensa",
      regulatory_compliance: "Cumplimiento Normativo",
      codigoconducta: "Código de conducta",
      values: "Valores",
      ethical_channel: "Canal ético",
      sustainability: "Compromisos"
    },
    infoFooter: "©Risi 2024. Todos los derechos reservados",
    descubrir: "Descubrir",
    todosNuestrosSnacks: "Todos<span>nuestros snacks</span>",
    sinGluten: "Sin gluten",
    sinFrutosCascara: "Sin frutos de cáscara",
    valorNutricional: "Valor Nutricional",
    valorEnergetico: "Valor energético",
    hidratosCarbono: "Hidratos de carbono",
    delosCualesAzucares: "de los cuales azúcares",
    delosCualesPolialcoholes: "de los cuales polialcoholes",
    grasas: "Grasas",
    saturadas: "de las cuales saturadas",
    sal: "Sal",
    proteinas: "Proteínas",
    fibraAlimentaria: "Fibra Alimentaria",
    verIngredientes: "Ver ingredientes",
    origen: "ORIGEN",
    maridaje: "MARIDAJE",
    notasCata: "NOTAS DE CATA",
    verAlegenos: "Ver alérgenos",
    verCata: "VER CATA <strong> by David Pallás</strong>",
    koala: "Koala",
    galletasCon: "Galletas con",
    todosNuestrasGalletas: "Todas<span>nuestras galletas",
    sweetlover: "¡Sweet Lovers!",
    todosNuestrosCaramelos: "Todos<span>nuestros caramelos</span>",
    saludablesDeliciosos: "¡Saludables y deliciosos!",
    todosNuestrosFrutos: "Todos<span>nuestros frutos secos</span>",
    todosNuestrasPatatas: "Todas<span>nuestras patatas",
    conoce: "Conoce",
    nuestra: "nuestra",
    historiaText: "Historia",
    irAHistoria: "Ir a historia",
    vermas: "Ver más",
    descargar: "Descargar",
    volver: "Volver",
    recetas: "Recetas",
    alaSarten: "a la sartén",
    masCrujientes: "¡Más crujientes!",
    masSabor: "¡Más sabor!",
    sigueA: "Sigue a Risi",
    acercate: "Acércate a",
    vernuestras: "Ver nuestras",
    promociones: "promociones",
    todas: "Todas",
    lasPromos: "las promociones",
    regulatory_compliance: {
      modules: [
        {
          path: "enlaces.codigoconducta",
          title: "CÓDIGO DE CONDUCTA",
          icon: "code-conduct.svg"
        },
        {
          path: "enlaces.values",
          title: "VALORES",
          icon: "values.svg"
        },
        {
          path: "enlaces.ethical_channel",
          title: "CANAL ÉTICO",
          icon: "ethical.svg"
        },
        {
          path: "enlaces.sustainability",
          title: "COMPROMISOS",
          icon: "sustainability.svg"
        }
      ],
      ethical: {
        label: "CANAL ÉTICO",
        title: "POLÍTICA GENERAL DEL SISTEMA INTERNO DE INFORMACIÓN",
        objetive: "Objetivo:",
        descrip1:
          "Establecer el procedimiento a seguir en caso de detectar cualquier incidencia o comportamiento contrario a los valores de la compañía, a su código de conducta, infracción normativa o susceptible de generar responsabilidad penal.",
        introduction: "1. Introducción",
        descrip2:
          "La Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción (en adelante, Ley 2/2023) establece los elementos que integran el Sistema Interno de Información, entre ellos, el Procedimiento de Gestión de Informaciones, la Política del Sistema Interno de Información (la cual incorpora las garantías de protección a los informantes), y el Canal Ético de Información de RISI.",
        descrip3:
          "El Consejo de Administración de RISI, S.A. (en adelante, “RISI”), en su voluntad de cumplir con la legislación vigente en cada momento, aprueba y suscribe la presente Política (en adelante, la “Política”) como parte del Sistema Interno de Información implantado para todas las sociedades que forman parte de RISI.",
        descrip4:
          "De igual forma, se procede al nombramiento de un Responsable del Sistema Interno de Información.",
        subjective: "2. Ámbito subjetivo",
        descrip5:
          "Esta Política se aprueba con el fin de establecer los principios básicos del Sistema Interno de Información de RISI y, en concreto del Canal Ético, que está disponible para los siguientes informantes:",
        descrip6:
          "Miembros de los órganos de administración, directivos y empleados de las empresas que forman parte de RISI (incluyendo exempleados, trabajadores autónomos, en prácticas, en proceso de selección).",
        descrip7:
          "Empleados de proveedores, contratistas, subcontratistas o socios de negocio.",
        descrip8:
          "Todos aquellos terceros con los que RISI mantenga una relación profesional directa o indirecta.",
        descrip9:
          "Todos los sujetos incluidos están referidos a cualquiera de las filiales sobre las que, de forma directa o indirecta, RISI ejerza el control efectivo.",
        descrip10:
          "Las sociedades sobre las que RISI tenga control, en los términos del artículo 42.1 del Código de Comercio, (las “Entidades de RISI”), también se verán vinculadas por los principios éticos y normas establecidos en la presente Política. A RISI y las Entidades de RISI se les denominará, en lo sucesivo, “RISI” o la “Compañía”.",
        communication: "3. Definición de comunicación",
        descrip11:
          "La consulta se define como la solicitud de información para conocer la interpretación de los principios y directrices contenidos en el Código de Conducta y la normativa interna que nos es de aplicación.",
        descrip12:
          "La información o denuncia se define como una inquietud sobre un posible incumplimiento o comportamiento contrario a los valores y procedimientos de RISI comunicada de buena fe y conscientemente por un empleado o tercera parte a través del Canal Ético de RISI.",
        descrip13:
          "La Política pretende regular la forma en que se gestionan las informaciones recibidas sobre conductas que afecten a los profesionales o cualquier sociedad perteneciente a RISI y puedan suponer la comisión de un delito o infracción de la normativa de aplicación.",
        scopeMaterial:
          "4. Ámbito material del Sistema Interno de Información de RISI",
        descrip14:
          "A través del Canal Ético de RISI se podrán presentar consultas o denuncias referentes a la normativa de aplicación a la actividad de RISI.",
        descrip15: "En concreto, se podrán comunicar:",
        descrip16:
          "Consultas: se referirá al alcance y la aplicabilidad del Código Ético o de algún elemento del Sistema de Compliance en su conjunto.",
        descrip17:
          "Para realizar cualquier consulta en este sentido, RISI tiene habilitado el siguiente canal: <a href='mailto:consultacodigo@risi.es'>consultacodigo@risi.es</a>",
        descrip18:
          "Denuncias sobre posibles incumplimientos del Sistema: se referirá a cualquier incumplimiento de los elementos del Sistema de Compliance que comprende en este concepto todas las infracciones del Código Ético, de cualquier otro elemento del Sistema o de cualquier otra normativa interna, así como las infracciones de cualquier normativa externa, legislación o regulación integrante del ordenamiento jurídico que resulte de aplicación, incluyendo especialmente (pero no exclusivamente) las infracciones graves o muy graves de naturaleza administrativa o penal (con especial atención a las conductas corruptas) y de la normativa de defensa  de la competencia, por su especial gravedad y por el compromiso específico que RISI asume respecto a su cumplimiento.",
        descrip19:
          "En especial, se incluyen las materias referidas en la Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informan de infracciones normativas y de lucha contra la corrupción para cuyos casos se asegurará la aplicación de los principios y prescripciones en ella establecidos.",
        descrip20:
          "RISI ha habilitado el siguiente canal: <a href='mailto:canaletico@risi.es'>canaletico@risi.es</a> para presentar las comunicaciones sobre infracciones previstas en la presente Política.",
        descrip21:
          "Quedan excluidas del alcance del presente procedimiento las informaciones vinculadas a reclamaciones sobre conflictos interpersonales o que afecten únicamente al informante y a las personas a las que se refiera la comunicación.",
        descrip22:
          "El Órgano de Gobierno de RISI ha designado a la Responsable de Cumplimiento como Responsable del Sistema Interno de Información y, por tanto, para la gestión de las informaciones o denuncias a través del Canal Ético.",
        informant: "5. Derechos y Deberes del informante",
        descrip23:
          "El Órgano de Gobierno de RISI establece que el Canal Ético de RISI se rige de conformidad a los siguientes principios:",
        descrip24:
          "<strong>Principio de buena fe</strong>. Todos los integrantes de RISI y todas las terceras partes de conformidad con lo previsto en el ámbito subjetivo del Sistema Interno de Información, deben actuar de buena fe y no hacer acusaciones falsas al manifestar sus inquietudes. La buena fe consiste en dar información sin malicia, sin considerar el beneficio personal y considerando la información veraz de forma razonable y con los medios de que dispone. El denunciante que deliberadamente haga declaraciones falsas o engañosas o de mala fe, podrá ser objeto de acciones disciplinarias de conformidad con la legislación vigente.",
        descrip25:
          "<strong>Compromiso de no represalia</strong>. RISI establece formalmente que no tolerará represalias de ningún tipo cometidas sobre aquellas personas que hagan uso de los procedimientos establecidos para la comunicación de conductas irregulares.",
        descrip26:
          "<strong>Derecho a ser informado</strong>. El denunciante o informante tiene derecho de ser informado desde la presentación de la consulta o denuncia. A estos efectos recibirá acuse de recibo de la recepción de su denuncia en el plazo de siete (7) días naturales. Asimismo, pondrá en su conocimiento, la admisión o no de la misma, o, en su caso, la existencia de una investigación interna y de su resolución en el plazo de tres (3) meses desde la recepción de la comunicación, salvo casos de especial complejidad en que este plazo podrá ser ampliado otros tres meses.",
        descrip27:
          "<strong>Derecho a la protección de los datos personales</strong>. Según la normativa vigente los Datos Personales deberán ser protegidos y tratados conforme a la Ley 2/2023, de 20 de febrero reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y la normativa de protección de datos vigente. El denunciante tiene derecho a conservar el anonimato cuando presente una comunicación o denuncia debiendo ser protegido en dicho derecho.",
        descrip28:
          "<strong>Confidencialidad</strong>. Se adoptarán las medidas necesarias para preservar la identidad y garantizar la confidencialidad de los datos correspondientes a todas las personas afectadas por la información suministrada en las denuncias. En especial, en el caso de denuncias no anónimas, la identidad del denunciante deberá mantenerse confidencial en todas las etapas del proceso de investigación y resolución de la denuncia, por lo que no se divulgará a terceros ni, por tanto, a la persona denunciada, ni tampoco a los mandos directivos del denunciante. Sin perjuicio de lo anterior, los datos del denunciante y del resto de intervinientes podrán ser objeto de comunicación a terceros para la adecuada gestión de la investigación y a los Juzgados o Tribunales, Ministerio Fiscal, Fuerzas y Cuerpos de Seguridad del Estado y demás autoridades competentes cuando resulte necesario para la tramitación de los procedimientos judiciales que, en su caso, procedan como consecuencia de las investigaciones llevadas a cabo con motivo de las denuncias formuladas.",
        accused: "6. Derechos y deberes del denunciado",
        descrip29:
          "<strong>Derecho al honor, a la presunción de inocencia y de defensa</strong>. El derecho al honor de las personas es una de las máximas de actuación de RISI. En ese sentido, pondremos la mayor atención en velar por tales derechos, garantizando los derechos de las personas denunciadas a defenderse de cualesquiera acusaciones que se dirigieran contra ellas con las máximas garantías legales. La persona afectada podrá hacer uso de sus derechos de defensa y ser asistida por la representación legal que estime oportuna.",
        descrip30:
          "<strong>Derecho a ser informado</strong>. La persona denunciada será informada de la instrucción de un procedimiento de investigación por hechos ilícitos o ilegales que pudieran serle atribuidos. En el plazo más breve posible, se le comunicará los hechos objeto de investigación y se velará por el legítimo respeto a sus derechos de defensa y presunción de inocencia.",
        descrip31:
          "<strong>Derecho a la protección de los datos personales</strong>. Según la normativa vigente los Datos Personales deberán ser protegidos y tratados conforme a la Ley 2/2023, de 20 de febrero reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y normativa de protección de datos de aplicación. Se le informará de que sus datos han sido obtenidos a través del Canal Ético cuya finalidad consiste en investigar, tramitar y resolver las comunicaciones recibidas. Solo en caso de ser necesario, al objeto de la investigación, tramitación y/o resolución, la información podrá ser cedida a terceros en cumplimiento de las obligaciones legales oportunas.",
        descrip32:
          "<strong>Deber de confidencialidad y colaboración:</strong> Tiene obligación expresa de mantener la debida confidencialidad, a salvo de su derecho de defensa. La violación por el empleado de las prevenciones advertidas dará lugar, en su caso, a las correspondientes medidas disciplinarias, sin perjuicio de la presentación de la oportuna denuncia ante las Fuerzas y Cuerpos de Seguridad, Fiscalía o el juzgado de instrucción correspondiente.",
        channel: "7. Canal Ético de RISI",
        descrip33:
          "El Canal Ético de RISI es un medio seguro y confidencial que permite a los empleados y otras partes interesadas (con el alcance señalado en el apartado 2 de la presente Política) informar de conductas inapropiadas, irregularidades o cualquier otra situación que pueda suponer una infracción normativa de conformidad con lo previsto en la Ley 2/2023 y afectar negativamente la reputación de RISI.",
        descrip34:
          "El Canal Ético de Información de RISI permite la presentación de:",
        descrip35:
          "<strong>Comunicación escrita:</strong> a través de dirección de correo electrónico. ",
        descrip36:
          "<strong>Comunicación presencial:</strong> previa solicitud del informante que será atendida en el plazo de siete (7) días naturales. ",
        descrip37:
          "Las comunicaciones o informaciones de acuerdo con el ámbito de aplicación de esta Política también se podrán remitir a la Autoridad Independiente de Protección del Informante y a las autoridades u órganos autonómicos correspondientes, a través de sus respectivos canales habilitados para estos efectos. De igual forma, se podrán comunicar dichos hechos a las autoridades creadas al efecto por los organismos y autoridades de cualquier otro país de la Unión Europea.",
        protection: "8. Protección de datos de carácter personal",
        descrip38:
          "Los datos suministrados a través del Canal Ético de Información de RISI se utilizarán con el fin de gestionar las comunicaciones relacionadas con dicho canal, así como para realizar las investigaciones necesarias, impulsar la gestión y determinar si se ha producido alguna infracción o delito.",
        descrip39:
          "El acceso al Canal Ético de Información de RISI y a los datos en él contenidos está limitado exclusivamente al Responsable del Sistema Interno de Información de RISI, el equipo gestor asignado al mismo, al responsable de RRHH u órgano designado para la imposición de medidas disciplinarias, Responsable Legal, los encargados de tratamiento que eventualmente se designen y el DPO de la entidad. No obstante, el Responsable del Sistema Interno de Información podrá comunicar los datos a terceros, cuando resulte necesario para la tramitación de los procedimientos administrativos o judiciales que, en su caso, procedan.",
        descrip40:
          "Todo ello de conformidad con lo previsto en la Política de Privacidad del Canal Ético de RISI.",
        "btn-accept": "ACEPTAR Y CONTINUAR",
        descrip41:
          "El Canal Ético es el canal de comunicación que RISI pone a disposición para:",
        queries: "<strong>Dudas o Consultas</strong>",
        descrip42:
          "Plantear dudas o consultas sobre la aplicación del Código de Conducta y sobre el resto de normativa interna de conducta de RISI. En este sentido, puedes contactar con tu Director de área o directamente con el Responsable de Cumplimiento, enviando tus preguntas a la siguiente dirección de correo electrónico: <a href='mailto:consultacodigo@risi.es'>consultacodigo@risi.es</a>",
        violations: "<strong>Infracciones o Incumplimientos</strong>",
        descrip43:
          "Informar sobre cualquier incidencia o comportamiento contrario a los valores de la compañía, a su código de conducta, infracción normativa o susceptible de generar responsabilidad penal. En este sentido, puedes contactar directamente con el Responsable de Cumplimiento enviando un email a la siguiente dirección de correo electrónico: <a href='mailto:canaletico@risi.es'>canaletico@risi.es</a> o bien, cumplimentando el siguiente formulario:"
      }
    },
    contacto: {
      titulo: "Contacta",
      subtitulo: "Estos son nuestros datos de contacto",
      gracias: "¡Gracias por participar!<br>y mucha suerte!",
      enviado: "¡Enviado!<br>Nos pondremos en contacto lo antes posible",
      enviando: "¡Un momento!<br>Lo estamos enviando",
      revisa: "Por favor,<br>revisa todos los campos",
      puedesEnviar: "¡Perfecto!<br>Ya lo puedes enviar :)",
      options: [
        {
          title: "Estoy interesad@ en vender productos RISI.",
          link: "distribuidores"
        },
        {
          title: "Tengo una consulta o reclamación sobre sus productos.",
          link: "contacto",
          param: "consultaComentario"
        },
        {
          title: "Trabaja con nosotros.",
          link: "contacto",
          param: "trabaja_con_nosotros"
        },
        {
          title: "Otras dudas, comentarios o sugerencias.",
          link: "contacto",
          param: "otro"
        }
      ],
      "consulta-o-comentario": {
        title: "ENVÍANOS TU CONSULTA SOBRE NUESTROS PRODUCTOS.",
        type: "4",
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Atención al consumidor:</p><p><a href='tel:900831000'>900 83 10 00</a></p>"
          },
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p>"
          }
        ]
      },
      "trabaja-con-nosotros": {
        megaTitle: "TRABAJA CON NOSOTROS",
        title: "ENVÍANOS TUS DATOS E INFORMACIÓN.",
        type: "5",
        contacts: [
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:empleo@risi.es'>empleo@risi.es</a></p>"
          }
        ]
      },
      otro: {
        title: "Envíanos TUS DUDAS, COMENTARIOS O SUGERENCIAS.",
        type: "0",
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Otras consultas:</p><p><a href='tel:900831000'>900 83 10 00</a></p>"
          },
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p>"
          }
        ]
      },
      hoja: [
        {
          content:
            "<img class='icon' src='/static/img/location.svg' alt='Icon-location'><p><strong>Polígono industrial Gitesa</strong></p><p>c/ Severo Ochoa, 2 Daganzo de Arriba 28814 - Madrid</p>"
        },
        {
          title: "Clientes y distribuidores:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:900909013'>900 909 013</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:pedidos@risi.es'>pedidos@risi.es</a></p></div>"
        },
        {
          title: "Consumidor:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:900831000'>900 831 000</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p></div>"
        },
        {
          title: "Empleo:",
          content:
            "<div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:empleo@risi.es'>empleo@risi.es</a></p></div>"
        },
        {
          title: "Otras consultas:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:918782110'>918 782 110</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:risi@risi.es'>risi@risi.es</a></p></div>"
        }
      ]
    },
    patatas: {
      ySiNosVamos: "Y si nos vamos",
      fuera: "Fuera",
      detodalavida: {
        titulo: "De toda la vida",
        enrisillevamos: "En Risi llevamos",
        haciendoPat: "haciendo deliciosas Patatas",
        en1970: "En 1970, abrimos nuestra",
        dePatatas: "de Patatas en Madrid",
        nuestrasRecetas: "Nuestras recetas son las",
        deSiempre: "de siempre, hechas con",
        yahoraMejores: "y ahora todavía mejores con",
        rompemosReglas:
          "<strong>Sabemos que ver las bolsas de patatas llenas de aire te frustra, pero es importante que sepas que <span>el aire en las bolsas es fundamental para mantener su frescura y calidad y reducir las roturas</span>, porque es un producto frágil.</strong></p><p>Pero en RISI estamos haciendo el esfuerzo de reducirlo al máximo, para:",
        disfrutarBolsa: "Que puedas disfrutar de una bolsa",
        bolsaLlena:
          " 70% de nuestra bolsa está llena de patatas, ¿no te lo crees? <strong>¡Garantizado!</strong> Es una de nuestras principales prioridades y medidas de calidad en nuestra fábrica.",
        reducirPlasti: "  Reducir el uso de plástico",
        consiguiendImpacto:
          "Consiguiendo impactar positivamente en nuestro entorno usando solo lo que es estrictamente necesario para que disfrutes de las mejores patatas fritas."
      },
      originales: {
        titulo: "Las Originales"
      },
      onduladas: {
        titulo: "Las onduladas"
      },
      selectas: {
        titulo: "Selectas"
      },
      exportacion: {
        titulo: "Exportación",
        subtitulo:
          "Nuestras recetas a la sartén.<br>¡Ahora más crujientes y deliciosas!"
      }
    },
    snacks: {
      gusanitos: {
        titulo: "Gusanitos",
        subtitulo:
          "¡Los auténticos Gusanitos!<br>El snack horneado más delicioso que sabe mucho mejor cuando se comparte.",
        yummy1: "Maíz 🌽, Aceite de girasol 🌻, Sal y mucho 💚",
        yummy2: "¡Dales un baño de salsa!"
      },
      palomitas: {
        titulo: "Palomitas",
        subtitulo:
          "¡Las auténticas Palomitas!<br>Para todos los gustos, para los más clásicos, los más dulces, los más acaramelados…<br>¿Cuáles son las tuyas?",
        yummy1: "Las de toda la vida",
        yummy2: "Dos sabores",
        yummy3: "que juntos",
        yummy4: "hacen",
        yummy5: "maravillas",
        yummy6: "mmmm...",
        yummy7: "Choco...",
        yummy8: "¡Chúpate<br>los dedos!",
        newflavor: "Nuevo sabor"
      },
      risketos: {
        titulo: "Risketos",
        subtitulo:
          "¡Deliciosos aperitivos muy, muy, muy crujientes! Es la batalla Risketera, ¡elige los tuyos!",
        yummy1: "¡Te chuparás los dedos!",
        yummy2: "¡ Descubre<br>nuestro<br>nuevo sabor !"
      },
      mios: {
        titulo: "Mios",
        subtitulo:
          "Un snack adulto y sofisticado que te hará disfrutar del placer de un aperitivo lleno de sabor.",
        yummy1: "¡Nuevos!",
        yummy2: "¿Has probado ya los Mios horneados?",
        yummy3: "Déjate llevar por los nuevos sabores",
        yummy4: "Deliciosos hexágonos de maíz",
        yummy5: "¡Ingredientes naturales!"
      },
      triskys: {
        titulo: "Triskys",
        subtitulo: "¡Deliciosos aritos de maíz muy, muy crujientes!",
        yummy1: "Con el sabor de siempre",
        yummy2: "Con un toque único",
        yummy3: "Con el sabor de siempre",
        yummy4: "¿Has probado el sabor jamón?"
      },
      matchBall: {
        titulo: "MatchBall ",
        subtitulo:
          "¡Las bolitas más sabrosas! Sabor a queso, kétchup o barbacoa, ¡tú eliges!",
        yummy1: "Las auténticas bolitas de queso",
        yummy2: "Nuevo formato, del pack a tu<br>boca"
      },
      jummy: {
        titulo: "Jummy ",
        subtitulo:
          "Divertido y atrevido, así es Jummy. <br>La estrella que ha nacido para quedarse y con la que prometemos no dejar indiferente a los amantes de lo auténtico e innovador.<br>¿Te lo vas a perder?"
      },
      otrosProductos: {
        titulo: "Otros productos ",
        yummy1: "Fajitas<br>de maíz<br>sabor BBQ",
        yummy2: "El sabor a queso<br>se derretirá<br>en tu boca",
        yummy3: "Nuestros<br>mejores productos<br>en una sola bolsa",
        yummy4: "El Snack<br>de Patata"
      }
    },
    galletas: {
      bsan0: {
        titulo: "B-SAN 0% AZÚCARES",
        subtitulo:
          "Deliciosas galletas de trigo con avena y cebada, totalmente cubiertas de chocolate y sin azúcares añadidos.</br> ¡Hacia una vida más sana!",
        subtituloMaria:
          "Galletas para desayunos deliciosos y saludables, sin azúcares añadidos.<br> ¡Hacia una vida más sana!",
        banadas: "BAÑADAS",
        maria: "MARÍA",
        yummy1: "0% azúcares añadidos",
        yummy2: "¡Con sésamo!",
        yummy3: "Fuente de fibra"
      },
      bsan0SinGluten: {
        titulo: "B-SAN sin gluten",
        subtitulo: "Una deliciosa galleta sin gluten bañada con chocolate negro"
      },
      bsanPlus: {
        titulo: "B-SAN PLUS",
        subtitulo:
          "Deliciosas y divertidas galletas para niños.<br>Con cereales y vitaminas.",
        yummy1: "CON GLUTEN",
        yummy2: "SIN GLUTEN",
        yummy3: "¡Sin lactosa!"
      },
      bsanDesayuno: {
        titulo: "B-SAN PLUS",
        subtitulo:
          "Deliciosas y divertidas galletas para niños.<br>Sin gluten, elaboradas con maíz y vitaminas.",
        yummy1: "¡Bajo en sal!"
      },
      fabs: {
        subtitulo:
          "<strong>Siente la paz que da la plena naturaleza en la que ha crecido nuestro cacao procedente de </strong> Tanzania, Vietnam y México mientras disfrutas del sabor de los<strong>mejores chocolates del mundo</strong> con FABS ORIGIN.",
        yummy1: "¡Intenso chocolate!",
        yummy2: "CONOCIENDO A",
        yummy3:
          "EXPERIMENTA UN VIAJE A LOS ORÍGENES DEL CHOCOLATE CON DAVID PALLÀS"
      }
    },
    caramelos: {
      azucares0: {
        titulo: "0% azúcares añadidos",
        subtitulo: "¡Deliciosos caramelos 0% azúcares añadidos y sin gluten!",
        yummy1: "Con zumo de frutas",
        yummy2: "Un dulce momento",
        yummy3: "¡Refrescante!"
      },
      tradicionales: {
        titulo: "Tradicionales",
        subtitulo:
          "Los caramelos de siempre con el sabor de las mejores frutas.",
        yummy1: "¡Simplemente deliciosos!",
        yummy2: "Caramelos de frutas",
        yummy3: "Sabor<br>Intenso"
      }
    },
    frutosSecos: {
      frutosSecos: {
        subtitulo:
          "Para disfrutar el momento… ¡A lo grande!<br> Los mejores ingredientes para un snack, saludable y delicioso.",
        yummy1: "¡Un clásico que nunca falta!",
        yummy2: "¡Que crujientes!",
        yummy3: "¡Todo energía!",
        yummy4: "¡Disfrútalo en ensalada!",
        yummy5: "¡Crujiente, crujiente!",
        yummy6: "¡Seleccionadas cuidadosamente para tí!"
      },
      pipas: {
        subtitulo: "¿Quién puede resistirse a unas deliciosas pipas?",
        yummy1: "¡No podrás parar!",
        yummy2: "Deliciosas y Sabrosas"
      }
    },
    formulario: {
      nombre: "Nombre",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      asunto: "Asunto",
      medioComunicacion: "Medio de comunicación",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      enviar: "Enviar",
      enviado: "Enviado",
      telefono: "Teléfono",
      provincia: "Provincia",
      localidad: "Localidad",
      calle: "Dirección postal (Calle, número y población)",
      cp: "Código postal",
      cv: "Adjuntar CV",
      documentation: "Adjuntar Documentación",
      fecha_nacimiento: "Fecha de nacimiento",
      publicidad:
        "Consiento el envío de comunicaciones comerciales sobre productos y servicios del grupo Risi así como el tratamiento automatizado para poder optimizar y personalizar dichas ofertas."
    },
    meses: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    productos: {
      "gusanitos-tradicionales": {
        family: "gusanitos",
        type: "left",
        titulo: "Gusanitos Originales",
        packs: "18g, 35g, 85g, 105g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "<strong>¡Los auténticos Gusanitos!</strong> Los de toda la vida, los que gustan a niñ@s y a mayores.",
        introDos:
          " Snack horneado sin colorantes y sin conservantes.<br>¿Quién puede decir que no a una bolsa de Gusanitos? ",
        introMovil:
          "<strong>¡Los auténticos Gusanitos!</strong> Los de toda la vida, los que gustan a niñ@s y a mayores.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (17,4%), sal y aroma natural. Puede contener <u>proteína de leche</u>. Puede contener <u>mostaza</u>",
        cantidadValor: "100g",
        hashtag: "#GusanitoOriginal",
        energia: "1.965kJ, 467kcal",
        hidratos: "71,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "17,4 g",
        saturadas: "2,2 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,6 g",
        mostrarSinLactosa: "1"
      },
      "gusanitos-ketchup": {
        family: "gusanitos",
        type: "left",
        titulo: "Gusanitos Kétchup",
        cantidadValor: "100g",
        hashtag: "#GusanitosKétchup",
        intro:
          "Un <strong>delicioso sabor kétchup</strong> invade a nuestros míticos Gusanitos, te encantarán.",
        introDos: " Sin conservantes y sin colorantes artificiales.",
        introMovil:
          "Un <strong>delicioso sabor kétchup</strong> invade a nuestros míticos Gusanitos, te encantarán.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (18.4 %), aroma de ketchup [azúcar, extracto de levadura, fructosa, tomate, cebolla y ajo en polvo, aroma, acidulante (ácido cítrico y málico), pimentón y colorante (extracto de pimentón)], y sal. Puede contener <u>proteína de leche</u> y <u>mostaza</u>",
        packs: "35g, 85g, 105g",
        energia: "2.065kJ, 492kcal",
        hidratos: "67,7 g",
        azucares: "5,4 g",
        grasas: "22 g",
        polialcoholes: "",
        saturadas: "2,8 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "5,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "palomitas-original": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Original",
        cantidadValor: "100g",
        hashtag: "#PalomitasOriginal",
        intro:
          "Las <strong>originales de toda la vida,</strong> nuestro sabor más clásico.",
        introDos:
          " <br>¡Imposible resistirse al sabor de la <strong>mantequilla</strong>!",
        introMovil:
          "Las <strong>originales de toda la vida,</strong> nuestro sabor más clásico.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (18,6 %), aroma de <u>mantequilla</u> [sustancias aromatizantes, <u>lactosa</u>, dextrosa, azúcar, suero <u>lácteo</u>, maltodextrina, almidón modificado y potenciador del sabor (E-621)] y sal. Puede contener <u>mostaza</u>.",
        packs: "35g, 90g, 105g",
        energia: "1.990kJ, 474kcal",
        hidratos: "71 g",
        azucares: "1,5 g",
        grasas: "18,6 g",
        saturadas: "2,4 g",
        fibra: "",
        polialcoholes: "",
        sal: "1,8 g",
        proteinas: "5,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "palomitas-ketchup-mostaza": {
        family: "palomitas",
        type: "right",
        titulo: "Palomitas Kétchup & Mostaza",
        cantidadValor: "100g",
        hashtag: "#PalomitasKétchup&Mostaza",
        intro:
          "¿Te atreves a mezclar? <strong>Las Palomitas más populares</strong>.",
        introDos: " <br>Con dos sabores que juntos hacen maravillas.",
        introMovil:
          "¿Te atreves a mezclar? <strong>Las Palomitas más populares</strong> ahora con dos sabores.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (17,1%), aroma de ketchup-<u>mostaza</u> [sustancias aromatizantes (contiene <u>mostaza</u>), azúcar, sal, maltodextrina, extracto de levadura, fructosa, tomate, cebolla y ajo en polvo, acidulante (ácido cítrico y málico), potenciador del sabor (E-621), dextrosa, colorantes (extracto de pimentón y curcumina) y miel]. Puede contener <u>proteína de leche</u>.",
        packs: "35g, 90g, 105g",
        energia: "1.977kJ, 470kcal",
        hidratos: "73 g",
        azucares: "2,9 g ",
        grasas: "17,1 g",
        polialcoholes: "",
        saturadas: "2,1 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "6,1 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "palomitas-pizza": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Pizza",
        cantidadValor: "100g",
        hashtag: "#PalomitasPizza",
        intro:
          "Si eres fan de las pizzas y también lo eres de las míticas Palomitas, <br>¡Este es tu snack!",
        introDos: " Las Palomitas con <strong>sabor a Italia.</strong>",
        introMovil:
          "Si eres fan de las pizzas y también lo eres de las míticas Palomitas, <br>¡este es tu snack!",
        ingredientes:
          "Sémola de maíz aceite de girasol (22,7%), aroma de pizza [aroma (contiene <u>leche</u>), maltodextrina, azúcar, potenciadores de sabor (E-621 y E-635), colorante (extracto de pimentón) y acidulante (ácido cítrico y málico)] y sal. Puede contener <u>mostaza.</u>",
        packs: "35g, 90g",
        energia: "1.882kJ, 450kcal",
        hidratos: "55,5 g",
        azucares: "4,4 g",
        polialcoholes: "",
        grasas: "22,7 g",
        saturadas: "2,7 g",
        fibra: "",
        sal: "1,8 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "palomitas-chocolate-blanco": {
        family: "palomitas",
        type: "right",
        titulo: "Palomitas Bombón Blanco",
        cantidadValor: "100g",
        hashtag: "#Palomitaschocoblanco",
        intro:
          "Para los que no pueden vivir sin el chocolate...nuestra versión de Palomitas recubiertas",
        introDos:
          " de <strong>delicioso Bombón Blanco.</strong><br>¡Una combinación de lo más especial!",
        introMovil:
          "Para los que no pueden vivir sin el chocolate...nuestra versión de Palomitas recubiertas.",
        ingredientes:
          "Azúcar, grasa de palmiste hidrogenada, sémola de maíz, suero de <u>leche</u> en polvo, <u>leche</u> desnatada en polvo, emulgente (lecitina de <u>soja</u>) y aromas (<u>leche</u>, y vainillina). Puede contener <u>frutos de cáscara (<u>almendra y avellana</u>)</u>.",
        packs: "30g, 80g",
        energia: "2.365kJ, 567kcal",
        hidratos: "62,2 g",
        polialcoholes: "",
        azucares: "46,0 g",
        grasas: "33,8 g",
        saturadas: "31,0 g",
        fibra: "",
        sal: "0,3 g",
        proteinas: "2,4 g",
        hasFrutosSecos: "1"
      },
      "palomitas-caramelo": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Caramelo",
        cantidadValor: "100g",
        hashtag: "#PalomitasCaramelo",
        intro:
          "¡Perfectas para los más golosos!… Nuestra edición de Palomitas más <strong>dulce</strong>.",
        introDos: " ¡Te encantarán!",
        introMovil:
          "¡Perfectas para los más golosos!… Nuestra edición de Palomitas más <strong>dulce</strong>.",
        ingredientes:
          "Azúcar, sémola de maíz, jarabe de glucosa, aceite de girasol (14.6%), <u>mantequilla</u>, lecitina de girasol, caramelo y sal. Contiene <u>leche y derivados</u>. Puede contener <u>frutos de cáscara (almendra y avellana)</u> y <u>soja</u>",
        packs: "30g, 80g",
        energia: "1.799kJ, 428kcal",
        hidratos: "70,7 g",
        polialcoholes: "",
        azucares: "47,6 g",
        grasas: "14,6 g",
        saturadas: "3,2 g",
        fibra: "",
        sal: "0,6 g",
        proteinas: "2,4 g",
        hasFrutosSecos: "1"
      },
      "palomitas-chocolate": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Choco",
        cantidadValor: "100g",
        hashtag: "#PalomitasChoco",
        intro:
          "Nuestra versión dulce recubierta de <strong>delicioso choco</strong>.",
        introDos: "",
        introMovil:
          "Nuestra versión dulce recubierta de <strong>delicioso chocolate</strong>.",
        ingredientes:
          "Azúcar, sémola de maíz, grasa de palma parcialmente hidrogenada, cacao en polvo desgrasado, emulgente (lecitina de girasol) y aroma (vainillina). Puede contener <u>leche, soja y frutos de cáscara (almendra y avellana).</u>",
        packs: "30g, 80g, 100g",
        energia: "2.260kJ, 542kcal",
        hidratos: "56,6 g",
        polialcoholes: "",
        azucares: "41,4 g",
        grasas: "33,1 g",
        saturadas: "30,5 g",
        fibra: "",
        sal: "0,06 g",
        proteinas: "4,3 g",
        hasFrutosSecos: "1"
      },
      "palomitas-bacon-cheese": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Bacon & Cheese",
        cantidadValor: "100g",
        hashtag: "#PalomitasBacon&Cheese",
        intro: "Nuestra versión sabor <strong>bacon & cheese</strong>.",
        introDos: "",
        introMovil: "Nuestra versión sabor <strong>bacon & cheese</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (24,8%), aromas de bacon y <u>queso</u> [aroma, aroma de humo, colorantes (extracto de pimentón y curcumina)]. Contiene <u>leche y derivados</u>. Puede contener <u>mostaza</u>",
        packs: "30g, 90g",
        energia: "2.237kJ, 534kcal",
        hidratos: "72 g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "24,8 g",
        saturadas: "3 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "5,6 g",
        hasFrutosSecos: "0"
      },
      "mios-tomillo-limon": {
        family: "mios",
        type: "left",
        titulo: "Horneados con un toque de Tomillo&Limón",
        cantidadValor: "100g",
        hashtag: "#MiosTomilloyLimón",
        intro:
          "Incluyen la proteína de los garbanzos integrales y las vitaminas y minerales de las <strong>espinacas</strong> y la <strong>cebolla</strong>, además, del poder antioxidante del limón.",
        introDos: "¡Veganos, deliciosos y perfectos para picar entre horas!",
        introMovil: "¡Veganos, deliciosos y perfectos para picar entre horas!",
        ingredientes:
          "Sémola de maíz, harina integral de lenteja, harina de arroz, aceite de girasol, harina integral de garbanzo (9 %), aroma (sustancias aromatizantes, maltodextrina, sal, azúcar, limón y tomillo en polvo), cebolla (0,9 %) y espinaca deshidratadas (0,5 %). Puede contener <u>leche y derivados</u> y <u>mostaza</u>.",
        packs: "95g",
        energia: "2.014kJ, 481kcal",
        hidratos: "60,0 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "20,6 g",
        saturadas: "2,6 g",
        fibra: "5,5 g",
        sal: "0,87 g",
        proteinas: "11,1 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-sal-pimienta": {
        family: "mios",
        type: "left",
        titulo: "Horneados con un toque de Sal Ahumada & Pimienta",
        cantidadValor: "100g",
        hashtag: "#HorneadosSalyPimienta",
        intro:
          "Mios! Horneados con un toque de Sal Ahumada y Pimienta Negra, contienen la fibra de las lentejas integrales, la energía del arroz y las propiedades antioxidantes del maiz.",
        introDos: " ¡Veganos, deliciosos y perfectos para picar entre horas!",
        introMovil: "¡Veganos y deliciosos! ",
        ingredientes:
          "Sémola de maíz (49 %), harina integral de lenteja (19 %), harina de arroz (19 %), aceite de girasol, harina integral de garbanzo, aroma (sustancias aromatizantes, maltodextrina, azúcar y sal ahumada), pimienta y colorante (extracto de pimentón). Puede contener <u>leche y derivados</u> y <u>mostaza</u>.",
        packs: "95g",
        energia: "2.006kJ, 478kcal",
        hidratos: "62,0 g",
        polialcoholes: "",
        azucares: "3 g",
        grasas: "19,5 g",
        saturadas: "2,5 g",
        fibra: "5,2 g",
        sal: "0,61 g",
        proteinas: "11,0 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-chia": {
        family: "mios",
        type: "left",
        titulo: "Chips de Maíz & Chía",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyChía",
        intro:
          "Aperitivo de maíz frito con uno de los superalimentos más queridos, la <strong>semillas de chía</strong> ",
        introDos:
          " y el toque especial de la <strong>sal marina.</strong><br>¡Con ingredientes naturales!",
        introMovil:
          "Aperitivo de maíz frito con uno de los superalimentos más queridos, la <strong>semillas de chía</strong>.",
        ingredientes:
          "Maíz (70%), aceite de girasol alto oleico (24 %), semillas de chía (3 %) y sal marina.",
        packs: "40g, 150g",
        energia: "2.154kJ, 515kcal",
        hidratos: "64,4 g",
        polialcoholes: "",
        azucares: "1,3 g",
        grasas: "24 g",
        saturadas: "2,4 g",
        fibra: "6,0 g",
        sal: "0,9 g",
        proteinas: "7,4 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-espinacas": {
        family: "mios",
        type: "right",
        titulo: "Chips de Maíz & Espinacas",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyEspinacas",
        intro:
          "¿Te atreves con un sabor de lo más exclusivo? Delicioso aperitivo de maíz frito.",
        introDos:
          " <strong>¡Con espinacas y pimienta rosa!</strong> Y… ¡Con ingredientes naturales!",
        introMovil:
          "¿Te atreves con un sabor de lo más exclusivo? Aperitivo de maíz frito<strong> con espinacas</strong>.",
        ingredientes:
          "Maíz (64 %), aceite de girasol alto oleico (25%), espinaca deshidratada (2 %) y aroma de pimienta [sal marina, pimientas rosa, negra y blanca molidas (0,4 %), azúcar y aroma].",
        packs: "150g",
        energia: "2.257kJ, 540kcal",
        hidratos: "61,1 g",
        azucares: "1,7 g",
        polialcoholes: "",
        grasas: "28,2 g",
        saturadas: "2,8 g",
        fibra: "7,7 g",
        sal: "1,2 g",
        proteinas: "6,8 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-boletus": {
        family: "mios",
        type: "right",
        titulo: "Chips de Maíz&Boletus",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyBoletus",
        intro:
          "¿Te atreves con un sabor de lo más exclusivo? Delicioso aperitivo de maíz frito con sabor a cebolla caramelizada.",
        introDos: "",
        introMovil:
          "¿Te atreves con un sabor de lo más exclusivo? Delicioso aperitivo de maíz frito con sabor a cebolla caramelizada.",
        ingredientes:
          "Maíz (68%), aceite de girasol alto oleico (23,5%), aroma (sustancias aromatizantes, maltodextrina, sal, sacarosa y fructosa) y boletus edulis deshidratado (2%). ",
        packs: "150g",
        energia: "2.087kJ, 499kcal",
        hidratos: "58,4 g",
        azucares: "2,2 g",
        polialcoholes: "",
        grasas: "25 g",
        saturadas: "2,5 g",
        fibra: "5,1 g",
        sal: "1,2 g",
        proteinas: "7,6 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-cebolla": {
        family: "mios",
        type: "left",
        titulo: "Chips de Maíz & Cebolla",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyCebolla",
        intro:
          "Un sabor <strong>delicioso y sofisticado</strong> que te hará disfrutar de un aperitivo lleno de sabor",
        introDos:
          " y como todas las variedades Mios!... <br>¡Solo con ingredientes naturales!",
        introMovil:
          "Un sabor <strong>delicioso y sofisticado</strong> que te hará disfrutar de un aperitivo lleno de sabor.",
        ingredientes:
          "Maíz (65%), aceite de girasol alto oleico (23,7%), cebolla deshidratada (3%), aroma de vinagre balsámico de Módena (0,02%) y cebolla.",
        packs: "40g, 150g",
        energia: "2.191kJ, 524kcal",
        hidratos: " 61,9 g",
        polialcoholes: "",
        azucares: "3,7 g",
        grasas: " 26,5 g",
        saturadas: "2,7 g",
        fibra: "6,0 g",
        sal: " 1,2 g",
        proteinas: " 6,5 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-queso": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Cheese",
        cantidadValor: "100g",
        hashtag: "#MatchBallCheese",
        intro:
          "Sabrosas bolitas con sabor a queso…mmm…<strong>¡Mucho queso!</strong>",
        introDos: "",
        introMovil:
          "Sabrosas bolitas con sabor a queso…mmm…<strong>¡Mucho queso!</strong>",
        ingredientes:
          "Sémola de maíz, aceite de girasol (23,4%), aroma de <u>queso</u> [aroma, maltodextrina, <u>lactosa</u>, <u>suero de leche</u>, potenciadores del sabor (E-621 y E-635) y acidulante (ácido cítrico)], azúcar y sal. Contiene <u>leche y derivados</u>. Puede contener <u>mostaza</u>.",
        packs: "30g, 105g",
        energia: "1.963kJ, 468kcal",
        hidratos: "64,7 g",
        polialcoholes: "",
        azucares: "8,2 g",
        grasas: "20,9 g",
        saturadas: "2,6 g",
        fibra: "",
        sal: "2,0 g",
        proteinas: "5,3 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "match-ball-ketchup": {
        family: "match-ball",
        type: "right",
        titulo: "MatchBall Kétchup",
        cantidadValor: "100g",
        hashtag: "#MatchBallKétchup",
        intro:
          "Si eres de los que adoras el Kétchup...estas son sin duda tus Match Ball.",
        introDos:
          " Las bolitas de siempre con <strong>sabor a Kétchup</strong>.",
        introMovil:
          "Si eres de los que adoras el Kétchup...estas son sin duda tus Match Ball.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (22,4%), aroma de ketchup [sal, fructosa, tomate en polvo, aroma, acidulantes (ácido cítrico y málico), cebolla y ajo en polvo, pimentón y colorante (extracto de pimentón)] y azúcar. Puede contener <u>proteína de leche</u>",
        packs: "30g, 105g",
        energia: "2044kJ, 487kcal",
        hidratos: "70,6 g",
        polialcoholes: "",
        azucares: "12,5 g",
        grasas: "20,2 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,0 g",
        proteinas: "5,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-barbacoa": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Barbacoa",
        cantidadValor: "100g",
        hashtag: "#MatchBallBarbacoa",
        intro:
          "¿Te declaras fan de las barbacoas y del <strong>sabor a barbacoa</strong>?",
        introDos:
          " <br>Estas Match Ball están pensadas solo para ti…¡Deliciosas!",
        introMovil:
          "¿Te declaras fan de las barbacoas y del <strong>sabor a barbacoa</strong>?",
        ingredientes:
          "Sémola de maíz, aceite de girasol (23,5%), aroma de salsa barbacoa [sal, maltodextrina, almidón de maíz, dextrosa, aromas, cebolla y ajo en polvo, acidulante (ácido cítrico), aromas de humo y colorante (extracto de pimentón)] y azúcar. Puede contener <u>proteína de leche.</u>",
        packs: "30g, 105g",
        energia: "2057kJ, 491kcal",
        hidratos: "68 g",
        polialcoholes: "",
        azucares: "10,8 g",
        grasas: "22,2 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,3 g",
        proteinas: "4,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-minis": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Minis 27g",
        cantidadValor: "100g",
        hashtag: "#MatchBallMinis",
        intro:
          "En tamaño mini pero con el sabor de las grandes y por supuesto con mucho queso.",
        introDos:
          " <br>¿Y lo mejor de todo? Que ahora con el nuevo formato van <strong>directas del pack a tu boca,</strong> ¿a qué mola?",
        introMovil:
          "En tamaño mini pero con el sabor de las grandes y por supuesto con mucho queso.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (22,8%), aroma de <u>queso</u> [aroma, maltodextrina, <u>lactosa</u>, suero <u>lácteo</u>, potenciadores del sabor (E-621 y E-635) y acidulante (ácido cítrico)], azúcar y sal. Puede contener <u>mostaza.</u>",
        packs: "27g",
        energia: "2.097kJ, 500kcal",
        hidratos: "66,2 g",
        polialcoholes: "",
        azucares: "11 g",
        grasas: "24 g",
        saturadas: "3,1 g",
        fibra: "",
        sal: " 1,6 g",
        proteinas: "4,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      jummy: {
        family: "jummy",
        type: "left",
        titulo: "Jummy",
        cantidadValor: "100g",
        hashtag: "#Jummy",
        intro: "<strong>¡Ha nacido una estrella!</strong>",
        introDos:
          " <br>Producto de aperitivo horneado con sabor a<br> mantequilla.",
        introMovil: "Producto de aperitivo horneado con sabor a mantequilla.",
        ingredientes:
          "Sémola de maíz (68%), aceite de girasol, aroma de mantequilla [sustancias aromatizantes, maltodextrina, suero de leche, sal, azúcar, acidulante (ácido cítrico), potenciadores del sabor (E-621 y E-635)]. <u>Puede contener soja.</u>",
        packs: "90g, 100g",
        energia: "1.968kJ, 469kcal",
        hidratos: "67,7 g",
        polialcoholes: "",
        azucares: "3,5 g",
        grasas: "19 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: " 1,9 g",
        proteinas: "5,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "risketos-original": {
        family: "risketos",
        type: "left",
        titulo: "Risketos Original",
        cantidadValor: "100g",
        hashtag: "#RisketosOriginal",
        intro:
          "Para los amantes de los auténticos Risketos, en su <strong>sabor original</strong>.",
        introDos: " Crujientes y con el característico sabor a queso.",
        introMovil:
          "Para los amantes de los auténticos Risketos, en su <strong>sabor original</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (26,5 %), aceite de girasol (9 %), aroma de <u>queso</u> [aroma (contiene <u>leche</u>), potenciador del sabor (glutamato monosódico) y colorante (extracto de pimentón)], sal y emulgente (E-471).",
        packs: "40g, 80g, 120g, 135g, 250g (XXL)",
        energia: "2.317kJ, 556kcal",
        hidratos: "53,5 g",
        azucares: "2,3 g",
        polialcoholes: "",
        grasas: "35,5 g",
        saturadas: "3,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,5 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "risketos-xhot": {
        family: "risketos",
        type: "left",
        titulo: "Risketos XtraHot",
        cantidadValor: "100g",
        hashtag: "#RisketosXtraHot",
        intro:
          "Los Risketos para los más atrevidos.  Igual de crunchy que todos pero con otra actitud. Ultrapicantes y supersabrosos",
        introDos: "",
        introMovil:
          "Los Risketos para los más atrevidos.  Igual de crunchy que todos pero con otra actitud. Ultrapicantes y supersabrosos",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (26,5%), aceite de girasol (9%), aroma de <u>queso</u> picante [aroma (contiene leche) y colorante (extracto de pimentón)], sal y emulgente (E-471). Puede contener <u>soja.</u> ",
        packs: "40g, 120g, 135g",
        energia: "2.366kJ, 567Kcal",
        hidratos: "55,4 g",
        polialcoholes: "",
        azucares: "2,8 g",
        grasas: "36 g",
        saturadas: "3,7 g",
        fibra: "",
        sal: "0,7 g",
        proteinas: "4,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "triskys-original": {
        family: "triskys",
        type: "left",
        titulo: "Triskys Original",
        cantidadValor: "100g",
        hashtag: "#TriskysOriginal",
        intro:
          "Tus Triskys de toda la vida, los auténticos aperitivos de maí­z, <strong>crujientes</strong>",
        introDos: " <strong>y redondos</strong> en su sabor original.",
        introMovil:
          "Tus Triskys de toda la vida, los auténticos aperitivos de maí­z <strong>crujientes</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (20%), almidón de maíz, sal, gasificante (bicarbonato sódico), emulgente (E-471), acidulante (ácido cítrico), corrector de acidez (E-526) y aroma. Puede contener <u>leche y soja</u>.",
        packs: "20g, 35g, 85g, 115g, 135g",
        energia: "1.961kJ, 467kcal",
        hidratos: "67,1 g",
        polialcoholes: "",
        azucares: "0,4 g",
        grasas: "20 g",
        saturadas: "1,8 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "4,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "triskys-jamon": {
        family: "triskys",
        type: "right",
        titulo: "Triskys Jamón",
        cantidadValor: "100g",
        hashtag: "#TriskysJamón",
        intro: "<strong>Sabor sabroso</strong>",
        introDos: " con un toque único que no te dejará indiferente.",
        introMovil:
          "<strong>Sabor sabroso</strong> con un toque único que no te dejará indiferente.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (20%), almidón de maíz, sal, aromas [aroma, aroma de humo, suero de <u>leche</u>, potenciador del sabor (E-621), colorante (extracto de pimentón), maltodextrina] gasificante (bicarbonato sódico), emulgente (E-471), acidulante (ácido cítrico) y corrector de acidez (E-526). Puede contener <u>soja</u>.",
        packs: "35g",
        energia: "1.944kJ, 463kcal",
        hidratos: " 65,9g",
        polialcoholes: "",
        azucares: "1,8 g",
        grasas: " 20 g",
        saturadas: "1,7 g",
        fibra: "",
        sal: " 2,5g",
        proteinas: "4,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "triskys-barbacoa": {
        family: "triskys",
        type: "left",
        titulo: "Triskys Barbacoa",
        cantidadValor: "100g",
        hashtag: "#TriskysBarbacoa",
        intro: "La novedad de la casa, un sabor intenso llega a tus Triskys,",
        introDos:
          " <strong>el sabor de una auténtica y crujiente parrilla</strong>.",
        introMovil:
          " <strong>El sabor de una auténtica y crujiente parrilla</strong> llega a tus Triskys.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (20,3 %), almidón de maíz, sal, aroma de salsa barbacoa [aroma, azúcar, maltodextrina, especias, potenciador del sabor (E-621) y edulcorante (E-954)], gasificante (bicarbonato sódico), emulgente (E-471), acidulante (ácido cítrico) y corrector de acidez (E-526). Puede contener <u>leche y soja</u>.",
        packs: "115g, 135g",
        energia: "1.967kJ, 469kcal",
        hidratos: "65,4 g",
        polialcoholes: "",
        azucares: "2,8 g",
        grasas: "21 g",
        saturadas: "1,8 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "4,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      buscalios: {
        family: "otros-productos",
        type: "left",
        titulo: "Buscalios",
        cantidadValor: "100g",
        hashtag: "#Buscalios",
        intro:
          "Deliciosas y crujientes fajitas de maí­z con intenso sabor a barbacoa,",
        introDos:
          " <br>así son los Buscalíos de Risi. <strong>¡Descubre el auténtico sabor del oeste!</strong>",
        introMovil:
          "Deliciosas y crujientes fajitas de maí­z con intenso sabor a barbacoa.",
        ingredientes:
          "Maíz, aceite de girasol alto oleico (23 %), aroma barbacoa [aroma, aroma de humo, azúcar, sal, maltodextrina, dextrosa, potenciadores del sabor (E-621 y E-635), almidón, acidulante (ácido cítrico) y colorante (extracto de pimentón)].",
        packs: "35g, 140g",
        energia: "2.102kJ, 502kcal",
        hidratos: "64,4 g",
        polialcoholes: "",
        azucares: "3,4 g",
        grasas: "24,1 g",
        saturadas: "2,4 g",
        fibra: "",
        sal: "1,6 g",
        proteinas: "6,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "clasicas-originales": {
        family: "otros-productos",
        type: "left",
        titulo: "Clásicas Originales",
        cantidadValor: "125g",
        hashtag: "#PatatasClásicasRisi",
        intro:
          "Nuestras patatas <strong>clásicas onduladas y con sal</strong>.",
        introDos: " <br>¡Las patatas más crujientes del mundo mundial!",
        introMovil:
          "Nuestras patatas <strong>clásicas onduladas y con sal</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (31%) y sal. Puede contener <u>proteína de leche</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.328kJ, 558kcal",
        hidratos: "54,1 g",
        polialcoholes: "",
        azucares: "1,0 g",
        grasas: "34,8 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-originales": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Originales",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasRisi",
        intro:
          "Nuestras patatas clásicas onduladas <strong>crujientes y con sal</strong>.",
        introDos: " <br>¡Descubre todas nuestras variedades de sabor!",
        introMovil:
          "Nuestras patatas clásicas onduladas <strong>crujientes y con sal</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (32.1 %) y sal. Puede contener <u>proteína de leche</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.206kJ, 529kcal",
        hidratos: "54,5 g",
        polialcoholes: "",
        azucares: "0,8 g",
        grasas: "32,1 g",
        saturadas: "3,9 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "5,4 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-campesinas": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Campesinas",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasCampesinas",
        intro:
          "Nuestras onduladas <strong>sabor campenisas</strong>, el sabor más campesino.",
        introDos: "",
        introMovil:
          "Nuestras onduladas <strong>sabor campenisas</strong>, el sabor más campesino.",
        ingredientes:
          "Patatas, aceite de girasol (34,5 %), aroma campesinas [aroma, aroma de humo, azúcar, sal (1,2 %), potenciadores del sabor (E-621 y E-635), colorante (extracto de pimentón) y tomate en polvo (0,1 %)]. Puede contener <u>proteína de leche</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.288kJ, 549kcal",
        hidratos: "53,5 g",
        polialcoholes: "",
        azucares: "1,6 g",
        grasas: "34,5 g",
        saturadas: "4,3 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-jamon": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Jamón",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasJamón",
        intro:
          "Nuestras onduladas <strong>sabor jamón</strong>, el sabor más serrano.",
        introDos: "",
        introMovil:
          "Nuestras onduladas <strong>sabor jamón</strong>, el sabor más serrano.",
        ingredientes:
          " Patatas, aceite de girasol (32.2 %), aroma jamón [aroma, aroma de humo, maltodextrina, azúcar, sal y acidulante (ácido cítrico)]. Puede contener <u>proteína de leche.</u>",
        packs: "30g, 50g, 125g",
        energia: "2.338kJ, 561kcal",
        hidratos: "50,4 g",
        polialcoholes: "",
        azucares: "1,6 g",
        grasas: "37,7 g",
        saturadas: "4,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-cheese-onion": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Cheese & Onion",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasCheeseOnion",
        intro: "Nuestra sabrosa versión con <strong>queso y cebolla</strong>.",
        introDos: "",
        introMovil:
          "Nuestra sabrosa versión con <strong>queso y cebolla</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (34,4 %), aroma <u>queso</u> y cebolla [aroma, especias, suero <u>lácteo</u>, sal, azúcar y potenciadores del sabor (E-621 y E-635)].",
        packs: "125g",
        energia: "2.285kJ, 548kcal",
        hidratos: "51,6 g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "35,2 g",
        saturadas: "4,2 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,2 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "onduladas-vinagreta": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Vinagreta",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasVinagreta",
        intro:
          "No te pierdas un <strong>sabor único a vinagreta</strong> para tus patatas onduladas.",
        introDos: "",
        introMovil:
          "No te pierdas un <strong>sabor único a vinagreta</strong> para tus patatas onduladas.",
        ingredientes:
          "Patatas, aceite de girasol (30.4 %), aroma de vinagre y sal. Puede contener <u>proteína de leche.</u>",
        packs: "125g",
        energia: "2.188kJ, 525kcal",
        hidratos: "51,7 g",
        azucares: "1,0 g",
        polialcoholes: "",
        grasas: "33,6 g",
        saturadas: "4,0 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "3,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      toscana: {
        family: "otros-productos",
        type: "left",
        titulo: "Clásicas Toscana",
        cantidadValor: "125g",
        hashtag: "#PatatasClásicasToscana",
        intro: "Patatas fritas lisas <strong>sabor toscana</strong>.",
        introDos: "",
        introMovil: "Patatas fritas lisas <strong>sabor toscana</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (30%), aroma toscana [azúcar, sal, fibra de guisante, tomate en polvo, maltodextrina, aromas, cebolla en polvo, dextrosa, perejil, pimentón, ajo en polvo, acidulante (ácido cítrico), colorante (extracto de pimentón), grasa de coco, cayena y pimienta negra]. Puede contener <u>proteína de leche.</u>",
        packs: "125g",
        energia: "2.144kJ, 513kcal",
        hidratos: "53,8 g",
        polialcoholes: "",
        azucares: "1,5 g",
        grasas: "30g",
        saturadas: "3,5 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      tejitas: {
        family: "otros-productos",
        type: "left",
        titulo: "Tejitas",
        cantidadValor: "100g",
        hashtag: "#TejitasRisi",
        intro:
          "Las legendarias Tejitas, con <strong>sabor a queso</strong> que se desharán en tu boca.",
        introDos: "",
        introMovil:
          "Las legendarias Tejitas, un <strong>sabor a queso</strong> que se desharán en tu boca.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (22%), aroma de <u>queso</u> [aroma, maltrodextrina, <u>lactosa</u>, azúcar, suero <u>lácteo</u>, potenciadores del sabor (E-621 y E-635), acidulante (ácido cítrico)] y sal. Puede contener <u>mostaza.</u>",
        packs: "35g, 100g",
        energia: "2.202kJ, 526kcal",
        hidratos: "65,6 g",
        polialcoholes: "",
        azucares: "4,1 g",
        grasas: "26,7 g",
        saturadas: "4,6 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      surtis4u: {
        family: "otros-productos",
        type: "left",
        titulo: "Surtis",
        cantidadValor: "100g",
        hashtag: "#Surtis",
        intro:
          "Nuestro mix más especial, disfruta de <strong>nuestros mejores productos en una sola bolsa</strong>.",
        introDos: "",
        introMovil:
          "Nuestro mix más especial, disfruta de <strong>nuestros mejores productos</strong>.",
        ingredientes:
          "Maíz, aceite de girasol (27 %), aromas de salsa barbacoa y <u>queso</u> [aroma (contiene <u>leche</u>), aroma de humo, azúcar, aroma, potenciador del sabor (glutamato monosódico) y colorante (extracto de pimentón)], almidón de maíz, sal, gasificante (bicarbonato sódico), emulgente (mono y diglicéridos de ácidos grasos), acidulante (ác. cítrico) y corrector de acidez (hidróxido de calcio).",
        packs: "37g, 110g",
        energia: "2.209kJ, 528kcal",
        hidratos: "60,6 g",
        polialcoholes: "",
        azucares: "1,0 g",
        grasas: "29,1 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      pajitas: {
        family: "otros-productos",
        type: "left",
        titulo: "Pajitas",
        cantidadValor: "100g",
        hashtag: "#PajitasdeRisi",
        intro: "Si piensas en algo crujiente y sabroso…¡No falla!",
        introDos:
          " <br>Te viene a la mente las inconfundibles Pajitas de Risi al punto de sal. <br><strong>¡Elige con o sin Kétchup!</strong>",
        introMovil: "Pajitas de Risi al punto de sal.",
        ingredientes:
          "Fécula de patata (52%), aceite de girasol alto oleico (19%), patata deshidratada (13%), almidón modificado de patata (6%), aroma de patata [aroma, maltodextrina, almidón y potenciadores del sabor (E-621 y E-635)], sal y emulgente (E-471). Puede contener <u>proteína de leche.</u>",
        packs: "20g, 100g",
        energia: "2.059kJ, 491kcal",
        hidratos: "69,8 g",
        polialcoholes: "",
        azucares: "1,2 g",
        grasas: "22,7 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "1,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "pajitas-ketchup": {
        family: "otros-productos",
        type: "left",
        titulo: "Pajitas Kétchup",
        cantidadValor: "100g",
        hashtag: "#PajitasDeKétchupRisi",
        intro: "Las mí­ticas y crujientes con <strong>sabor Kétchup</strong>.",
        introDos: "",
        introMovil:
          "Las mí­ticas y crujientes con <strong>sabor Kétchup</strong>.",
        ingredientes:
          "Fécula de patata (51%), aceite de girasol alto oleico (20%), patata deshidratada (13%), almidón modificado de patata (6%), aroma de ketchup [azúcar, extracto de levadura, fructosa, tomate, cebolla y ajo en polvo, aroma, acidulante (ácido cítrico y málico), pimentón], sal y emulgente (E-471), y colorante (extracto de pimentón). Puede contener <u>proteína de leche.</u>",
        packs: "20g, 100g",
        energia: "2.012kJ, 480kcal",
        hidratos: "64,1 g",
        polialcoholes: "",
        azucares: "2,0 g",
        grasas: "22,9 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "4,4 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      trikers: {
        family: "otros-productos",
        type: "left",
        titulo: "Trikers",
        cantidadValor: "45g y 100g",
        hashtag: "#TrikersRisi",
        intro:
          "Delicioso aperitivo con auténtico sabor Tex Mex. Sin gluten y sin colorantes artificiales ¡Más por menos! ",
        introDos: "No te resistas...",
        introMovil:
          "Delicioso aperitivo con auténtico sabor Tex Mex. No te resistas...",
        ingredientes:
          " Maíz, aceite de girasol alto oleico (27.8 %), aroma tex mex [maltodextrina, dextrosa, sal, almidón de maíz, extractos de levadura, cebolla, tomate y ajo en polvo, aromas, grasa de coco, cloruro de potasio, acidulantes (ácido cítrico, ácido láctico y lactato de calcio), colorantes (extracto de pimentón y E-160b) y cayena] y pimentón dulce. Puede contener <u>proteína de leche</u>.",
        packs: "45g, 110g, 180g",
        energia: "2166kJ, 518kcal",
        hidratos: "60,8 g",
        polialcoholes: "",
        azucares: "2,1 g",
        grasas: "27,8 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "espelta-integral": {
        family: "desayuno",
        type: "left",
        titulo: "BSAN 0% Espelta",
        packs: "480g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinLactosa: "1",
        bajoSal: "1",
        intro:
          "Deliciosas galletas <strong>0% azúcar finas y sabrosas</strong>.",
        introDos:
          " <br>Con espelta, cereal milenario, reconocido por sus múltiples propiedades nutricionales.",
        introMovil:
          "Deliciosas galletas <strong>0% azúcar finas y sabrosas</strong>.",
        ingredientes:
          "Harina integral de <u>trigo espelta</u> (50 %), edulcorantes (maltitol y jarabe de maltitol), harina de <u>trigo</u> (17%), aceite de girasol alto oleico, almidón de patata, harina de malta de <u>cebada</u> (1,9%), gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), harina de <u>trigo</u> con salvado (1%), aromas, emulgente (lecitina de girasol), colorante (E-150d) y conservador (<u>metabisulfito</u> potásico). Puede contener trazas de <u>soja</u>, proteína de la <u>leche</u> y <u>sésamo</u>",
        cantidadValor: "100g",
        hashtag: "#BSanEspeltaIntegral",
        energia: "1.782 kJ, 425 kcal",
        hidratos: "63,9 g",
        polialcoholes: "15 g",
        azucares: "1,0 g",
        grasas: "16,0 g",
        saturadas: "1,4 g",
        fibra: "6,6 g",
        sal: "0,19g",
        proteinas: "9,2 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      integral: {
        family: "desayuno",
        type: "left",
        titulo: "BSAN 0% con sésamo",
        packs: "160g y 480g",
        hasIntegral: "1",
        bajoAzucares: "1",
        bajosal: "1",
        intro:
          "Exquisitas galletas <strong>0% azúcar, integrales con calcio y sésamo</strong>.",
        introDos: "",
        introMovil:
          "Exquisitas galletas <strong>0% azúcar, integrales con calcio y sésamo</strong>.",
        ingredientes:
          " Harina de <u>trigo</u> (48%), edulcorantes (maltitol, jarabe de maltitol), harina de <u>trigo</u> con salvado (16%), aceite de girasol alto oleico, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), <u>sésamo</u> (2,5%), almidón de patata, harina de malta de <u>cebada</u> (1,9%), carbonato cálcico, aroma, emulgente (lecitina de girasol), colorante (E-150d), conservador (<u>metabisulfito</u> potásico). Puede contener trazas de <u>soja</u> y proteína de <u>leche</u>. <strong>RECOMENDACIONES</strong>: Un consumo excesivo puede producir efectos laxantes.",
        cantidadValor: "100g",
        hashtag: "#BSanConSésamo",
        energia: "1.848 kJ, 441 kcal",
        hidratos: "68,0 g",
        polialcoholes: "16,1 g",
        azucares: "3,0 g",
        grasas: "17,2 g",
        saturadas: "1,6 g",
        fibra: "3,6 g",
        sal: "0,19 g",
        proteinas: "8,2 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      supermaria: {
        family: "tradicionales",
        type: "left",
        titulo: "Súper María 0%",
        packs: "432g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        sinhuevo: "1",
        intro: "Las María de toda la vida, más deliciosas que nunca.",
        introDos: " <br><strong>Enriquecidas con sésamo</strong>.",
        introMovil:
          "Las María de toda la vida, <strong>enriquecidas con sésamo</strong>.",
        ingredientes:
          "Harina de <u>trigo</u>, Harina de <u>trigo</u> con salvado, harina de trigo (22%),  aceite de girasol alto oleico, edulcorante (maltitol),  semillas de <u><strong>sésamo</u></strong> (3%), zumo concentrado de manzana, almidón de patata,  gasificantes (carbonatos de sodio y carbonatos de amonio), emulgente (lecitina de girasol), aroma, conservador (<u>metabisulfito</u> potásico). Puede contener trazas de <u>proteína de leche</u> y <u>soja</u>.",
        cantidadValor: "100g",
        hashtag: "#VirginiaSúperMaría",
        energia: "1.976 kJ, 472 kcal",
        hidratos: "65,0g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "22,0 g",
        saturadas: "3,4 g",
        fibra: "3,6 g",
        sal: "0,21g",
        proteinas: "7,4 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1"
      },
      "bsan-singluten-infantil": {
        family: "tradicionales",
        type: "right",
        type: "right",
        titulo: "BSAN Plus+ Adventure Sin Gluten",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Divertidas y nutritivas galletas para la merienda de los más pequeños de la casa, con maíz, arroz, 5 vitaminas y sin aceite de palma. Además, están certificadas por la Federación de Asociaciones de Celiacos de España (FACE).",
        introDos: "",
        introMovil:
          "Divertidas y nutritivas galletas para la merienda de los más pequeños de la casa, con maíz, arroz, 5 vitaminas y sin aceite de palma. Además, están certificadas por la Federación de Asociaciones de Celiacos de España (FACE).",
        ingredientes:
          "Almidón de maíz (28,3%), harina de arroz (21,7%), azúcar, aceite de girasol alto oleico, almidón de patata, proteína de arroz, azúcar líquido invertido, espesantes (goma guar y goma xantana), dextrosa, humectante (sorbitol), aromas, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), emulgente (lecitina de girasol), conservador (<u>metabisulfito</u> potásico) y vitaminas [ácido pantoténico (B5), tiamina (B1), vitamina A, ácido fólico (B9) y vitamina D]. Puede contener <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#BSAN+SinGluten",
        energia: "1.928 kJ, 459 kcal",
        hidratos: "73,7 g",
        azucares: "17 g",
        polialcoholes: "",
        grasas: "16 g",
        saturadas: "1,4 g",
        fibra: "2,4 g",
        sal: "0,08 g",
        proteinas: "4,2 g",
        ocultarSinGluten: "0",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "bsan-singluten-chocolate-infantil": {
        family: "tradicionales",
        type: "right",
        titulo: "BSAN Plus+ Adventure Chocolate Sin Gluten",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Nutritivas y deliciosas galletas ideales para la merienda, con chocolate, maíz, arroz, 5 vitaminas y sin aceite de palma. Además, están certificadas por la Federación de Asociaciones de Celiacos de España (FACE).",
        introDos: "",
        introMovil:
          "Nutritivas y deliciosas galletas ideales para la merienda, con chocolate, maíz, arroz, 5 vitaminas y sin aceite de palma. Además, están certificadas por la Federación de Asociaciones de Celiacos de España (FACE).",
        ingredientes:
          " Almidón de maíz (28,3 %), harina de arroz (21,7%), azúcar, aceite de girasol alto oleico, edulcorantes (maltitol y acesulfame K), almidón de patata, <u>leche</u> entera en polvo, manteca de cacao, pasta de cacao, proteína de arroz, azúcar líquido invertido, espesantes (goma guar y goma xantana), dextrosa, humectante (sorbitol), aromas, emulgentes (lecitina de girasol y <u>soja</u>) gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), conservador (<u>metabisulfito</u> potásico) y vitaminas [ácido pantoténico (B5), tiamina (B1), vitamina A, ácido fólico (B9) y vitamina D].Puede contener trazas de <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#BSAN+SinGlutenChocolate",
        energia: "1.978 kJ, 471 kcal",
        hidratos: "70,9 g",
        polialcoholes: "",
        azucares: "18,6 g",
        grasas: "18,0 g",
        saturadas: "5,5 g",
        fibra: "2,8 g",
        sal: "0,08 g",
        proteinas: "5,0 g",
        ocultarSinGluten: "0",
        mostrarSinLactosa: "0",
        hasFrutosSecos: "1"
      },
      "bsan-plus-infantil": {
        family: "plus",
        type: "right",
        titulo: "BSAN Plus+ Adventure",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "Divertidas y nutritivas galletas para la merienda de los más pequeños de la casa, con cereales, 5 vitaminas y sin aceite de palma.",
        introDos: " ",
        introMovil:
          "Divertidas y nutritivas galletas para la merienda de los más pequeños de la casa, con cereales, 5 vitaminas y sin aceite de palma.",
        ingredientes:
          "Harinas de cereales (64%) (harina de <u>trigo</u>, harina con salvado de <u>trigo</u>, harina de <u>avena</u>, harina de malta de <u>cebada</u>), azúcar, aceite de girasol alto oleico, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), aromas, sal, emulgente (lecitina de girasol), colorante (E-150d) y vitaminas [ácido pantoténico (B5), tiamina (B1), vitamina A, ácido fólico (B9) y vitamina D]. Puede contener trazas de <u>soja</u>, proteína de <u>leche</u>, <u>frutos de cáscara</u>, <u>sésamo</u> y <u>sulfitos</u>.",
        cantidadValor: "100g",
        hashtag: "#BSAN+",
        energia: "2.029 kJ, 484 kcal",
        hidratos: "68,0 g",
        azucares: "21,8 g",
        polialcoholes: "",
        grasas: "20,0 g",
        saturadas: "1,9 g",
        fibra: "2,6 g",
        sal: "1,24 g",
        proteinas: "6,6 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "bsan-plus-chocolate-infantil": {
        family: "plus",
        type: "right",
        titulo: "BSAN Plus+ Adventure Chocolate",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        intro:
          "Nutritivas y deliciosas galletas ideales para la merienda, con chocolate, cereales, 5 vitaminas y sin aceite de palma. ",
        introDos: " ",
        introMovil:
          "Nutritivas y deliciosas galletas ideales para la merienda, con chocolate, cereales, 5 vitaminas y sin aceite de palma.",
        ingredientes:
          "     Harinas de cereales (52%) (harina de <u>trigo</u>, harina con salvado de <u>trigo</u>, harina de <u>avena</u>, harina de malta de <u>cebada</u>), azúcar, aceite de girasol alto oleico, edulcorantes (maltitol y acesulfame K), <u>leche</u> entera en polvo, manteca de cacao, pasta de cacao, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), aromas, sal, emulgentes (lecitina de girasol y <u>soja</u>), colorante (E-150d) y vitaminas [ácido pantoténico (B5), tiamina (B1), vitamina A, ácido fólico (B9) y vitamina D]. Puede contener trazas de <u>frutos de cáscara</u>, <u>sésamo</u> y <u>sulfitos</u>.",
        cantidadValor: "100g",
        hashtag: "#BSAN+Chocolate",
        energia: "1.958 kJ, 466 kcal",
        hidratos: "67,3 g",
        polialcoholes: "",
        azucares: "18,6 g",
        grasas: "18,0 g",
        saturadas: "5,1 g",
        fibra: "2,9 g",
        sal: "0,64 g",
        proteinas: "7,4 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "singluten-digestive": {
        family: "adultas",
        type: "center",
        titulo: "BSAN Sin Gluten Digestive",
        packs: "140g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Galletas Digestive recubiertas de un delicioso e intenso chocolate negro, <strong>70% de cacao</strong>.",
        introDos: "",
        introMovil:
          "Galletas Digestive recubiertas de un delicioso e intenso chocolate negro, <strong>70% de cacao</strong>.",
        ingredientes:
          "Almidón de maíz, harina de arroz, pasta de cacao, azúcar, edulcorantes (maltitol, lactitol y acesulfame K), aceite de girasol alto oleico, manteca de cacao, harina de lino, almidón de patata, cacao en polvo desgrasado, azúcar líquido invertido, proteína de arroz, espesantes (goma guar y goma xantana), dextrosa, humectante (sorbitol), aromas, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), emulgente (lecitina de girasol y de <u>soja</u>). <br><strong>RECOMENDACIONES</strong>: Un consumo excesivo puede producir efectos laxantes. Puede contener <u>leche</u> y <u>frutos de cáscara</u>",
        cantidadValor: "100g",
        hashtag: "#BsanDigestiveChocolate",
        energia: "2070 kJ, 494 kcal",
        hidratos: "60,2 g",
        polialcoholes: "7,8g",
        azucares: "16,5 g",
        grasas: "23,0 g",
        saturadas: "7,0 g",
        fibra: "7,5 g",
        sal: "0,08 g",
        proteinas: "6,9 g",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "cacao-intenso": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Cacao intenso ",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "El placer de una galleta totalmente <strong>bañada de intenso cacao 70%</strong>. ¿Hay algo mejor para un auténtico chocolate lover?",
        introDos: "",
        introMovil:
          "El placer de una galleta totalmente <strong>bañada de intenso cacao 70%</strong>. ¿Hay algo mejor para un auténtico chocolate lover?",
        ingredientes:
          "     Pasta de cacao, harina de <u>trigo</u> (24,8 %), edulcorantes (maltitol, jarabe de maltitol, lactitol y acesulfame K), harina de <u>trigo</u> con salvado (8,2%), manteca de cacao, <u>mantequilla</u> (contiene <u>leche</u>), cacao en polvo desgrasado, harina de <u>avena</u> (1,5%), harina de malta de <u>cebada</u> (1%), almidón de patata, aceite de girasol alto oleico, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), aromas, emulgentes (lecitina de <u>soja</u> y girasol) , fibra vegetal, conservador (<u>metabisulfito</u> potásico) y vitaminas [ácido pantoténico (B5), tiamina (B1), vitamina A, ácido fólico (B9) y vitamina D]. Puede contener trazas de <u>frutos de cáscara</u> y <u>sésamo</u>. <strong>RECOMENDACIONES</strong>: Un consumo excesivo puede producir efectos laxantes.",
        cantidadValor: "80g, 120g",
        hashtag: "#BSAN_0%CacaoIntenso",
        energia: "2.501 kJ, 600 kcal",
        hidratos: "51,0 g",
        polialcoholes: "21,1 g",
        azucares: "4,0 g",
        grasas: "32,4 g",
        saturadas: "15,7 g",
        fibra: "6,8 g",
        sal: "0,1g",
        proteinas: "8,3 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "fabs-vietnam": {
        name: "VIETNAM",
        family: "fabs-vietnam",
        type: "right",
        titulo: "Fabs Origins Vietnam",
        packs: "160g",
        intro:
          "Con nuestro <strong>chocolate más exclusivo</strong>, pues solo el 0,1% del cacao del mundo procede de Vietnam. Peculiar y delicioso sabor ácido gracias al bajo PH de esta tierra.",
        introDos: "",
        introMovil:
          "Con nuestro <strong>chocolate más exclusivo</strong>, pues solo el 0,1% del cacao del mundo procede de Vietnam. Peculiar y delicioso sabor ácido gracias al bajo PH de esta tierra.",
        ingredientes:
          "     Harina de <u>trigo</u>, pasta de cacao, azúcar, <u>mantequilla</u> (contiene <u>leche</u>), manteca de cacao, fibra vegetal, sal, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), emulgente (lecitina de girasol) y aromas.<br>Puede contener trazas de <u>frutos de cáscara</u>, <u>sésamo</u>, <u>soja</u> y <u>sulfitos</u>.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsVietnam",
        energia: "2.144 kJ, 513 kcal",
        hidratos: "54,2 g",
        polialcoholes: "",
        azucares: "21,8 g",
        grasas: "29,0 g",
        saturadas: "17,0 g",
        fibra: "6,7 g",
        sal: "0,4 g",
        proteinas: "8,8 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video: "https://www.youtube.com/watch?v=HReSXTH-ZPg&ab_channel=Risi",
        origen: {
          title: "ORIGEN",
          text:
            "Está elaborado con granos excepcionales de cacao, llamados Trinitarios, que se obtienen principalmente de la región del delta del Mekong. El peculiar y delicioso sabor ácido de este cacao es gracias al bajo PH de esta tierra.",
          img: "mapa-vietnam.png"
        },
        maridaje: {
          title: "MARIDAJE",
          text:
            "Para un maridaje perfecto, acompaña este chocolate con un vino Malbec, para lograr un sabor más dulce; con frutas como la pera o el plátano, que suavizan el sabor, pero sin neutralizarlo; o con menta, que aporta ese frescor que tan bien conecta con el calor del chocolate negro.",
          img: "hoja-vietnam.png"
        },
        notas_cata: {
          img: "cata-vietnam.png"
        }
      },
      "fabs-mexico": {
        name: "MÉXICO",
        family: "fabs-mexico",
        type: "right",
        titulo: "Fabs Origins México",
        packs: "150g",
        intro:
          "Con un cacao procedente de México, esta galleta se caracteriza por un suave y delicioso sabor que no dejará indiferente ni a los <strong>amantes del chocolate</strong> con leche ni a los <strong>amantes de las galletas</strong> crujientes.",
        introDos: "",
        introMovil:
          "Con un cacao procedente de México, esta galleta se caracteriza por un suave y delicioso sabor que no dejará indiferente ni a los <strong>amantes del chocolate</strong> con leche ni a los <strong>amantes de las galletas</strong> crujientes.",
        ingredientes:
          "      Harina de <u>trigo</u>, azúcar, pasta de cacao, <u>leche</u> entera en polvo, manteca de cacao, <u>mantequilla</u> (contiene <u>leche</u>), emulgentes (lecitina de girasol y <u>soja</u>), fibra vegetal, sal, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio) y aromas.<br>Puede contener trazas de <u>frutos de cáscara</u>, <u>sésamo</u> y <u>sulfitos</u>.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsMéxico",
        energia: "2.148 kJ, 513 kcal",
        hidratos: "59,3 g",
        polialcoholes: "",
        azucares: "28,6 g",
        grasas: "27,0 g",
        saturadas: "14,9 g",
        fibra: "4,0 g",
        sal: "0,43g",
        proteinas: "8,3 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video: "https://www.youtube.com/watch?v=oJs1TfT-QSY&ab_channel=Risi",
        origen: {
          title: "ORIGEN",
          text:
            "Este excepcional cacao procede de plantaciones ubicadas en el cálido Golfo de México, y tienen tanta calidad como historia: ya eran cultivadas por los aztecas, los mayas y los toltecas.",
          img: "mapa-mexico.png"
        },
        maridaje: {
          title: "MARIDAJE",
          text:
            "Para un maridaje perfecto, acompaña este chocolate con un vino dulce, que completará el sabor gracias a su aroma afrutado; con caramelo, para potenciar el dulzor del chocolate; o con especias como la canela o el curry, para elevar la experiencia del sabor.",
          img: "hoja-mexico.png"
        },
        notas_cata: {
          img: "cata-mexico.png"
        }
      },
      "fabs-tanzania": {
        name: "TANZANIA",
        family: "fabs-tanzania",
        type: "right",
        titulo: "Fabs Origins Tanzania",
        packs: "150g",
        intro:
          "El chocolate de esta galleta, procedente de los granos de cacao Criollo & Trinitario, ha viajado desde los campos más selectos de Tanzania para crear una <strong>exquisita experiencia</strong> con el <strong>cacao más intenso.</strong>",
        introDos: "",
        introMovil:
          "El chocolate de esta galleta, procedente de los granos de cacao Criollo & Trinitario, ha viajado desde los campos más selectos de Tanzania para crear una <strong>exquisita experiencia</strong> con el <strong>cacao más intenso.</strong>",
        ingredientes:
          "Pasta de cacao, harina de <u>trigo</u> azúcar, <u>mantequilla</u> (contiene <u>leche</u>), manteca de cacao, fibra vegetal, sal, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), emulgente (lecitina de girasol) y aromas.<br>Puede contener trazas de <u>frutos de cáscara</u>, <u>sésamo</u> y <u>sulfitos</u>.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsTanzania",
        energia: "2.154 kJ, 515 kcal",
        hidratos: "54,8 g",
        polialcoholes: "",
        azucares: "18,4 g",
        grasas: "29,0 g",
        saturadas: "17,9 g",
        fibra: "6,7 g",
        sal: "0,4 g",
        proteinas: "8,8 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video:
          "https://www.youtube.com/watch?v=vEWlbRaaOBg&t=1s&ab_channel=Risi",
        origen: {
          title: "ORIGEN",
          text:
            "Respaldado por el Kilimanjaro y rodeado por los Grandes Lagos africanos, la mezcla tropical de las altas temperaturas con estaciones lluviosas crea el clima perfecto para la plantación de cacao de Tanzania.",
          img: "mapa-tanzania.png"
        },
        maridaje: {
          title: "MARIDAJE",
          text:
            "Para un maridaje perfecto, acompaña este chocolate con fruta como el coco y la frambuesa, para completar el toque ácido con la frescura de estos alimentos; con aceite de trufa, para una experiencia aún más compleja; o con canela, para suavizar el sabor amargo con su dulzor.",
          img: "hoja-tanzania.png"
        },
        notas_cata: {
          img: "cata-tanzania.png"
        }
      },
      "maria-sesamo": {
        family: "mariasesamo",
        type: "left",
        titulo: "BSAN 0% Sésamo",
        packs: "480g",
        hasIntegral: "0",
        bajoSal: "1",
        sinLactosa: "1",
        intro:
          "Exquisitas galletas 0% azúcares, <strong>con semillas de sésamo</strong>, que son ricas en grasas saludables, proteínas de origen vegetal y calcio. ",
        introDos: "",
        introMovil:
          "Exquisitas galletas 0% azúcares, <strong>con semillas de sésamo</strong>, que son ricas en grasas saludables, proteínas de origen vegetal y calcio. ",
        ingredientes:
          "     Harina de <u>trigo</u> (48%), edulcorantes (maltitol, jarabe de maltitol), harina de <u>trigo</u> con salvado (16%), aceite de girasol alto oleico, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), <u>sésamo</u> (2,5%), almidón de patata, harina de malta de <u>cebada</u> (1,9%), carbonato cálcico, aroma, emulgente (lecitina de girasol), colorante (E-150d), conservador (<u>metabisulfito</u> potásico). <br>Puede contener trazas de <u>soja</u> y proteína de <u>leche</u>.<br><strong>RECOMENDACIONES<strong/>: Un consumo excesivo puede producir efectos laxantes.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%conSésamo",
        energia: "1.848 kJ, 441 kcal",
        hidratos: "68,0 g",
        polialcoholes: "16,1 g",
        azucares: "3,0 g",
        grasas: "17,2 g",
        saturadas: "1,6 g",
        fibra: "3,6 g",
        sal: "0,19g",
        proteinas: "8,2 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "maria-espelta": {
        family: "mariasesamo",
        type: "left",
        titulo: "BSAN 0% Espelta",
        packs: "480g",
        hasIntegral: "0",
        bajoSal: "1",
        sinLactosa: "1",
        intro:
          "Deliciosas galletas 0% azúcares elaboradas <strong>con espelta</strong>, cereal milenario, de sabor intenso y muy nutritivo.",
        introDos: " ",
        introMovil:
          "Deliciosas galletas 0% azúcares elaboradas <strong>con espelta</strong>, cereal milenario, de sabor intenso y muy nutritivo.",
        ingredientes:
          "Harina integral de <u>trigo espelta</u> (67%), edulcorantes (maltitol y jarabe de maltitol), aceite de girasol alto oleico, almidón de patata, harina de malta de <u>cebada</u> (2%), gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), harina de <u>trigo</u> con salvado (1%), aromas, emulgente (lecitina de girasol), colorante (E-150d) y conservador (<u>metabisulfato</u> potásico).<br>Puede contener trazas de <u>soja</u>, proteína de la <u>leche</u> y <u>sésamo.</u><br><strong>RECOMENDACIONES</strong>: Un consumo excesivo puede producir efectos laxantes. ",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%EspeltaIntegral",
        energia: "1782 kJ, 425 kcal",
        hidratos: "63,9 g",
        polialcoholes: "15,0 g",
        azucares: "1,0 g",
        grasas: "16,0 g",
        saturadas: "1,4 g",
        fibra: "6,6 g",
        sal: "0,19g",
        proteinas: "9,2 g"
      },
      "chocolate-con-leche": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Chocolate con leche",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "El placer de una galleta bañada en <strong>delicioso chocolate con leche.</strong>",
        introDos: "",
        introMovil:
          "El placer de una galleta bañada en <strong>delicioso chocolate con leche.</strong>",
        ingredientes:
          "Edulcorantes (maltitol, jarabe de maltitol y acesulfame K), harina de <u>trigo</u> (24,6%), <u>leche</u> entera en polvo, manteca de cacao, harina de <u>trigo</u> con salvado (8,2%), pasta de cacao, <u>mantequilla</u> (contiene <u>leche</u>), harina de <u>avena</u> (1,5%), harina de malta de <u>cebada</u> (1%), almidón de patata, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), aceite de girasol alto oleico, aromas, emulgentes (lecitina de <u>soja</u> y girasol), fibra vegetal, conservador (<u>metabisulfito</u> potásico) y vitaminas [ácido pantoténico (B5), tiamina (B1), vitamina A, ácido fólico (B9) y vitamina D]. Puede contener trazas de <u>frutos de cáscara</u> y <u>sésamo</u>. <strong>RECOMENDACIONES</strong>: Un consumo excesivo puede producir efectos laxantes.",
        cantidadValor: "80g, 120g",
        hashtag: "#BSAN_0%ChocolateConLeche",
        energia: "2.478 kJ, 593 kcal",
        hidratos: "59,0 g",
        polialcoholes: "31 g",
        azucares: "5,2 g",
        grasas: "27,3 g",
        saturadas: "12,9 g",
        fibra: "3,4 g",
        sal: "0,18g",
        proteinas: "7,5 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-blanco": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0%Chocolate blanco",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "El placer de una galleta bañada en <strong>un suave chocolate blanco.</strong>",
        introDos: "",
        introMovil:
          "El placer de una galleta bañada en <strong>un suave chocolate blanco.</strong>",
        ingredientes:
          "Edulcorantes (maltitol, jarabe de maltitol y acesulfame K), harina de <u>trigo</u> (24,5%), manteca de cacao, <u>leche</u> entera en polvo, harina de <u>trigo</u> con salvado (8,2%), <u>mantequilla</u> (contiene <u>leche</u>), harina de <u>avena</u> (1,5%), gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), harina de malta de <u>cebada</u> (1%), almidón de patata, cacao en polvo desgrasado, aceite de girasol alto oleico, aromas, emulgentes (lecitina de <u>soja</u> y girasol), fibra vegetal, conservador (<u>metabisulfito</u> potásico) y vitaminas [ácido pantoténico (B5), tiamina (B1), vitamina A, ácido fólico (B9) y vitamina D]. Puede contener trazas de <u>frutos de cáscara</u> y <u>sésamo</u>. <strong>RECOMENDACIONES</strong>: Un consumo excesivo puede producir efectos laxantes.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%ChocolateBlanco",
        energia: "2.457 kJ, 591 kcal",
        hidratos: "66,0 g",
        polialcoholes: "33 g",
        azucares: "6,1 g",
        grasas: "24,0 g",
        saturadas: "13,9 g",
        fibra: "1,8 g",
        sal: "0,23g",
        proteinas: "7,0 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-naranja": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Chocolate a la Naranja",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinhuevo: "1",
        chocolatelovers: "1",
        intro:
          "Descubre un sabor muy especial. Galleta de trigo con avena y cebada bañada en delicioso <strong>chocolate a la naranja.</strong>",
        introDos: " ",
        introMovil:
          "Descubre un sabor muy especial. Galleta de trigo con avena y cebada bañada en delicioso <strong>chocolate a la naranja.</strong>",
        ingredientes:
          "Harina de <u>trigo</u> (24,6%), pasta de cacao, edulcorantes (maltitol, jarabe de maltitol, lactitol y acesulfame K), harina de <u>trigo</u> con salvado (8,2%), manteca de cacao, <u>mantequilla</u> (contiene <u>leche</u>), cacao en polvo desgrasado, harina de <u>avena</u> (1,5%), harina de malta de <u>cebada</u> (1%), almidón de patata, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), aceite de girasol alto oleico, <u>leche</u> entera en polvo, aromas, emulgentes (lecitina de <u>soja</u> y  girasol), fibra vegetal, conservador (<u>metabisulfito</u> potásico),  zumo de naranja en polvo (0,04%), vitaminas [ácido pantoténico (B5), tiamina (B1), vitamina A, ácido fólico (B9) y vitamina D] y aceite esencial de naranja (0,01 %)Puede contener trazas de <u>frutos de cáscara</u> y <u>sésamo.</u> <strong>RECOMENDACIONES</strong>: Un consumo excesivo puede producir efectos laxantes.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%ChocolateNaranja",
        energia: "2.375 kJ, 569 kcal",
        hidratos: "52 g",
        polialcoholes: "23,2 g",
        azucares: "3,1 g",
        grasas: "28,4 g",
        saturadas: "15,7 g",
        fibra: "8,3 g",
        sal: "0,13g",
        proteinas: "8,3 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "mix-melon-sandia": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Melón y Sandía 0%",
        packs: "110g",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "Caramelos blandos sin azúcar sabor melón y sandía con edulcorantes.",
        introDos: " ",
        introMovil:
          "Caramelos blandos sin azúcar sabor melón y sandía con edulcorantes.",
        ingredientes:
          "Edulcorantes (maltitol, manitol, sorbitol, glucósidos de esteviol), dextrina, grasa vegetal coco, gelatina bovina, acidulante (ácido cítrico), emulgente (E 471) y aromas (sandía 0,01% y melón 0,01%).<br> Un consumo excesivo puede producir efectos laxantes.",
        hashtag: "#MixMelón&Sandía",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "mix-frutos-rojos": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Frutos Rojos",
        packs: "70g, 110g, 1Kg",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Caramelos masticables con edulcorantes blancos con sabores fresa, arándano y cereza.",
        introDos: "",
        introMovil:
          "Caramelos masticables con edulcorantes blancos con sabores fresa, arándano y cereza.",
        ingredientes:
          "Edulcorantes (maltitol, manitol, sorbitol, glucósidos de esteviol), dextrina, grasa vegetal coco, gelatina bovina, acidulante (ácido cítrico), emulgente (E 471) y aromas (fresa 0,01%, arándano 0,01% y cereza 0,01%). <br>Un consumo excesivo puede producir efectos laxantes.",
        hashtag: "#MixFrutosRojos",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "mix-5-frutas": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix 5 Frutas",
        packs: "70g, 110g, 1Kg",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Caramelos masticables con edulcorantes blancos con sabores piña, naranja, fresa, limón y cereza.",
        introDos: "",
        introMovil:
          "Caramelos masticables con edulcorantes blancos con sabores piña, naranja, fresa, limón y cereza.",
        ingredientes:
          "Edulcorantes (maltitol, manitol, sorbitol, glucósidos de esteviol), dextrina, grasa vegetal coco, gelatina bovina, acidulante (ácido cítrico), emulgente (E 471) y aromas (naranja 0,01%, limón 0,01%, fresa 0,01%, cereza 0,01% y piña 0,01%).<br>Sabores fresa y cereza (solo en formatos de 500g y 1kg).<br> Un consumo excesivo puede producir efectos laxantes.",
        hashtag: "#Mix5Frutas",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      citricos: {
        family: "citrico",
        type: "left",
        titulo: "Cítricos 0%",
        hasFrutosSecos: "1",
        packs: "110g",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "Caramelos sin azúcar sabor naranja y limón con edulcorantes.",
        introDos: "",
        introMovil:
          "Caramelos sin azúcar sabor naranja y limón con edulcorantes.",
        ingredientes:
          "<strong>Caramelo de limón:</strong> Edulcorante (Jarabe de maltitol), ácido cítrico, aroma natural de limón (0,6%), colorante natural curcumina. <strong>Caramelo de naranja:</strong> Edulcorante (Jarabe de maltitol), ácido cítrico, aroma natural de naranja (0,7%), colorante natural betacaroteno naranja, colorante natural betacaroteno amarillo. <br>Puede contener trazas de <u>leche</u>, <u>soja</u> y <u>frutos de cáscara</u>. Un consumo excesivo puede producir efectos laxantes",
        hashtag: "#RisiCítricos",
        energia: "975 kJ, 234 kcal",
        hidratos: "97,5g",
        azucares: "0g",
        polialcoholes: "97,5g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "0g",
        sal: "0g",
        proteinas: "0g"
      },
      stevia: {
        family: "citrico",
        type: "left",
        titulo: "FruitSin Stevia",
        packs: "110g",
        hasFrutosSecos: "1",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Caramelos duros con edulcorantes sabor (cereza, limón, fresa y naranja).",
        introDos: "",
        introMovil:
          ":Caramelos duros con edulcorantes sabor (cereza, limón, fresa y naranja).",
        ingredientes:
          "Edulcorantes (isomalt, glucósido de esteviol 0,05%), acidulante (ácido cítrico), aroma (de cereza 0,5%, de limón 0,5%, de fresa 0,5% y de naranja 0,5%) y colorantes (E 150d, carmín y carotenos).  <br> Un consumo excesivo puede producir efectos laxantes.",
        hashtag: "#RisiFruitSinStevia",
        energia: "1001 kJ, 240 kcal",
        hidratos: "98,9g",
        azucares: "0,15",
        polialcoholes: "99,6g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "0,86g",
        sal: "0g",
        proteinas: "0g"
      },
      balsamicos: {
        family: "balsamicos",
        type: "left",
        titulo: "Glassmins 0%",
        packs: "105g, 500g, 1Kg",
        hasFrutosSecos: "1",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "Caramelos sin azúcar sabor mentolado con edulcorantes.",
        introDos: "",
        introMovil: "Caramelos sin azúcar sabor mentolado con edulcorantes.",
        ingredientes:
          "Edulcorante (jarabe de maltilol), mentol (0,3%), colorante E-131, esencia de eucalipto y edulcorante (E950).<br> Puede contener trazas de <u>leche</u>, <u>soja</u> y <u>frutos de cáscara</u>. Un consumo excesivo puede producir efectos laxantes.",
        hashtag: "#RisiGlassmins",
        energia: "968 kJ, 232 kcal",
        hidratos: "96,8g",
        azucares: "0g",
        polialcoholes: "96.8g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "mix-variado": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Surtido de Frutas",
        packs: "150g, 500g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        sinlactosa: "1",
        intro:
          "Caramelos blandos con sabor a limón, piña, naranja, fresa y plátano.",
        introDos: "",
        introMovil:
          "Caramelos blandos con sabor a limón, piña, naranja, fresa y plátano.",
        ingredientes:
          "Jarabe de glucosa, azúcar, dextrina, grasa vegetal coco, gelatina bovina, aromas (naranja 0,01%, limón 0,01%, fresa 0,01%, piña 0,01% y plátano 0,01%), acidulante (ácido cítrico), emulgente (E 471) y colorantes (cúrcuma, carmín, carotenos). <br>Sabor piña (solo en formatos de 500g y 1kg).",
        hashtag: "#MixFrutasDelSol",
        energia: "1476 kJ, 377 kcal",
        hidratos: "88g",
        azucares: "82g",
        grasas: "2,7g",
        polialcoholes: "",
        saturadas: "2,3g",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "azucares-gajos": {
        family: "citrico",
        type: "left",
        titulo: "Gajos",
        packs: "70g, 150g, 500g, 1Kg",
        hasFrutosSecos: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "Caramelos con sabor a naranja y limón.",
        introDos: "",
        introMovil: "Caramelos con sabor a naranja y limón.",
        ingredientes:
          "<strong>Caramelo de naranja:</strong> Jarabe de glucosa, azúcar, ácido cítrico, aroma de naranja (0,6%), colorante natural betacaroteno amarillo y colorante natural betacaroteno naranja. <strong>Caramelo de limón:</strong> Jarabe de glucosa, azúcar, ácido cítrico, aroma de limón (0,5%) y colorante natural curcumina. Puede contener trazas de <u>leche</u>, <u>soja</u> y <u>frutos de cáscara</u>",
        hashtag: "#FrutasDelSolGajos",
        energia: "1.652 kJ, 389 kcal",
        hidratos: "97,2g",
        polialcoholes: "",
        azucares: "49,6",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      doble: {
        family: "citrico",
        type: "left",
        titulo: "Dooble",
        packs: "70g, 150g, 500g, 1Kg",
        hasFrutosSecos: "1",
        hasGluten: "0",
        sinlactosa: "0",
        intro: "Caramelos dobles con sabor a plátano, fresa o piña.",
        introDos: "",
        introMovil: "Caramelos dobles con sabor a plátano, fresa o piña.",
        ingredientes:
          "<strong>Caramelo de Piña:</strong> Jarabe de glucosa, azúcar, ácido cítrico, aroma de piña (0,4%) y colorante natural curcumina. <strong>Caramelo de Plátano:</strong> Jarabe de glucosa, azúcar, aroma de plátano (1%), ácido cítrico y colorante natural curcumina. <strong>Caramelo de Fresa:</strong> Jarabe de glucosa, azúcar, aroma de fresa (1,6%), ácido cítrico, y colorante natural antocianina.",
        hashtag: "#FrutasDelSolDooble",
        energia: "1.652 kJ, 389 kcal",
        hidratos: "97,2g",
        polialcoholes: "",
        azucares: "49,6",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "frutas-acidas": {
        family: "citrico",
        type: "left",
        titulo: "Frutas Ácidas",
        packs: "150g",
        hasFrutosSecos: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro: "Caramelos con sabor a limón, naranja, manzana y fresa.",
        introDos: "",
        introMovil: "Caramelos con sabor a limón, naranja, manzana y fresa.",
        ingredientes:
          "<strong>Caramelo de limón:</strong> Jarabe de glucosa, azúcar, ácido cítrico, aroma de limón (0,4%) y colorante natural de curcumina. <strong>Caramelo de manzana:</strong> Jarabe de glucosa, azúcar, ácido cítrico, aroma de manzana (0,8%), colorante natural curcumina y colorante natural clorofila. <strong>Caramelo de naranja:</strong> Jarabe de glucosa, azúcar, ácido cítrico, aroma de naranja (0,6%), colorante natural betacaroteno amarillo y colorante natural betacaroteno naranja. <strong>Caramelo de fresa:</strong> Jarabe de glucosa, azúcar, ácido cítrico, aroma de fresa (1,9%), colorante natural antocianina y colorante natural betacaroteno naranja. <br>Puede contener trazas de <u>leche</u>, <u>soja</u> y <u>frutos de cáscara</u>.",
        hashtag: "#FrutasDelSolÁcidas",
        energia: "1.650 kJ, 388 kcal",
        hidratos: "97,05g",
        azucares: "36,1g",
        grasas: "0g",
        polialcoholes: "",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "nueces-en-grano": {
        family: "frutos-secos",
        type: "left",
        titulo: "Nueces en grano",
        packs: "50g, 90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Nueces sin cáscara y en grano, uno de los frutos secos por excelencia.",
        introDos:
          "Saludables y sabrosas a partes iguales. Un alimento básico que no puede faltar en casa.",
        introMovil:
          "Nueces sin cáscara y en grano, uno de los frutos secos por excelencia.",
        ingredientes:
          "Nueces en grano de california. Contiene <u>nueces</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#NuecesEnGrano",
        energia: "2.745 kJ, 666 kcal",
        hidratos: "2,5 g",
        polialcoholes: "",
        azucares: "1,8 g",
        grasas: "64 g",
        saturadas: "6,3 g",
        fibra: "",
        sal: "<0,01 g",
        proteinas: "16 g",
        mostrarSinLactosa: "1"
      },
      "pistachos-tostados": {
        family: "frutos-secos",
        type: "left",
        titulo: "Pistachos tostados y al punto de sal",
        packs: "50g, 80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Pistachos, uno de los frutos secos favoritos de pequeños y mayores. Tostados y con un toque de sal.",
        introDos:
          " Úsalos como ingrediente para recetas o como snack, ¡Tú eliges!",
        introMovil:
          "Pistachos, uno de los frutos secos favoritos de pequeños y mayores. Tostados y con un toque de sal.",
        ingredientes:
          "Pistachos y sal. Contiene <u>pistachos</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#PistachosTostados",
        energia: "2.565 kJ, 620 kcal",
        hidratos: "6,4 g",
        polialcoholes: "",
        azucares: "6,4 g",
        grasas: "52 g",
        saturadas: "6,5 g",
        fibra: "",
        sal: "1,3 g",
        proteinas: "26 g",
        mostrarSinLactosa: "1"
      },
      "cacahuetes-fritos": {
        family: "frutos-secos",
        type: "left",
        titulo: "Cacahuetes fritos y salados",
        packs: "80g, 110g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "Una peli o una serie no serían lo mismo sin unos cacahuetes.",
        introDos:
          " Tostados, crujientes y sabrosos gracias a su punto de sal idóneo. Un indispensable en tu despensa.",
        introMovil:
          "Una peli o una serie no serían lo mismo sin unos cacahuetes.",
        ingredientes:
          "<u>Cacahuete</u> sin piel, aceite vegetal de girasol y sal. Contiene <u>cacahuete</u>. Puede contener trazas de <u>frutos secos</u>",
        cantidadValor: "100g",
        hashtag: "#CacahuetesFritos",
        energia: "2.617 kJ, 632 kcal",
        hidratos: "8,2 g",
        polialcoholes: "",
        azucares: "4,2 g",
        grasas: "53 g",
        saturadas: "8,7 g",
        fibra: "",
        sal: "0,96 g",
        proteinas: "27 g",
        mostrarSinLactosa: "1"
      },
      "anacardos-fritos": {
        family: "frutos-secos",
        type: "left",
        titulo: "Anacardos fritos y salados",
        packs: "55g, 80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Saborea un snack delicioso y saludable perfecto para el picoteo entre horas.",
        introDos: " ",
        introMovil:
          "Saborea un snack delicioso y saludable perfecto para el picoteo entre horas.",
        ingredientes:
          "<u>Anacardo</u>, aceite vegetal de girasol y sal. Contiene <u>anacardo</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#AnacardosFritos",
        energia: "2.552 kJ, 615 kcal",
        hidratos: "26 g",
        polialcoholes: "",
        azucares: "5,1 g",
        grasas: "48 g",
        saturadas: "9,5 g",
        fibra: "",
        sal: "0,07 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "avellanas-tostadas": {
        family: "frutos-secos",
        type: "left",
        titulo: "Avellanas tostadas",
        packs: "80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Disfruta de las deliciosas avellanas como snack y  como el topping crujiente perfecto, para tus postres.",
        introDos: "",
        introMovil:
          "Disfruta de las deliciosas avellanas como snack y  como el topping crujiente perfecto, para tus postres.",
        ingredientes:
          "<u>Avellana</u> en grano. Contiene <u>avellana</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#AvellanasTostadas",
        energia: "2.910 kJ, 706 kcal",
        hidratos: "2,7 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "67 g",
        saturadas: "5,5 g",
        fibra: "",
        sal: "0,03 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "almendras-fritas": {
        family: "frutos-secos",
        type: "left",
        titulo: "Almendras fritas y saladas",
        packs: "55g, 90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Almendras fritas y saladas, un toque crujiente y salado perfecto para alegrarte cualquier momento. ¡Si las compartes todavía saben mejor!",
        introDos:
          " Tostadas y crujientes gracias a su proceso de elaboración. ¡Qué no falten en la despensa!",
        introMovil:
          "Sí piensas en frutos secos, seguro que piensas en almendras. Uno de los frutos secos más clásicos.",
        ingredientes:
          "<u>Almendra</u> sin piel, aceite vegetal de girasol y sal. Contiene <u>almendra</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#AlmendrasFritas",
        energia: "2.526 kJ, 611 kcal",
        hidratos: "52 g",
        azucares: "4,3 g",
        polialcoholes: "",
        grasas: "52 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "0,80 g",
        proteinas: "25 g",
        mostrarSinLactosa: "1"
      },
      "mix-frito": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix frito",
        packs: "70g, 100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "El clásico mix de frutos secos, el que nunca falla, ",
        introDos: "¡disfruta de su variedad de sabores y texturas!",
        introMovil: "El clásico mix de frutos secos, el que nunca falla,",
        ingredientes:
          "Maíz frito y salado, <u>cacahuete</u> sin piel frito y salado, <u>cacahuete</u> con piel frito y salado, garbanzos tostados, habas fritas y saladas, aceite vegetal de girasol y sal. Contiene <u>cacahuete</u>. Puede contener trazas de <u>frutos secos con cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#MixFrito",
        energia: "1.814kJ, 436 kcal",
        hidratos: "30 g",
        azucares: "2,5 g",
        polialcoholes: "",
        grasas: "28 g",
        saturadas: "4 g",
        fibra: "",
        sal: "1,5 g",
        proteinas: "14 g",
        mostrarSinLactosa: "1"
      },
      "mix-bbq": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix barbacoa",
        packs: "80g, 100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Perfecto para aquellos que buscan juntar en un solo bocado la textura",
        introDos:
          " y propiedades de los frutos secos con el intenso sabor de la barbacoa.",
        introMovil:
          "Perfecto para aquellos que buscan juntar en un solo bocado la textura",
        ingredientes:
          "<u>Cacahuete</u> frito y salado (cacahuete con piel, cacahuete sin piel, aceite vegetal de girasol, sal) producto de aperitivo horneado sabor barbacoa (sémola de maíz, sémola de arroz, azúcar, aceite vegetal de girasol, aroma de barbacoa, (aromas, aroma de humo, maltodextrina, sal, potenciadores de sabor: E-621 y E-631), maíz frito sabor barbacoa (maíz, aceite vegetal de girasol, sal, condimento barbacoa, (hierbas, maltodextrina, especias, tomate seco, sal, aroma de humo), potenciador del sabor E-621) <u>cacahuete</u> con cobertura sabor de barbacoa (cacahuete, harina de maíz, sal, azúcar, almidón modificado de maíz, almidón de maíz, aceite vegetal de girasol, condimento barbacoa (maltodextrina, especias, tomate seco, sal, aroma de humo), potenciador del sabor E-621. Contiene <u>cacahuetes</u>. Puede contener <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#MixBBQ",
        energia: "2.150kJ, 518 kcal",
        hidratos: "25 g",
        azucares: "4 g",
        polialcoholes: "",
        grasas: "37 g",
        saturadas: "5,8 g",
        fibra: "",
        sal: "1,7 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "mix-picante": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix picante",
        packs: "90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "Mezcla de cacahuetes fritos y salados,",
        introDos: " maíz frito y producto de aperitivo horneado sabor chili.",
        introMovil: "Mezcla de cacahuetes fritos y salados",
        ingredientes:
          "<u>Cacahuete</u> frito y salado (cacahuete con piel, cacahuete sin piel, aceite vegetal de girasol, sal), maíz frito con sabor a chili (maíz, aceite vegetal de girasol, condimento chili (maltodextrina, cebolla, pimienta, tomate seco, ajo, pimentón, cayena, sal), sal, aceite de pimentón (colorante (extracto de pimentón)), potenciador de sabor(E-621)) y producto de aperitivo horneado con sabor a chili (sémola de maíz, sémola de arroz, aceite vegetal de girasol, azúcar, aroma de chili (aromas, potenciadores de sabor (E-621, E-631, E-627)), colorante (extracto de pimentón)) y sal.",
        cantidadValor: "100g",
        hashtag: "#MixPicante",
        energia: "2.159kJ, 517 kcal",
        hidratos: "44 g",
        azucares: "3,6 g",
        polialcoholes: "",
        grasas: "30 g",
        saturadas: "4,1 g",
        fibra: "5,7 g",
        sal: "1,9 g",
        proteinas: "15 g",
        mostrarSinLactosa: "1"
      },
      "avellanas-tostadas-1kg": {
        family: "frutos-secos-1kg",
        type: "left",
        titulo: "Avellanas tostadas",
        packs: "1kg",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "Disfruta de las deliciosas avellanas tanto como snack, ",
        introDos:
          " como el topping crujiente y dulce perfecto para tus postres.",
        introMovil: "Disfruta de las deliciosas avellanas tanto como snack",
        ingredientes:
          "<u>Avellana</u> con piel. Contiene <u>Avellana</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#AvellanaTostada",
        energia: "2.910 kJ, 706 kcal",
        hidratos: "2,7 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "67 g",
        saturadas: "5,5 g",
        fibra: "",
        sal: "0,03 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "pipas-saladas": {
        family: "pipas",
        type: "left",
        titulo: "Pipas Saladas",
        packs: "40g, 90g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Pipas saladas, de las de toda la vida, de esas que cuando empiezas, ya no paras.",
        introDos: "",
        introMovil:
          "Pipas saladas, de las de toda la vida, de esas que cuando empiezas, ya no paras.",
        ingredientes:
          "Semillas de girasol, sal y harina de arroz. Puede Contener trazas de <u>cacahuete</u> y <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#PipasSaladas",
        energia: "2.561kJ, 619 kcal",
        polialcoholes: "",
        hidratos: "3,3 g",
        azucares: "3,3 g",
        grasas: "52 g",
        saturadas: "6,4 g",
        fibra: "11 g",
        sal: "7,1 g",
        proteinas: "29 g",
        mostrarSinLactosa: "1"
      },
      "pipas-aguasal": {
        family: "pipas",
        type: "left",
        titulo: "Pipas Aguasal",
        packs: "90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Cualquier momento y lugar es bueno para disfrutar de las pipas de girasol Aguasal.",
        introDos: "¿Empezamos?",
        introMovil:
          "Cualquier momento y lugar es bueno para disfrutar de las pipas de girasol Aguasal.",
        ingredientes:
          "Semillas de girasol y sal. Puede Contener trazas de <u>cacahuete</u> y <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#PipasAguasal",
        energia: "2.589kJ, 626 kcal",
        hidratos: "4,8 g",
        azucares: "3,1 g",
        grasas: "52 g",
        saturadas: "6,7 g",
        polialcoholes: "",
        fibra: "9,2 g",
        sal: "2,3 g",
        proteinas: "30 g",
        mostrarSinLactosa: "1"
      },
      "mix-antiox": {
        family: "mix-antiox",
        type: "left",
        titulo: "Mix Antiox",
        packs: "100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "La combinación rica en antioxidantes perfecta para tus ensaladas:",
        introDos:
          " California, almendras, pistachos, pasas, pipas de girasol y arándanos. ¡ A disfrutar!",
        introMovil:
          "La combinación rica en antioxidantes perfecta para tus ensaladas.",
        ingredientes:
          "<u>Almendras</u> peladas crudas, semillas de girasol peladas crudas, trozos de <u>nueces</u>, arándanos desecados (arándanos, azúcar, aceite vegetal de girasol), uvas pasas sin semilla (pasas y aceite vegetal de girasol) y <u>pistachos</u> en grano crudos. Puede contener <u>cacahuetes</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#MixAntiox",
        energia: "2.297kJ, 554 kcal",
        hidratos: "24 g",
        azucares: "24 g",
        polialcoholes: "",
        grasas: "42 g",
        saturadas: "4,2 g",
        fibra: "",
        sal: "0,01 g",
        proteinas: "17 g",
        mostrarSinLactosa: "1"
      },
      "mix-equilibrio": {
        family: "mix-equilibrio",
        type: "left",
        titulo: "Mix Equilibrio",
        packs: "100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Si buscas un picoteo sano, sabroso y 100% saludable, el Mix Equilibrio es la opción perfecta para ti.",
        introDos: "",
        introMovil:
          "Si buscas un picoteo sano, sabroso y 100% saludable, el Mix Equilibrio es la opción perfecta para ti.",
        ingredientes:
          "<u>Avellanas</u> crudas peladas, <u>almendras</u> crudas peladas, <u>nueces pecanas</u> en grano crudas, trozos de <u>nueces</u>. Contiene <u>avellanas, almendras, pecanas y nueces</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#MixEquilibrio",
        energia: "2.781kJ, 674 kcal",
        hidratos: "3,1 g",
        azucares: "2,9 g",
        polialcoholes: "",
        grasas: "64 g",
        saturadas: "5,6 g",
        fibra: "",
        sal: "0 g",
        proteinas: "16 g",
        mostrarSinLactosa: "1"
      },
      "patata-sal-al-punto": {
        family: "patata-sal-al-punto",
        type: "left",
        titulo: "Sal al punto",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Las patatas de toda la vida, sencillas con el punto perfecto de sal. De esas <strong>tan irresistibles</strong>, que si las pruebas <strong>no podrás parar de comer.</strong>",
        introDos: "",
        introMovil:
          "Las patatas de toda la vida, sencillas con el punto perfecto de sal. De esas <strong>tan irresistibles</strong>, que si las pruebas <strong>no podrás parar de comer.</strong>",
        ingredientes:
          "Patatas, aceite de girasol (26 %) y sal (1,4%). Puede contener <u>proteína de leche</u>.",
        cantidadValor: "125g",
        hashtag: "#SalAlPunto",
        energia: "2.002kJ, 479 kcal",
        hidratos: "54,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        mostrarSinLactosa: "1"
      },
      campesinas: {
        family: "campesinas",
        type: "left",
        titulo: "Campesinas",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Unas deliciosas patatas con un <strong>toque aromático de hierbas</strong> que recuerda el campo mas auténtico y fresco.",
        introDos: "",
        introMovil:
          "Unas deliciosas patatas con un <strong>toque aromático de hierbas</strong> que recuerda el campo mas auténtico y fresco.",
        ingredientes:
          "Patatas, aceite de girasol (26%), aroma campesina [azúcar, sal, dextrosa, potenciadores del sabor (E-621 y E-635), cebolla, perejil, tomate y ajo en polvo, extracto de levadura, acidulantes (ácido málico y ácido cítrico), colorante (extracto de pimentón) y aroma de humo]. Puede contener <u>proteína de leche.</u>",
        cantidadValor: "125g",
        hashtag: "#Campesinas",
        energia: "1.974kJ, 472 kcal",
        hidratos: "53,5 g",
        azucares: "1,6 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "6 g",
        mostrarSinLactosa: "1"
      },
      vinagreta: {
        family: "vinagreta",
        type: "left",
        titulo: "Vinagreta",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Las mejores patatas con un <strong>sabor intenso a vinagreta</strong> y un toque de sal. Los auténticos fans de los sabores avinagrados no podrán resistirse a ellas.",
        introDos: "",
        introMovil:
          "Las mejores patatas con un <strong>sabor intenso a vinagreta</strong> y un toque de sal. Los auténticos fans de los sabores avinagrados no podrán resistirse a ellas.",
        ingredientes:
          "Patatas, aceite de girasol (26%), aroma de vinagre y sal [aromas, sal (1,4%), azúcar, maltodextrina y acidulantes (ácido cítrico y ácido málico)]. Puede contener <u>proteína de leche.</u>",
        cantidadValor: "125g",
        hashtag: "#Vinagreta",
        energia: "1.907kJ, 456 kcal",
        hidratos: "51,7 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "3,9 g",
        mostrarSinLactosa: "1"
      },
      "jamon-onduladas": {
        family: "jamon-onduladas",
        type: "left",
        titulo: "Jamón",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "¿Quién puede resistirse a una crujiente patata ondulada con el mejor sabor a jamón? <strong>Flipa con el sabor intenso</strong> de estas deliciosas y míticas patatas.",
        introDos: "",
        introMovil:
          "¿Quién puede resistirse a una crujiente patata ondulada con el mejor sabor a jamón?<strong>",
        ingredientes:
          "Patatas, aceite de girasol (25%), aroma jamón [maltodextrina, sal, aroma, aroma de humo y acidulante (ácido málico)]. Puede contener <u>proteína de leche.</u>",
        cantidadValor: "125g",
        hashtag: "#Jamón",
        energia: "2.048kJ, 490 kcal",
        hidratos: "57,5 g",
        azucares: "0,5 g",
        polialcoholes: "",
        grasas: "25 g",
        saturadas: "3,2 g",
        fibra: "",
        sal: "1,6 g",
        proteinas: "6,4 g",
        mostrarSinLactosa: "1"
      },
      "originales-onduladas": {
        family: "originales-onduladas",
        type: "left",
        titulo: "Originales",
        packs: "125g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Las patatas mas crujientes e intensas, con el toque salado perfecto. Onduladas e <strong>irresistiblemente crunchy.</strong>",
        introDos: "",
        introMovil:
          "Las patatas mas crujientes e intensas, con el toque salado perfecto. Onduladas e <strong>irresistiblemente crunchy.</strong>",
        ingredientes:
          "Patatas, aceite de girasol (32.1 %) y sal (1,4%). Puede contener <u>proteína de leche.</u>",
        cantidadValor: "125g",
        hashtag: "#Originales",
        energia: "2.206kJ, 529 kcal",
        hidratos: "54,5 g",
        azucares: "0,8 g",
        polialcoholes: "",
        grasas: "32,1 g",
        saturadas: "3,9 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "5,4 g",
        mostrarSinLactosa: "1"
      },
      "sour-cream-onion": {
        family: "sour-cream-onion",
        type: "left",
        titulo: "Sour Cream & Onion",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Para los amantes de los sabores intensos de <strong>Crema Agria & Cebolla</strong>, llega este sabor tan especial sobre una base de patata natural, crujiente y sorprendente",
        introDos: "",
        introMovil:
          "Para los amantes de los sabores intensos de <strong>Crema Agria & Cebolla</strong>, llega este sabor tan especial sobre una base de patata natural, crujiente y sorprendente",
        ingredientes:
          "Patatas, aceite de girasol (26%), aroma nata acidificada y cebolla [aromas, harina de arroz, sal, azúcar, maltodextrina, acidulantes (ácido cítrico y ácido málico) y regulador de acidez (E-327)]. <u>Puede contener proteína de leche</u>",
        cantidadValor: "125g",
        hashtag: "#SourCreamOnion",
        energia: "2.082kJ, 498 kcal",
        hidratos: "57,4 g",
        azucares: "1,7 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,5 g",
        proteinas: "6,2 g",
        mostrarSinLactosa: "1"
      },
      "york-queso": {
        family: "york-queso",
        type: "left",
        titulo: "York&Queso",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "La mejor combinación del mundo mundial, <strong>no hay mejor match que el jamón con el queso</strong> en estas crujientes patatas. Uooohhhh",
        introDos: "",
        introMovil:
          "La mejor combinación del mundo mundial, <strong>no hay mejor match que el jamón con el queso</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (26%), aroma jamón y queso [aroma (contiene leche), aroma de humo, sal, maltodextrina, azúcar y colorante (extracto de pimentón)].",
        cantidadValor: "125g",
        hashtag: "#YorkQueso",
        energia: "2.090kJ, 500 kcal",
        hidratos: "58 g",
        azucares: "2,9 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,3 g",
        mostrarSinLactosa: "1"
      },
      "selectas-clasicas": {
        family: "selectas-clasicas",
        type: "left",
        titulo: "Selectas Clásicas",
        packs: "100g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Las patatas más artesanas, fritas cuidadosamente en sartén. Verdadero <strong>sabor a origen y tradición</strong> en un solo bocado.",
        introDos: "",
        introMovil:
          "Las patatas más artesanas, fritas cuidadosamente en sartén. Verdadero <strong>sabor a origen y tradición</strong> en un solo bocado.",
        ingredientes:
          "Patatas, aceite de girasol (30 %) y sal. Puede contener <u>proteína de leche.</u>",
        cantidadValor: "125g",
        hashtag: "#SelectasClásicas",
        energia: "2.328kJ, 558 kcal",
        hidratos: "54,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "34,8 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        mostrarSinLactosa: "0"
      }
    },
    historia: {
      inicio: "Inicio",
      nuestra: "Nuestra",
      historia: "historia",
      descrip1:
        "El rojo de Palomitas, el verde Gusanitos y el blanco de los Risketos…¿Qué niño nacido entre la década de los 70 y hasta hoy no reconoce estos colores?",
      descrip2: "Te contamos cómo empezó todo…. ¡Esta es nuestra historia!",
      yummy1970: "Desde 1970<br>especialistas en snacking",
      nuestros: "Nuestros",
      origenes: "Orígenes",
      descrip3:
        "El carácter emprendedor de la familia Gómez-Cuétara hizo que adquiriese en 1970 la compañía Chips Ibérica S.A.situada en Torrejón de Ardoz.",
      descrip4:
        "La fábrica, se acondicionó y modernizó para dedicarse exclusivamente a la fabricación de patatas fritas, el principal aperitivo conocido en España por entonces.",
      unaSonrisa: "¡Una sonrisa ante",
      momentos: "momentos adversos!",
      descrip5:
        "En 1975 toda la ilusión puesta en este incipiente proyecto se vió truncada por un incendio que destruyó totalmente la fábrica y toda su maquinaria.",
      plantarCara: "¡Plantar cara a la adversidad!",
      descrip6:
        "La fortaleza y carácter optimista de la familia fundadora evitó que en esos críticos momentos se diera todo por perdido. ¡Al contrario! fue en esa etapa cuando se decide trasladar la fábrica de Torrejón de Ardoz a Daganzo de Arriba. ¡Pero no solo eso! Además se apuesta por ampliar la fabricación de patatas fritas, a snacks y aperitivos de maíz.",
      yAhoraSi: "¡Y ahora si, Risi!",
      descrip7:
        "Nacen las marcas más famosas de Risi: Gusanitos, Palomitas, Pajitas, Triskys y Risketos. Siempre acompañadas de uno de los elementos más valiosos y reconocibles de la marca hasta nuestros días, su logo, el niño con la eterna sonrisa.",
      risiLogo: "Risi Logo",
      descrip8: "¿Cómo se pasó de la fábrica de patatas",
      descrip9: "fritas a la producción de snacks?",
      descrip10:
        "Todo gracias a la incorporación del extrusionado de maíz. Una técnica que permitía dar formas distintas  a la materia prima mediante presión y temperatura.",
      epocaDorada: "¡Una época dorada!",
      descrip11:
        "Entre los años 80 y 90 Risi era conocido y admirado por todos los niños españoles.",
      descrip12:
        "¿Quién no recuerda ver bolsitas Risi en las mochilas del cole, en los recreos, en los parques, tiendas y quioscos del barrio y en todos los cumpleaños?",
      descrip13: "Afrontamos los problemas con una sonrisa",
      descrip14:
        "A pesar del éxito de los snacks y su gran aceptación entre el público, llegan nuevos problemas a la compañía que terminan provocando su cierre durante un año.",
      descrip15:
        "Sin embargo en Risi, lo que nunca falta es la sonrisa, así que la compañía tras su cierre, es adquirida por un gran emprendedor, Juan Gómez- Cuétara, quien con visión, esfuerzo y un equipo de excelentes  colaboradores consiguieron revertir la situación.Tras unos años de mucho trabajo, entrega y dedicación situaron a Risi como una de las empresas líderes de la categoría.",
      nuevoCambio: "¡Un nuevo cambio!",
      estrenamos: "¡Estrenamos",
      fabrica: "fábrica!",
      descrip16:
        "Bajo el mando de Juan Gómez-Cuétara y del nuevo equipo de colaboradores, Risi alcanza su récord histórico en ventas.El éxito de nuestros productos hace necesario construir nuevas instalaciones con la última tecnología y espacio suficiente para hacer frente a la gran demanda.",
      descrip17:
        "Risi adquiere una fábrica de Patatas Fritas en el municipio de Loeches. Para potenciar la gama, además de las clásicas se unen las Patatas fritas onduladas y las Clásicas fritas en sartén.",
      descrip18:
        "Se produce un cambio generacional pasando a dirigir la compañía Juan y Marta Gómez-Cuétara abordando un  ilusionante periodo de  profesionalización y crecimiento.",
      descrip19:
        "Risi celebra su 40 aniversario con un aumento de las ventas del 7%",
      descrip20:
        "Fue un año muy importante para Risi, decidimos revolucionar nuestro negocio. La compañía apuesta por dos nuevas categorías: galletas y caramelos.",
      hoyYSiempreContigo: "Hoy y siempre  contigo",
      cumplimos50: "¡Cumplimos 50 años a vuestro lado!",
      celebralo: "Celébralo con nosotros",
      viajamosFabs:
        " <strong>¡Viajamos a México, Tanzania y Vietnam con FABS ORIGIN!</strong><br>Lanzamos FABS ORIGIN, unas finísimas galletas bañadas con chocolate, de los mejores cacaos del mundo, que ofrecen un placer inigualable y lleno de sabor a los amantes de los momentos  más auténticos. <br> ¡En Risi, seguimos innovando!",
      presentamos:
        "¡Os presentamos las (nuevas) patatas de toda la vida, las de Risi!",
      descrip21:
        " Esas deliciosas patatas que hacemos desde 1970, seguimos hoy elaborándolas con el mismo cariño y las recetas de siempre. Y es que en Risi, no tenemos secretos ni  fórmulas mágicas, simplemente hacemos buenas patatas fritas, con os mejores ingredientes y sabores auténticos.",
      slide2:
        "Una gran flota de vehículos de transporte pesado y ligero, tiene RISI a través de toda España para que sus productos lleguen a todos los lugares de la Península",
      slide2_1:
        "Las PATATAS FRITAS son transportadas hasta la red nacional de Distribuciones RISI, para de ahí pasar mediante los vendedores a tiendas, bares, cafeterias...etc etc",
      slide2_2:
        "Y en la mañana, cuando el sol comienza a levantar en el horizonte, la actividad comercial de RISI empieza a llenar los almacenes de vida y movimiento.",
      forLittle: "Relanzamos una gama para los más pequeños de la casa:",
      descrip22:
        "Las nuevas BSAN PLUS+, con una imagen más divertida que nunca y un nuevo compañero de aventuras, Nikoala. Tienen un perfil nutricional ideal para la merienda ya que están elaboradas con cereales, enriquecidas con 5 vitaminas y sin aceite de palma, y además vienen en 4 cómodas bolsitas individuales para llevar."
    },
    risihoy: {
      especialistas: "Especialistas en snacks y aperitivos",
      subtitulo:
        "Somos una empresa española familiar con más de 50 años de historia, especialistas en la fabricación de snacks y aperitivos.",
      descrip1:
        "<strong>La pasión y dedicación por nuestro trabajo</strong> nos ha llevado a en la actualidad <strong>fabricar más de 250 millones de bolsitas de aperitivos</strong>, en más de 60 presentaciones, figurando entre ellas nuestros emblemáticos <strong>Gusanitos, Palomitas, Risketos, Triskys</strong> y nuestro snack más adulto, <strong>Míos!</strong>",
      "descrip1-1":
        "Pero por supuesto, tenemos mucho más…. ¡Descubre todos nuestros aperitivos y snacks!",
      "descrip1-2":
        "Además, <strong>desde el 2019</strong>, a nuestra familia de aperitivos y snacks se han unido las <strong>galletas y caramelos</strong>.",
      descubre: "Descubre nuestros productos",
      nuestrosValores: "Nuestros valores",
      descrip2:
        "Durante más de 50 años de historia, la fidelidad a nuestros principales valores nos ha permitido ser hoy una marca líder en nuestro sector.",
      equipo: "Equipo",
      descrip3:
        "Queremos <strong>una organización</strong> formada por personas que desarrollan su potencial contribuyendo al objetivo común e interrelacionándose para conseguirlo, <strong>con intereses corporativos</strong> alineados con los individuales.",
      simplificacion: "Simplificación",
      descrip4:
        "Queremos una organización en las que las cosas <strong>sean fáciles</strong> y en la que los procesos, la información <strong>y las actividades resulten ágiles</strong>, sin tiempos ni complicaciones innecesarias.",
      felicidad: "Felicidad",
      descrip5:
        "Queremos una organización en la que <strong>se respire buen ambiente</strong> tanto colectivo como individual, con personas comunicativas, positivas y sonrientes que disfruten en el  trabajo y con el resto de personas de la empresa.",
      integridad: "Integridad",
      descrip6:
        "Queremos una organización formada por personas con <strong>sólidos valores</strong> profundos dispuestas a crecer y a hacer crecer al resto de compañeros y a la organización, en un contexto en el que la persona se sitúa en el centro.",
      liderazgo: "Liderazgo Individual",
      descrip7:
        "Queremos una organización formada por personas capaces de hacer que ocurran cosas. <strong>Personas que desplieguen su máximo potencial</strong> individual dentro de un contexto de pertenencia de equipo"
    },
    bannerRsc: {
      titulo: "Compromisos",
      subtitulo:
        "En RISI trabajamos para ofrecer momentos de felicidad, conscientes de que estos momentos no serán duraderos si no están asentados en el cuidado del medioambiente y de las personas, especialmente nuestros empleados y consumidores. Con este objetivo, desarrollamos un firme compromiso con la sostenibilidad, que se asienta en tres líneas de acción: <strong>compromisos ambientales, compromiso con las personas y Buen Gobierno</strong>.",
      descrip1:
        "Nuestro Estado de Información no Financiera detalla nuestros objetivos en materia de sostenibilidad y los avances alcanzados en el último año.",
      informeRsc: "Informe EINF 2023"
    },
    codigoconducta: {
      titulo: "Código de<br>Conducta",
      subtitulo: "Risi cumple contigo </br> y gracias a ti cumplimos con todos",
      download: "Descargar código de conducta",
      cartapresidente: {
        titulo: "CARTA",
        descrip1: "Estimados todos:",
        descrip2:
          "Nuestra compañía ya tiene 50 años de existencia, en 1,970 emprendimos el ilusionante camino que nos ha llevado hasta lo que hoy somos. En estos años hemos crecido, hemos evolucionado y hemos ido añadiendo señas de identidad a nuestra compañía.",
        descrip3:
          "La <strong>Misión y la Visión</strong> son el foco de nuestra vida empresarial, pero esto no sería suficiente si no le añadimos los <strong>Valores</strong>, que son la cultura de nuestra empresa, nuestros núcleo y ADN, que deben regir nuestro modo de hacer las cosas en el presente y nos ayudarán a transformar el futuro.",
        descrip4:
          "Este esfuerzo debe ir acompañado por un <strong>Código de Conducta</strong> que lleve al máximo nivel a nuestra organización y que la preparen para afrontar los requerimientos legislativos, la defensa de los derechos humanos y  competir en un futuro cambiante. Este código deberá presidir todas nuestras actuaciones, tanto a nivel interno como en nuestras relaciones con nuestros consumidores, clientes, proveedores y con la sociedad.",
        descrip5:
          "Os animo a que lo leáis, reflexionéis acerca de su contenido y que lo hagáis parte de vuestro día a día. La suma de los comportamientos de todos los que formamos parte de la empresa es una responsabilidad conjunta para cuya puesta en práctica contamos contigo.",
        descrip6:
          "Solo me resta dar las gracias a todas las personas que en estos 50 años han hecho de Risi una gran empresa.",
        descrip7: "Un cordial saludo,"
      },
      principiosgenerales: {
        titulo: "Principios<br>generales",
        subtitulo: "Transformando<br>el futuro con valores",
        vision: "Visión",
        descrip1:
          "Desarrollar un negocio basado en marcas y conseguir ser actores de primera línea del mercado nacional de compra “por impulso”.",
        mision: "Misión",
        descrip2:
          "Alcanzaremos un <strong>crecimiento orgánico</strong> por encima del mercado que nos haga ganar cuota de forma sostenible/rentable.",
        descrip3:
          "El logro se basará en el conocimiento de nuestros clientes/canales y consumidores potenciando las marcas, el trade marketing, la visibilidad y <strong>la capilaridad</strong>.",
        descrip4:
          "Desarrollaremos un sistema de distribución en el canal impulso que nos permita de forma efectiva llegar a la mayor cantidad de clientes y puntos de venta.",
        descrip5:
          "<strong>La aportación de la innovación y nuevos negocios contribuirán al crecimiento de la compañía por encima del negocio tradicional.</strong>",
        alcance: "Alcance",
        descrip6:
          "Atendiendo al entorno normativo actual, el Consejo de Administración de Risi ha decidido elaborar el presente Código de Conducta con la finalidad de mantener y propugnar los más altos estándares éticos en el desarrollo de la actividad empresarial de la Compañía.",
        descrip7:
          "Este documento tiene la vocación de servir de guía para la actuación de todos los empleados, directivos y administradores, inspirando la toma de decisiones cotidianas y la actividad diaria de Risi.",
        descrip8:
          "El Código de Conducta es de obligado cumplimiento para los órganos de gobierno de Risi, tanto los directivos como empleados, con independencia de su función y ubicación geográfica y para el conjunto de actividades o acciones corporativas que realicemos. Asimismo, debe ser una guía en nuestras relaciones con colaboradores y terceros.",
        descrip9:
          "A este respecto el Consejo de Administración de Risi ha acordado el nombramiento de un <strong>Responsable de Cumplimiento</strong> que tiene encomendada, entre otras funciones, asegurar el despliegue, ayuda y entendimiento de todos los colaboradores, así como la verificación periódica del efectivo cumplimiento del Código de Conducta."
      },
      risiempleados: {
        titulo: "Risi y sus<br>empleados",
        comportamientos: "Comportamientos",
        descrip1:
          "La Compañía se compromete a <strong>prevenir y corregir</strong> cualquier manifestación o conducta susceptible de ser considerada violenta, de acoso en cualquiera de sus modalidades, discriminatoria o intimidatoria así como a hacer<strong>respetar los derechos</strong> de todos los que trabajamos en RISI.",
        descrip2:
          "Por su parte, los empleados y directivos y administradores de RISI se comprometen a evitar y denunciar cualquiera de estas conductas, así como a esforzarse por mantener un ambiente de trabajo que favorezca el pleno desarrollo profesional de toda la plantilla.Por ello, deberá imperar el respeto a nuestros valores como guía de nuestros actos: el liderazgo individual, la integridad, la felicidad, la simplificación y el trabajo en equipo.",
        confidencialidad: "Confidencialidad",
        descrip3:
          "RISI se compromete a <strong>respetar el carácter reservado y confidencial</strong> de la información personal facilitada en el marco de sus relaciones y a no divulgarlos de acuerdo al estricto  cumplimiento de la normas aplicables.",
        descrip4:
          "Todos los que por su actividad accedan a información confidencial de la Compañía o de terceros colaboradores, se comprometen a guardar la máxima confidencialidad y secreto sobre la misma.",
        usomedios: "Uso de medios informáticos",
        descrip5:
          "RISI pone a disposición de sus empleados y directivos los medios necesarios para el desempeño de su actividad, así como los mecanismos para la adecuada salvaguarda de los mismos.",
        descrip6:
          "Los empleados y directivos de la compañía se comprometen a utilizar de forma responsable los medios propiedad de RISI utilizándolos para fines profesionales. Si bien, <strong>podrán utilizarlos con carácter no profesional</strong>, de un modo comedido, siendo conscientes de que<strong>en los medios informáticos puestos a disposición por la empresa no existe expectativa de privacidad</strong>, pudiendo quedar su uso registrado en las bases de datos propiedad de la compañía, susceptible de ser objeto de revisión por RISI, siempre de conformidad con la Ley aplicable y con las garantías previstas en la normativa interna, respetando en todo caso los derechos fundamentales de los trabajadores.",
        descrip7:
          "Asimismo, no se podrán instalar ni utilizar programas o aplicaciones que infrinjan derechos de cualquier naturaleza, que sean susceptibles de dañar dichos recursos o puedan ser empleados con fines ilícitos.",
        conflictosIntereses: "Conflictos de interés",
        descrip8:
          "Los empleados y directivos de RISI deben <strong>proteger los intereses de la compañía</strong> así como velar por su buena reputación, evitando actuar en contra de sus intereses.",
        descrip9:
          "En el caso en que cualquier colaborador de Risi realice alguna actividad o transacción donde pudiera tener cualquier tipo de interés personal, deberá ponerlo en conocimiento de su director de área o del responsable de cumplimiento para que le indique el modo de proceder.",
        comunicacion: "Comunicación externa",
        descrip10:
          "Las declaraciones públicas sobre RISI o en su nombre, tanto en medios tradicionales como en redes sociales, pueden influir en la imagen de la compañía y en sus relaciones con la sociedad. Por este motivo disponemos de procedimientos y áreas para su gestión  y cualquier acción en este sentido <strong>solo podrá realizarse por aquellas personas expresamente autorizadas para ello.</strong>",
        derechosLaborales: "Respeto a los derechos laborales",
        descrip11:
          "Risi se compromete a respetar los derechos laborales de sus empleados y facilitar un entorno de trabajo seguro y saludable para todos.​",
        descrip12:
          "Dicho compromiso incluye unas condiciones seguras de trabajo para cualquiera que visite nuestras instalaciones y conseguir así los más altos estándares de calidad.​",
        descrip13:
          "Todos los empleados deben respetar las leyes en materia de seguridad y salud en el trabajo, así como la normas y políticas que se implanten en esta materia, y denunciar cualquier situación que suponga un riesgo grave para la salud y seguridad de los trabajadores.",
        descrip14:
          "De igual forma en Risi respetamos los derechos de negociación colectiva y libertad de afiliación de los empleados.​",
        derechosHumanos: "Respeto a los derechos humanos",
        descrip15:
          "Risi respeta los derechos humanos y prohíbe cualquier comportamiento que vaya en contra de los mismos.​",
        descrip16:
          "Por este motivo, promovemos un comportamiento justo y adecuado de todas las personas que trabajan en el ámbito de su actividad que proteja los derechos humanos y no sean cómplices en su vulneración.​",
        discriminacion: "No discriminación",
        descrip17:
          "Risi considera que sus empleados constituyen su activo más valioso y se preocupa por la promoción de una cultura diversa e inclusiva, basada en un ambiente de trabajo abierto y estimulante. ​",
        descrip18:
          "Nos comprometemos a ofrecer a nuestros empleados un entorno de trabajo justo y ético, una política retributiva basada en el desempeño y sistemas de evaluación y promoción objetivos y no discriminatorios.​"
      },
      risiconsumidores: {
        titulo: "Risi y sus<br>consumidores",
        descrip1:
          "Nuestros consumidores son la base de nuestra existencia. Por esto nuestra prioridad es satisfacer sus expectativas sobre los pilares de producto seguro, fresco  y con la mayor calidad.",
        descrip2:
          "En Risi se trabaja, a través de la <strong>gestión de la calidad y de la seguridad alimentaria</strong> para mejorar constantemente los productos y los procesos de fabricación, evitar y corregir errores y seguir mejorando en la seguridad,  calidad e innovación de nuestros productos.",
        descrip3:
          "A tal efecto nos comprometemos a mantener nuestro sistema de calidad y seguridad alimentaria auditado y certificado por entidades externas acreditadas.",
        descrip4:
          "Risi está comprometida con una <strong>comunicación ética y responsable</strong>, tanto en nuestra publicidad como en el etiquetado. Por esto y atendiendo a las especiales necesidades de nuestro consumidor más joven, estamos adheridos voluntariamente a los <strong>códigos PAOS y NAOS</strong> del Ministerio, sometiendo nuestra publicidad a la supervisión externa e independiente de <strong>AUTOCONTROL</strong>.",
        descrip5:
          "De la misma manera ponemos a disposición de nuestros consumidores diversos canales de comunicación para la tramitación de cualquier consulta o reclamación con el objetivo de cercanía y mejora continua.",
        descrip6: "Estos son nuestros datos de contacto"
      },
      risiproveedores: {
        titulo: "Risi y sus clientes<br>y proveedores",
        descrip1:
          "RISI, en su <strong>relación con los clientes</strong>, se compromete a trabajar bajo normas de estrategia de mercado compartida, transparencia, información y protección.",
        descrip2:
          "Risi aplicará criterios de objetividad, transparencia e imparcialidad en la selección de <strong>proveedores y suministradores</strong>, evitando conflictos de interés o favoritismos en su selección.",
        descrip3:
          "El <strong>compromiso con la calidad del producto y de servicio</strong> regirá las relaciones de Risi con los clientes y proveedores.",
        descrip4:
          "Risi considera a clientes y proveedores eslabones vitales para el desarrollo de su actividad, por eso  trataremos siempre con respeto a las personas, seremos rigurosos con los compromisos adquiridos de calidad de producto y servicio, así como cualquier otro contractual y desplegaremos nuestros valores corporativos en <strong>nuestras</strong> relaciones. Nos esforzaremos en convencer a  clientes y proveedores para que interioricen los beneficios de este Código."
      },
      risisociedad: {
        titulo: "Risi y la<br>sociedad",
        medioAmbiente: "Medio ambiente",
        descrip0:
          "En Risi conocemos perfectamente nuestra <strong>responsabilidad hacia el medio ambiente</strong> y por tanto es prioritario la aplicación de medidas que garanticen el máximo respeto al mismo, maximizando los esfuerzos para alcanzar en su conjunto la sostenibilidad ambiental en todas nuestras actividades. En nuestra actividad empleamos medidas de seguridad para evitar perjuicios ambientales.",
        descrip1:
          "A tal efecto nos comprometemos a mantener nuestro sistema medioambiental auditado y certificado por entidades externas acreditadas.",
        mercados: "Mercados",
        descrip2:
          "Risi se compromete a <strong>competir en los mercados de forma leal</strong>, de acuerdo a nuestro valor de integridad, impulsando la libre competencia en beneficio del consumidor y evitando cualquier conducta contraria a la legislación aplicable en materia de competencia.",
        infoFinanciera: "Información financiera y tributación",
        descrip3:
          "Risi garantiza la <strong>realidad y máxima transparencia</strong> de la información financiera de la Compañía, de conformidad con los principios contables previstos en las normas nacionales e internacionales.",
        descrip4:
          "Asimismo, los empleados y directivos de la compañía se comprometen al respeto de las normas internas de Risi en materia de facturación, pagos y reembolsos.",
        descrip5:
          "Risi es consciente de su responsabilidad corporativa en materia de cumplimiento de sus <strong>obligaciones tributarias y de seguridad social</strong>. Por ello, en sus operaciones, Risi, sus empleados y directivos se ceñirán siempre a las leyes aplicables.",
        prevencion: "Prevención de corrupción y otras conductas ilegales",
        descrip6:
          "En Risi se limita la entrega y recepción de regalos, prohibiendo aquellos que tengan por objeto el <strong>soborno</strong> o pretendan influenciar en quien lo recibe para que adopte decisiones que comprometan su imparcialidad y buen juicio.",
        descrip7:
          "En este sentido no se permite la entrega de regalos, dádivas, beneficios personales o compensaciones económicas a funcionarios y empleados públicos, dirigentes de partidos políticos, cargos públicos o candidatos a dichos cargos. Igualmente colaboraremos con la debida diligencia con todas las autoridades competentes que nos requieran en el desarrollo de sus funciones.",
        entorno: "Entorno próximo",
        descrip9:
          "Risi tratará de impactar positivamente en los entornos geográficos en los que tenemos actividad, con una colaboración desinteresada en algunas iniciativas que persigan la mejora de la vecindad y del medio ambiente."
      },
      risicumplimiento: {
        titulo: "Cumplimiento <br> y canal ético",
        descrip1:
          "El contenido del presente <strong>Código de Conducta es de obligado cumplimiento</strong> para los administradores, directivos, empleados y colaboradores de Risi.",
        descrip2:
          "Las <strong>conductas contrarias</strong> a los principios contenidos en el Código de Conducta, así como en el resto de las normas internas vigentes en la Compañía, podrán dar lugar a la <strong>formulación del correspondiente expediente disciplinario</strong> y, en su caso, a la aplicación del régimen sancionador que corresponda, de acuerdo con la gravedad del incumplimiento y dentro del marco legal aplicable conforme al Estatuto de los Trabajadores y  Convenios Colectivos que sean de aplicación.",
        descrip3:
          "Todos los administradores, directivos, empleados y colaboradores de Risi <strong>deben comunicar al Responsable de Cumplimiento cualquier conducta inapropiada</strong>, irregular, susceptible de vulnerar el contenido del presente Código o de la normativa interna de la compañía, con independencia de si éstas causan un beneficio o un perjuicio para Risi.",
        descrip4:
          'A estos efectos, se ha habilitado un <strong>canal ético</strong> a través de la siguiente dirección de correo electrónico: <a  href="mailto:canaletico@risi.es" > canaletico@risi.es</a >.',
        descrip5:
          "Las denuncias deberán cumplir el principio de buena fe y relacionarán el detalle de los hechos acaecidos. No existirán represalias de ningún tipo contra los denunciantes respetándose igualmente las garantías del denunciado.",
        descrip6:
          "Risi se compromete a tratar estos datos con el más estricto cumplimiento de la legislación en este sentido."
      }
    },
    hoycontigo: {
      titulo: "Hemos cumplido<br>más de 50 años…",
      subtitulo: "¡Descubre todo sobre nosotros!",
      descrip1: "En todo este tiempo hay cosas que NO han cambiado",
      descrip2: "Nuestro ADN",
      descrip3: "Esfuerzo",
      descrip4: "Dedicación",
      descrip5: "Ilusión",
      descrip6: "Positividad",
      descrip7: "Siempre",
      descrip8: "con una",
      descrip9: "sonrisa",
      descrip10: "La actitud positiva",
      descrip11: "La fiel apuesta por la innovación",
      descrip12: "Y otras que han llegado NUEVAS",
      descrip13: "A la fabricación de snacks",
      descrip14: "se une la elaboración de",
      descrip15: "Galletas y caramelos",
      descrip16: "¿Cuál es nuestro objetivo para los próximos años?",
      descrip17:
        "Seguiremos trabajando como mejor sabemos hacerlo, con optimismo y una gran sonrisa  para seguir cumpliendo años a vuestro lado"
    },
    noticias: {
      mostrando: "Mostrando",
      resultados: "resultados",
      noresultados:
        "No hemos publicado ninguna noticia aún.<br>Vuelve mas tarde",
      quebuscas: "¿Que estás buscando?",
      producto: "PRODUCTO",
      web: "WEB",
      promocion: "PROMOCIÓN",
      rsc: "RSC",
      novedades: "NOVEDADES",
      familia: "FAMILIA",
      tepuede: "Te puede",
      interesar: "Interesar...",
      masNoticias: "Más noticias",
      compartir: "Compartir",
      cerrar: "Cerrar"
    },
    nutririsi: {
      titulo: "Compromiso calidad risi",
      subtitulo: "Seguridad y<br>calidad en todos los productos Risi",
      descrip1:
        "Desde Risi S.A. <strong>nuestro equipo trabaja cada día para que el consumidor pueda disfrutar de nuestros snacks sin que esto signifique renunciar a una vida saludable.</strong> Por ello Risi cumple en todos sus centros productivos con la normativa <strong>IFS Food</strong>, norma de seguridad alimentaria reconocida por la Global Food Safety Initiative (GFSI) que se centra en la seguridad y calidad alimentaria de todos los productos procesados empaquetados o a granel.",
      descrip2:
        "Risi está comprometida con la calidad y el medioambiente a través de las directrices marcadas en la Política de Calidad, Seguridad Alimentaria y Medio Ambiente.",
      descrip3: "<strong>Política de calidad y medio ambiente</strong>",
      descrip4:
        "Los snacks, patatas fritas, caramelos y galletas sin gluten Risi están incluidos en la Lista Oficial de la Federación de Asociaciones de Celíacos de España (FACE).",
      descrip5:
        "Estamos comprometidos con la Estrategia NAOS (Nutrición, Actividad Física y Prevención de la Obesidad).",
      descrip6:
        "Solo utilizamos Aceite de Girasol y Aceite de Girasol Alto Oleico.",
      descrip7:
        "Revalorizamos los subproductos de nuestros procesos y se transforman en productos para alimentación animal.",
      descrip8:
        "Reciclamos los envases y embalajes y nuestro residuo de aceite vegetal se emplea para generar biodiesel.",
      descrip9:
        "Trabajamos para reducir el desperdicio alimentario a lo largo de toda la cadena de valor.",
      descrip10:
        "En Risi, el 100% de las cajas de cartón están fabricadas con papel reciclado.",
      descrip11:
        "Gracias a las energías renovables utilizadas en 2024 en nuestro centro productivo de Madrid, hemos evitado la emisión a la atmósfera de 670 Tn de CO2.",
      descrip12:
        "El 28% de la energía consumida en la planta de Madrid en el año 2024 ha procedido de energía solar.",
      descrip13:
        "Impartimos a todos nuestros empleados formación sobre buenas prácticas ambientales y trabajamos en la concienciación frente al desperdicio alimentario,  el ahorro en el consumo energético y el agua.",
      descrip14:
        "En nuestra planta de Sevilla, hemos reducido el consumo de agua un 4,6% por debajo de la consumida en 2021.",
      descrip15:
        "En 2022, el consumo de energía de la planta de Sevilla ha sido un 3,6% menor que la consumida en 2021.",
      descrip16:
        "Risi colabora en el cuidado del entorno y participa en la conservación y restauración de bosques de alto valor ecológico.",
      descrip18:
        "En nuestra planta de Sevilla se ha reducido el consumo energético en 2024, un 7% con respecto a 2023."
    },
    distribuidor: {
      localiza: "Localiza tu distribuidor más cercana",
      seleccionaProvincia: "Selecciona una provincia",
      losentimos: "Lo sentimos",
      actualmente: "Actualmente no hay distribuidor en esta provincia.",
      puedesContactar: "Puedes contactar con nosotros",
      aqui: "aquí",
      descargate: "Descárgate",
      nuestro: "nuestro",
      catalago: "catálogo",
      catalalogoSnacks: "Descargar Aquí catálogo snacks",
      catalalogoGalletas: "Descargar Aquí catálogo galletas",
      catalalogoCaramelos: "Descargar Aquí catálogo caramelos",
      estamosActualizando:
        "Estamos actualizando nuestro catálogo<br>En breve, estará disponible",
      superKiosco: "¡Súper kiosco Risi!",
      vender: "¿Quieres vender nuestros productos en tu establecimiento?",
      escribenos: "Escríbenos y te daremos toda la información",
      general: {
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Atención al cliente:</p><p><a href='tel:900909013'>900 90 90 13</a> <strong>/</strong> <a href='mailto:pedidos@risi.es'>pedidos@risi.es</a></p>"
          },
          {
            img: "/static/img/aeroplane.svg",
            alt: "Icon-aeroplane",
            text:
              "<p>Exportación:</p><p><a href='mailto:nballand@risi.es'>nballand@risi.es</a></p>"
          }
        ]
      }
    },
    faqs: {
      busqueda: "¿Qué estás buscando?"
    },
    pressroom: {
      press: "Press",
      room: "Room",
      titulo: "Escríbenos y te daremos toda la información",
      subtitulo:
        "Si eres un profesional del sector y necesitas información puedes hacerlo a través de este formulario",
      descargate: "Descárgate",
      nuestros: "Nuestros",
      materiales: "Materiales"
    },
    bannerRisiHoy: {
      titulo: "¿Quieres saber más?",
      subtitulo: "te lo contamos en",
      risiHoy: "Risi HOY",
      ira: "ir a risi hoy"
    },
    materialesPrensa: {
      materiales: "Materiales",
      prensa: "Prensa",
      descarga: "Descárgate nuestros materiales",
      descrip1:
        "Si eres un profesional de los medios de comunicación ponemos a tu disposición una selección de materiales corporativos que ayuden, apoyen y refuercen todos aquellos contenidos vinculados a  Risi, sus marcas y sus productos."
    },
    politica_cookies: {
      descrip1:
        "<h3>1. ÁMBITO DE APLICACIÓN.</h3><p>Conforme a lo dispuesto en el artículo 22.2 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE) vigente, RISI debe cumplir con la obligación de informar sobre las cookies que utiliza y sus finalidades.</p><p>Este sitio web utiliza cookies y/o tecnologías similares que almacenan y recuperan información cuando el Usuario navega. Las cookies permiten a una página web o plataforma, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un Usuario o de su equipo y, dependiendo de la información que contenga y de la forma en que utilice su equipo, pueden utilizarse para reconocer al Usuario.</p><p>El Usuario puede modificar la configuración personalizada <a>AQUI</a></p>",
      descrip2:
        "<h3>2. DEFINICIÓN Y FUNCIONES DE LAS COOKIES.</h3><p>La información que le proporcionamos a continuación, le ayudará a comprender los diferentes tipos de cookies:</p>",
      descrip3:
        "<table class='table'><tr><th class='odd'></th><th class='odd'></th><th class='odd'>TIPOS DE COOKIES</th></tr><tr><th rowspan='2'>SEGÚN LA ENTIDAD QUE LAS GESTIONE</th><td>COOKIES PROPIAS<td>Son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario</td></tr><tr><td>COOKIES DE TERCERO</td><td>Son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos a través de las cookies.</td></tr><tr><th rowspan='2'>SEGÚN EL PLAZO DE TIEMPO QUE PERMANEZCAN ACTIVADAS</th><td>COOKIES DE SESIÓN</td><td>Son aquellas diseñadas para recabar y almacenar datos mientras el usuario accede a una página web. Se suelen emplear para almacenar información que solo interesa conservar para la prestación del servicio solicitado por el usuario en una sola ocasión (por ejemplo, una lista de productos adquiridos) y desaparecen al terminar la sesión</td></tr><tr><td>COOKIES PERSISTENTES</td><td>Son aquellas en las que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie, y que puede ir de unos minutos a varios años.</td></tr><tr><th rowspan='5'>SEGÚN SU FINALIDAD</th><td>COOKIES TÉCNICAS<td>Son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan.</td></tr><tr><td>COOKIES DE PERSONALIZACIÓN</td><td>Permiten aplicar características propias para la navegación del usuario por el website (Ej. idioma).</td></tr><tr><td>COOKIES DE ANÁLISIS</td><td>Son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas, incluida la cuantificación de los impactos de los anuncios. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</td></tr><tr><td>COOKIES PUBLICITARIAS</td><td>Permiten al editor incluir en la página web espacios publicitarios, según el contenido de la propia web.</td></tr><tr><td>COOKIES DE PUBLICIDAD COMPORTAMENTAL</td><td>Son aquellas que almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.</td></tr></table>",
      descrip4:
        "<h3>3. INFORMACIÓN SOBRE EL TIPO DE COOKIES QUE UTILIZA RISI.</h3><p>RISI informa de manera más detallada de las cookies que utiliza sus titulares, el uso o finalidad concreta, los plazos de conservación, así como de las Transferencias Internacionales de datos (si existiera) y de cada una de ellas utilizadas en la web.</p>",
      descrip5:
        "<table class='table'><tr><th class='odd2'>TIPO</th><th class='odd2'>COOKIE</th><th class='odd2'>FINALIDAD</th><th class='odd2'>CONSERVACIÓN</th></tr><tr><td>Sesión y persistentes</td><td>-cookieyesID cky-consent-cookieyes-necessary-cookieyes-functional-cookieyes-analytics-cookieyes-performance-cookieyes-advertisement</td><td>Diseñadas para recabar y almacenar datos mientras el usuario accede a una página web. Se suelen emplear para almacenar información que solo interesa conservar para la prestación del servicio solicitado por el usuario en una sola ocasión (por ejemplo, una lista de productos adquiridos) y desaparecen al terminar la sesión.</td><td>1 año</td></tr><tr><td>Analíticas Google analytics.</td><td>ga_gid</td><td>Permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas, incluida la cuantificación de los impactos de los anuncios. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio</td><td>1 año</td></tr><tr><td>Técnicas</td><td>_gat_UA-139143569-1_cfduid http</td><td>Permiten al usuario la navegación a través de una página web, y la utilización de las diferentes opciones o servicios que en ella existan, incluyendo aquellas que el editor utiliza para permitir la gestión y opera-tiva de la página web y habilitar sus funciones y servicios, como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido.</td><td>1 año</td></tr></table>",
      descrip6:
        "Téngase en cuenta que, si acepta las cookies de terceros, deberá eliminarlas desde las opciones del navegador o desde el sistema ofrecido por el propio tercero.",
      descrip7:
        "<h3>4. CONFIGURACIÓN DE LAS COOKIES.</h3><p>Usted puede configurar las cookies que no sean estrictamente necesarias para la navegación a través del panel de configuración AQUI. Tenga en cuenta que, si rechaza el uso de cookies, alguno de los servicios de RISI pueden verse afectados.</p><p>A continuación, le proporcionamos los enlaces de diversos navegadores, a través de los cuales podrá modificar la configuración de su navegador sobre el uso de cookies:</p>",
      descrip8:
        "Página web: <ul><li><strong>Firefox desde aquí: </strong><a href='http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we' target='_blank'>http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></li><li><strong>Chrome desde aquí: </strong><a href='http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647' target='_blank'>http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647</a></li><li><strong>Explorer desde aquí: </strong><a href='http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-10' target='_blank'>http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-10</a></li><li><strong>Safari desde aquí: </strong><a href='https://support.apple.com/kb/ph17191?locale=es_ES' target='_blank'>https://support.apple.com/kb/ph17191?locale=es_ES</a></li><li><strong>Opera desde aquí: </strong><a href='https://help.opera.com/en/latest/web-preferences/#cookies' target='_blank'>https://help.opera.com/en/latest/web-preferences/#cookies</a></li><ul>",
      descrip9:
        "Para conocer más información sobre el tratamiento de datos personales, le recomendamos visitar nuestro apartado <strong>“Política de Privacidad”.</strong>",
      descrip10: "<strong>Última actualización:</strong> Noviembre de 2023"
    },
    aviso_legal: {
      descrip1:
        "En cumplimiento de lo dispuesto en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, se hace constar que estas páginas corresponden a RISI, S.A., con CIF A28194090, y domicilio social en Severo Ochoa, 2. Pol. Ind. GITESA. 28814 Daganzo (Madrid).",
      descrip2: "Denominación Social: RISI, S.A&nbsp;",
      descrip3: "NIF: A28194090<br>",
      descrip4:
        "Dirección: Severo Ochoa, 2. Pol. Ind. GITESA. 28814 Daganzo (Madrid).",
      descrip5:
        'E-mail:&nbsp;<strong><a href="mailto:risi@risi.es">risi@risi.es</a></strong>',
      descrip6: "CONDICIONES GENERALES DE USO",
      descrip7: "1. OBJETO",
      descrip8:
        'Las presentes Condiciones Generales de Uso regulan el uso del sitio web http://risi.es, ya sea con su actual nombre o con cualquier otra denominación con la que pueda figurar en el futuro, ("Sitio Web") de RISI, S.A., con CIF A28194090, domicilio social en Severo Ochoa, Pol. Ind. GITESA. 28814 Daganzo (Madrid) y dirección de e-mail&nbsp;<strong><a href="mailto:risi@risi.es">risi@risi.es</a></strong>&nbsp;(en adelante "RISI"). Este Sitio Web está dirigido exclusivamente a personas físicas residentes en España. Los usuarios que residan o se encuentren domiciliados en cualquier otro país y que decidan acceder y/o utilizar este Sitio Web lo harán bajo su propia responsabilidad y riesgo y deberán asegurarse de que tal acceso y/o utilización cumple con la legislación local aplicable. Al acceder y utilizar este Sitio Web usted ("Usuario") reconoce que ha leído y aceptado estas Condiciones Generales de Uso y se compromete a cumplir con todos sus términos y condiciones. Asimismo, el Usuario reconoce y acepta que el acceso y uso de este Sitio Web estará sujeto a las Condiciones Generales de Uso que se encuentren en vigor en el momento en que acceda al mismo. RISI se reserva el derecho de modificar en cualquier momento las presentes Condiciones Generales de Uso, así como cualesquiera otras condiciones generales o particulares que resulten de aplicación. Asimismo, RISI se reserva el derecho de suspender, interrumpir o dejar de operar el Sitio Web en cualquier momento.',
      descrip9: "2. CONTENIDOS",
      descrip10:
        'A través del Sitio Web, RISI facilita a los Usuarios el acceso a diversos contenidos, información y datos proporcionados por RISI ("Contenidos"). RISI se reserva el derecho a modificar en cualquier momento la presentación, la configuración y ubicación del Sitio Web, y/o los Contenidos, así como las correspondientes condiciones de acceso y uso. RISI no garantiza que los Contenidos proporcionados a través del Sitio Web serán en todo caso correctos, completos o actualizados. Con la inclusión de Contenidos de terceros en el Sitio Web, RISI no se convierte en editor de los mismos y por tanto no garantiza ni se hace responsable de la licitud, fiabilidad, utilidad, veracidad, exactitud, exhaustividad y actualidad de dichos Contenidos. En ningún caso RISI será responsable de cualesquiera daños y perjuicios que pudieran derivarse de (i) la posible infracción de derechos de terceros, fiabilidad, utilidad, veracidad, exactitud, exhaustividad, y/o actualidad de los Contenidos proporcionados por terceros; (ii) la inadecuación para cualquier propósito y la defraudación de las expectativas generadas por los Contenidos; (iii) las decisiones o acciones tomadas por el Usuario confiando en dichos Contenidos. Sin perjuicio de lo anterior, RISI se reserva el derecho de retirar y/o bloquear el acceso a cualesquiera Contenidos en caso de que tenga conocimiento efectivo de que dichos Contenidos son ilegales o infringen derechos de terceros, o en caso de que sea requerido para ello en virtud de una resolución judicial o una orden administrativa.',
      descrip11: "3. ACCESO Y USO DEL SITIO WEB",
      descrip12:
        "El acceso al Sitio Web estará limitado a mayores de 14 años. No obstante lo anterior, el acceso a determinados contenidos y/o participación en las promociones de RISI puede estar limitado a mayores de edad o menores emancipados, según se indique en cada caso. Con carácter general, los Usuarios podrán acceder al Sitio Web de forma libre y gratuita. El Usuario reconoce y acepta que el acceso y uso del Sitio Web y/o de los Contenidos incluidos en el mismo tiene lugar libre y conscientemente, bajo su exclusiva responsabilidad. RISI no será en ningún caso responsable del uso que los Usuarios y/o terceros pudieran hacer del Sitio Web o los Contenidos, ni de los daños y perjuicios que pudieran derivarse del mismo. El Usuario se compromete a hacer un uso adecuado y lícito del Sitio Web y de los Contenidos, de conformidad con la legislación aplicable, las presentes Condiciones Generales de Uso, la moral y buenas costumbres generalmente aceptadas y el orden público. El Usuario deberá abstenerse de (i) hacer un uso no autorizado o fraudulento del Sitio Web y/o de los Contenidos; (ii) acceder o intentar acceder a recursos restringidos del Sitio Web; (iii) utilizar el Sitio Web y/o los Contenidos con fines o efectos ilícitos, ilegales, contrarios a lo establecido en el presente Condiciones Generales de Uso, a la buena fe y al orden público, lesivos de los derechos e intereses de terceros, o que de cualquier forma puedan dañar, inutilizar o sobrecargar el Sitio Web o impedir la normal utilización o disfrute del Sitio Web; (iv) provocar daños en el Sitio Web, o en los sistemas de sus proveedores o de terceros; (v) introducir o difundir virus informáticos o cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar daños en los sistemas de RISI, de sus proveedores o de terceros, (vi) intentar acceder, utilizar y/o manipular los datos de RISI, terceros proveedores y otros usuarios; (vii) reproducir o copiar, distribuir, permitir el acceso del público a través de cualquier modalidad de comunicación pública, transformar o modificar los Contenidos, a menos que se cuente con la autorización del titular de los correspondientes derechos o ello esté legalmente permitido; (viii) suprimir, ocultar o manipular las notas sobre derechos de autor y demás datos identificativos de los derechos de RISI o de terceros incorporados a los Contenidos;",
      descrip13:
        "(ix) obtener o intentar obtener los Contenidos empleando para ello medios o procedimientos distintos de los que, según los casos, se hayan puesto a su disposición a este efecto o se hayan indicado expresamente en las páginas Web donde se encuentren los Contenidos o, en general, de los que se empleen habitualmente en Internet por no entrañar un riesgo de daño o inutilización del Sitio Web y/o de los Contenidos.",
      descrip14:
        "4. CONDICIONES ADICIONALES PARA EL ACCESO Y USO DE ÁREAS DE ACCESO RESTRINGIDO",
      descrip15:
        'En el supuesto de que algún área del Sitio Web tenga acceso restringido y/o limitado, y sin perjuicio de las condiciones específicas que rijan su uso, el acceso a dicha área estará sujeto en todo caso al previo registro del Usuario mediante la cumplimentación del correspondiente formulario ("Formulario de Registro"), que será previamente facilitado al Usuario. RISI se reserva el derecho de aceptar o rechazar libremente la solicitud de registro por parte del Usuario. Los datos introducidos por el Usuario en el Formulario de Registro deberán ser exactos, actuales y veraces en todo momento. En tal caso, el acceso y uso del área específica del Sitio Web podrá estar sujeta una contraseña asignada al Usuario por RISI al rellenar el Formulario de Registro y el acceso se reputará realizado por dicho Usuario, quien responderá en todo caso de tal acceso y uso. El Usuario será responsable en todo momento de la custodia de su contraseña, asumiendo, en consecuencia, cualesquiera daños y perjuicios que pudieran derivarse de su uso indebido, así como de la cesión, revelación o extravío de la misma. En caso de olvido de la contraseña o cualquier otra circunstancia que suponga un riesgo de acceso y/o utilización por parte de terceros no autorizados, el Usuario lo comunicará inmediatamente a RISI a fin de que éste proceda inmediatamente al bloqueo y sustitución de la misma. En todo caso, cualesquiera operaciones realizadas antes de dicha comunicación se reputarán efectuadas por el Usuario, quien será responsable y pagará los gastos y/o daños que se deriven de cualquier acceso y/o uso no autorizado que se realice con anterioridad a dicha comunicación.',
      descrip16: "5. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL",
      descrip17:
        "El Usuario reconoce y acepta que todos los derechos de propiedad intelectual e industrial sobre los Contenidos y/o cualesquiera otros elementos insertados en el Sitio Web (incluyendo, sin limitación, marcas, logotipos, nombres comerciales, textos, imágenes, gráficos, diseños, sonidos, bases de datos, software, diagramas de flujo, presentación, audio y vídeo), pertenecen a RISI y/o a terceros. Queda terminantemente prohibida la utilización de tales elementos, su reproducción, comunicación y/o distribución con fines comerciales o lucrativos, así como su modificación, alteración o descompilación. Cualquier otro uso o explotación de cualesquiera Contenidos y/u otros elementos insertados en el Sitio Web distinto de los aquí expresamente previstos estará sujeto a la autorización previa de RISI o del tercero titular de los derechos afectados.",
      descrip18: "6. ENLACES",
      descrip19:
        "El Sitio Web puede incluir enlaces y herramientas de búsqueda que permitan a los Usuarios acceder a sitios Web de terceros. Dichos enlaces y herramientas de búsqueda se facilitan únicamente a efectos de referencia. En todo caso se recomienda a los Usuarios consultar los términos y condiciones de uso y las políticas de privacidad de los sitios Web de terceros a los que accedan a través de enlaces incluidos en el Sitio Web. Si bien RISI revisa previamente el contenido de los sitios Web con los que establece un enlace y únicamente facilita enlaces a aquellos sitios Web que, a su leal saber y entender, cumplen con la legislación aplicable, RISI no aprueba ni controla los contenidos de dichos sitios Web y/o cualesquiera modificaciones de los mismos, y excluye expresamente toda responsabilidad por cualquier daño que pudiera derivarse del acceso, uso o imposibilidad de uso, por parte de los Usuarios, de cualquier sitio Web con el que se haya establecido un enlace o del contenido del mismo. Sin perjuicio de lo anterior, RISI se reserva el derecho a eliminar los enlaces a cualquier sitio Web en caso de que tenga conocimiento efectivo de que las actividades desarrolladas en dicho sitio Web o los contenidos del mismo son ilegales o infringen derechos de terceros, o en caso de que sea requerido para ello en virtud de una resolución judicial o una orden administrativa.",
      descrip20: "7. EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD",
      descrip21:
        "RISI no garantiza la disponibilidad y continuidad del funcionamiento del Sitio Web. En consecuencia, RISI no será en ningún caso responsable por cualesquiera daños y perjuicios que puedan derivarse de (i) la falta de disponibilidad o accesibilidad al Sitio Web; (ii) la interrupción en el funcionamiento del Sitio Web o fallos informáticos, averías telefónicas, desconexiones, retrasos o bloqueos causados por deficiencias o sobrecargas en las líneas telefónicas, centros de datos, en el sistema de Internet o en otros sistemas electrónicos, producidos en el curso de su funcionamiento; y (iii) otros daños que puedan ser causados por terceros mediante intromisiones no autorizadas ajenas al control de RISI. RISI no garantiza la ausencia de virus ni de otros elementos en el Sitio Web introducidos por terceros ajenos a RISI que puedan producir alteraciones en los sistemas físicos o lógicos de los Usuarios o en los documentos electrónicos y ficheros almacenados en sus sistemas. En consecuencia, RISI no será en ningún caso responsable de cualesquiera daños y perjuicios de toda naturaleza que pudieran derivarse de la presencia de virus u otros elementos que puedan producir alteraciones en los sistemas físicos o lógicos, documentos electrónicos o ficheros de los Usuarios. RISI no garantiza que terceros no autorizados no puedan conocer las páginas del Sitio Web que visita el Usuario, así como tampoco las condiciones, características y circunstancias en las cuales el Usuario visita el Sitio Web. En consecuencia, RISI no será en ningún caso responsable de los daños y perjuicios que pudieran derivarse de dicho acceso no autorizado.",
      descrip22: "8. LEY APLICABLE Y JURISDICCIÓN",
      descrip23:
        "Las presentes Condiciones de Uso, así como la relación entre RISI y el Usuario, se regirán e interpretarán con arreglo la ley española. Las partes acuerdan someterse a la jurisdicción exclusiva de los juzgados y tribunales del lugar de residencia del Usuario para la resolución de cualquier controversia en relación con las presentes Condiciones de Uso o la relación entre las mismas."
    },
    politica_privacidad: {
      descrip1:
        "<h3>1. ¿QUIENES SOMOS?</h3><p>RISI es una Empresa española familiar con casi cincuenta años de historia, especialistas en la fabricación y comercialización de snacks y aperitivos.</p><p>El objetivo y fin de la existencia de RISI es el de cubrir las necesidades y satisfacer las expectativas de los consumidores, basándose en marcas de la máxima calidad y procesos en mejora permanente</p>",
      descrip2:
        "<h3>2. ¿QUIÉN ES EL RESPONSABLE DEL TRATAMIENTO DE SUS DATOS PERSONALES?</h3><p>Los datos de carácter personal facilitados por usted serán tratados por RISI SA (RISI), con NIF A28194090 y domicilio social sito en Severo Ochoa, 2. Pol. Ind. GITESA. 28814 Daganzo (Madrid) y correo electrónico:<a href='mailto:risi@risi.es' target='_blank'> risi@risi.es</a></p><p>Los datos de contacto de nuestro Delegado de Protección de datos:<a href='mailto:dpd.cliente@conversia.es' target='_blank'> dpd.cliente@conversia.es</a> y teléfono: <a href='tel:902877192' target='_blank'>902 877 192</a></p>",
      descrip3:
        "<h3>3. ÁMBITO DE APLICACIÓN.</h3><p>La presente Política de Privacidad tienen por objeto regular el tratamiento de datos que se lleva a cabo de los datos de los Usuarios de la web de RISI. Por tanto, será de aplicación a todo aquel Usuario que navegue y utilice la web de RISI, solicite información mediante cualquier canal habilitado al efecto (correo electrónico, formulario, teléfono, etc), se registre e inscriba en promociones y/o sorteos o interactúe con nosotros.</p><p>Asi como también, es aplicable a los clientes, proveedores y otras figuras afines en sus relaciones con RISI.</p><p>El Interesado declara haber leído y entendido previamente la presente Política de Privacidad y voluntariamente las acepta, sin reserva alguna y exime a RISI del mal uso que se pueda hacer de la información que se envía a través de la misma.</p>",
      descrip4:
        "<h3>4. ¿DE DÓNDE OBTENEMOS SUS DATOS PERSONALES?</h3><p>Sus datos los recabamos por diferentes canales:</p><h4>4.1. Información proporcionada por usted.</h4><p>Tratamos información personal proporcionada por usted mediante los canales creados al efecto, como formulario de contacto provisto en la web y/o en nuestras oficinas, correo electrónico, teléfono, WhatsApp, o bien, interactúa con nosotros por redes sociales o comparte nuestro contenido. Asimismo, recabamos información cuando participa en sorteos o promociones, campañas de marketing, suscripciones a boletines de información, o bien en encuestas de satisfacción.</p><p>Asimismo, tratamos datos derivados del uso y funcionamiento del sistema interno de información de RISI. Dichos datos, son aportados directamente por los interesados o, en su caso, por los informantes, trabajadores y/o terceros a los que se solicite información durante el transcurso de la investigación (si se diera el caso) y estarán en todo caso relacionados con los hechos investigados</p><p>También tratamos sus datos para cuando desee querer formar parte de nuestro equipo de RISI al enviarnos su candidatura por correo electrónico: <a href='mailto:empleo@risi.es' target='_blank'>empleo@risi.es</a></p><h4>4.2. Información recopilada por RISI</h4><p>Nosotros y nuestros proveedores de servicios de terceros, como socios de analítica, redes sociales y publicitarias, podemos usar tecnologías que recopilan de forma automática (o pasiva) cierta información cuando un Usuario interactúa en línea en la web. Utilizamos también cookies, pero para ello, revisa nuestra <strong><a href='https://risi.es/es/politica-de-cookies' target='_blank'>“Política de Cookies”</a></strong>.</p>",
      descrip5:
        "<h3>5. ¿QUÉ TIPO DE INFORMACIÓN TRATAMOS?</h3><p>RISI, podría tratar el siguiente tipo de información:</p></br><ul><li>Identificadores e información de contacto como nombre, nombre de usuario, dirección de correo electrónico, dirección postal, código postal, número de teléfono, sexo, edad, fecha de nacimiento.</li><li>Comprobante de compra, como un ticket de supermercado o recibo, para alguna promoción o sorteo.</li><li>Cualquier contenido producido y compartido por el usuario en nuestros sitios web, aplicaciones o páginas de redes sociales.</li><li>Información sobre tu uso y navegación en nuestros sitios web y aplicaciones; por ejemplo, el sitio web del que provienes, las páginas web que más visita, la cantidad de veces que ve un vídeo o interactúa con una imagen.</li><li>Información sobre participación previa en promociones como sorteos o concursos; por ejemplo, tipo de promoción, marca asociada.</li><li>Datos de contacto e información personal y profesional para cuando nos remita su candidatura para un puesto vacante.</li><li> Cualquier dato derivado del uso y funcionamiento del sistema interno de información. Consistirán en información sobre los hechos de los que se informa, así como, en caso de que se proporcionen, datos identificativos, de contacto (nombre y apellidos, e-mail, teléfono), económicos, profesionales y laborales del informante y las personas sobre las que se informa. En ocasiones excepcionales, y solo si fuera necesario, se tratarán datos de categorías especiales (por ejemplo, datos relativos a infracciones penales o administrativas, datos de salud, datos sobre la orientación o vida sexual u origen étnico o racial). </li></ul><p>RISI solo procesará datos personales sensibles o confidenciales cuando sea estrictamente necesario y solo con su consentimiento previo.</p>",
      descrip6:
        "<h3>6. ¿CON QUÉ FINALIDAD Y BASE LEGAL TRATAMOS SUS DATOS PERSONALES?</h3><p>RISI, se comprometen a tratar sus datos personales de conformidad con lo establecido en la normativa aplicable y, en particular para las siguientes finalidades:</p><ul><li><strong>Visitantes in situ. </strong>Recabaremos sus datos personales cuando visite alguna de nuestras fabricas o instalaciones “in situ”, con la finalidad de controlar los pases o visitas.</li><li><strong>Gestionar las consultas, reclamaciones, incidencias y/o sugerencias. </strong>Sus datos los trataremos con la finalidad de gestionar de manera administrativa las consultas, reclamaciones, incidencias y/o sugerencias remitidas por el canal correspondiente (correo electrónico, teléfono, chat, WhatsApp, etc).</li><li><strong>Participación en sorteos y/o promociones. </strong>Le informamos que sus datos podemos tratarlos para desarrollar iniciativas, concursos, promociones y otras actividades análogas y permitir su participación en las mismas.</li><li><strong>Presentación de ofertas y/o promociones. Comunicaciones comerciales. </strong>Sus datos personales serán tratados con la finalidad de hacerle llegar, tanto a través de medios impresos como electrónicos y telefónicos, publicidad, relacionada con productos de RISI. Por tanto, se determinará aquellas ofertas y novedades que pueden resultarle más interesantes.</li><li><strong>Datos recabados a través de la web. </strong>La finalidad del recabado de este tipo de datos es para brindarle una mejor experiencia en el uso de la web.</li><li><strong>Gestión de candidatos. </strong>Recopilamos la información personal y profesional, que nos proporciona al correo electrónico <a href='mailto:empleo@risi.es' target='_blank'>empleo@risi.es</a>, para tratar a los posibles candidatos.</li></ul><p>La base legal para los tratamientos de tus datos para las finalidades anteriormente mencionadas es el consentimiento que nos ha otorgado según las finalidades específicas y en virtud de lo establecido en el art. 6.1 a) del RGPD. Sus datos personales serán conservados para esta finalidad hasta que no revoque su consentimiento.</p><ul><li><strong>Gestión datos de clientes. </strong>Se tratarán los datos personales con la finalidad de prestarle el servicio y/o producto contratado u ofrecido, siento necesario para ello cierta información de carácter personal.</li><li><strong>Gestión de proveedores de servicios. </strong>RISI tratará datos personales de sus proveedores con la finalidad estrictamente para la ejecución del contrato.</li></ul><p>La base legal para las finalidades mencionadas anteriormente es para la ejecución de un contrato en el que el interesado es parte en virtud de lo establecido en el art. 6.1 b) del Reglamento General de Protección de Datos (en adelante 'RGPD').</p><ul><li><strong>Gestión de datos para el cumplimiento de obligaciones de carácter legal y regulatorio. </strong>Todos los responsables del tratamiento de datos están sometidos a las leyes de los países en los que desarrollan su actividad, y están obligados a cumplirlas. Entre estas obligaciones se incluye la entrega, en determinadas circunstancias, de datos de carácter personal a órganos judiciales, organismos reguladores o supervisores y cuerpos y fuerzas de seguridad del estado.</li><li> <strong>Canal de denuncias: </strong> RISI tratará la información recibida en el Canal de Denuncias, que contiene datos personales, de acuerdo con una obligación legal de la Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y, con la única finalidad de procesar la comunicación y decidir sobre su admisión o inadmisión. En caso de admitir, se llevará a cabo la investigación correspondiente para adoptar las medidas disciplinarias que correspondan. En los casos de revelación pública, el tratamiento tiene como base de legitimación el cumplimiento de una misión realizada en interés público conforme al artículo 6.1.e del RGPD. Además, se solicitará el consentimiento cuando proceda para cumplir con los requisitos de la normativa. </br> Las condiciones del tratamiento de las informaciones recibidas en el Canal de Denuncias habilitado se regulan en la presente política de privacidad.  </li></ul><p>La base legal para los tratamientos de sus datos para las finalidades anteriormente mencionadas es el cumplimiento de obligaciones legales aplicables al responsable del tratamiento, en virtud de lo establecido en el art. 6.1 c) del RGPD.</p><ul><li><strong>Encuestas de satisfacción. </strong>Le informamos que sus datos podemos tratarlos para realizar encuestas con el objetivo de conocer los intereses y obtener información a través de las Redes Sociales sobre la percepción de nuestra marca o nuestros productos.</li><li><strong>Gestión de control de calidad. </strong>Le informamos que registramos las interacciones con los consumidores, como correos electrónicos, llamadas telefónicas a la línea de ayuda de RISI, para control de calidad.</li></ul><p>La base legal para los tratamientos de sus datos para las finalidades anteriormente mencionadas es el interés legítimo aplicables al responsable del tratamiento, en virtud de lo establecido en el art. 6.1 d) del RGPD.</p>",
      descrip7:
        "<h3>7. ¿POR CUÁNTO TIEMPO CONSERVAREMOS SUS DATOS?</h3><p>Sus datos personales serán conservados durante el tiempo necesario para cumplir las finalidades mencionadas. En todo caso, limitamos el acceso a sus datos sólo a aquellas personas que necesiten utilizarla para el desempeño de sus funciones.</p><p>El periodo de conservación de la información tratada se fundamenta en las necesidades del negocio, por lo cuando sean innecesarios, se mantendrán debidamente bloqueados con el único fin de atender las responsabilidades de cualquier índole que pudieran surgir.</p><ul><li><strong>Finalidades relacionadas con el consentimiento prestado. </strong>Se mantendrá los datos hasta que no se revoque el consentimiento por el interesado y, como máximo hasta el plazo de cuatro años desde que se recabo el consentimiento expreso.</li><li><strong>Finalidades relacionadas con la ejecución de un contrato. </strong>El periodo de conservación para la gestión de alguna obligación contractual que tengamos con usted, conservaremos esos datos durante el período de vigencia del contrato y durante los diez años siguientes, para poder atender a posibles consultas o reclamaciones posteriores.</li><li><strong>Finalidades relacionadas con el cumplimiento de obligaciones legales. </strong>Determinada información deberá mantenerse durante los plazos exigidos por la normativa específica que resulte de aplicación (fiscal, mercantil, blanqueo de capitales, etc.).</li><li><strong>Finalidades relacionadas con el interés legítimo de RISI. </strong>Determinada información deberá mantenerse durante los plazos necesarios en cumplimiento del interés de RISI.</li><li><strong>Finalidades relacionadas con el canal ético de RISI. </strong>El plazo máximo de tramitación de la investigación y resolución de lascomunicaciones recibidas será de tres meses para los casos generales y paraaquellos de especial complejidad, la duración podrá prorrogarse otros tresmeses previa motivación del Responsable del Sistema Interno de Información ycon el fin de dejar evidencia del funcionamiento del sistema.</li></ul><p>En caso de que la comunicación sea admitida a trámite, los datos personales serán tratados por el tiempo necesario para llevar a cabo la investigación y cumplir con obligaciones legales. Una vez concluida la investigación, los datos personales serán conservados por el tiempo necesario para adoptar y ejecutar las medidas que correspondan y, tras ello, por el plazo máximo de prescripción de cualesquiera acciones legales o contractuales. En ningún caso se conservarán los datos por un período superior a diez años. Si se acreditara que la información facilitada o parte de ella no es veraz, se procederá a su inmediata supresión desde el momento en que se tenga constancia de dicha circunstancia, salvo que dicha falta de veracidad pueda constituir un ilícito penal, en cuyo caso se guardará la información por el tiempo necesario durante el que se tramite el correspondiente procedimiento judicial.</p><p>Aquellas <strong>denuncias orales,</strong> deberán quedar documentadas, previo consentimiento del informante, a través de una grabación en un formato duradero, seguro y accesible, o de una transcripción completa y exacta, en cuyo caso se ofrecerá al informante la oportunidad de comprobar, rectificar y aceptar mediante su firma la transcripción de la conversación. A estos efectos, se entiende que, al formular la comunicación verbalmente, el informante acepta y es consciente de que la misma será documentada por alguna de las vías anteriores.</p>",
      descrip8:
        "<h3>8. ¿A QUÉ DESTINATARIOS SE COMUNICARÁN SUS DATOS PERSONALES?</h3><p>Sus datos no se comunicarán a terceros, salvo autorización expresa o bien, en los casos legalmente admisibles, se facilitará información a las Autoridades Públicas como: a las Autoridades Tributarias, para el cumplimiento de obligaciones fiscales; a las Administraciones competentes, Fuerzas y Cuerpos de Seguridad del Estado Jueces y Tribunales y a la Agencia Española de Protección de Datos, en cumplimiento de obligaciones legales de los Responsables del Tratamiento o para el caso de conflictos relacionados con derechos de los consumidores, derecho de protección de datos, derecho de propiedad intelectual o industrial, o con cualesquiera otros bienes y/o derechos protegidos.  Así como, como a entidades financieras para la gestión de cobros y pagos.</p><p>Del mismo modo, algunas entidades subcontratadas por RISI podrían acceder a los datos personales e información como encargados o sub encargados del tratamiento para prestarnos el servicio necesario. Estos proveedores de servicios firman un contrato que les obliga a utilizar su información personal únicamente para la prestación de los servicios informados en esta política.  Esto incluye a terceros que nos permiten responder a sus consultas, call center, brindar servicios al consumidor, participar en nuestras promociones, alojar nuestros sitios web, entregar comunicaciones de marketing y analizar información.</p><p>En relación al Canal de Denuncias, los datos serán tratados por la persona responsable del mismo y sólo, serán comunicados a terceros cuando sea apropiado para llevar a cabo la investigación o para la posterior adopción de las medidas correctivas correspondientes (por ejemplo, el responsable de RRHH cuando proceda adoptar medidas disciplinarias contra un trabajador, o el responsable de servicios jurídicos si procediera adoptar medidas legales en relación con los hechos relatados).</p>",
      descrip9:
        "<h3>9. MEDIDAS DE SEGURIDAD DE LA INFORMACIÓN.</h3><p>RISI, garantiza el buen uso de la información, y en especial, la plena confidencialidad de los datos de carácter personal contenidos en nuestro sistema, así como el pleno cumplimiento de las obligaciones en materia de protección de datos de carácter personal.</p><p>RISI tiene implantadas las medidas de seguridad de índole técnica y organizativas necesarias para garantizar la seguridad de sus datos de carácter personal y evitar su alteración, pérdida y tratamiento y/o acceso no autorizado, habida cuenta del estado de la tecnología, de la naturaleza de los datos almacenados y de los riesgos a que están expuestos, ya provengan de la acción humana o del medio físico o natural.</p>",
      descrip10:
        "<h3>10. ¿CUÁLES SON SUS DERECHOS CUANDO NOS FACILITA INFORMACIÓN PERSONAL?</h3><p>Le informamos que, en cualquier momento, puede ejercer sus derechos de acceso, rectificación, oposición, supresión, portabilidad, no ser objeto de decisiones automatizadas y limitación del tratamiento ante RISI.</p><h4>10.1 ¿En qué consisten tus derechos como Interesado?</h4><ul><li>Derecho de acceso: tienes derecho a obtener confirmación sobre si RISI trata sus datos personales, así como a acceder a los mismos.</li><li>Derecho de rectificación: podrá solicitar la modificación o rectificación de los datos personales que sean inexactos.</li><li>Derecho de supresión: podrá solicitar la supresión de sus datos personales.</li><li>Derecho de limitación del tratamiento: En determinadas circunstancias, podrá solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente se conservarán para el ejercicio o la defensa de reclamaciones.</li><li>Derecho de oposición: podrá oponerse al tratamiento de sus datos para la finalidad que especifique.</li><li>Derecho a no ser objeto de decisiones individuales automatizadas: tiene derecho a no ser objecto de una decisión basada únicamente en el tratamiento automatizado, incluida la elaboración de perfiles, que pueda producir efectos jurídicos o le afecte significativamente de modo similar.</li><li>Derecho de portabilidad: si la web lo permite, podrá ejercer el derecho a la portabilidad de sus datos, en un formato estructurado, de uso común y lectura mecánica, y a transmitirlos a otro responsable del tratamiento.</li></ul><h4>10.2 ¿Cómo ejerzo mis derechos?</h4><p>Según el tipo de información que tratemos de usted, podrá dirigirse a RISI o a los proveedores con los que trabajamos para tratar sus datos en relación a campañas de publicidad, call center, atención al cliente o similares, para ello sugerimos que preste atención a la cláusula de información en materia de protección de datos de la campaña en cuestión.</p><p>El ejercicio de sus derechos será totalmente gratuito.</p><p>La oposición a una determinada finalidad o la revocación de los consentimientos otorgados no afectarán a la utilización que pueda hacer de la web, ni a la licitud del tratamiento de manera previa a la oposición o revocación del consentimiento.</p><p>Los consentimientos otorgados podrán revocarse mediante el envío de un correo electrónico a: <a href='mailto:risi@risi.es' target='_blank'>risi@risi.es</a> y/o en el link puesto a su disposición para darse de baja, en este tipo de envíos ubicado en cada una de las comunicaciones recibidas.</p><p><strong>En cualquiera caso, deberá hacer la solicitud indicando el ejercicio del derecho y el canal por el cual se desea recibir la respuesta. Asimismo, se deberá indicar la persona que ejerce el derecho, adjuntando una copia del documento de identidad. De lo contrario no se podrá atender su solicitud con las mínimas garantías.</strong></p><p>Finalmente, si considera que no ha obtenido satisfacción en el ejercicio de sus derechos o no está conforme con el tratamiento llevado a cabo de sus datos personales, puede presentar una reclamación ante la Agencia Española de Protección de Datos a través de su página web <a href='mailto:www.aepd.es' target='_blank'>www.aepd.es</a>.</p>",
      descrip11:
        "<h3>11. MODIFICACIONES.</h3><p>Nos reservamos el derecho a modificar la presente Política para adaptarla a novedades legislativas o jurisprudenciales. En caso que se produzcan cambios en la misma RISI informará oportunamente.</p></br><p><strong>ÚLTIMA ACTUALIZACIÓN: Enero de 2024.</strong></p>"
    },
    bases_legales_risi: {
      risketos: "BBLL RISKETOS NUEVO PACKAGING Y X-HOT",
      mios: "BBLL CASHBACK RISI MIOS HORNEADOS",
      pipas: "BBLL Promoción Pipas",
      menosAire: "BBLL Promoción #MENOSAIREMÁSDISFRUTE",
      patatas: "BBLL Sorteo Patatas IG",
      trikers: "BBLL Promoción Trikers",
      fabs: "BBLL Promoción FABS"
    },
    daganzo: {
      text1:
        "En nuestra fábrica de Daganzo de Arriba (Madrid) elaboramos snacks y aperitivos Risi.",
      text2: "Certificados",
      text3: "Política Medioambiental"
    },
    promocionEspiral: "Disfruta de nuestras promociones",
    promocionCta: "Ver Bases Legales",
    promocionesList: [
      {
        img: "/static/img/banner-home/mios-es.jpg",
        url: "/static/pdf/bbll-promocion-mios.pdf"
      }
    ],
    newsletter: {
      popup: {
        title: "Únete a nuestra newsletter y recibe contenido exclusivo",
        cta: "SUSCRIBIRSE"
      },
      banner: {
        title1: "Únete a nuestra ",
        title1_1: "newsletter",
        title1_2: "y recibe directamente en tu bandeja de entrada",
        title2: "CONTENIDO EXCLUSIVO",
        title3: "SORTEOS ESPECIALES",
        title4: "Y MUCHO MÁS",
        tipoContactoLabel: "Tipo de contacto",
        tipoContactoOptions: ["CONSUMIDOR", "DISTRIBUIDOR", "VENDEDOR"],
        obligatorioFechaNacimiento:
          "El campo fecha de nacimiento es obligatorio",
        msg_succes:
          "¡MUCHAS GRACIAS! <br> Su suscripción se ha formalizado correctamente.",
        msg_error: "No ha sido posible formalizar la suscripción"
      }
    }
  },
  en: {
    enlaces: {
      home: "/",
      noticias: "news",
      noticia: "new",
      sala_de_prensa: "sala-de-prensa",
      contacto: "contact",
      promociones: "promociones",
      distribuidores: "distributor",
      promocion: "promocion",
      pressroom: "pressroom",
      faqs: "faqs",
      bases_legales: "bases-legales",
      trabaja_con_nosotros: "works-with-us",
      politica_privacidad: "data-protection-policy",
      politica_cookies: "cookies-policy",
      aviso_legal: "legal-notice",
      snacks: "snacks",
      gusanitos: "snacks/gusanitos",
      palomitas: "snacks/palomitas",
      risketos: "snacks/risketos",
      mios: "snacks/mios",
      triskys: "snacks/triskys",
      matchBall: "snacks/match-ball",
      jummy: "snacks/jummy",
      otrosProductos: "snacks/other-products",
      surtis4u: "snacks/other-products/surtis",
      tejitas: "snacks/other-products/tejitas",
      buscalios: "snacks/other-products/buscalios",
      pajitas: "snacks/other-products/pajitas",
      trikers: "snacks/other-products/trikers",
      patatas: "crisps",
      originales: "crisps/originales",
      onduladas: "crisps/onduladas",
      selectas: "crisps/selectas",
      exportacion: "crisps/export",
      detodalavida: "crisps/since-the-very-beginning",
      galletas: "biscuits",
      bsan: "biscuits/b-san",
      chocolate: "biscuits/b-san-0azucares-chocolate",
      maria: "biscuits/b-san-0azucares-maria",
      adultas: "biscuits/b-san-gluten-free",
      desayuno: "biscuits/b-san-plus/singluten",
      infantiles: "biscuits/hello-kitty-doraemon",
      tradicionales: "biscuits/sin-gluten",
      plus: "biscuits/b-san-plus/with-gluten",
      fabs: "biscuits/fabs",
      caramelos: "sugars",
      azucares0: "sugars/0sugars",
      caramelosTradicionales: "sugars/traditional",
      borges: "nuts",
      frutossecos: "nuts/nuts",
      pipas: "nuts/sunflower-seeds",
      historia: "history",
      nutririsi: "nutririsi",
      quienessomos: "about-us",
      materialesprensa: "materiales-de-prensa",
      concursofulloftrickers: "fulloftrikersrandom",
      codigoconducta: "regulatory-compliance/code-of-conduct",
      cartapresidente:
        "regulatory-compliance/code-of-conduct/letter-from-the-president",
      principiosgenerales:
        "regulatory-compliance/code-of-conduct/general-principles",
      risiempleados:
        "regulatory-compliance/code-of-conduct/risi-and-its-employeers",
      risiconsumidores:
        "regulatory-compliance/code-of-conduct/risi-and-its-consumers",
      risiproveedores:
        "regulatory-compliance/code-of-conduct/risi-and-its-providers",
      risisociedad:
        "regulatory-compliance/code-of-conduct/risi-and-the-society",
      daganzo:
        "regulatory-compliance/code-of-conduct/risi-y-la-sociedad/risi-sa",
      loeches:
        "regulatory-compliance/code-of-conduct/risi-y-la-sociedad/loeches",
      matarile:
        "regulatory-compliance/code-of-conduct/risi-y-la-sociedad/matarile",
      cumplimientoetico:
        "regulatory-compliance/code-of-conduct/compliance-and-communication-channel",
      bases_legales_risi: "risi-promotion-terms-and-conditions",
      consultaComentario: "query-or-comment",
      otro: "other",
      mcdonals: "https://mcextreme.mcdonalds.es/",
      regulatory_compliance: "regulatory-compliance",
      values: "regulatory-compliance/values",
      ethical_channel: "regulatory-compliance/ethical-channel",
      sustainability: "regulatory-compliance/commitments",
      seo: {
        home: {
          title: "Risi | Snacks, Crisps, Biscuits, Sweets and Nuts",
          description:
            "Welcome to the home of iconic brands such as Gusanitos, Palomitas, Risketos, Triskys, Matchball, Pajitas, Tejitas ... and much more!"
        },
        noticias: {
          title: "Risi | RISI News and Promotions",
          description: "Don't miss out on the latest news and fun promotions."
        },
        noticia: {
          title: "Risi | RISI News and Promotions",
          description: "Don't miss out on the latest news and fun promotions."
        },
        contacto: {
          title: "Risi | Contact",
          description:
            "Contact us through our contact form or call us on 900 909 013. We will be happy to help you!"
        },
        faqs: {
          title: "Risi FAQ",
          description:
            "From Risi we answer all your questions about us and our products so that you have all the information you need."
        },
        nutririsi: {
          title: "Risi | NutriRisi",
          description:
            "We are firmly committed to quality, nutritional improvement and respect for the environment, learn more about Risi's commitment to quality!"
        },
        historia: {
          title: "Risi | History",
          description:
            "The green of Gusanitos, the red of Palomitas, the orange of Risketos... who doesn't recognise these colours? At Risi, we have been by your side since 1970. Discover our fascinating history!"
        },
        pressroom: {
          title: "Risi | Press Room",
          description:
            "Are you a press professional and do you need information about Risi? In our press room you will find all the information you need and a wide variety of materials to accompany your news."
        },
        distribuidores: {
          title: "Risi | Distributors",
          description:
            "Do you want to sell our products? Access our virtual map and contact our regional distributors."
        },
        snacks: {
          title: "Risi | The Best RISI Snacks",
          description:
            "You will find the most famous and funniest snacks in Risi, Gusanitos, Palomitas, Risketos, Matchball...does anyone know anyone who has resisted to try Risi Snacks?"
        },
        otrosProductos: {
          familia: "snacks",
          title: "Risi | Products",
          description:
            "Worms, Popcorn, Risketos, Triskys, Matchball, Straws, Tejitas ... and much more!"
        },
        gusanitos: {
          familia: "snacks",
          title: "Risi | The Real Gusanitos",
          description:
            "The most famous, delicious and irresistible baked snack with which the fun is guaranteed. Who can say no to a bag of Los Auténticos Gusanitos?"
        },
        matchBall: {
          familia: "snacks",
          title: "Match Ball Risi: light balls full of flavour",
          description:
            "The traditional Match Ball Risi balls are delicious with their cheese flavour, but you will also be surprised by the new recipes: Ketchup, Barbecue and Mini format."
        },
        mios: {
          familia: "snacks",
          title: "Míos Risi: the most sophisticated and original snack",
          description:
            "Míos is a snack specially designed for adults and has surprising flavours: Corn&Chia, Corn&Spinach, Corn&Onion, Corn&Onion, Corn&Chia, Corn&Spinach, Corn&Spinach, Corn&Spinach, Corn&Spinach"
        },
        palomitas: {
          familia: "snacks",
          title: "Risi | The Real Popcorn",
          description:
            "Authentic Popcorn is the favourite snack to make the most of your movie and blanket moments... make sure you don't miss it at home!"
        },
        risketos: {
          familia: "snacks",
          title: "Risi | Risketos",
          description:
            "An irresistible snack that leaves its mark. Super crunchy, with the most irresistible cheese flavour. Delicious and unique - get your fingers dirty with Risketos!"
        },
        triskys: {
          familia: "snacks",
          title: "Risi | Triskys",
          description:
            "Delicious, crunchy and round corn rings that will make you reconnect with the best moments. Choose the original flavour of your usual Triskys or the delicious ham or barbecue flavoured Triskys - irresistible!"
        },
        jummy: {
          familia: "snacks",
          title: "Risi | Jummy",
          description:
            "Fun and entertainment, that's Jummy. The star that we are born to stay and with what we promise does not always leave lovers of authenticity and innovation indifferent. Are you going to lose?"
        },
        exportacion: {
          familia: "patatas",
          title: "Risi : RISI Crisps",
          description:
            "At Risi we have been making good fries for a lifetime, with the best ingredients and authentic flavours. Discover our Original, Wavy and Select potatoes!"
        },
        galletas: {
          title: "Risi | BSAN and FABS biscuits",
          description:
            "Delicious premium biscuits for all tastes and needs: BSAN biscuits to take care of you in a holistic way and our FABS biscuits, with the most authentic and exclusive flavours of the best chocolates in the world."
        },
        bsan: {
          familia: "galletas",
          title: "Risi | Galletas BSAN  y FABS",
          description:
            "Deliciosas galletas premium para todos los gustos y necesidades: Galletas BSAN para cuidarte de forma integral y nuestras galletas FABS , con los sabores más auténticos y exclusivos de los mejores chocolates del mundo."
        },
        chocolate: {
          familia: "galletas",
          title: "RISI | BSAN 0% Added Sugars Biscuits, Chocolate",
          description:
            "BSAN biscuits coated in delicious chocolates: milk, dark and white. And best of all, they are delicious with 0% sugar!"
        },
        maria: {
          familia: "galletas",
          title: "RISI/ BSAN 0% Added Sugars Maria Biscuits",
          description:
            "The traditional BSAN Maria type 0% sugars, perfect for a healthy breakfast. With sesame seeds or with spelt, which one do you choose?"
        },
        adultas: {
          familia: "galletas",
          title: "Risi : BSAN Gluten Free Biscuits for Adults",
          description:
            "Delicious gluten-free BSAN biscuit, coated in intense dark chocolate with 70% cocoa. Crunchy and surprisingly tasty."
        },
        desayuno: {
          familia: "galletas",
          title: "RISI | BSAN Gluten Free Children's Biscuits",
          description:
            "Delicious biscuits made with corn flour and rice that will delight the little ones at home with their favourite characters, ¡HolaKitty and Doraemon! Includes gift."
        },
        infantiles: {
          familia: "galletas",
          title: "Virginias Infantiles: the best biscuits for children",
          description:
            "Biscuits made with corn, gluten-free and lactose-free in the shape of the children's favourite characters: Hello Kitty and Doraemon."
        },
        tradicionales: {
          familia: "galletas",
          title:
            "Traditional Virginias: the perfect breakfast for the whole family",
          description:
            "Biscuits with a high cereal and fibre content, ideal for breakfast with the family. Choose between Super Maria 0% and Digestiva Chocolate."
        },
        plus: {
          familia: "galletas",
          title: "Virginias Infantiles: the best biscuits for children",
          description:
            "Biscuits made with corn, gluten-free and lactose-free in the shape of the children's favourite characters: Hello Kitty and Doraemon."
        },
        fabs: {
          familia: "galletas",
          title: "RISI | FABS biscuits",
          description:
            "The first biscuits with the authentic and exclusive taste of the world's finest chocolates from Tanzania, Vietnam and Mexico."
        },
        caramelos: {
          title: "Risi | 0% Sugars or Sugared Sweets",
          description:
            "At Risi we have a wide variety of gluten-free sweets. 0% sugar sweets and sweets with sugar, fruit, citrus and menthol flavours, delicious!"
        },
        azucares0: {
          familia: "caramelos",
          title: "RISI | Sugar Free Sweets",
          description:
            "The best sweets with 0% added sugars and gluten free. Discover our candies with fruit juice and our menthol Glassmint."
        },
        caramelosTradicionales: {
          familia: "caramelos",
          title: "Risi | Sugared Sweets",
          description:
            "The traditional sweets with the best flavour of the best fruits. Delicious!"
        },
        borges: {
          title: "Risi | Borges Dried Fruits",
          description:
            "Classics that you can't miss in your pantry from the leader in nuts and dried fruits: Borges by RISI. Discover our delicious varieties of nuts: walnuts, pistachios, peanuts... and of course our irresistible seeds, to start and not stop.",
          familia: "frutos-secos"
        },
        frutossecos: {
          familia: "frutos-secos",
          title: "Risi | Borges Dried Fruits",
          description:
            "Enjoy Borges nuts with Risi: walnuts, pistachios, peanuts, hazelnuts, almonds and our delicious assorted cocktails."
        },
        pipas: {
          familia: "frutos-secos",
          title: "Risi | Nuts Sunflower Seeds",
          description:
            "Who can resist some delicious pipes? Choose between salted seeds or aguasal."
        },
        promociones: {
          title: "Risi | Promotions",
          description:
            "At Risi we like to reward your loyalty with different promotions so that you can enjoy the best prizes and advantages."
        },
        basesLegalesPromocion: {
          title: "Risi product promotions",
          description:
            "At Risi we like to reward your loyalty with different promotions so that you can enjoy the best prizes and advantages."
        },
        codigoconducta: {
          title: "Risi | Code of Conduct",
          description:
            "Risi complies with you and thanks to you we comply with everyone. Get to know the general principles of our code of conduct, on which we base our business development."
        },
        cartapresidente: {
          incodigoconducta: true,
          title: "Letter from the President",
          description: ""
        },
        risiempleados: {
          incodigoconducta: true,
          title: "Risi and its employees",
          description: ""
        },
        risiproveedores: {
          incodigoconducta: true,
          title: "Risi and its suppliers",
          description: ""
        },
        risisociedad: {
          incodigoconducta: true,
          title: "Risi and society",
          description: ""
        },
        daganzo: {
          title: "Risi and society - Daganzo",
          description: ""
        },
        loeches: {
          title: "Risi and society - Loeches",
          description: ""
        },
        patatas: {
          title: "Risi | RISI crisps",
          description:
            "At Risi we have been making good fries for a lifetime, with the best ingredients and authentic flavours. Discover our Original, Wavy and Select potatoes!"
        },
        originales: {
          familia: "patatas",
          title: "Patatas Originales",
          description: ""
        },
        onduladas: {
          familia: "patatas",
          title: "Patatas onduladas",
          description: ""
        },
        selectas: {
          familia: "patatas",
          title: "Patatas selectas",
          description: ""
        },
        detodalavida: {
          familia: "patatas",
          title: "De toda la vida",
          description: ""
        },
        matarile: {
          title: "Risi and society - Matarile",
          description: ""
        },
        cumplimientoetico: {
          incodigoconducta: true,
          title: "Compliance and ethical channel",
          description: ""
        },
        risiconsumidores: {
          incodigoconducta: true,
          title: "Risi and its consumers",
          description: ""
        },
        principiosgenerales: {
          incodigoconducta: true,
          title: "General Principles",
          description: ""
        },
        materialesprensa: {
          title: "Press materials",
          description: ""
        },
        concursofulloftrickers: {
          title: "Full of Trikers",
          description: ""
        },
        basesconcursofulloftrickers: {
          title: "Full of Trikers",
          description: ""
        },
        politica_privacidad: {
          title: "Data protection Risi",
          description:
            "At Risi we guarantee the privacy and protection of your data."
        },
        politica_cookies: {
          title: "Risi Cookie Policy",
          description:
            "Find out all the details in information about our cookie policy."
        },
        aviso_legal: {
          title: "Risi Legal Notice",
          description: ""
        },
        bases_legales_risi: {
          title: "Risi Legal Basis",
          description: ""
        },
        regulatory_compliance: {
          title: "Normative compliance"
        },
        values: {
          title: "Values"
        },
        ethical_channel: {
          title: "Ethical channel"
        },
        sustainability: {
          title: "Commitments"
        }
      }
    },
    header: {
      patatas: "Crisps",
      snack: "Snacks",
      galletas: "Biscuits",
      caramelos: "Sweets",
      tradicionales: "Traditional",
      frutosSecos: "Nuts",
      atencionCliente: "Customer Service",
      cartapresidente: "Letter from the president",
      principiosgenerales: "General principles",
      risiempleados: "Risi and its employees",
      risiconsumidores: "Risi and its </br> consumers",
      risiproveedores: "Risi and its customers and suppliers",
      risisociedad: "Risi and </br> society",
      risicumplimiento: "Ethical </br>Compliance",
      inicio: "Home",
      sobre_risi: "About Risi",
      historia: "History",
      quienessomos: "About us​",
      codigoconducta: "Code of Ethics",
      conoceNuestraHistoria: "Get to know our fascinating history",
      hoyYSiempreContigo: "Today and always with you",
      blogPlacerosofia: "Pleasure-osophy Blog",
      noticias: "News",
      nutririsi: "NutriRisi",
      distribuidores: "Distributors",
      contacto: "Contact",
      siguenos: "Follow us",
      faqs: "FAQS",
      pipas: "Sunflower Seeds"
    },
    vistas: {
      productos: "Products",
      snacks: "Snacks",
      galletas: "Biscuits",
      caramelos: "Sweets",
      promociones: "Promotions",
      sobre_risi: "About Risi",
      historia: "History",
      quienessomos: "About us​​",
      nutririsi: "Nutririsi",
      noticias_risi: "Risi News",
      faqs: "Faqs",
      contacto: "Contact",
      profesionales: "Professionals",
      distribuidores: "Distributors",
      press_room: "Press Room",
      legal: "Legal",
      politica_cookies: "Cookies Policy",
      aviso_legal: "Terms And Conditions",
      proteccion_datos: "Data Protection",
      bases_legales_risi: "Risi Promotion Terms And Conditions",
      materialesprensa: "Press Materials",
      regulatory_compliance: "Regulatory compliance",
      codigoconducta: "Code of ETHICS",
      values: "Values",
      ethical_channel: "Ethical channel",
      sustainability: "Commitments"
    },
    infoFooter: "©Risi 2024. All Rights Reserved",
    descubrir: "Find out more",
    todosNuestrosSnacks: "All<span>our snacks</span>",
    sinGluten: "Gluten-Free",
    sinFrutosCascara: "Nut free",
    valorNutricional: "Nutritional Value",
    valorEnergetico: "Energy",
    hidratosCarbono: "Carbohydrate",
    delosCualesAzucares: "of which Sugars",
    delosCualesPolialcoholes: "of which Polyols",
    grasas: "Fat",
    saturadas: "of which Saturates",
    sal: "Salt",
    proteinas: "Protein",
    fibraAlimentaria: "Dietary Fibre",
    verIngredientes: "See ingredients",
    origen: "ORIGIN",
    maridaje: "MARRIAGE",
    notasCata: "TASTING NOTES",
    verAlegenos: "See allergens",
    verCata: "SEE TASTING <strong> by David Pallás</strong>",
    koala: "Koala",
    galletasCon: "Biscuits with",
    todosNuestrasGalletas: "All<span>our biscuits",
    sweetlover: "¡Sweet Lovers!",
    todosNuestrosCaramelos: "All<span>our sweets</span>",
    saludablesDeliciosos: "Healthy and delicious!",
    todosNuestrosFrutos: "All<span>our nuts</span>",
    todosNuestrasPatatas: "All<span>our crisps",
    conoce: "Know",
    nuestra: "our",
    historiaText: "history",
    irAHistoria: "Go to History",
    vermas: "See more",
    descargar: "Download",
    volver: "Back to",
    recetas: "Recipes",
    alaSarten: "Frying pan",
    masCrujientes: "More crispy",
    masSabor: "More flavour!",
    sigueA: "Follow ",
    acercate: "Check out",
    vernuestras: "Our",
    promociones: "promotions",
    todas: "All",
    lasPromos: "promotions",
    regulatory_compliance: {
      modules: [
        {
          path: "enlaces.codigoconducta",
          title: "CODE OF ETHICS",
          icon: "code-conduct.svg"
        },
        {
          path: "enlaces.values",
          title: "VALUES",
          icon: "values.svg"
        },
        {
          path: "enlaces.ethical_channel",
          title: "ETHICAL CHANNEL",
          icon: "ethical.svg"
        },
        {
          path: "enlaces.sustainability",
          title: "COMMITMENTS",
          icon: "sustainability.svg"
        }
      ],
      ethical: {
        label: "CANAL ÉTICO",
        title: "POLÍTICA GENERAL DEL SISTEMA INTERNO DE INFORMACIÓN",
        objetive: "Objetivo:",
        descrip1:
          "Establecer el procedimiento a seguir en caso de detectar cualquier incidencia o comportamiento contrario a los valores de la compañía, a su código de conducta, infracción normativa o susceptible de generar responsabilidad penal.",
        introduction: "1. Introducción",
        descrip2:
          "La Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción (en adelante, Ley 2/2023) establece los elementos que integran el Sistema Interno de Información, entre ellos, el Procedimiento de Gestión de Informaciones, la Política del Sistema Interno de Información (la cual incorpora las garantías de protección a los informantes), y el Canal Ético de Información de RISI.",
        descrip3:
          "El Consejo de Administración de RISI, S.A. (en adelante, “RISI”), en su voluntad de cumplir con la legislación vigente en cada momento, aprueba y suscribe la presente Política (en adelante, la “Política”) como parte del Sistema Interno de Información implantado para todas las sociedades que forman parte de RISI.",
        descrip4:
          "De igual forma, se procede al nombramiento de un Responsable del Sistema Interno de Información.",
        subjective: "2. Ámbito subjetivo",
        descrip5:
          "Esta Política se aprueba con el fin de establecer los principios básicos del Sistema Interno de Información de RISI y, en concreto del Canal Ético, que está disponible para los siguientes informantes:",
        descrip6:
          "Miembros de los órganos de administración, directivos y empleados de las empresas que forman parte de RISI (incluyendo exempleados, trabajadores autónomos, en prácticas, en proceso de selección).",
        descrip7:
          "Empleados de proveedores, contratistas, subcontratistas o socios de negocio.",
        descrip8:
          "Todos aquellos terceros con los que RISI mantenga una relación profesional directa o indirecta.",
        descrip9:
          "Todos los sujetos incluidos están referidos a cualquiera de las filiales sobre las que, de forma directa o indirecta, RISI ejerza el control efectivo.",
        descrip10:
          "Las sociedades sobre las que RISI tenga control, en los términos del artículo 42.1 del Código de Comercio, (las “Entidades de RISI”), también se verán vinculadas por los principios éticos y normas establecidos en la presente Política. A RISI y las Entidades de RISI se les denominará, en lo sucesivo, “RISI” o la “Compañía”.",
        communication: "3. Definición de comunicación",
        descrip11:
          "La consulta se define como la solicitud de información para conocer la interpretación de los principios y directrices contenidos en el Código de Conducta y la normativa interna que nos es de aplicación.",
        descrip12:
          "La información o denuncia se define como una inquietud sobre un posible incumplimiento o comportamiento contrario a los valores y procedimientos de RISI comunicada de buena fe y conscientemente por un empleado o tercera parte a través del Canal Ético de RISI.",
        descrip13:
          "La Política pretende regular la forma en que se gestionan las informaciones recibidas sobre conductas que afecten a los profesionales o cualquier sociedad perteneciente a RISI y puedan suponer la comisión de un delito o infracción de la normativa de aplicación.",
        scopeMaterial:
          "4. Ámbito material del Sistema Interno de Información de RISI",
        descrip14:
          "A través del Canal Ético de RISI se podrán presentar consultas o denuncias referentes a la normativa de aplicación a la actividad de RISI.",
        descrip15: "En concreto, se podrán comunicar:",
        descrip16:
          "Consultas: se referirá al alcance y la aplicabilidad del Código Ético o de algún elemento del Sistema de Compliance en su conjunto.",
        descrip17:
          "Para realizar cualquier consulta en este sentido, RISI tiene habilitado el siguiente canal: <a href='mailto:consultacodigo@risi.es'>consultacodigo@risi.es</a>",
        descrip18:
          "Denuncias sobre posibles incumplimientos del Sistema: se referirá a cualquier incumplimiento de los elementos del Sistema de Compliance que comprende en este concepto todas las infracciones del Código Ético, de cualquier otro elemento del Sistema o de cualquier otra normativa interna, así como las infracciones de cualquier normativa externa, legislación o regulación integrante del ordenamiento jurídico que resulte de aplicación, incluyendo especialmente (pero no exclusivamente) las infracciones graves o muy graves de naturaleza administrativa o penal (con especial atención a las conductas corruptas) y de la normativa de defensa  de la competencia, por su especial gravedad y por el compromiso específico que RISI asume respecto a su cumplimiento.",
        descrip19:
          "En especial, se incluyen las materias referidas en la Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informan de infracciones normativas y de lucha contra la corrupción para cuyos casos se asegurará la aplicación de los principios y prescripciones en ella establecidos.",
        descrip20:
          "RISI ha habilitado el siguiente canal: <a href='mailto:canaletico@risi.es'>canaletico@risi.es</a> para presentar las comunicaciones sobre infracciones previstas en la presente Política.",
        descrip21:
          "Quedan excluidas del alcance del presente procedimiento las informaciones vinculadas a reclamaciones sobre conflictos interpersonales o que afecten únicamente al informante y a las personas a las que se refiera la comunicación.",
        descrip22:
          "El Órgano de Gobierno de RISI ha designado a la Responsable de Cumplimiento como Responsable del Sistema Interno de Información y, por tanto, para la gestión de las informaciones o denuncias a través del Canal Ético.",
        informant: "5. Derechos y Deberes del informante",
        descrip23:
          "El Órgano de Gobierno de RISI establece que el Canal Ético de RISI se rige de conformidad a los siguientes principios:",
        descrip24:
          "<strong>Principio de buena fe</strong>. Todos los integrantes de RISI y todas las terceras partes de conformidad con lo previsto en el ámbito subjetivo del Sistema Interno de Información, deben actuar de buena fe y no hacer acusaciones falsas al manifestar sus inquietudes. La buena fe consiste en dar información sin malicia, sin considerar el beneficio personal y considerando la información veraz de forma razonable y con los medios de que dispone. El denunciante que deliberadamente haga declaraciones falsas o engañosas o de mala fe, podrá ser objeto de acciones disciplinarias de conformidad con la legislación vigente.",
        descrip25:
          "<strong>Compromiso de no represalia</strong>. RISI establece formalmente que no tolerará represalias de ningún tipo cometidas sobre aquellas personas que hagan uso de los procedimientos establecidos para la comunicación de conductas irregulares.",
        descrip26:
          "<strong>Derecho a ser informado</strong>. El denunciante o informante tiene derecho de ser informado desde la presentación de la consulta o denuncia. A estos efectos recibirá acuse de recibo de la recepción de su denuncia en el plazo de siete (7) días naturales. Asimismo, pondrá en su conocimiento, la admisión o no de la misma, o, en su caso, la existencia de una investigación interna y de su resolución en el plazo de tres (3) meses desde la recepción de la comunicación, salvo casos de especial complejidad en que este plazo podrá ser ampliado otros tres meses.",
        descrip27:
          "<strong>Derecho a la protección de los datos personales</strong>. Según la normativa vigente los Datos Personales deberán ser protegidos y tratados conforme a la Ley 2/2023, de 20 de febrero reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y la normativa de protección de datos vigente. El denunciante tiene derecho a conservar el anonimato cuando presente una comunicación o denuncia debiendo ser protegido en dicho derecho.",
        descrip28:
          "<strong>Confidencialidad</strong>. Se adoptarán las medidas necesarias para preservar la identidad y garantizar la confidencialidad de los datos correspondientes a todas las personas afectadas por la información suministrada en las denuncias. En especial, en el caso de denuncias no anónimas, la identidad del denunciante deberá mantenerse confidencial en todas las etapas del proceso de investigación y resolución de la denuncia, por lo que no se divulgará a terceros ni, por tanto, a la persona denunciada, ni tampoco a los mandos directivos del denunciante. Sin perjuicio de lo anterior, los datos del denunciante y del resto de intervinientes podrán ser objeto de comunicación a terceros para la adecuada gestión de la investigación y a los Juzgados o Tribunales, Ministerio Fiscal, Fuerzas y Cuerpos de Seguridad del Estado y demás autoridades competentes cuando resulte necesario para la tramitación de los procedimientos judiciales que, en su caso, procedan como consecuencia de las investigaciones llevadas a cabo con motivo de las denuncias formuladas.",
        accused: "6. Derechos y deberes del denunciado",
        descrip29:
          "<strong>Derecho al honor, a la presunción de inocencia y de defensa</strong>. El derecho al honor de las personas es una de las máximas de actuación de RISI. En ese sentido, pondremos la mayor atención en velar por tales derechos, garantizando los derechos de las personas denunciadas a defenderse de cualesquiera acusaciones que se dirigieran contra ellas con las máximas garantías legales. La persona afectada podrá hacer uso de sus derechos de defensa y ser asistida por la representación legal que estime oportuna.",
        descrip30:
          "<strong>Derecho a ser informado</strong>. La persona denunciada será informada de la instrucción de un procedimiento de investigación por hechos ilícitos o ilegales que pudieran serle atribuidos. En el plazo más breve posible, se le comunicará los hechos objeto de investigación y se velará por el legítimo respeto a sus derechos de defensa y presunción de inocencia.",
        descrip31:
          "<strong>Derecho a la protección de los datos personales</strong>. Según la normativa vigente los Datos Personales deberán ser protegidos y tratados conforme a la Ley 2/2023, de 20 de febrero reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y normativa de protección de datos de aplicación. Se le informará de que sus datos han sido obtenidos a través del Canal Ético cuya finalidad consiste en investigar, tramitar y resolver las comunicaciones recibidas. Solo en caso de ser necesario, al objeto de la investigación, tramitación y/o resolución, la información podrá ser cedida a terceros en cumplimiento de las obligaciones legales oportunas.",
        descrip32:
          "<strong>Deber de confidencialidad y colaboración:</strong> Tiene obligación expresa de mantener la debida confidencialidad, a salvo de su derecho de defensa. La violación por el empleado de las prevenciones advertidas dará lugar, en su caso, a las correspondientes medidas disciplinarias, sin perjuicio de la presentación de la oportuna denuncia ante las Fuerzas y Cuerpos de Seguridad, Fiscalía o el juzgado de instrucción correspondiente.",
        channel: "Canal Ético de RISI",
        descrip33:
          "El Canal Ético de RISI es un medio seguro y confidencial que permite a los empleados y otras partes interesadas (con el alcance señalado en el apartado 2 de la presente Política) informar de conductas inapropiadas, irregularidades o cualquier otra situación que pueda suponer una infracción normativa de conformidad con lo previsto en la Ley 2/2023 y afectar negativamente la reputación de RISI.",
        descrip34:
          "El Canal Ético de Información de RISI permite la presentación de:",
        descrip35:
          "<strong>Comunicación escrita:</strong> a través de dirección de correo electrónico. ",
        descrip36:
          "<strong>Comunicación presencial:</strong> previa solicitud del informante que será atendida en el plazo de siete (7) días naturales. ",
        descrip37:
          "Las comunicaciones o informaciones de acuerdo con el ámbito de aplicación de esta Política también se podrán remitir a la Autoridad Independiente de Protección del Informante y a las autoridades u órganos autonómicos correspondientes, a través de sus respectivos canales habilitados para estos efectos. De igual forma, se podrán comunicar dichos hechos a las autoridades creadas al efecto por los organismos y autoridades de cualquier otro país de la Unión Europea.",
        protection: "Protección de datos de carácter personal",
        descrip38:
          "Los datos suministrados a través del Canal Ético de Información de RISI se utilizarán con el fin de gestionar las comunicaciones relacionadas con dicho canal, así como para realizar las investigaciones necesarias, impulsar la gestión y determinar si se ha producido alguna infracción o delito.",
        descrip39:
          "El acceso al Canal Ético de Información de RISI y a los datos en él contenidos está limitado exclusivamente al Responsable del Sistema Interno de Información de RISI, el equipo gestor asignado al mismo, al responsable de RRHH u órgano designado para la imposición de medidas disciplinarias, Responsable Legal, los encargados de tratamiento que eventualmente se designen y el DPO de la entidad. No obstante, el Responsable del Sistema Interno de Información podrá comunicar los datos a terceros, cuando resulte necesario para la tramitación de los procedimientos administrativos o judiciales que, en su caso, procedan.",
        descrip40:
          "Todo ello de conformidad con lo previsto en la Política de Privacidad del Canal Ético de RISI.",
        "btn-accept": "ACCEPT AND CONTINUE",
        descrip41:
          "The Ethics Channel is a communication channel provided by RISI to:",
        queries: "<strong>Doubts or Queries</strong>",
        descrip42:
          "Ask questions or request clarifications about the application of the Code of Conduct and other internal conduct regulations at RISI. If you have a query, please contact your area Manager or the Compliance Manager directly by forwarding your questions to the following email address: <a href='mailto:consultacodigo@risi.es'>consultacodigo@risi.es</a>",
        violations: "<strong>Violations or Non-Compliance</strong>",
        descrip43:
          "Report any infringements of or non-compliance with the Code of Conduct and other internal conduct regulations at RISI. If you wish to report an issue, please contact the Compliance Manager directly by writing to the following email address: <a href='mailto:canaletico@risi.es'>canaletico@risi.es</a>, or complete the form below."
      }
    },
    contacto: {
      titulo: "Contact",
      subtitulo: "These are our contact details.",
      gracias: "Thank you for participating!<br> and good luck!",
      enviado: "Sent!<br>We will contact you as soon as possible",
      enviando: "Just a moment!<br>We are sending it",
      revisa: "Please,<br> check all fields",
      puedesEnviar: "Perfect!<br>You can send it now :)",
      options: [
        {
          title: "I am interested in selling Risi products.",
          link: "distribuidores"
        },
        {
          title: "I have a question or complaint about your products.",
          link: "contacto",
          param: "consultaComentario"
        },
        {
          title: "Work with us.",
          link: "contacto",
          param: "trabaja_con_nosotros"
        },
        {
          title: "Other questions, comments or suggestions.",
          link: "contacto",
          param: "otro"
        }
      ],
      "query-or-comment": {
        title: "SEND US YOUR QUERY ABOUT OUR PRODUCTS.",
        type: "4",
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Customer Support:</p><p><a href='tel:900831000'>900 83 10 00</a></p>"
          },
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p>"
          }
        ]
      },
      "works-with-us": {
        megaTitle: "WORK WITH US",
        title: "SEND US YOUR DATA AND INFORMATION.",
        type: "5",
        contacts: [
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:empleo@risi.es'>empleo@risi.es</a></p>"
          }
        ]
      },
      other: {
        title: "Send us YOUR QUESTIONS, COMMENTS OR SUGGESTIONS.",
        type: "0",
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Other queries:</p><p><a href='tel:900831000'>900 83 10 00</a></p>"
          },
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p>"
          }
        ]
      },
      hoja: [
        {
          content:
            "<img class='icon' src='/static/img/location.svg' alt='Icon-location'><p><strong>Polígono industrial Gitesa</strong></p><p>c/ Severo Ochoa, 2 Daganzo de Arriba 28814 - Madrid</p>"
        },
        {
          title: "Customers and distributors:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:900909013'>900 909 013</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:pedidos@risi.es'>pedidos@risi.es</a></p></div>"
        },
        {
          title: "Consumer:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:900831000'>900 831 000</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p></div>"
        },
        {
          title: "Employment:",
          content:
            "<div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:empleo@risi.es'>empleo@risi.es</a></p></div>"
        },
        {
          title: "Other queries:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:918782110'>918 782 110</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:risi@risi.es'>risi@risi.es</a></p></div>"
        }
      ]
    },
    patatas: {
      ySiNosVamos: "And if you're",
      fuera: "abroad",
      detodalavida: {
        titulo: "Since the very beginning",
        enrisillevamos: "At Risi, we have been",
        haciendoPat: "making delicious crisps",
        en1970: "In 1970, we opened our",
        dePatatas: "in Madrid",
        nuestrasRecetas: "We use traditional recipes,",
        deSiempre: "made with",
        yahoraMejores: "and now they're even better with",
        rompemosReglas:
          "<strong> We know how frustrating it is to find that your bag of crisps is full of air. <span>However, air is actually really important so the crisps stay tasty and fresh and don't break</span>, because they're quite fragile.</strong></p> But at RISI, we're doing everything we can to keep that air to a minimum so that:",
        disfrutarBolsa: "You can enjoy a bag",
        bolsaLlena:
          "70% of the bag is full of crisps. Don't believe us? <strong>We promise!</strong> It's one of our main priorities and quality standards in our factory.",
        reducirPlasti: "We can reduce the use of plastic",
        consiguiendImpacto:
          "This way, we can have a positive impact on the environment by only using as much plastic as strictly necessary so that you can enjoy the very best crisps."
      },
      originales: {
        titulo: "Las Originales"
      },
      onduladas: {
        titulo: "Las Onduladas"
      },
      selectas: {
        titulo: "Selectas"
      },
      exportacion: {
        titulo: "Exportation",
        subtitulo:
          "Our pan-fried recipes. Now crunchier and more delicious than ever!"
      }
    },
    snacks: {
      gusanitos: {
        titulo: "Gusanitos",
        subtitulo:
          "The genuine Gusanitos! The delicious baked snack that tastes even better shared with friends.",
        yummy1: "Corn 🌽, sunflower oil 🌻, salt and lots of  💚",
        yummy2: "Give them a dip in the sauce!"
      },
      palomitas: {
        titulo: "Palomitas",
        subtitulo:
          "The authentic Palomitas!<br>For all tastes, classic, sweet, caramel...<br>Which are your favourites?",
        yummy1: "Those of all times",
        yummy2: "Two flavours",
        yummy3: "that go ",
        yummy4: "together ",
        yummy5: "perfectly",
        yummy6: "mmmm...",
        yummy7: "Choco...",
        yummy8: "Get ready to <br>lick your fingers!",
        newflavor: "New Flavor"
      },
      risketos: {
        titulo: "Risketos",
        subtitulo:
          "Very, very, very crunchy, delicious snacks! It's the Risketos battle, choose your favourite!",
        yummy1: "You'll be licking your fingers clean!",
        yummy2: "Discover <br>a new flavour!"
      },
      mios: {
        titulo: "Mios",
        subtitulo:
          "A sophisticated, adult snack that guarantees pleasure and flavour.",
        yummy1: "New!",
        yummy2: "Have you tried baked Mios yet?",
        yummy3: "Let yourself be carried away by the new flavours",
        yummy4: "Delicious corn hexagon snacks",
        yummy5: "Natural ingredients!"
      },
      triskys: {
        titulo: "Triskys",
        subtitulo: "Delicious and exceedingly crunchy corn rings!",
        yummy1: "With the traditional taste",
        yummy2: "With a unique touch",
        yummy3: "The flavor of always!",
        yummy4: "Have you tried HAM flavor?"
      },
      matchBall: {
        titulo: "MatchBall ",
        subtitulo:
          "The tastiest flavours! Cheese, ketchup or barbecue. You choose!",
        yummy1: "The authentic cheese balls",
        yummy2: "New format, straight from the pack and into your mouth"
      },
      jummy: {
        titulo: "Jummy ",
        subtitulo:
          "Fun and entertainment, that's Jummy.<br> The star that we are born to stay and with what we promise does not always leave lovers of authenticity and innovation indifferent. <br>Are you going to lose?"
      },
      otrosProductos: {
        titulo: "Other products",
        yummy1: "BBQ-flavour<br>corn fajitas",
        yummy2: "The cheesy taste<br> that melts in the mouth",
        yummy3: "Our best <br>products in <br>a single bag",
        yummy4: "Potato <br>Snack"
      }
    },
    galletas: {
      bsan0: {
        titulo: "B-SAN 0% AZÚCARES",
        subtitulo:
          "Delicious wheat biscuits with oats and barley, fully covered with chocolate and no added sugars<br> Towards a healthier life!",
        subtituloMaria:
          "Biscuits for a delicious and healthy breakfast, <br>with no added sugars.",
        banadas: "COATED",
        maria: "MARÍA",
        yummy1: "0% added sugars",
        yummy2: "With sesame!",
        yummy3: "Source of fibre"
      },
      bsan0SinGluten: {
        titulo: "B-SAN sin gluten",
        subtitulo: "A delicious gluten-free biscuit coated in dark chocolate"
      },
      bsanPlus: {
        titulo: "B-SAN PLUS",
        subtitulo:
          "Fun, delicious biscuits for kids.<br>With cereals and vitamins.",
        yummy1: "WITH GLUTEN",
        yummy2: "GLUTEN-FREE",
        yummy3: "Lactose-free"
      },
      bsanDesayuno: {
        titulo: "B-SAN PLUS",
        subtitulo:
          "Fun and tasty gluten-free biscuits for kids. <br>Made from corn and contain lots of vitamins.",
        yummy1: "Low in salt!"
      },
      fabs: {
        subtitulo:
          "<strong>Feel the peace of nature where our cocoa</strong> from Tanzania, Vietnam and Mexico has been grown while you enjoy the taste of <strong>the best chocolates in the world</strong> with FABS ORIGIN.",
        yummy1: "Intense chocolate!",
        yummy2: "MEETING A",
        yummy3:
          "EXPERIENCE A JOURNEY TO THE ORIGINS OF CHOCOLATE WITH DAVID PALLÀS"
      }
    },
    caramelos: {
      azucares0: {
        titulo: "0% Added Sugars",
        subtitulo: "Delicious gluten-free sweets with 0% added sugars!",
        yummy1: "Sugarfree ",
        yummy2: "A moment of sweetness",
        yummy3: "Refreshing!"
      },
      tradicionales: {
        titulo: "Traditional",
        subtitulo: "Traditional sweets with the best fruit flavours.",
        yummy1: "Simply delicious!",
        yummy2: "Fruit sweets",
        yummy3: "Intense <br>flavour"
      }
    },
    frutosSecos: {
      frutosSecos: {
        subtitulo:
          "For enjoying the moment... to the max!<br>The best ingredients for a healthy and delicious snack.",
        yummy1: "A classic that never fails!",
        yummy2: "So crunchy!",
        yummy3: "All energy!",
        yummy4: "Enjoy it in salad!",
        yummy5: "Crunchy, crunchy!",
        yummy6: "Carefully selected for you!"
      },
      pipas: {
        subtitulo: "Who could resist some delicious sunflower seeds?",
        yummy1: "You won't be able to stop",
        yummy2: "Tasty and delicious"
      }
    },
    formulario: {
      nombre: "Name",
      apellidos: "Last name",
      email: "E-mail address",
      mensaje: "Message",
      asunto: "Subject",
      medioComunicacion: "Media",
      he_leido: "I have read and accept the",
      y_acepto: "Data Protection Policy",
      enviar: "Send",
      enviado: "Sent",
      telefono: "Telephone No.",
      provincia: "Province",
      localidad: "Town/City",
      calle: "Postal address (Street, number and town)",
      cp: "Postcode",
      cv: "Attach CV",
      fecha_nacimiento: "Date of birth",
      documentation: "Attach Documentation",
      publicidad:
        "I consent to the sending of commercial communications about products and services of the Risi group as well as the automated processing to be able to optimize and personalize said offers."
    },
    meses: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
      "September",
      "October",
      "November",
      "December"
    ],
    productos: {
      "gusanitos-tradicionales": {
        family: "gusanitos",
        type: "left",
        titulo: "Gusanitos Originales",
        packs: "18g, 35g, 85g, 105g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "<strong>The real Gusanitos!</strong> The classic snack adored by children and adults alike. ",
        introDos:
          "Baked corn snack with no colourings or preservatives. <br>Who could say no to a bag of Gusanitos?",
        introMovil:
          "<strong>The real Gusanitos!</strong> The classic snack adored by children and adults alike. Baked corn snack with no colourings or preservatives. Who could say no to a bag of Gusanitos?",
        ingredientes:
          "Cornmeal, sunflower oil (17.4%), salt and natural seasoning. May contain <u>milk protein</u>. May contain <u>mustard</u>.",
        cantidadValor: "100g",
        hashtag: "#GusanitoOriginal",
        energia: "1.965kJ, 467kcal",
        hidratos: "71,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "17,4 g",
        saturadas: "2,2 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,6 g",
        mostrarSinLactosa: "1"
      },
      "gusanitos-ketchup": {
        family: "gusanitos",
        type: "left",
        titulo: "Gusanitos Kétchup",
        cantidadValor: "100g",
        hashtag: "#GusanitosKétchup",
        intro:
          "Our legendary Gusanitos now come in a <strong>delicious ketchup flavour</strong>. You'll love them. ",
        introDos: "No preservatives or artificial colourings.",
        introMovil:
          "Our legendary Gusanitos now come in a <strong>delicious ketchup flavour</strong>. You'll love them. No preservatives or artificial colourings.",
        ingredientes:
          "Cornmeal, sunflower oil (18.4%), ketchup seasoning [sugar, yeast extract, fructose, tomato, onion and dried garlic, flavouring, acids (citric and malic acid), paprika and colouring (paprika extract)] and salt. May contain <u>milk protein</u> and <u>mustard.</u>",
        packs: "35g, 85g, 105g",
        energia: "2.065kJ, 492kcal",
        hidratos: "67,7 g",
        azucares: "5,4 g",
        grasas: "22 g",
        polialcoholes: "",
        saturadas: "2,8 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "5,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "palomitas-original": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Original",
        cantidadValor: "100g",
        hashtag: "#PalomitasOriginal",
        intro: "The originals, <strong>our most classic flavour</strong>.",
        introDos: "<br>Impossible to resist that buttery taste!",
        introMovil:
          "The originals, <strong>our most classic flavour</strong>. Impossible to resist that buttery taste!",
        ingredientes:
          "Cornmeal, sunflower oil (18.6%), butter seasoning [flavouring substances, lactose, dextrose, sugar, whey, maltodextrin, modified starch and flavour enhancers (E621)] and salt. May contain <u>mustard</u>.",
        packs: "35g, 90g, 105g",
        energia: "1.990kJ, 474kcal",
        hidratos: "71 g",
        azucares: "1,5 g",
        grasas: "18,6 g",
        saturadas: "2,4 g",
        fibra: "",
        polialcoholes: "",
        sal: "1,8 g",
        proteinas: "5,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "palomitas-ketchup-mostaza": {
        family: "palomitas",
        type: "right",
        titulo: "Palomitas Kétchup & Mostaza",
        cantidadValor: "100g",
        hashtag: "#PalomitasKétchup&Mostaza",
        intro:
          "<strong>Are you ready to mix? </strong>The most popular Palomitas. ",
        introDos: " <br>With two flavours that do wonders together.",
        introMovil:
          "<strong>Are you ready to mix? </strong>The most popular Palomitas. ",
        ingredientes:
          "Cornmeal, sunflower oil (17.1%), ketchup-mustard seasoning [flavouring substances (contains mustard), sugar, salt, maltodextrin, yeast extract, fructose, dried tomato, dried onion, dried garlic, acids (citric and malic acid), flavour enhancers (E621), dextrose, colourings (paprika and turmeric extract) and honey]. May contain <u>milk protein</u>.",
        packs: "35g, 90g",
        energia: "1.977kJ, 470kcal",
        hidratos: "73 g",
        azucares: "2,9 g ",
        grasas: "17,1 g",
        polialcoholes: "",
        saturadas: "2,1 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "6,1 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "palomitas-pizza": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Pizza",
        cantidadValor: "100g",
        hashtag: "#PalomitasPizza",
        intro:
          "If you love pizza and also love our legendary Palomitas, <strong>this is the snack for you!</strong>",
        introDos: " Palomitas with the taste of Italy.",
        introMovil:
          "If love pizza and also love our legendary Palomitas, this <strong>is the snack for you</strong>! ",
        ingredientes:
          "Cornmeal, sunflower oil (22.7%), pizza seasoning [flavouring (contains <u>milk</u>), maltodextrin, sugar, flavour enhancers (E621 and E635), colouring (paprika extract) and acid (citric and malic acid)] and salt. May contain <u>mustard</u>.",
        packs: "35g, 90g",
        energia: "1.882kJ, 450kcal",
        hidratos: "55,5 g",
        azucares: "4,4 g",
        polialcoholes: "",
        grasas: "22,7 g",
        saturadas: "2,7 g",
        fibra: "",
        sal: "1,8 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "palomitas-chocolate-blanco": {
        family: "palomitas",
        type: "right",
        titulo: "Palomitas Bombón Blanco",
        cantidadValor: "100g",
        hashtag: "#Palomitaschocoblanco",
        intro:
          "<p>For those who just can't live without chocolate... here are our Palomitas <strong>coated in delicious white chocolate.</strong></p>",
        introDos: "One of our most special combinations!",
        introMovil:
          "For those who just can't without chocolate...here are our Palomitas <strong>coated in delicious white chocolate.</strong>",
        ingredientes:
          "Sugar, hydrogenated palm oil, cornmeal, whey powder, skimmed milk powder, emulsifier (<u>soya</u> lecithin) and flavourings (milk and vanilla). May contain <u>nuts</u> (almonds and hazelnut).",
        packs: "30g, 80g",
        energia: "2.365kJ, 567kcal",
        hidratos: "62,2 g",
        polialcoholes: "",
        azucares: "46,0 g",
        grasas: "33,8 g",
        saturadas: "31,0 g",
        fibra: "",
        sal: "0,3 g",
        proteinas: "2,4 g",
        hasFrutosSecos: "1"
      },
      "palomitas-caramelo": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Caramelo",
        cantidadValor: "100g",
        hashtag: "#PalomitasCaramelo",
        intro:
          "Perfect for <strong>sweet</strong> tooths!... Our sweetest variety of Palomitas.",
        introDos: " You'll love them!",
        introMovil:
          "Perfect for <strong>sweet</strong> tooths!... Our sweetest variety of Palomitas. You'll love them!",
        ingredientes:
          "Sugar, cornmeal, glucose syrup, sunflower oil (14.6%), butter, sunflower lecithin, caramel and salt. contains <u>milk</u> and derivatives. May contain <u>soya and nuts (almonds and hazelnuts)</u>.",
        packs: "30g, 80g",
        energia: "1.799kJ, 428kcal",
        hidratos: "70,7 g",
        polialcoholes: "",
        azucares: "47,6 g",
        grasas: "14,6 g",
        saturadas: "3,2 g",
        fibra: "",
        sal: "0,6 g",
        proteinas: "2,4 g",
        hasFrutosSecos: "1"
      },
      "palomitas-chocolate": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Choco",
        cantidadValor: "100g",
        hashtag: "#PalomitasChoco",
        intro:
          "Our sweet version coated in <strong>delicious chocolate</strong>.",
        introDos: "",
        introMovil:
          "Our sweet version coated in <strong>delicious chocolate</strong>.",
        ingredientes:
          "Sugar, cornmeal, partially hydrogenated palm oil, degreased cocoa powder, emulsifier (sunflower lecithin) and flavouring (vanilla). May contain <u> milk, soya and nuts (almonds and hazelnut)</u>.",
        packs: "30g, 80g, 100g",
        energia: "2.260kJ, 542kcal",
        hidratos: "56,6 g",
        polialcoholes: "",
        azucares: "41,4 g",
        grasas: "33,1 g",
        saturadas: "30,5 g",
        fibra: "",
        sal: "0,06 g",
        proteinas: "4,3 g",
        hasFrutosSecos: "1"
      },
      "palomitas-bacon-cheese": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Bacon & Cheese",
        cantidadValor: "100g",
        hashtag: "#PalomitasBacon&Cheese",
        intro: "Nuestra versión sabor <strong>bacon & cheese</strong>.",
        introDos: "",
        introMovil: "Nuestra versión sabor <strong>bacon & cheese</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (24,8%), aromas de bacon y <u>queso</u> [aroma, aroma de humo, colorantes (extracto de pimentón y curcumina)]. Contiene <u>leche y derivados</u>. Puede contener <u>mostaza</u>",
        packs: "30g, 90g",
        energia: "2.237kJ, 534kcal",
        hidratos: "72 g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "24,8 g",
        saturadas: "3 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "5,6 g",
        hasFrutosSecos: "0"
      },
      "mios-tomillo-limon": {
        family: "mios",
        type: "left",
        titulo: "Horneados con un toque de Tomillo&Limón",
        cantidadValor: "100g",
        hashtag: "#MiosTomilloyLimón",
        intro:
          "They contain protein from whole chickpeas and vitamins and minerals from spinach and <strong>onion</strong>, as well as the antioxidant properties of <strong>lemon</strong>. ",
        introDos: " Delicious, vegan and perfect for a between-meal snack!",
        introMovil: "Delicious, vegan and perfect for a between-meal snack!",
        ingredientes:
          "Cornmeal, whole lentil flour, rice flour, sunflower oil, whole chickpea flour (9%), seasoning (flavouring substances, maltodextrin, salt, sugar, lemon and dried thyme), dehydrated onion (0.9%) and dehydrated spinach (0.5%). May contain <u>milk and derivatives and mustard</u>.",
        packs: "95g",
        energia: "2.014kJ, 481kcal",
        hidratos: "60,0 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "20,6 g",
        saturadas: "2,6 g",
        fibra: "5,5 g",
        sal: "0,87 g",
        proteinas: "11,1 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-sal-pimienta": {
        family: "mios",
        type: "left",
        titulo: "Horneados con un toque de Sal Ahumada & Pimienta",
        cantidadValor: "100g",
        hashtag: "#HorneadosSalyPimienta",
        intro:
          "Mios! Baked with a touch of smoked salt and black pepper, they contain fibre from whole lentils, the energy of rice and the antioxidant properties of corn. Delicious, vegan and perfect for a between-meal snack!",
        introDos: "",
        introMovil:
          "Mios! Baked with a touch of smoked salt and black pepper, they contain fibre from whole lentils, the energy of rice and the antioxidant properties of corn. Delicious, vegan and perfect for a between-meal snack!",
        ingredientes:
          "Cornmeal (49%), whole lentil flour (19%), rice flour (19%), sunflower oil, whole chickpea flour, seasoning (flavouring substances, maltodextrin, sugar and smoked salt), pepper and colouring (paprika extract). May contain <u>milk and derivatives and mustard</u>.",
        packs: "95g",
        energia: "2.006kJ, 478kcal",
        hidratos: "62,0 g",
        polialcoholes: "",
        azucares: "3 g",
        grasas: "19,5 g",
        saturadas: "2,5 g",
        fibra: "5,2 g",
        sal: "0,61 g",
        proteinas: "11,0 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-chia": {
        family: "mios",
        type: "left",
        titulo: "Chips de Maíz & Chía",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyChía",
        intro:
          "Fried corn snack with one of the most popular superfoods, <strong>chia seeds, and with a special touch of sea salt</strong>. ",
        introDos: "Made with natural ingredients!!",
        introMovil:
          "Fried corn snack with one of the most popular superfoods, <strong>chia seeds, and with a special touch of sea salt</strong>.",
        ingredientes:
          "Corn (70%), high oleic sunflower oil (24%), chia seeds (3%) and sea salt.",
        packs: "40g, 150g",
        energia: "2.154kJ, 515kcal",
        hidratos: "64,4 g",
        polialcoholes: "",
        azucares: "1,3 g",
        grasas: "24 g",
        saturadas: "2,4 g",
        fibra: "6,0 g",
        sal: "0,9 g",
        proteinas: "7,4 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-espinacas": {
        family: "mios",
        type: "right",
        titulo: "Chips de Maíz & Espinacas",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyEspinacas",
        intro:
          "¿Te atreves con un sabor de lo más exclusivo? Delicioso aperitivo de maíz frito.",
        introDos:
          " <strong>¡Con espinacas y pimienta rosa!</strong> Y… ¡Con ingredientes naturales!",
        introMovil:
          "¿Te atreves con un sabor de lo más exclusivo? Aperitivo de maíz frito<strong> con espinacas</strong>.",
        ingredientes:
          "Maíz (64 %), aceite de girasol alto oleico (25%), espinaca deshidratada (2 %) y aroma de pimienta [sal marina, pimientas rosa, negra y blanca molidas (0,4 %), azúcar y aroma].",
        packs: "150g",
        energia: "2.257kJ, 540kcal",
        hidratos: "61,1 g",
        azucares: "1,7 g",
        polialcoholes: "",
        grasas: "28,2 g",
        saturadas: "2,8 g",
        fibra: "7,7 g",
        sal: "1,2 g",
        proteinas: "6,8 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-boletus": {
        family: "mios",
        type: "right",
        titulo: "Chips de Maíz&Boletus",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyBoletus",
        intro:
          "Are you ready to try one of the most exclusive flavours? A delicious fried corn snack with the taste of caramelised onion.",
        introDos: "",
        introMovil:
          "Are you ready to try one of the most exclusive flavours? A delicious fried corn snack with the taste of caramelised onion.",
        ingredientes:
          "Corn (68%), high oleic sunflower oil (23.5%), seasoning (flavouring substances, maltodextrin, salt, sucrose and fructose) and dehydrated boletus edulis (2%).",
        packs: "150g",
        energia: "2.087kJ, 499kcal",
        hidratos: "58,4 g",
        azucares: "2,2 g",
        polialcoholes: "",
        grasas: "25 g",
        saturadas: "2,5 g",
        fibra: "5,1 g",
        sal: "1,2 g",
        proteinas: "7,6 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-cebolla": {
        family: "mios",
        type: "left",
        titulo: "Chips de Maíz & Cebolla",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyCebolla",
        intro:
          "<strong>A delicious, sophisticated taste</strong>. Discover a snack full of flavour and, like all MIOS! Varieties... made only with natural ingredients!",
        introDos: "",
        introMovil:
          "<strong>A delicious, sophisticated taste</strong>. Discover a snack full of flavour and, like all MIOS! Varieties... made only with natural ingredients!",
        ingredientes:
          "Corn (65%), high oleic sunflower oil (23.7%), dehydrated onion (3%), balsamic vinegar of Modena (0.02%) and onion seasoning.",
        packs: "40g, 150g",
        energia: "2.191kJ, 524kcal",
        hidratos: " 61,9 g",
        polialcoholes: "",
        azucares: "3,7 g",
        grasas: " 26,5 g",
        saturadas: "2,7 g",
        fibra: "6,0 g",
        sal: " 1,2 g",
        proteinas: " 6,5 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-queso": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Cheese",
        cantidadValor: "100g",
        hashtag: "#MatchBallCheese",
        intro: "Tasty cheese balls... Mmm.... <strong>So cheesy!</strong>",
        introDos: "",
        introMovil: "Tasty cheese balls... Mmm.... <strong>So cheesy!</strong>",
        ingredientes:
          "Cornmeal, sunflower oil (23.4%), <u>cheese </u>seasoning [flavouring, maltodextrin, lactose, whey, flavour enhancers (E621 and E635) and acid (citric acid)], sugar and salt. contains <u>milk</u> and derivatives. May contain <u>mustard</u>.",
        packs: "30g, 105g",
        energia: "1.963kJ, 468kcal",
        hidratos: "64,7 g",
        polialcoholes: "",
        azucares: "8,2 g",
        grasas: "20,9 g",
        saturadas: "2,6 g",
        fibra: "",
        sal: "2,0 g",
        proteinas: "5,3 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "match-ball-ketchup": {
        family: "match-ball",
        type: "right",
        titulo: "MatchBall Kétchup",
        cantidadValor: "100g",
        hashtag: "#MatchBallKétchup",
        intro:
          "If you're one of those that adore Ketchup.... these are the MatchBalls for you <strong>! Classic MatchBalls with the taste of ketchup.</strong>",
        introDos: "",
        introMovil:
          "If you're one of those that adore Ketchup.... these are the MatchBalls for you <strong>! Classic MatchBalls with the taste of ketchup.</strong>",
        ingredientes:
          "Cornmeal, sunflower oil (22.4%), ketchup seasoning [salt, fructose, dried tomato, flavouring, acid (citric and malic acid), dried onion, dried garlic, paprika and colouring (paprika extract)] and sugar. May contain <u>milk protein</u>.",
        packs: "30g, 105g",
        energia: "2044kJ, 487kcal",
        hidratos: "70,6 g",
        polialcoholes: "",
        azucares: "12,5 g",
        grasas: "20,2 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,0 g",
        proteinas: "5,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-barbacoa": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Barbacoa",
        cantidadValor: "100g",
        hashtag: "#MatchBallBarbacoa",
        intro:
          "<strong>Do you love the taste of a good barbecue?</strong> <br>Then get a load of these MatchBalls...They're delicious!",
        introDos: "",
        introMovil:
          "<strong>Do you love the taste of a good barbecue?</strong> <br>Then get a load of these MatchBalls...They're delicious!",
        ingredientes:
          "Cornmeal, sunflower oil (23.5%), barbecue sauce seasoning [salt, maltodextrin, corn starch, dextrose, flavourings, dried onion, dried garlic, acid (citric acid), smoke flavouring and colouring (paprika extract)] and sugar. May contain <u>milk protein</u>.",
        packs: "30g, 105g",
        energia: "2057kJ, 491kcal",
        hidratos: "68 g",
        polialcoholes: "",
        azucares: "10,8 g",
        grasas: "22,2 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,3 g",
        proteinas: "4,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-minis": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Minis 27g",
        cantidadValor: "100g",
        hashtag: "#MatchBallMinis",
        intro:
          "Small but still with a big taste, and of course, a lot of cheese. <br>And best of all? In their new format, they can now go straight <strong>from the pack into your mouth</strong> Isn't that awesome?",
        introDos: "",
        introMovil:
          "Small but still with a big taste, and of course, a lot of cheese. <br>And best of all? In their new format, they can now go straight <strong>from the pack into your mouth</strong> Isn't that awesome?",
        ingredientes:
          "Cornmeal, sunflower oil (22.8%), <u>cheese </u>seasoning (flavouring, maltodextrin, lactose, whey, flavour enhancers (E621 and E635) and acid (citric acid)], sugar and salt. May contain <u>mustard</u>.",
        packs: "27g",
        energia: "2.097kJ, 500kcal",
        hidratos: "66,2 g",
        polialcoholes: "",
        azucares: "11 g",
        grasas: "24 g",
        saturadas: "3,1 g",
        fibra: "",
        sal: " 1,6 g",
        proteinas: "4,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      jummy: {
        family: "jummy",
        type: "left",
        titulo: "Jummy",
        cantidadValor: "100g",
        hashtag: "#Jummy",
        intro: "<strong>A star is born!</strong>",
        introDos: " <br>Butter-flavored baked snack product.",
        introMovil: "Butter-flavored baked snack product.",
        ingredientes:
          "Corn semolina (68%), sunflower oil, butter flavor [flavoring substances, maltodextrin, whey, salt, sugar, acidulant (citric acid), flavor enhancers (E-621 and E-635)]. <u>May contain soy.<u>",
        packs: "90g, 100g",
        energia: "1.968kJ, 469kcal",
        hidratos: "67,7 g",
        polialcoholes: "",
        azucares: "3,5 g",
        grasas: "19 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: " 1,9 g",
        proteinas: "5,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "risketos-original": {
        family: "risketos",
        type: "left",
        titulo: "Risketos Original",
        cantidadValor: "100g",
        hashtag: "#RisketosOriginal",
        intro:
          "For people who love authentic Risketos with <strong>their original flavour.</strong>",
        introDos:
          "  Crunchy and with their <strong>traditional cheesy taste.</strong>",
        introMovil:
          "For people who love authentic Risketos with <strong>their original flavour.</strong>",
        ingredientes:
          "Cornmeal, high oleic sunflower oil (26.5%), sunflower oil (9%), <u>cheese </u>seasoning [flavouring (contains <u>milk</u>), flavour enhancer (monosodium glutamate) and colouring (paprika extract)], salt and emulsifier (E471).",
        packs: "40g, 80g, 120g, 135g, 250g (XXL)",
        energia: "2.317kJ, 556kcal",
        hidratos: "53,5 g",
        azucares: "2,3 g",
        polialcoholes: "",
        grasas: "35,5 g",
        saturadas: "3,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,5 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },

      "risketos-xhot": {
        family: "risketos",
        type: "left",
        titulo: "Risketos XtraHot",
        cantidadValor: "100g",
        hashtag: "#RisketosXtraHot",
        intro:
          "Risketos for daredevils. Just as crunchy but with a different attitude. Ultra-spicy and super-tasty.",
        introDos: "",
        introMovil:
          "Risketos for daredevils. Just as crunchy but with a different attitude. Ultra-spicy and super-tasty.",
        ingredientes:
          "Cornmeal, high oleic sunflower oil (26.5%), sunflower oil (9%), spicy <u>cheese </u>seasoning [flavouring (contains <u>milk</u>) and colouring (paprika extract)], salt and emulsifier (E471). May contain <u>soya</u>.",
        packs: "40g, 120g, 135g",
        energia: "2.366kJ, 567Kcal",
        hidratos: "55,4 g",
        polialcoholes: "",
        azucares: "2,8 g",
        grasas: "36 g",
        saturadas: "3,7 g",
        fibra: "",
        sal: "0,7 g",
        proteinas: "4,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "triskys-original": {
        family: "triskys",
        type: "left",
        titulo: "Triskys Original",
        cantidadValor: "100g",
        hashtag: "#TriskysOriginal",
        intro:
          "Your classic Triskys, the authentic round, <strong>crunchy corn rings with their original flavour</strong>.",
        introDos: "",
        introMovil:
          "Your classic Triskys, the authentic round, crunchy corn rings with their original flavour.",
        ingredientes:
          "Cornmeal, high oleic sunflower oil (20%), corn starch, salt, raising agent (bicarbonate of soda), emulsifier (E471), acid (citric acid), acidity regulator (E526) and flavour. May contain <u>milk and soy</u>.",
        packs: "20g, 35g, 85g, 115g, 135g",
        energia: "1.961kJ, 467kcal",
        hidratos: "67,1 g",
        polialcoholes: "",
        azucares: "0,4 g",
        grasas: "20 g",
        saturadas: "1,8 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "4,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "triskys-jamon": {
        family: "triskys",
        type: "right",
        titulo: "Triskys Jamón",
        cantidadValor: "100g",
        hashtag: "#TriskysJamón",
        intro:
          "<strong>Tasty flavor</strong> with a unique touch that will not leave you indifferent.",
        introDos: " ",
        introMovil:
          "<strong>Tasty flavor</strong> with a unique touch that will not leave you indifferent.",
        ingredientes:
          "Cornmeal, high oleic sunflower oil (20%), corn starch, salt, seasoning [flavouring, smoke flavouring, whey, flavour enhancer (E621), colouring (paprika extract), maltodextrin], raising agent (bicarbonate of soda), emulsifier (E471), acid (citric acid) and acid regulator (E526). May contain <u>soy</u>.",
        packs: "35g",
        energia: "1.944kJ, 463kcal",
        hidratos: " 65,9g",
        polialcoholes: "",
        azucares: "1,8 g",
        grasas: " 20 g",
        saturadas: "1,7 g",
        fibra: "",
        sal: " 2,5g",
        proteinas: "4,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "triskys-barbacoa": {
        family: "triskys",
        type: "left",
        titulo: "Triskys Barbacoa",
        cantidadValor: "100g",
        hashtag: "#TriskysBarbacoa",
        intro:
          "The new flavour in town! Triskys now come with the <strong>intense taste of an authentic, crispy grill.</strong>",
        introDos: "",
        introMovil:
          "The new flavour in town! Triskys now come with the <strong>intense taste of an authentic, crispy grill.</strong>",
        ingredientes:
          "Cornmeal, high oleic sunflower oil (20.3%), corn starch, salt, barbecue sauce seasoning [flavouring, sugar, maltodextrin, spices, flavour enhancer (E621) and sweetener (E954)], raising agent (bicarbonate of soda), emulsifier (E471), acid (citric acid) and acid regulator (E526). May contain <u>milk and soy</u>.",
        packs: "115g, 135g",
        energia: "1.967kJ, 469kcal",
        hidratos: "65,4 g",
        polialcoholes: "",
        azucares: "2,8 g",
        grasas: "21 g",
        saturadas: "1,8 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "4,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      buscalios: {
        family: "otros-productos",
        type: "left",
        titulo: "Buscalios",
        cantidadValor: "100g",
        hashtag: "#Buscalios",
        intro:
          "Risi Buscalíos are delicious, crunchy corn fajitas with an intense BBQ flavour. <br><strong>Discover the authentic taste of the West!</strong>",
        introDos: "",
        introMovil:
          "Risi Buscalíos are delicious, crunchy corn fajitas with an intense BBQ flavour. <br><strong>Discover the authentic taste of the West!</strong>",
        ingredientes:
          "Corn, high oleic sunflower oil (23%), barbecue seasoning [flavouring, smoke flavouring, sugar, salt, maltodextrin, dextrose, flavour enhancers [E621 and E635], starch, acid (citric acid) and colouring (paprika extract)].",
        packs: "35g, 140g",
        energia: "2.102kJ, 502kcal",
        hidratos: "64,4 g",
        polialcoholes: "",
        azucares: "3,4 g",
        grasas: "24,1 g",
        saturadas: "2,4 g",
        fibra: "",
        sal: "1,6 g",
        proteinas: "6,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "clasicas-originales": {
        family: "otros-productos",
        type: "left",
        titulo: "Clásicas Originales",
        cantidadValor: "125g",
        hashtag: "#PatatasClásicasRisi",
        intro: "Our classic <strong>crinkle-cut salted crisps</strong>",
        introDos: " <br>The crunchiest crisps in the whole world!",
        introMovil: "Our classic <strong>crinkle-cut salted crisps</strong>",
        ingredientes:
          "Potatoes, sunflower oil (31%) and salt. May contain <u>milk protein</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.328kJ, 558kcal",
        hidratos: "54,1 g",
        polialcoholes: "",
        azucares: "1,0 g",
        grasas: "34,8 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-originales": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Originales",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasRisi",
        intro: "Our classic crinkle-cut <strong>salted crisps</strong>.",
        introDos: " <br>Discover our full range of flavours!",
        introMovil: "Our classic crinkle-cut <strong>salted crisps</strong>.",
        ingredientes:
          "Potatoes, sunflower oil (32.1%) and salt. May contain <u>milk protein</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.206kJ, 529kcal",
        hidratos: "54,5 g",
        polialcoholes: "",
        azucares: "0,8 g",
        grasas: "32,1 g",
        saturadas: "3,9 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "5,4 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-campesinas": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Campesinas",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasCampesinas",
        intro:
          "Our campesina <strong>crinkle-cut crisps</strong>, the authentic taste of the countryside.",
        introDos: "",
        introMovil:
          "Nuestras onduladas <strong>sabor campenisas</strong>, el sabor más campesino.",
        ingredientes:
          "Potatoes, sunflower oil (34.5%), campesina seasoning [flavourings, smoke flavouring, sugar, salt (1.2%), flavour enhancers (E621 and E635), colourings (paprika extract) and dried tomato (0.1%)]. May contain <u>milk protein</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.288kJ, 549kcal",
        hidratos: "53,5 g",
        polialcoholes: "",
        azucares: "1,6 g",
        grasas: "34,5 g",
        saturadas: "4,3 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-jamon": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Jamón",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasJamón",
        intro:
          "Our ham-flavour crinkle-cut crisps with the authentic <strong>taste of serrano ham</strong>.",
        introDos: "",
        introMovil:
          "Our ham-flavour crinkle-cut crisps with the authentic <strong>taste of serrano ham</strong>.",
        ingredientes:
          "Potatoes, sunflower oil (32.2%), ham seasoning [flavouring, smoke flavouring, maltodextrin, sugar, salt and acid (citric acid). May <u>contain milk protein</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.338kJ, 561kcal",
        hidratos: "50,4 g",
        polialcoholes: "",
        azucares: "1,6 g",
        grasas: "37,7 g",
        saturadas: "4,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-cheese-onion": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Cheese & Onion",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasCheeseOnion",
        intro: "Our <strong>tasty cheese and onion</strong> version.",
        introDos: "",
        introMovil: "Our <strong>tasty cheese and onion</strong> version.",
        ingredientes:
          "Potatoes, sunflower oil (34.4%), cheese and onion seasoning [flavourings, spices, whey, salt, sugar and flavour enhancers (E621 and E635)].",
        packs: "125g",
        energia: "2.285kJ, 548kcal",
        hidratos: "51,6 g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "35,2 g",
        saturadas: "4,2 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,2 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "onduladas-vinagreta": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Vinagreta",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasVinagreta",
        intro:
          "Don't forget to try our <strong>unique vinegar-flavour crinkle-cut crisps</strong>.",
        introDos: "",
        introMovil:
          "Don't forget to try our <strong>unique vinegar-flavour crinkle-cut crisps</strong>.",
        ingredientes:
          "Potatoes, sunflower oil (30.4%), salt and vinegar seasoning. May contain <u></u>.",
        packs: "125g",
        energia: "2.188kJ, 525kcal",
        hidratos: "51,7 g",
        azucares: "1,0 g",
        polialcoholes: "",
        grasas: "33,6 g",
        saturadas: "4,0 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "3,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      toscana: {
        family: "otros-productos",
        type: "left",
        titulo: "Clásicas Toscana",
        cantidadValor: "125g",
        hashtag: "#PatatasClásicasToscana",
        intro: "Crisps laced with <strong>Tuscan flavour</strong>.",
        introDos: "",
        introMovil: "Crisps laced with <strong>Tuscan flavour</strong>.",
        ingredientes:
          "Potatoes, sunflower oil (30%), Tuscan seasoning [sugar, salt, pea fibre, dried tomato, maltodextrin, flavourings, dried onion, dextrose, parsley, paprika, dried garlic, acid (citric acid), colourings (paprika extract), coconut oil, cayenne and black pepper]. May contain <u>milk protein</u>.",
        packs: "125g",
        energia: "2.144kJ, 513kcal",
        hidratos: "53,8 g",
        polialcoholes: "",
        azucares: "1,5 g",
        grasas: "30g",
        saturadas: "3,5 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      tejitas: {
        family: "otros-productos",
        type: "left",
        titulo: "Tejitas",
        cantidadValor: "100g",
        hashtag: "#TejitasRisi",
        intro:
          "Our legendary Tejitas, <strong>the cheesy snack</strong> that melts in the mouth.",
        introDos: "",
        introMovil:
          "Our legendary Tejitas, <strong>the cheesy snack</strong> that melts in the mouth.",
        ingredientes:
          "Cornmeal, sunflower oil (22%), <u>cheese </u>seasoning [flavouring, maltodextrin, lactose, sugar, whey, flavour enhancers (E621 and E635), acid (citric acid)] and salt. May contain <u>mustard</u>.",
        packs: "35g, 100g",
        energia: "2.202kJ, 526kcal",
        hidratos: "65,6 g",
        polialcoholes: "",
        azucares: "4,1 g",
        grasas: "26,7 g",
        saturadas: "4,6 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      surtis4u: {
        family: "otros-productos",
        type: "left",
        titulo: "Surtis",
        cantidadValor: "100g",
        hashtag: "#Surtis",
        intro:
          "Our extra special mix. Enjoy our best products, <strong>all in one bag</strong>.",
        introDos: "",
        introMovil:
          "Our extra special mix. Enjoy our best products, <strong>all in one bag</strong>.",
        ingredientes:
          "Corn, sunflower oil (27%), barbecue sauce and <u>cheese </u>seasoning [flavouring (contains <u>milk</u>), smoke flavouring, sugar, flavouring, flavour enhancer (monosodium glutamate) and colouring (paprika extract)], corn starch, salt, raising agent (sodium bicarbonate), emulsifier (mono- and diglycerides of fatty acids), acid (citric acid) and acidity regulator (calcium hydroxide).",
        packs: "110g",
        energia: "2.209kJ, 528kcal",
        hidratos: "60,6 g",
        polialcoholes: "",
        azucares: "1,0 g",
        grasas: "29,1 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      pajitas: {
        family: "otros-productos",
        type: "left",
        titulo: "Pajitas",
        cantidadValor: "100g",
        hashtag: "#PajitasdeRisi",
        intro:
          "If you're looking for something crunchy and tasty...these are just what you're looking for!",
        introDos:
          "<br>Risi's unmistakable ready- salted Pajitas.<br><strong>Choose them with or without ketchup!</strong>",
        introMovil:
          "If you're looking for something crunchy and tasty...these are just what you're looking for!",
        ingredientes:
          "Potato starch (52%), high oleic sunflower oil (19%), dried potato (13%), modified potato starch (6%), potato seasoning [flavouring, maltodextrin, starch and flavour enhancers (E621 and E635)], salt and emulsifier (E471). May contain <u>milk protein</u>.",
        packs: "20g, 100g",
        energia: "2.059kJ, 491kcal",
        hidratos: "69,8 g",
        polialcoholes: "",
        azucares: "1,2 g",
        grasas: "22,7 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "1,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "pajitas-ketchup": {
        family: "otros-productos",
        type: "left",
        titulo: "Pajitas Kétchup",
        cantidadValor: "100g",
        hashtag: "#PajitasDeKétchupRisi",
        intro:
          "Our legendary crunchy <strong>ketchup-flavour </strong>pajitas..",
        introDos: "",
        introMovil:
          "Our legendary crunchy <strong>ketchup-flavour </strong>pajitas..",
        ingredientes:
          "Corn starch (51%), high oleic sunflower oil (20%), dried potato (13%), modified potato starch (6%), ketchup seasoning [sugar, yeast extract, fructose, tomato, onion and garlic powder, flavouring, acid (citric and malic acid), paprika], salt and emulsifier (E471), and colouring (paprika extract). May contain <u>milk protein</u>.",
        packs: "12g, 20g, 100g",
        energia: "2.012kJ, 480kcal",
        hidratos: "64,1 g",
        polialcoholes: "",
        azucares: "2,0 g",
        grasas: "22,9 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "4,4 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      trikers: {
        family: "otros-productos",
        type: "left",
        titulo: "Trikers",
        cantidadValor: "45g y 100g",
        hashtag: "#TrikersRisi",
        intro:
          "Delicious snack with an authentic Tex-Mex flavour. Gluten-free and with no artificial colourings. More for less! You won't be able to resist...",
        introDos: "",
        introMovil:
          "Delicious snack with an authentic Tex-Mex flavour. Gluten-free and with no artificial colourings. More for less! You won't be able to resist...",
        ingredientes:
          "Corn, high oleic sunflower oil (27.8%) tex-mex seasoning [maltodextrin, dextrose, salt, corn starch, yeast extract, onion, tomato and garlic powder, flavourings, coconut oil, potassium chloride, acids (citric acid, lactic acid and calcium lactate), colourings (paprika extract and E160b) and cayenne] and sweet paprika. May contain <u>milk protein.</u>.",
        packs: "45g, 110g, 180g",
        energia: "2166kJ, 518kcal",
        hidratos: "60,8 g",
        polialcoholes: "",
        azucares: "2,1 g",
        grasas: "27,8 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "espelta-integral": {
        family: "desayuno",
        type: "left",
        titulo: "BSAN 0% Espelta",
        packs: "480g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinLactosa: "1",
        bajoSal: "1",
        intro:
          "Deliciosas galletas <strong>0% azúcar finas y sabrosas</strong>.",
        introDos:
          " <br>Con espelta, cereal milenario, reconocido por sus múltiples propiedades nutricionales.",
        introMovil:
          "Deliciosas galletas <strong>0% azúcar finas y sabrosas</strong>.",
        ingredientes:
          "Harina integral de <strong>TRIGO ESPELTA</strong> (50 %), edulcorantes (maltitol y jarabe de maltitol), harina de <strong>TRIGO</strong> (17%), aceite de girasol alto oleico, almidón de patata, harina de malta de <u>cebada</u> (1,9%), gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), harina de <strong>TRIGO</strong> con salvado (1%), aromas, emulgente (lecitina de girasol), colorante (E-150d) y conservador (<strong>METABISULFITO</strong> potásico). Puede contener trazas de <u>soja</u>, proteína de la <strong>LECHE y SÉSAMO</strong> ",
        cantidadValor: "100g",
        hashtag: "#BSanEspeltaIntegral",
        energia: "1.782 kJ, 425 kcal",
        hidratos: "63,9 g",
        polialcoholes: "15 g",
        azucares: "1,0 g",
        grasas: "16,0 g",
        saturadas: "1,4 g",
        fibra: "6,6 g",
        sal: "0,19g",
        proteinas: "9,2 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      integral: {
        family: "desayuno",
        type: "left",
        titulo: "BSAN 0% con sésamo",
        packs: "160g y 480g",
        hasIntegral: "1",
        bajoAzucares: "1",
        bajosal: "1",
        intro:
          "Exquisitas galletas <strong>0% azúcar, integrales con calcio y sésamo</strong>.",
        introDos: "",
        introMovil:
          "Exquisitas galletas <strong>0% azúcar, integrales con calcio y sésamo</strong>.",
        ingredientes:
          " Harina de <strong>TRIGO</strong> (48%), edulcorantes (maltitol, jarabe de maltitol), harina de <strong>TRIGO</strong> con salvado (16%), aceite de girasol alto oleico, gasificantes (carbonato ácido de amonio y carbonato ácido de sodio), <strong>SÉSAMO</strong> (2,5%), almidón de patata, harina de malta de <u>cebada</u> (1,9%), carbonato cálcico, aroma, emulgente (lecitina de girasol), colorante (E-150d), conservador (<strong>METABISULFITO</strong> potásico).  Puede contener trazas de <u>soja</u> y proteína de <strong>LECHE</strong>. RECOMENDACIONES: Un consumo excesivo puede producir efectos laxantes.",
        cantidadValor: "100g",
        hashtag: "#BSanConSésamo",
        energia: "1.848 kJ, 441 kcal",
        hidratos: "68,0 g",
        polialcoholes: "16,1 g",
        azucares: "3,0 g",
        grasas: "17,2 g",
        saturadas: "1,6 g",
        fibra: "3,6 g",
        sal: "0,19 g",
        proteinas: "8,2 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      supermaria: {
        family: "tradicionales",
        type: "left",
        titulo: "Súper María 0%",
        packs: "432g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        sinhuevo: "1",
        intro: "Las María de toda la vida, más deliciosas que nunca.",
        introDos: " <br><strong>Enriquecidas con sésamo</strong>.",
        introMovil:
          "Las María de toda la vida, <strong>enriquecidas con sésamo</strong>.",
        ingredientes:
          "Harina de <u><strong>trigo</u></strong>, Harina de <u><strong>trigo</u></strong> con salvado, harina de trigo (22%),  aceite de girasol alto oleico, edulcorante (maltitol),  semillas de <u><strong>sésamo</u></strong> (3%), zumo concentrado de manzana, almidón de patata,  gasificantes (carbonatos de sodio y carbonatos de amonio), emulgente (lecitina de girasol), aroma, conservador (<u><strong>metabisulfito</u></strong> potásico). Puede contener trazas de proteína de leche y soja.",
        cantidadValor: "100g",
        hashtag: "#VirginiaSúperMaría",
        energia: "1.976 kJ, 472 kcal",
        hidratos: "65,0g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "22,0 g",
        saturadas: "3,4 g",
        fibra: "3,6 g",
        sal: "0,21g",
        proteinas: "7,4 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1"
      },
      "bsan-singluten-infantil": {
        family: "tradicionales",
        type: "right",
        type: "right",
        titulo: "BSAN Plus+ Adventure Sin Gluten",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Fun and nutritious biscuits for kids, ideal for a morning snack. Made with corn and rice, they contain 5 vitamins and no palm oil. They're also gluten-free certified by the Spanish Federation of Coeliac Associations (FACE).",
        introDos: "",
        introMovil:
          "Fun and nutritious biscuits for kids, ideal for a morning snack. Made with corn and rice, they contain 5 vitamins and no palm oil. They're also gluten-free certified by the Spanish Federation of Coeliac Associations (FACE).",
        ingredientes:
          "Corn starch (28.3%), rice flour (21.7%), sugar, high oleic sunflower oil, potato starch, rice protein, inverted sugar syrup, thickening agents (guar gum and xanthan gum), dextrose, humidifier (sorbitol), flavourings, raising agents (ammonium carbonate and sodium acid carbonate), emulsifier (sunflower lecithin), preservatives (potassium metabisulfate) and vitamins [pantothenic acid (B5), thiamine (B1), vitamin A, folic (B9) and vitamin D]. May contain <u>nuts</u>.",
        cantidadValor: "100g",
        hashtag: "#BSAN+SinGluten",
        energia: "1.928 kJ, 459 kcal",
        hidratos: "73,7 g",
        azucares: "17 g",
        polialcoholes: "",
        grasas: "16 g",
        saturadas: "1,4 g",
        fibra: "2,4 g",
        sal: "0,08 g",
        proteinas: "4,2 g",
        ocultarSinGluten: "0",

        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "bsan-singluten-chocolate-infantil": {
        family: "tradicionales",
        type: "right",
        titulo: "BSAN Plus+ Adventure Chocolate Sin Gluten",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Fun and nutritious chocolate biscuits for kids, ideal for a morning snack. Made with corn and rice, they contain 5 vitamins and no palm oil. They're also gluten-free certified by the Spanish Federation of Coeliac Associations (FACE).",
        introDos: "",
        introMovil:
          "Fun and nutritious chocolate biscuits for kids, ideal for a morning snack. Made with corn and rice, they contain 5 vitamins and no palm oil. They're also gluten-free certified by the Spanish Federation of Coeliac Associations (FACE).",
        ingredientes:
          "Corn starch (28.3%), rice flour (21.7%), sugar, high oleic sunflower oil, sweeteners (maltitol and acesulfame K), potato starch, whole <u>milk</u> powder, cocoa butter, cocoa paste, rice protein, inverted sugar syrup, thickening agents (guar gum and xanthan gum), dextrose, humidifier (sorbitol), flavourings, emulsifiers (sunflower lecithin and soy lecithin), raising agents (ammonium carbonate and sodium acid carbonate), preservatives (potassium metabisulfate) and vitamins [pantothenic acid (B5), thiamine (B1), vitamin A, folic (B9) and vitamin D]. May contain <u>nuts</u>.",
        cantidadValor: "100g",
        hashtag: "#BSAN+SinGlutenChocolate",
        energia: "1.978 kJ, 471 kcal",
        hidratos: "70,9 g",
        polialcoholes: "",
        azucares: "18,6 g",
        grasas: "18,0 g",
        saturadas: "5,5 g",
        fibra: "2,8 g",
        sal: "0,08 g",
        proteinas: "5,0 g",
        ocultarSinGluten: "0",
        mostrarSinLactosa: "0",
        hasFrutosSecos: "1"
      },
      "bsan-plus-infantil": {
        family: "plus",
        type: "right",
        titulo: "BSAN Plus+ Adventure",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "Fun and nutritious biscuits for kids, ideal for a morning snack. Contain cereals, 5 vitamins and no palm oil.",
        introDos: " ",
        introMovil:
          "Fun and nutritious biscuits for kids, ideal for a morning snack. Contain cereals, 5 vitamins and no palm oil.",
        ingredientes:
          "Cereal flours (64%) (wheat flour, <u>bran</u> flour, <u>oat</u> flour, <u>barley</u> malt flour), sugar, high oleic sunflower oil, raising agents (ammonium carbonate and sodium acid carbonate), flavourings, salt, emulsifiers (sunflower lecithin), colouring (E150d) and vitamins (pantothenic acid (B5), thiamine (B1), vitamin A, folic acid (B9) and vitamin D]. May contain traces of <u>soy<u>, a milk</u> protein, <u>nuts</u>, <u>sesame</u> and sulphites.</u>",
        cantidadValor: "100g",
        hashtag: "#BSAN+",
        energia: "2.029 kJ, 484 kcal",
        hidratos: "68,0 g",
        azucares: "21,8 g",
        polialcoholes: "",
        grasas: "20,0 g",
        saturadas: "1,9 g",
        fibra: "2,6 g",
        sal: "1,24 g",
        proteinas: "6,6 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "bsan-plus-chocolate-infantil": {
        family: "plus",
        type: "right",
        titulo: "BSAN Plus+ Adventure Chocolate",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        intro:
          "Fun and nutritious chocolate biscuits for kids, ideal for a morning snack. Contain cereals, 5 vitamins and no palm oil.",
        introDos: " ",
        introMovil:
          "Fun and nutritious chocolate biscuits for kids, ideal for a morning snack. Contain cereals, 5 vitamins and no palm oil.",
        ingredientes:
          "Cereal flours (52%) (wheat flour, <u>bran</u> flour, <u>oat</u> flour, <u>barley</u> malt flour), sugar, high oleic sunflower oil, sweeteners (maltitol and acesulfame K), whole <u>milk</u> powder, cocoa butter, cocoa paste, raising agents (ammonium carbonate and sodium acid carbonate), flavourings, salt, emulsifiers (sunflower lecithin and soy lecithin), colouring (E150d) and vitamins (pantothenic acid (B5), thiamine (B1), vitamin A, folic acid (B9) and vitamin D]. May contain traces of <u>nuts</u>, <u>sesame</u> and sulphites.",
        cantidadValor: "100g",
        hashtag: "#BSAN+Chocolate",
        energia: "1.958 kJ, 466 kcal",
        hidratos: "67,3 g",
        polialcoholes: "",
        azucares: "18,6 g",
        grasas: "18,0 g",
        saturadas: "5,1 g",
        fibra: "2,9 g",
        sal: "0,64 g",
        proteinas: "7,4 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "singluten-digestive": {
        family: "adultas",
        type: "center",
        titulo: "BSAN Sin Gluten Digestive",
        packs: "140g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Digestive biscuit coated in an intense and <strong>tasty 70% cocoa dark chocolate.</strong>",
        introDos: "",
        introMovil:
          "Digestive biscuit coated in an intense and <strong>tasty 70% cocoa dark chocolate</strong>, with the unmistakable touch of orange.",
        ingredientes:
          "maize starch, rice flour, cocoa paste, sugar, sweeteners (maltitol, lactitol and acesulfame potassium), high oleic sunflower oil, cocoa butter, flaxseed flour, potato starch, fat-free cocoa powder, invert liquid sugar, rice protein, thickeners (guar gum and xanthan gum), dextrose, humectant (sorbitol), aromas, gasifying agents (ammonium hydrogen carbonate and sodium hydrogen carbonate), emulsifiers (<u>soy</u> and sunflower lecithin).<br><strong>RECOMMENDATIONS</strong>: Excessive consumption can produce laxative effectsMay contain <u>milk and nuts</u>",
        cantidadValor: "100g",
        hashtag: "#BsanDigestiveChocolate",
        energia: "2070 kJ, 494 kcal",
        hidratos: "60,2 g",
        polialcoholes: "7,8g",
        azucares: "16,5 g",
        grasas: "23,0 g",
        saturadas: "7,0 g",
        fibra: "7,5 g",
        sal: "0,08 g",
        proteinas: "6,9 g",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "cacao-intenso": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Cacao intenso ",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "Tasty biscuits completely <strong>covered in intense 70% cocoa dark chocolate</strong>. Is there anything more delicious for a true chocolate lover?",
        introDos: "",
        introMovil:
          "Tasty biscuits completely <strong>covered in intense 70% cocoa dark chocolate</strong>. Is there anything more delicious for a true chocolate lover?",
        ingredientes:
          "Cocoa paste, wheat flour (24.8%), sweeteners (maltitol, maltitol syrup, lactitol and acesulfame K), bran flour (8.2%), cocoa butter, butter (contains <u>milk</u>), degreased cocoa powder, <u>oat</u> flour (1.5%), <u>barley</u> malt flour (1%), potato starch, high oleic sunflower oil, raising agents (ammonium carbonate and sodium acid carbonate), flavourings, emulsifiers (soy lecithin and sunflower lecithin), dietary fibre, preservative (potassium metabisulfate) and vitamins (pantothenic acid (B5), thiamine (B1), vitamin A, folic acid (B9) and vitamin D]. May contain traces of <u>nuts and sesame seeds</u>. <strong>PLEASE NOTE:</strong> Excessive consumption may produce laxative effects.",
        cantidadValor: "80g, 120g",
        hashtag: "#BSAN_0%CacaoIntenso",
        energia: "2.501 kJ, 600 kcal",
        hidratos: "51,0 g",
        polialcoholes: "21,1 g",
        azucares: "4,0 g",
        grasas: "32,4 g",
        saturadas: "15,7 g",
        fibra: "6,8 g",
        sal: "0,1g",
        proteinas: "8,3 g",
        ocultarSinGluten: "1",

        hasFrutosSecos: "1"
      },
      "fabs-vietnam": {
        name: "VIETNAM",
        family: "fabs-vietnam",
        type: "right",
        titulo: "Fabs Origins Vietnam",
        packs: "160g",
        intro:
          "<strong>Made with our most exclusive chocolate</strong>, since just 0.1% of the world's chocolate comes from Vietnam. It has a unique and acidic flavour due to the low pH of the land.",
        introDos: "",
        introMovil:
          "<strong>Made with our most exclusive chocolate</strong>, since just 0.1% of the world's chocolate comes from Vietnam. It has a unique and acidic flavour due to the low pH of the land.",
        ingredientes:
          "Wheat flour, cocoa paste, sugar, butter (contains <u>milk</u>), cocoa butter, dietary fibre, salt, raising agents (ammonium carbonate and sodium acid carbonate), emulsifier (sunflower lecithin) and flavourings.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsVietnam",
        energia: "2.144 kJ, 513 kcal",
        hidratos: "54,2 g",
        polialcoholes: "",
        azucares: "21,8 g",
        grasas: "29,0 g",
        saturadas: "17,0 g",
        fibra: "6,7 g",
        sal: "0,4 g",
        proteinas: "8,8 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video: "https://www.youtube.com/watch?v=HReSXTH-ZPg&ab_channel=Risi",
        origen: {
          title: "ORIGIN",
          text:
            "It is made from exceptional cocoa beans, called Trinitarios, which are mainly sourced from the Mekong Delta region. The peculiar and delicious sour taste of this cocoa is thanks to the low PH of this land.",
          img: "mapa-vietnam.png"
        },
        maridaje: {
          title: "MARRIAGE",
          text:
            "For a perfect pairing, accompany this chocolate with a Malbec wine, for a sweeter taste; with fruits such as pear or banana, which soften the flavour, but do not neutralise it; or with mint, which brings that freshness that connects so well with the warmth of dark chocolate.",
          img: "hoja-vietnam.png"
        },
        notas_cata: {
          img: "cata-vietnam-en.png"
        }
      },
      "fabs-mexico": {
        name: "MÉXICO",
        family: "fabs-mexico",
        type: "right",
        titulo: "Fabs Origins México",
        packs: "150g",
        intro:
          "Made from Mexican cocoa, this biscuit has a smooth and delicious taste that will delight <strong>fans of milk chocolate and crunchy biscuit</strong> lovers alike.",
        introDos: "",
        introMovil:
          "Made from Mexican cocoa, this biscuit has a smooth and delicious taste that will delight <strong>fans of milk chocolate and crunchy biscuit</strong> lovers alike.",
        ingredientes:
          "Wheat flour, sugar, cocoa paste, whole <u>milk</u> powder, cocoa butter, butter (contains <u>milk</u>), emulsifiers (sunflower lecithin and soy lecithin), dietary fibre, salt, raising agents (ammonium carbonate and sodium acid carbonate) and flavourings. May contain traces of <u>nuts</u>, <u>sesame</u> and sulphites.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsMéxico",
        energia: "2.148 kJ, 513 kcal",
        hidratos: "59,3 g",
        polialcoholes: "",
        azucares: "28,6 g",
        grasas: "27,0 g",
        saturadas: "14,9 g",
        fibra: "4,0 g",
        sal: "0,43g",
        proteinas: "8,3 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video: "https://www.youtube.com/watch?v=oJs1TfT-QSY&ab_channel=Risi",
        origen: {
          title: "ORIGIN",
          text:
            "This exceptional cocoa comes from plantations in the warm Gulf of Mexico and is as rich in quality as it is in history: it was already cultivated by the Aztecs, the Mayans and the Toltecs.",
          img: "mapa-mexico.png"
        },
        maridaje: {
          title: "MARRIAGE",
          text:
            "For a perfect pairing, pair this chocolate with a sweet wine, which will complete the flavour thanks to its fruity aroma; with caramel, to enhance the sweetness of the chocolate; or with spices such as cinnamon or curry, to elevate the taste experience.",
          img: "hoja-mexico.png"
        },
        notas_cata: {
          img: "cata-mexico-en.png"
        }
      },
      "fabs-tanzania": {
        name: "TANZANIA",
        family: "fabs-tanzania",
        type: "right",
        titulo: "Fabs Origins Tanzania",
        packs: "150g",

        intro:
          "The chocolate used for this biscuit is made using Criollo and Trinitario cocoa grains, which have travelled from the most select fields in Tanzania to create a <strong>truly exquisite experience with the most intense cocoa</strong>.",
        introDos: "",
        introMovil:
          "The chocolate used for this biscuit is made using Criollo and Trinitario cocoa grains, which have travelled from the most select fields in Tanzania to create a <strong>truly exquisite experience with the most intense cocoa</strong>.",
        ingredientes:
          "Cocoa paste, wheat flour, sugar, butter (contains <u>milk</u>), cocoa butter, dietary fibre, salt, raising agents (ammonium carbonate and sodium acid carbonate), emulsifiers (sunflower lecithin) and flavourings. May contain traces of <u>nuts</u>, soy, <u>sesame</u> and sulphites.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsTanzania",
        energia: "2.154 kJ, 515 kcal",
        hidratos: "54,8 g",
        polialcoholes: "",
        azucares: "18,4 g",
        grasas: "29,0 g",
        saturadas: "17,9 g",
        fibra: "6,7 g",
        sal: "0,4 g",
        proteinas: "8,8 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video:
          "https://www.youtube.com/watch?v=vEWlbRaaOBg&t=1s&ab_channel=Risi",
        origen: {
          title: "ORIGIN",
          text:
            "Backed by Kilimanjaro and surrounded by the African Great Lakes, the tropical mix of high temperatures and rainy seasons creates the perfect climate for Tanzania's cocoa plantation.",
          img: "mapa-tanzania.png"
        },
        maridaje: {
          title: "MARRIAGE",
          text:
            "For a perfect pairing, pair this chocolate with fruit such as coconut and raspberry, to complete the acidic touch with the freshness of these foods; with truffle oil, for an even more complex experience; or with cinnamon, to soften the bitter taste with its sweetness.",
          img: "hoja-tanzania.png"
        },
        notas_cata: {
          img: "cata-tanzania-en.png"
        }
      },
      "maria-sesamo": {
        family: "mariasesamo",
        type: "left",
        titulo: "BSAN 0% Sésamo",
        packs: "480g",
        hasIntegral: "0",
        bajoSal: "1",
        sinLactosa: "1",
        intro:
          "Exquisite biscuits <strong>with 0% added sugar, made with sesame seeds,</strong> which are rich in healthy fats, vegetable proteins and calcium.",
        introDos: "",
        introMovil:
          "Exquisite biscuits <strong>with 0% added sugar, made with sesame seeds,</strong> which are rich in healthy fats, vegetable proteins and calcium.",
        ingredientes:
          "Wheat flour (48%), sweeteners (maltitol, maltitol syrup), wheat flour with bran (16%), high oleic sunflower oil, raising agents (ammonium carbonate and sodium acid carbonate), <u>sesame</u> (2.5%), potato starch, <u>barley</u> malt flour (1.9%), calcium carbonate, flavourings, emulsifiers (sunflower lecithin), colouring (E150d), preservatives (potassium metabisulfate). May contain traces of soy and <u>milk</u> protein. <strong>PLEASE NOTE:</strong> Excessive consumption may produce laxative effects",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%conSésamo",
        energia: "1.848 kJ, 441 kcal",
        hidratos: "68,0 g",
        polialcoholes: "16,1 g",
        azucares: "3,0 g",
        grasas: "17,2 g",
        saturadas: "1,6 g",
        fibra: "3,6 g",
        sal: "0,19g",
        proteinas: "8,2 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "maria-espelta": {
        family: "mariasesamo",
        type: "left",
        titulo: "BSAN 0% Espelta",
        packs: "480g",
        hasIntegral: "0",
        bajoSal: "1",
        sinLactosa: "1",
        intro:
          "Delicious 0% sugar biscuits made with <strong>spelt</strong>, an ancient cereal with an intense flavour and very nutritious.",
        introDos: " ",
        introMovil:
          "Delicious 0% sugar biscuits made with <strong>spelt</strong>, an ancient cereal with an intense flavour and very nutritious.",
        ingredientes:
          "Whole SPELT wheat flour (67%), sweeteners (maltitol and maltitol syrup), high oleic sunflower oil, potato starch, <u>barley</u> malt flour (2%), raising agents (ammonium carbonate and sodium acid carbonate), wheat flour with bran (1%), flavourings, emulsifiers (sunflower lecithin), colourings (E150d) and preservatives (potassium metabisulfate). May contain traces of <u>soyA, <u>milk</u> protein and <u>sesame</u></u>. <strong>PLEASE NOTE:</strong> Excessive consumption may produce laxative effects.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%EspeltaIntegral",
        energia: "1782 kJ, 425 kcal",
        hidratos: "63,9 g",
        polialcoholes: "15,0 g",
        azucares: "1,0 g",
        grasas: "16,0 g",
        saturadas: "1,4 g",
        fibra: "6,6 g",
        sal: "0,19g",
        proteinas: "9,2 g"
      },
      "chocolate-con-leche": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Chocolate con leche",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "Tasty biscuits <strong>coated in delicious milk chocolate</strong>.",
        introDos: "",
        introMovil:
          "Tasty biscuits <strong>coated in delicious milk chocolate</strong>.",
        ingredientes:
          "wheat (24.6%), whole <u>milk</u> powder, cocoa butter, wheat flour with bran (8.2%), cocoa paste, butter (contains <u>milk</u>), <u>oat</u> flour (1.5%), <u>barley</u> malt flour (1%), potato starch, raising agents (ammonium carbonate and sodium acid carbonate), high oleic sunflower oil, flavourings, emulsifiers (soy lecithin and sunflower lecithin), dietary fibre, preservatives (potassium metabisulfate) and vitamins [pantothenic acid (B5), thiamine (B1), vitamin A, folic acid (B9) and vitamin D]. May contain traces of <u>nuts and sesame seeds</u>. <strong>PLEASE NOTE:</strong> Excessive consumption may produce laxative effects.",
        cantidadValor: "80g, 120g",
        hashtag: "#BSAN_0%ChocolateConLeche",
        energia: "2.478 kJ, 593 kcal",
        hidratos: "59,0 g",
        polialcoholes: "31 g",
        azucares: "5,2 g",
        grasas: "27,3 g",
        saturadas: "12,9 g",
        fibra: "3,4 g",
        sal: "0,18g",
        proteinas: "7,5 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-blanco": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0%Chocolate blanco",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "All the pleasure of an biscuit <strong>coated in smooth white chocolate</strong>.",
        introDos: "",
        introMovil:
          "All the pleasure of an oat biscuit <strong>coated in smooth white chocolate</strong>.",
        ingredientes:
          "wheat (24.5%), cocoa butter, whole <u>milk</u> powder, wheat flour with bran (8.2%), butter (contains <u>milk</u>), <u>oat</u> flour (1.5%), raising agents (ammonium carbonate and sodium acid carbonate), <u>barley</u> malt flour (1%), potato starch, degreased cocoa powder, high oleic sunflower oil, flavourings, emulsifiers (soy lecithin and sunflower lecithin), dietary fibre, preservatives (potassium metabisulfate) and vitamins [pantothenic acid (B5), thiamine (B1), vitamin A, folic acid (B9) and vitamin D]. May contain traces of <u>nuts and sesame seeds</u>. <strong>PLEASE NOTE:</strong> Excessive consumption may produce laxative effects.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%ChocolateBlanco",
        energia: "2.457 kJ, 591 kcal",
        hidratos: "66,0 g",
        polialcoholes: "33 g",
        azucares: "6,1 g",
        grasas: "24,0 g",
        saturadas: "13,9 g",
        fibra: "1,8 g",
        sal: "0,23g",
        proteinas: "7,0 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-naranja": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Chocolate a la Naranja",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinhuevo: "1",
        chocolatelovers: "1",
        intro:
          "Discover a very special flavour. Wheat biscuit with oats and barley dipped in delicious <strong>orange chocolate.</strong>",
        introDos: " ",
        introMovil:
          "Discover a very special flavour. Wheat biscuit with oats and barley dipped in delicious <strong>orange chocolate.</strong>",
        ingredientes:
          "Wheat flour (24.6%), cocoa paste, sweeteners (maltitol, maltitol syrup, lactitol and acesulfame K), wheat flour with bran (8.2%), cocoa butter, butter (contains <u>milk</u>), degreased cocoa powder, <u>oat</u> flour (1.5%), <u>barley</u> malt flour (1%), potato starch, raising agents (ammonium carbonate and sodium acid carbonate), high oleic sunflower oil, whole <u>milk</u> powder, flavourings, emulsifiers (soy lecithin and sunflower lecithin), dietary fibre, preservatives (potassium metabisulfate), orange juice powder (0.04%), vitamins [pantothenic acid (B5), thiamine (B1), vitamin A, folic acid (B9) and vitamin D] and orange essential oil (0.01%). May contain traces of <u>nuts and sesame seeds</u>. <strong>PLEASE NOTE:</strong> Excessive consumption may produce laxative effects.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%ChocolateNaranja",
        energia: "2.375 kJ, 569 kcal",
        hidratos: "52 g",
        polialcoholes: "23,2 g",
        azucares: "3,1 g",
        grasas: "28,4 g",
        saturadas: "15,7 g",
        fibra: "8,3 g",
        sal: "0,13g",
        proteinas: "8,3 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "mix-melon-sandia": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Melon and Watermelon 0%",
        packs: "110g",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "Sugar-free soft candies with melon and watermelon flavor with sweeteners.",
        introDos: " ",
        introMovil:
          "Sugar-free soft candies with melon and watermelon flavor with sweeteners.",
        ingredientes:
          "Sweeteners (maltitol, mannitol, sorbitol, steviol glycoside), dextrin, coconut oil, bovine gelatine, acid (citric acid), emulsifier (E471) and flavourings (watermelon 0.01% and melon 0.01%). Excessive consumption may produce laxative effects.",
        hashtag: "#MixMelón&Sandía",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "mix-frutos-rojos": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Frutos Rojos",
        packs: "70g, 110g, 1Kg",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Chewy sweets with white sweeteners in strawberry, cranberry and cherry flavours.",
        introDos: "",
        introMovil:
          "Chewy sweets with white sweeteners in strawberry, cranberry and cherry flavours.",
        ingredientes:
          "Sweeteners (maltitol, mannitol, sorbitol, steviol glycoside), dextrin, coconut oil, bovine gelatine, acid (citric acid), emulsifier (E471) and flavourings (strawberry 0.01%, cranberry 0.01% and cherry 0.01%). Excessive consumption may produce laxative effects.",
        hashtag: "#MixFrutosRojos",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "mix-5-frutas": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix 5 Frutas",
        packs: "70g, 110g, 1Kg",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Chewy sweets with white sweeteners in pineapple, orange, strawberry, lemon and cherry flavours.",
        introDos: "",
        introMovil:
          "Chewy sweets with white sweeteners in pineapple, orange, strawberry, lemon and cherry flavours.",
        ingredientes:
          "Sweeteners (maltitol, mannitol, sorbitol, steviol glycoside), dextrin, coconut oil, bovine gelatine, acid (citric acid), emulsifier (E471) and flavourings (orange 0.01%, lemon 0.01%, strawberry 0.01%, cherry 0.01% and pineapple 0.01%). Strawberry and cherry flavours only available in 500g and 1kg packs. Excessive consumption may produce laxative effects.",
        hashtag: "#Mix5Frutas",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },

      citricos: {
        family: "citrico",
        type: "left",
        titulo: "Citrus 0%",
        hasFrutosSecos: "1",
        packs: "110g",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Sugar-free candies with orange and lemon flavor with sweeteners.",
        introDos: "",
        introMovil:
          "Sugar-free candies with orange and lemon flavor with sweeteners.",
        ingredientes:
          "<strong>Lemon sweet:</strong> Sweetener (maltitol syrup), citric acid, natural lemon flavouring (0.6%), natural curcumin colouring. <strong>Orange sweet:</strong> Sweetener (maltitol syrup), citric acid, natural orange flavouring (0.7%), natural beta-carotene orange colouring, natural beta-carotene yellow colouring. May contain traces of <u>milk, soy and nuts</u>. Excessive consumption may produce laxative effects.",
        hashtag: "#RisiCítricos",
        energia: "975 kJ, 234 kcal",
        hidratos: "97,5g",
        azucares: "0g",
        polialcoholes: "97,5g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "0g",
        sal: "0g",
        proteinas: "0g"
      },
      stevia: {
        family: "citrico",
        type: "left",
        titulo: "FruitSin Stevia",
        packs: "110g",
        hasFrutosSecos: "1",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Cherry, lemon, strawberry and orange flavours candies with sweeteners.",
        introDos: "",
        introMovil:
          "Cherry, lemon, strawberry and orange flavours candies with sweeteners.",
        ingredientes:
          "Sweetener (isomalt, steviol glycosides (0,05%), citric acid, flavour (cherry 0.5%,  0,5%, lemon 0,5%, strawberry 0,5% and orange 0,5%) and coloring (E 150d, carmine and carotenes).<br> Excessive consumption may produce laxative effects.",
        hashtag: "#RisiFruitSinStevia",
        energia: "1001 kJ, 240 kcal",
        hidratos: "98,9g",
        azucares: "0,15",
        polialcoholes: "99,6g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "0,86g",
        sal: "0g",
        proteinas: "0g"
      },
      balsamicos: {
        family: "balsamicos",
        type: "left",
        titulo: "Glassmins 0%",
        packs: "105g, 500g, 1Kg",
        hasFrutosSecos: "1",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "Mint-flavored sugar-free candies with sweeteners.",
        introDos: "",
        introMovil: "Mint-flavored sugar-free candies with sweeteners.",
        ingredientes:
          "Sweetener (maltitol syrup), menthol (0.3%), E131 colouring, essence of eucalyptus and sweetener (E950). May contain traces of <u>milk, soy and nuts</u>. Excessive consumption may produce laxative effects.",
        hashtag: "#RisiGlassmins",
        energia: "968 kJ, 232 kcal",
        hidratos: "96,8g",
        azucares: "0g",
        polialcoholes: "96.8g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "mix-variado": {
        family: "0-azucares",
        type: "left",
        titulo: "Assorted Fruit Mix",
        packs: "150g, 500g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        sinlactosa: "1",
        intro:
          "Soft candies flavored with lemon, pineapple, orange, strawberry and banana.",
        introDos: "",
        introMovil:
          "Soft candies flavored with lemon, pineapple, orange, strawberry and banana.",
        ingredientes:
          "Glucose syrup, sugar, dextrin, coconut oil, bovine gelatine, flavourings (orange 0.01%, lemon 0.01%, strawberry 0.01%, pineapple 0.01% and banana 0.01%), acid (citric acid), emulsifier E471) and colourings (turmeric, carmine and carotenes). Pineapple flavour only available in 500g and 1kg packs.",
        hashtag: "#MixFrutasDelSol",
        energia: "1476 kJ, 377 kcal",
        hidratos: "88g",
        azucares: "82g",
        grasas: "2,7g",
        polialcoholes: "",
        saturadas: "2,3g",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "azucares-gajos": {
        family: "citrico",
        type: "left",
        titulo: "Wedges",
        packs: "70g, 150g, 500g, 1Kg",
        hasFrutosSecos: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "Orange and lemon flavored candies.",
        introDos: "",
        introMovil: "Orange and lemon flavored candies.",
        ingredientes:
          "<strong>Orange sweet</strong>: Glucose syrup, sugar, citric acid, orange flavouring (0.6%), natural beta-carotene yellow colouring and natural beta-carotene orange colouring. <strong>Lemon sweet</strong>: Glucose syrup, sugar, citric acid, lemon flavouring (0.5%) and natural curcumin colouring. May contain traces of milk, soy and nuts.",
        hashtag: "#FrutasDelSolGajos",
        energia: "1.652 kJ, 389 kcal",
        hidratos: "97,2g",
        polialcoholes: "",
        azucares: "49,6",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      doble: {
        family: "citrico",
        type: "left",
        titulo: "Dooble",
        packs: "70g, 150g, 500g, 1Kg",
        hasFrutosSecos: "1",
        hasGluten: "0",
        sinlactosa: "0",
        intro: "Double candies with banana, strawberry or pineapple flavor.",
        introDos: "",
        introMovil:
          "Double candies with banana, strawberry or pineapple flavor.",
        ingredientes:
          "<strong>Pineapple Sweet</strong>: Glucose syrup, sugar, citric acid, pineapple flavouring (0.4%) and natural curcumin colouring. <strong>Banana Sweet</strong>: Glucose syrup, sugar, banana flavouring (1%), citric acid and natural curcumin colouring. <strong>Trawberry Sweet</strong>: Glucose syrup, sugar, strawberry flavouring (1.6%), citric acid and natural anthocyanin colouring.",
        hashtag: "#FrutasDelSolDooble",
        energia: "1.652 kJ, 389 kcal",
        hidratos: "97,2g",
        polialcoholes: "",
        azucares: "49,6",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "frutas-acidas": {
        family: "citrico",
        type: "left",
        titulo: "Acid Fruits",
        packs: "150g",
        hasFrutosSecos: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro: "Candies flavored with lemon, orange, apple and strawberry.",
        introDos: "",
        introMovil:
          "Candies flavored with lemon, orange, apple and strawberry.",
        ingredientes:
          "<strong>Lemon sweet</strong>: Glucose syrup, sugar, citric acid, lemon flavouring (0.4%) and natural curcumin colouring. <strong>Apple sweet</strong>: Glucose syrup, sugar, citric acid, apple flavouring (0.8%), natural curcumin colouring and natural chlorophyll colouring. <strong>Orange sweet</strong>: Glucose syrup, sugar, citric acid, orange flavouring (0.6%), natural beta-carotene yellow colouring and natural beta-carotene orange colouring. <strong>Strawberry sweet</strong>: Glucose syrup, sugar, citric acid, strawberry flavouring (1.9%), natural anthocyanin colouring and natural beta-carotene orange colouring. May contain traces of <u>milk, soy and nuts</u>.",
        hashtag: "#FrutasDelSolÁcidas",
        energia: "1.650 kJ, 388 kcal",
        hidratos: "97,05g",
        azucares: "36,1g",
        grasas: "0g",
        polialcoholes: "",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "nueces-en-grano": {
        family: "frutos-secos",
        type: "left",
        titulo: "Nueces en grano",
        packs: "50g, 90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Walnuts are one of the best nuts there are because they're both healthy and delicious. The kitchen cupboard just wouldn't be complete without them.",
        introDos: "",
        introMovil:
          "Walnuts are one of the best nuts there are because they're both healthy and delicious. The kitchen cupboard just wouldn't be complete without them.",
        ingredientes:
          "Californian walnuts. Contains walnuts. May <u>contain traces of peanut and other nuts.</u>",
        cantidadValor: "100g",
        hashtag: "#NuecesEnGrano",
        energia: "2.745 kJ, 666 kcal",
        hidratos: "2,5 g",
        polialcoholes: "",
        azucares: "1,8 g",
        grasas: "64 g",
        saturadas: "6,3 g",
        fibra: "",
        sal: "<0,01 g",
        proteinas: "16 g",
        mostrarSinLactosa: "1"
      },
      "pistachos-tostados": {
        family: "frutos-secos",
        type: "left",
        titulo: "Pistachos tostados y al punto de sal",
        packs: "50g, 80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Pistachios are a favourite among young and older people alike. Roasted and with a touch of salt. Eat them on their own as a snack, or add them to your recipes. You choose!",
        introDos: "",
        introMovil:
          "Pistachios are a favourite among young and older people alike. Roasted and with a touch of salt. Eat them on their own as a snack, or add them to your recipes. You choose!",
        ingredientes:
          "Pistachios and salt. Contains pistachios. May contain traces of <u>peanut and other nuts.</u>",
        cantidadValor: "100g",
        hashtag: "#PistachosTostados",
        energia: "2.565 kJ, 620 kcal",
        hidratos: "6,4 g",
        polialcoholes: "",
        azucares: "6,4 g",
        grasas: "52 g",
        saturadas: "6,5 g",
        fibra: "",
        sal: "1,3 g",
        proteinas: "26 g",
        mostrarSinLactosa: "1"
      },
      "cacahuetes-fritos": {
        family: "frutos-secos",
        type: "left",
        titulo: "Cacahuetes fritos y salados",
        packs: "80g, 110g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Watching TV or a film just wouldn't be the same without some peanuts.",
        introDos:
          " Roasted, crunchy, full of flavour and with just the right amount of salt. A snack that simply shouldn't be missing from your kitchen cupboard.",
        introMovil:
          "Watching TV or a film just wouldn't be the same without some peanuts.",
        ingredientes:
          "Skinned peanuts with sunflower oil and salt. Contains peanuts. May contain <u>traces of nuts</u>.",
        cantidadValor: "100g",
        hashtag: "#CacahuetesFritos",
        energia: "2.617 kJ, 632 kcal",
        hidratos: "8,2 g",
        polialcoholes: "",
        azucares: "4,2 g",
        grasas: "53 g",
        saturadas: "8,7 g",
        fibra: "",
        sal: "0,96 g",
        proteinas: "27 g",
        mostrarSinLactosa: "1"
      },
      "anacardos-fritos": {
        family: "frutos-secos",
        type: "left",
        titulo: "Anacardos fritos y salados",
        packs: "55g, 80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Try a delicious and tasty snack that's just right for a break between meals.",
        introDos: " ",
        introMovil:
          "Try a delicious and tasty snack that's just right for a break between meals.",
        ingredientes:
          "Cashews, sunflower oil and salt. Contains cashews. May contain <u>traces of peanuts and other nuts</u>.",
        cantidadValor: "100g",
        hashtag: "#AnacardosFritos",
        energia: "2.552 kJ, 615 kcal",
        hidratos: "26 g",
        polialcoholes: "",
        azucares: "5,1 g",
        grasas: "48 g",
        saturadas: "9,5 g",
        fibra: "",
        sal: "0,07 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "avellanas-tostadas": {
        family: "frutos-secos",
        type: "left",
        titulo: "Avellanas tostadas",
        packs: "80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Disfruta de las deliciosas avellanas como snack y  como el topping crujiente perfecto, para tus postres.",
        introDos: "",
        introMovil:
          "Disfruta de las deliciosas avellanas como snack y  como el topping crujiente perfecto, para tus postres.",
        ingredientes:
          "<u>Avellana</u> en grano. Contiene <u>avellana</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#AvellanasTostadas",
        energia: "2.910 kJ, 706 kcal",
        hidratos: "2,7 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "67 g",
        saturadas: "5,5 g",
        fibra: "",
        sal: "0,03 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "almendras-fritas": {
        family: "frutos-secos",
        type: "left",
        titulo: "Almendras fritas y saladas",
        packs: "55g, 90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Fried and salted almonds, a crunchy and salty treat to enjoy at any time of day. And they taste even better when you share them! Roasted and crunchy thanks to the way we prepare them. Your kitchen cupboard shouldn't be without them!",
        introDos: " ",
        introMovil:
          "Fried and salted almonds, a crunchy and salty treat to enjoy at any time of day. And they taste even better when you share them! Roasted and crunchy thanks to the way we prepare them. Your kitchen cupboard shouldn't be without them!",
        ingredientes:
          "Almonds without skin, sunflower oil and salt. Contains almonds. May contain traces of <u>peanuts and other nuts</u>.",
        cantidadValor: "100g",
        hashtag: "#AlmendrasFritas",
        energia: "2.526 kJ, 611 kcal",
        hidratos: "52 g",
        azucares: "4,3 g",
        polialcoholes: "",
        grasas: "52 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "0,80 g",
        proteinas: "25 g",
        mostrarSinLactosa: "1"
      },
      "mix-frito": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix frito",
        packs: "70g, 100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "The classic nut mix ideal for every occasion. Enjoy the variety of flavours and textures! ",
        introDos: "",
        introMovil:
          "The classic nut mix ideal for every occasion. Enjoy the variety of flavours and textures!",
        ingredientes:
          "Fried and salted corn, fried and salted skinned peanuts, <u>fried and salted peanuts with skin</u>, toasted chickpeas, fried and salted broad beans, sunflower oil and salt. Contains peanuts. May contain <u>traces of nuts</u>. ",
        cantidadValor: "100g",
        hashtag: "#MixFrito",
        energia: "1.814kJ, 436 kcal",
        hidratos: "30 g",
        azucares: "2,5 g",
        polialcoholes: "",
        grasas: "28 g",
        saturadas: "4 g",
        fibra: "",
        sal: "1,5 g",
        proteinas: "14 g",
        mostrarSinLactosa: "1"
      },
      "mix-bbq": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix barbacoa",
        packs: "80g, 100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "The perfect choice when you're looking to combine the texture and properties of nuts with an intense barbecue flavour in the same bite.",
        introDos: "",
        introMovil:
          "The perfect choice when you're looking to combine the texture and properties of nuts with an intense barbecue flavour in the same mouthful.",
        ingredientes:
          "Fried and salted peanuts (peanuts with skin, peanuts without skin, sunflower oil and salt), barbecue-flavour baked snack product (cornmeal, ricemeal, sugar, sunflower oil, barbecue seasoning (flavourings, smoke flavouring, maltodextrin, salt, flavour enhancers: E621 and E631), barbecue-flavour fried corn (corn, sunflower oil, salt, barbecue condiment (herbs, maltodextrin, spices, dried tomato, salt, smoke flavouring), E621 flavour enhancer, peanut with barbecue-flavour coating (peanut, corn flour, salt, sugar, modified corn starch, corn starch, sunflower oil, barbecue condiment (maltodextrin, spices, dried tomato, salt, smoke flavouring), E621 flavour enhancer. Contains <u>peanuts</u>. <u>May contain nuts</u>.",
        cantidadValor: "100g",
        hashtag: "#MixBBQ",
        energia: "2.150kJ, 518 kcal",
        hidratos: "25 g",
        azucares: "4 g",
        polialcoholes: "",
        grasas: "37 g",
        saturadas: "5,8 g",
        fibra: "",
        sal: "1,7 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "mix-picante": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix picante",
        packs: "90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "Mix of fried and salted peanuts,",
        introDos: " fried corn and chilli-flavoured baked snack product.",
        introMovil: "Mix of fried and salted peanuts",
        ingredientes:
          "Fried and salted <u>peanuts</u> (peanuts with skin, peanuts without skin, sunflower vegetable oil and salt), chilli-flavoured fried corn (corn, sunflower vegetable oil, chilli seasoning (maltodextrin, onion, pepper, sun-dried tomato, garlic, paprika, cayenne, salt), salt, paprika oil (colouring (paprika extract)), flavour enhancer (E621)) and chilli-flavoured baked snack product (maize grits, rice grits, sunflower vegetable oil, sugar, chilli flavouring (flavourings, flavour enhancers (E621, E631, E627), colouring (paprika extract)) and salt. Contains <u>peanuts</u>. May contain traces of nuts",
        cantidadValor: "100g",
        hashtag: "#MixPicante",
        energia: "2.159kJ, 517 kcal",
        hidratos: "44 g",
        azucares: "3,6 g",
        polialcoholes: "",
        grasas: "30 g",
        saturadas: "4,1 g",
        fibra: "5,7 g",
        sal: "1,9 g",
        proteinas: "15 g",
        mostrarSinLactosa: "1"
      },
      "avellanas-tostadas-1kg": {
        family: "frutos-secos-1kg",
        type: "left",
        titulo: "Avellanas tostadas",
        packs: "1kg",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "Disfruta de las deliciosas avellanas tanto como snack, ",
        introDos:
          " como el topping crujiente y dulce perfecto para tus postres.",
        introMovil: "Disfruta de las deliciosas avellanas tanto como snack",
        ingredientes:
          "<u>Avellana</u> con piel. Contiene <u>Avellana</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#AvellanaTostada",
        energia: "2.910 kJ, 706 kcal",
        hidratos: "2,7 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "67 g",
        saturadas: "5,5 g",
        fibra: "",
        sal: "0,03 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },

      "pipas-saladas": {
        family: "pipas",
        type: "left",
        titulo: "Pipas Saladas",
        packs: "40g, 90g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Classic salted sunflower seeds. Once you start, you won't be able to stop yourself.",
        introDos: "",
        introMovil:
          "Classic salted sunflower seeds. Once you start, you won't be able to stop yourself.",
        ingredientes:
          "Sunflower seeds, salt and rice flour. May contain <u>traces of peanut and nuts</u>.",
        cantidadValor: "100g",
        hashtag: "#PipasSaladas",
        energia: "2.561kJ, 619 kcal",
        polialcoholes: "",
        hidratos: "3,3 g",
        azucares: "3,3 g",
        grasas: "52 g",
        saturadas: "6,4 g",
        fibra: "11 g",
        sal: "7,1 g",
        proteinas: "29 g",
        mostrarSinLactosa: "1"
      },
      "pipas-aguasal": {
        family: "pipas",
        type: "left",
        titulo: "Pipas Aguasal",
        packs: "90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Any time or place is good for enjoying some Aguasal sunflower seeds. Shall we open a pack now?",
        introDos: "",
        introMovil:
          "Any time or place is good for enjoying some Aguasal sunflower seeds. Shall we open a pack now?",
        ingredientes:
          "Sunflower seeds, salt and rice flour. May contain traces of <u>peanut and nuts</u>.",
        cantidadValor: "100g",
        hashtag: "#PipasAguasal",
        energia: "2.589kJ, 626 kcal",
        hidratos: "4,8 g",
        azucares: "3,1 g",
        grasas: "52 g",
        saturadas: "6,7 g",
        polialcoholes: "",
        fibra: "9,2 g",
        sal: "2,3 g",
        proteinas: "30 g",
        mostrarSinLactosa: "1"
      },
      "mix-antiox": {
        family: "mix-antiox",
        type: "left",
        titulo: "Mix Antiox",
        packs: "100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "La combinación rica en antioxidantes perfecta para tus ensaladas:",
        introDos:
          " California, almendras, pistachos, pasas, pipas de girasol y arándanos. ¡ A disfrutar!",
        introMovil:
          "La combinación rica en antioxidantes perfecta para tus ensaladas.",
        ingredientes:
          "<u>Almendras</u> peladas crudas, semillas de girasol peladas crudas, trozos de <u>nueces</u>, arándanos desecados (arándanos, azúcar, aceite vegetal de girasol), uvas pasas sin semilla (pasas y aceite vegetal de girasol) y <u>pistachos</u> en grano crudos. Puede contener <u>cacahuetes</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#MixAntiox",
        energia: "2.297kJ, 554 kcal",
        hidratos: "24 g",
        azucares: "24 g",
        polialcoholes: "",
        grasas: "42 g",
        saturadas: "4,2 g",
        fibra: "",
        sal: "0,01 g",
        proteinas: "17 g",
        mostrarSinLactosa: "1"
      },
      "mix-equilibrio": {
        family: "mix-equilibrio",
        type: "left",
        titulo: "Mix Equilibrio",
        packs: "100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Si buscas un picoteo sano, sabroso y 100% saludable, el Mix Equilibrio es la opción perfecta para ti.",
        introDos: "",
        introMovil:
          "Si buscas un picoteo sano, sabroso y 100% saludable, el Mix Equilibrio es la opción perfecta para ti.",
        ingredientes:
          "<u>Avellanas</u> crudas peladas, <u>almendras</u> crudas peladas, <u>nueces pecanas</u> en grano crudas, trozos de <u>nueces</u>. Contiene <u>avellanas, almendras, pecanas y nueces</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#MixEquilibrio",
        energia: "2.781kJ, 674 kcal",
        hidratos: "3,1 g",
        azucares: "2,9 g",
        polialcoholes: "",
        grasas: "64 g",
        saturadas: "5,6 g",
        fibra: "",
        sal: "0 g",
        proteinas: "16 g",
        mostrarSinLactosa: "1"
      },
      "patata-sal-al-punto": {
        family: "patata-sal-al-punto",
        type: "left",
        titulo: "Sal al punto",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Classic crisps with just the right touch of salt. <strong>So irresistible that you won't be able to stop eating them.</strong>",
        introDos: "",
        introMovil:
          "Classic crisps with just the right touch of salt. <strong>So irresistible that you won't be able to stop eating them.</strong>",
        ingredientes:
          "Potatoes, sunflower oil (26%) and salt (1.4%). May contain <u>milk protein</u>.",
        cantidadValor: "125g",
        hashtag: "#SalAlPunto",
        energia: "2.002kJ, 479 kcal",
        hidratos: "54,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        mostrarSinLactosa: "1"
      },
      campesinas: {
        family: "campesinas",
        type: "left",
        titulo: "Campesinas",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Delicious crisps <strong>with an aromatic touch of herbs</strong> that conjures up memories of the fresh countryside.",
        introDos: "",
        introMovil:
          "Delicious crisps <strong>with an aromatic touch of herbs</strong> that conjures up memories of the fresh countryside.",
        ingredientes:
          "Potatoes, sunflower oil (26%), campesina seasoning [sugar, salt, dextrose, flavour enhancers (E621 and E635), dried onion, dried parsley, dried tomato, dried garlic, yeast extract, acids (malic and citric acid), colouring (paprika extract) and smoke flavouring]. <u>May contain milk protein.</u>",
        cantidadValor: "125g",
        hashtag: "#Campesinas",
        energia: "1.974kJ, 472 kcal",
        hidratos: "53,5 g",
        azucares: "1,6 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "6 g",
        mostrarSinLactosa: "1"
      },
      vinagreta: {
        family: "vinagreta",
        type: "left",
        titulo: "Vinagreta",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "The best crisps with an <strong>intense vinegar flavour</strong> and a touch of salt. True fans of vinegar won't be able to resist them.",
        introDos: "",
        introMovil:
          "The best crisps with an <strong>intense vinegar flavour</strong> and a touch of salt. True fans of vinegar won't be able to resist them.",
        ingredientes:
          "Potatoes, sunflower oil (26%), salt and vinegar seasoning [flavourings, salt (1.4%), sugar, maltodextrin and acids (citric and malic acid)]. <u>Many contain milk protein.</u>",
        cantidadValor: "125g",
        hashtag: "#Vinagreta",
        energia: "1.907kJ, 456 kcal",
        hidratos: "51,7 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "3,9 g",
        mostrarSinLactosa: "1"
      },
      "jamon-onduladas": {
        family: "jamon-onduladas",
        type: "left",
        titulo: "Jamón",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Who can resist a crunchy ham-flavour crinkle-cut crisp? <strong>You'll be blown away by the intense</strong> but delicious taste of these legendary crisps.",
        introDos: "",
        introMovil:
          "Who can resist a crunchy ham-flavour crinkle-cut crisp? <strong>You'll be blown away by the intense</strong> but delicious taste of these legendary crisps.",
        ingredientes:
          "Potatoes, sunflower oil (25%), ham seasoning [maltodextrin, salt, flavouring, smoke flavouring and acid (malic acid). May contain <u>milk protein.</u>",
        cantidadValor: "125g",
        hashtag: "#Jamón",
        energia: "2.048kJ, 490 kcal",
        hidratos: "57,5 g",
        azucares: "0,5 g",
        polialcoholes: "",
        grasas: "25 g",
        saturadas: "3,2 g",
        fibra: "",
        sal: "1,6 g",
        proteinas: "6,4 g",
        mostrarSinLactosa: "1"
      },
      "originales-onduladas": {
        family: "originales-onduladas",
        type: "left",
        titulo: "Originales",
        packs: "125g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "The crunchiest, most intense crisps, with just the right touch of salt. Wavy and <strong>irresistibly crunchy.</strong>",
        introDos: "",
        introMovil:
          "The crunchiest, most intense crisps, with just the right touch of salt. Wavy and <strong>irresistibly crunchy.</strong>",
        ingredientes:
          "Potatoes, sunflower oil (32.1%) and salt (1.4%). May contain <u>milk protein.</u>",
        cantidadValor: "125g",
        hashtag: "#Originales",
        energia: "2.206kJ, 529 kcal",
        hidratos: "54,5 g",
        azucares: "0,8 g",
        polialcoholes: "",
        grasas: "32,1 g",
        saturadas: "3,9 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "5,4 g",
        mostrarSinLactosa: "1"
      },
      "sour-cream-onion": {
        family: "sour-cream-onion",
        type: "left",
        titulo: "Sour Cream & Onion",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "For anyone who loves the intense<strong> taste of sour cream and onion</strong>, we bring you this special flavour on a natural crunchy potato base.",
        introDos: "",
        introMovil:
          "For anyone who loves the intense<strong> taste of sour cream and onion</strong>, we bring you this special flavour on a natural crunchy potato base.",
        ingredientes:
          "Potatoes, sunflower oil (26%, sour cream and onion seasoning [flavourings, rice flour, salt, sugar, maltodextrin, acids (citric and malic acid) and acidity regulators (E-327). May contain<u> milk protein.</u>",
        cantidadValor: "125g",
        hashtag: "#SourCreamOnion",
        energia: "2.082kJ, 498 kcal",
        hidratos: "57,4 g",
        azucares: "1,7 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,5 g",
        proteinas: "6,2 g",
        mostrarSinLactosa: "1"
      },
      "york-queso": {
        family: "york-queso",
        type: "left",
        titulo: "York & Queso",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Simply the best pairing in the world. <strong> There's no match for these crunchy ham and cheese </strong> flavour crisps.",
        introDos: "",
        introMovil:
          "Simply the best pairing in the world. <strong> There's no match for these crunchy ham and cheese </strong> flavour crisps.",
        ingredientes:
          "Potatoes, sunflower oil (26%), ham and <u>cheese </u>seasoning [flavouring (contains <u>milk</u>), smoke flavouring, salt, maltodextrin, sugar and colouring (paprika extract)].",
        cantidadValor: "125g",
        hashtag: "#YorkQueso",
        energia: "2.090kJ, 500 kcal",
        hidratos: "58 g",
        azucares: "2,9 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,3 g",
        mostrarSinLactosa: "1"
      },
      "selectas-clasicas": {
        family: "selectas-clasicas",
        type: "left",
        titulo: "Selectas Clásicas",
        packs: "100g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Our most artisan crisps, carefully pan-fried. The true <strong>taste of our roots and tradition</strong> from the very first bite.",
        introDos: "",
        introMovil:
          "Our most artisan crisps, carefully pan-fried. The true <strong>taste of our roots and tradition</strong> from the very first bite.",
        ingredientes:
          "Potatoes, sunflower oil (30%) and salt. May contain <u>milk protein</u>.",
        cantidadValor: "125g",
        hashtag: "#SelectasClásicas",
        energia: "2.328kJ, 558 kcal",
        hidratos: "54,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "34,8 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        mostrarSinLactosa: "0"
      }
    },
    historia: {
      inicio: "Start",
      nuestra: "Our",
      historia: "history",
      descrip1:
        "Red for Palomitas, green for Gusanitos and white for Risketos... Any child born in Spain from the 70s onwards will recognise these colours instantly!",
      descrip2: "Let us tell you how it all began.... This is our story",
      yummy1970: "Specialists<br> in snacking since 1970",
      nuestros: "The very ",
      origenes: "beginning",
      descrip3:
        "In 1970, the entrepreneurial Gómez-Cuétara family bought Chips Ibérica S.A., based in Torrejón de Ardoz, near Madrid, Spain. ",
      descrip4:
        "The factory was modernised and adapted, being dedicated solely to producing potato crisps, the most popular snack in Spain at the time.",
      unaSonrisa: "Keeping a smile ",
      momentos: "in tough times!",
      descrip5:
        "In 1975, all the illusion placed in this incipient project was cut short by a fire that totally destroyed the factory and all its machinery.",
      plantarCara: "Standing strong in the face of adversity!",
      descrip6:
        "The family's resolve and optimism ensured that all was not lost at that critical time. Instead, they decided to move the factory from Torrejón de Ardoz to the nearby town of Daganzo de Arriba and expand operations to include the production of other snacks as well.",
      yAhoraSi: 'Say "hello" to Risi!',
      descrip7:
        "Risi's most famous snack brands are created: Gusanitos, Palomitas, Pajitas, Triskys and Risketos. All of them featured one of the most important and recognisable symbols of the company, its logo, the eternally smiling child.",
      risiLogo: "Risi Logo",
      descrip8: "How did they move from producing ",
      descrip9: "potato crisps to manufacturing other snacks?",
      descrip10:
        "It was all thanks to the introduction of corn extrusion, a technique that makes it possible to shape the raw ingredients using heat and pressure.",
      epocaDorada: "A golden era!",
      descrip11:
        "During the 80s and 90s, Risi was loved and recognised by all Spanish children.",
      descrip12:
        "Risi snacks were seen everywhere. In shops, in kiosks, in children's school bags, in the park and at every child's birthday party.",
      descrip13: "Facing problems with a smile",
      descrip14:
        "Despite the company's success and its popularity among the general public, the firm suffered new problems that eventually caused it to close for a year.",
      descrip15:
        "However, at Risi, we have always kept smiling. Following its closure, the company was acquired by a successful entrepreneur, Juan Gómez-Cuétara, and the situation was turned around thanks to his vision, effort and excellent team of workers. Following years of much hard work and dedication, Risi once again became one of the leading companies in the sector.",
      nuevoCambio: "A new change!",
      estrenamos: "We unveil ",
      fabrica: "a new factory!",
      descrip16:
        "Under the leadership of Juan Gómez-Cuétara and his team, Risi achieved record sales. The success of our products meant that we needed new facilities with more space and the latest technology in order to meet the increasing demand.",
      descrip17:
        "Risi acquired a crisp factory in the town of Loeches, near Madrid. They also expanded their range of crisps to include crinkle-cut and pan-fried crisps",
      descrip18:
        "A new generation takes over the company, with Juan and Marta Gómez-Cuétara at the helm, as Risi moves into a new and exciting era of growth and professionalisation.",
      descrip19:
        "Risi celebrates its 40th birthday with a 7% increase in sales",
      descrip20:
        "This was a very important year for Risi. We decided to revolutionise our business and incorporated two new product categories: biscuits and sweets.",
      hoyYSiempreContigo: "ALWAYS WITH YOU",
      cumplimos50: "We're now more than 50 years old!",
      celebralo: "Come and celebrate with us!",
      viajamosFabs:
        "<strong>With FABS ORIGIN, we travel to Mexico, Tanzania and Vietnam!</strong><br>We launch FABS ORIGIN, our brand of thin chocolate-coated biscuits, made using the best cocoa from around the world, to create an unbeatable experience full of flavour for those special moments.<br> At Risi, we're still innovating!",
      presentamos: "Presenting the (new) classic crisps, Risi's!",
      descrip21:
        "Those delicious crisps that we've made since 1970, we still make them with the same care and attention using our traditional recipes. At Risi, we don't have any secrets or magic formulas. We simply make good crisps, with the best ingredients and authentic flavours.",
      slide2:
        "RISI has a large fleet of heavy and light transport vehicles throughout Spain to ensure that its products reach all parts of the peninsula.",
      slide2_1:
        "The FRYED POTATOES are transported to the national network of RISI Distributions, and from there they are passed on to shops, bars, cafeterias...etc etc.",
      slide2_2:
        "And in the morning, as the sun begins to rise over the horizon, RISI's commercial activity begins to fill the warehouses with life and movement.",
      forLittle: "We are relaunching a range for the little ones in the house:",
      descrip22:
        "The new BSAN PLUS+, with a funnier image than ever and a new adventure companion, Nikoala. They have an ideal nutritional profile for snacks since they are made with cereals, enriched with 5 vitamins and without palm oil, and they also come in 4 convenient individual bags to take away."
    },
    risihoy: {
      especialistas: "Specialists in snacking",
      subtitulo:
        "We're a Spanish family business with more than 50 years of history, specialising in crisps and other snacks.",
      descrip1:
        "<strong>Our passion and dedication</strong> have brought us <strong>to manufacture more than 250 million bags of snacks</strong> in more than 60 different formats, including our iconic <strong>Gusanitos, Palomitas, Risketos, Triskys and our more adult snack, MIOS!</strong>",
      "descrip1-1":
        "But of course, we have much more...Come and discover all our snacks and products!",
      "descrip1-2":
        "Furthermore, <strong>since 2019</strong>, we have added <strong>biscuits and sweets to our family</strong>.",
      descubre: "Discover our products",
      nuestrosValores: "Our Values",
      descrip2:
        "For more than 50 years of history, our loyalty to our guiding principles is what has helped make us the leading brand in the sector.",
      equipo: "Team",
      descrip3:
        "We want <strong>an organisation</strong> made up of people who can achieve their potential whilst contributing towards a common goal. We want a team that works together to achieve <strong>that goal with corporate and individual interests</strong> fully aligned.",
      simplificacion: "Simplification",
      descrip4:
        "We want an organisation where <strong>things are easy</strong> and processes, information and operations <strong>are agile</strong>, with no unnecessary delays or complications.",
      felicidad: "Happiness",
      descrip5:
        "We <strong>want an organisation with a good atmosphere</strong>, where people are positive, communicate and smile as they enjoy their work with the other people who work at the company.",
      integridad: "Integrity",
      descrip6:
        "We want an organisation made up of <strong>people with solid values</strong>, a desire to grow and a commitment to help their colleagues and the organisation grow. We want a working environment that puts people at the centre.",
      liderazgo: "Individual Leadership",
      descrip7:
        "We want an organisation made up of people who are able to make things happen. <strong>People who strive to develop their personal potential</strong> as part of a strong team."
    },
    bannerRsc: {
      titulo: "Commitment",
      subtitulo:
        "At RISI we work to offer moments of happiness, aware that these moments will not last if they are not based on caring for the environment and people, especially our employees and consumers. With this objective, we develop a firm commitment to sustainability, which is based on three lines of action: <strong>environmental commitments, commitment to people and Good Governance</strong>.",
      descrip1:
        "Our Non-Financial Information Statement details our sustainability objectives and the progress made in the last year.",
      informeRsc: "2023 EINF REPORT"
    },
    codigoconducta: {
      titulo: "Code of<br>Ethics",
      subtitulo: "Risi maintains high standards thanks to you",
      download: "Download code of conduct",
      cartapresidente: {
        titulo: "LETTER",
        descrip1: "Dear all,",
        descrip2:
          "Our company is already 50 years old. In 1970, we began the exciting journey that made us what we are today. Over the years, we have grown, evolved and developed a strong identity as a company.",
        descrip3:
          "<strong>Our Mission and Vision</strong> are our business’ main focus, but this would be nothing if we didn’t also have strong <strong>values</strong>. Our Values are our company’s culture and part of our DNA. They have guided the way we have done things in the past and will help us to transform the future.",
        descrip4:
          "In addition, this effort needs to be governed by a <strong>Code of Ethics</strong> to take our organisation to the highest possible level. This way, we can ensure that we comply with legislative requirements, defend human rights and remain competitive in an ever-changing world. This Code applies to all our activities, both internally and externally with consumers, customers, suppliers and wider society.",
        descrip5:
          "As a result, I strongly encourage you to read it, reflect on its content and incorporate it into your daily work. The way we behave as individuals and as a company is everyone’s responsibility, and we rely on all of you to implement this code.",
        descrip6:
          "All that remains is for me to thank all those people who, over the last 50 years, have helped make RISI the great company it is today.",
        descrip7: "Kind regards,"
      },
      principiosgenerales: {
        titulo: "General <br> Principles",
        subtitulo: "Transforming <br>the future through our values",
        vision: "Vision",
        descrip1:
          "To develop a brand-based business and become leaders in the national<strong> “impulse buy” </strong>market.",
        mision: "Mission",
        descrip2:
          "To achieve <strong>organic growth</strong> above the market average in order to win sustainable and profitable market share.",
        descrip3:
          "To achieve this by having an in-depth knowledge of our customers, channels and consumers and by promoting brands, trade marketing, visibility and diffusion.",
        descrip4:
          "To develop a <strong>distribution system</strong> for the impulse channel that allows us to efficiently reach as many sales points and customers as possible.",
        descrip5:
          "The injection of innovation and new business will contribute to the company's growth beyond that of traditional business.",
        alcance: "Scope",
        descrip6:
          "Taking into consideration the current regulatory environment, the RISI Board of Directors has decided to create this Code of Ethics to maintain and promote the highest ethical standards throughout the business.",
        descrip7:
          "This document is intended as a guide for all employees, managers and directors in the execution of their roles and decision-making at RISI.",
        descrip8:
          "All employees, managers and directors at RISI are obliged to abide by this Code of Ethics in all their business and corporate activities, regardless of their role or geographic location. It should also be a guiding principle in our relations with partners and third parties.",
        descrip9:
          "Furthermore, the RISI Board of Directors has agreed to appoint a Compliance Officer who, in addition to other functions, will be responsible for ensuring that all workers understand the code and adhere to it. They will also be charged with carrying out regular checks that RISI staff are fully complying with this Code of Ethics."
      },
      risiempleados: {
        titulo: "Risi and <br>its employees",
        comportamientos: "Conduct",
        descrip1:
          "RISI is committed to <strong>preventing and correcting</strong> any form of violence, harassment, discrimination or intimidation, as well as ensuring <strong>respect for the rights</strong> of all who work at RISI.",
        descrip2:
          "RISI’s employees, managers and directors are committed to preventing and reporting any such behaviour, as well as making efforts to maintain a working environment that allows all members of the workforce to achieve their full potential. To achieve this, it is paramount that all employees respect our values: individual leadership, integrity, happiness, simplification and teamwork.",
        confidencialidad: "Confidentiality",
        descrip3:
          "RISI acknowledges the <strong>confidential nature of all personal information that it receives in the course of its business relationships</strong>. It is therefore committed to not reveal such information to any third parties and to strictly observe the applicable legislation on the matter.",
        descrip4:
          "All employees whose roles involve having access to confidential information, either concerning the company or third parties, are obliged to maintain maximum levels of confidentiality at all times.",
        usomedios: "Use of it systems",
        descrip5:
          "RISI provides its employees and managers with the necessary IT tools to perform their roles, as well as the necessary security mechanisms to protect them.",
        descrip6:
          "Employees and managers are therefore obliged to use these IT systems (being the property of RISI) in a responsible manner for professional ends. While these IT systems <strong>can be used for non-professional purposes</strong>, in moderation, workers should be aware that any use of these systems may be recorded on RISI databases and be subject to review by RISI in accordance with applicable legislation and internal rules, respecting workers’ fundamental rights at all times.",
        descrip7:
          "Similarly, employees and managers will not be permitted to install or use any programs or applications that infringe any rights, could damage company IT equipment or be used for illegal purposes.",
        conflictosIntereses: "Conflicts of interest",
        descrip8:
          "RISI employees and managers must <strong>protect the company’s interests</strong> and uphold its good standing, avoiding all possibility of acting against its interests.",
        descrip9:
          "If any RISI worker finds themselves performing a role or transaction where there might be a conflict of interest, they should inform their manager or the compliance officer immediately so that the appropriate measures can be put in place.",
        comunicacion: "External communications",
        descrip10:
          "Any public statements about RISI or made in its name, whether in traditional media or on social media, may have an impact on the company’s image and its relationship with wider society. For this reason, the company has a special department and specific procedures for handling external communications and these should <strong>only be carried out by people with the express authorisation to do so</strong>.",
        derechosLaborales: "Respect for workers' rights",
        descrip11:
          "Risi is committed to respecting the employment rights of its employees and providing a safe and healthy working environment for all.",
        descrip12:
          "This commitment includes providing safe working conditions for all visitors to our facilities and therefore, allowing us to uphold the highest standards of quality.",
        descrip13:
          "All employees must comply with all established occupational health and safety laws, regulations and policies and report any situation that poses a serious risk to employees' health and safety.",
        descrip14:
          "At Risi we also respect employees' collective bargaining rights and freedom of association.",
        derechosHumanos: "Respect for human rights",
        descrip15:
          "Risi respects human rights and prohibits any behaviour that may violate them.",
        descrip16:
          "As a result, we encourage all persons involved in our business operations to act fairly and appropriately in order to uphold human rights and avoid becoming complicit in human rights violations.",
        discriminacion: "Non-discrimination",
        descrip17:
          "Risi considers its employees to be its most valuable asset and strives to promote a diverse and inclusive culture, based on an open and stimulating work environment.",
        descrip18:
          "We are committed to providing our employees with a fair and ethical working environment, a performance-based remuneration policy and fair and non-discriminatory appraisal and promotion procedures."
      },
      risiconsumidores: {
        titulo: "Risi and <br>its consumers",
        descrip1:
          "Our consumers are the reason for our existence. That is why our priority is to meet their expectations by delivering a safe, fresh, high-quality product.",
        descrip2:
          "At RISI, we rely on our quality and food safety management systems to continuously <strong>improve our products and manufacturing processes, preventing and correcting errors, and striving to deliver a safe, high-quality, innovative product</strong>.",
        descrip3:
          "Therefore, we are committed to having <strong>our quality and food safety systems audited and certified by accredited external agencies</strong>.",
        descrip4:
          "RISI is committed to communicating in an ethical and responsible way, both in our advertising and labelling. For this reason, and with particular regard to our young consumers, we are voluntarily signed up to the Spanish government’s <strong>PAOS and NAOS codes</strong> and our advertising is subject to external and independent monitoring by <strong>AUTOCONTROL</strong>.",
        descrip5:
          "In addition, we also provide our consumers with <strong>various channels</strong> so that we can provide a personal response to any query or complaint whilst striving for continuous improvement.",
        descrip6: "Here are our contact details"
      },
      risiproveedores: {
        titulo: "Risi and its customers<br> and suppliers",
        descrip1:
          "In its relationships with customers, RISI is committed to values of fairness, transparency, information and protection.",
        descrip2:
          "In addition, RISI will apply objective, transparent and impartial criteria when selecting its <strong>suppliers and providers</strong> and avoid all possible favouritism or conflicts of interest.",
        descrip3:
          "RISI’s relationships with both customers and suppliers will be governed by its <strong>commitment to providing high-quality products and services.</strong>",
        descrip4:
          "RISI considers its customers and suppliers to be a vital component in the success of its business. As a result, we will always treat people with respect and rigorously adhere to our commitments in terms of the quality of our products and services and our contractual agreements. We will also apply our values to all our business relationships and encourage customers and suppliers to adopt them as well."
      },
      risisociedad: {
        titulo: "Risi <br>and society",
        medioAmbiente: "Environment",
        descrip0:
          "At RISI, we fully recognise <strong>our responsibilities concerning the environment</strong>. That's why we have implemented measures to guarantee that we show the maximum respect for nature and ensure the environmental sustainability of all our business activities. We adopt safety precautions across our entire business to avoid harming the environment.",
        descrip1:
          "To achieve this, we ensure that our environmental system is audited and certified regularly by accredited external bodies.",
        mercados: "Markets",
        descrip2:
          "RISI is <strong>fully committed to acting with integrity and competing in a fair and free market for the benefit of the consumer</strong>, abstaining from any behaviour that could represent a violation of anti-competition legislation.",
        infoFinanciera: "Financial and tax information",
        descrip3:
          "RISI is firmly committed to <strong>accuracy and transparency with respect to the company's financial information</strong>, in accordance with the accounting principles set out in national and international regulations.",
        descrip4:
          "Similarly, the company's employees and managers are all committed to respecting RISI's internal rules concerning invoicing, payments and refunds.",
        descrip5:
          "RISI is fully aware of its corporate <strong>responsibility to meet its tax and social security obligations</strong>. As a result, RISI, its employees and its management will always adhere strictly to the applicable legislation in such matters.",
        prevencion: "Fight against corruption and other illegal conduct",
        descrip6:
          "At RISI, the giving and receiving of gifts is restricted. Any gifts that could be considered a <strong>bribe</strong> are strictly prohibited, including any that are intended to influence the recipient so that they make decisions that would otherwise be contrary to impartiality or good judgement.",
        descrip7:
          "Additionally, RISI employees are forbidden from offering gifts, handouts, personal benefits or financial incentives to civil servants, public employees, leaders of political parties, public policy makers or candidates for any such role.",
        descrip8:
          "Similarly, RISI will fully cooperate with due diligence with all competent authorities should they require us in the performance of their duties.",
        entorno: "Local community",
        descrip9:
          "RISI strives to have a positive impact on the local community wherever it has a physical presence. As a result, RISI enthusiastically and altruistically participates in various initiatives that are beneficial for the local community and environment."
      },
      risicumplimiento: {
        titulo: "Ethical <br>Compliance",
        descrip1:
          "All RISI employees, managers, directors and partners <strong>are obliged to adhere to the provisions of this Code of Ethics</strong>.",
        descrip2:
          "Any conduct that goes <strong>against the principles</strong> set out in the code or any of the company’s internal rules will be subject to a disciplinary investigation and the application of penalties where appropriate, in accordance with the severity of the violation, <strong>the applicable legal framework and any relevant provisions of the Workers</strong>’ Statute and Collective Bargaining Agreements.",
        descrip3:
          "All RISI employees, managers, directors and partners <strong>are obliged to inform the Compliance Officer about any conduct that they believe to be inappropriate</strong>, irregular or a potential breach of the company’s Code of Ethics or internal rules, regardless of whether such behaviour is beneficial or harmful to the company.",
        descrip4:
          'An Ethics Channel has been set up for this purpose and can be reached through the following email address: <a  href="mailto:canaletico@risi.es" > canaletico@risi.es</a >.',
        descrip5:
          "Any reports of concern must comply with the principles of good faith and should include the full details of the relevant facts. There will be no reprisals of any kind against the whistleblower, and the rights of the person subject to the report will be fully respected at all times.",
        descrip6:
          "RISI is committed to processing this information in the strictest compliance with applicable legislation."
      }
    },
    hoycontigo: {
      titulo: "We are more than<br50 years old...",
      subtitulo: "Find out everything about risi!",
      descrip1:
        "In all this time, there are some things that have NEVER changed",
      descrip2: "Our DNA",
      descrip3: "Effort",
      descrip4: "Dedication",
      descrip5: "Excitement",
      descrip6: "Positivity",
      descrip7: "Always ",
      descrip8: "with a",
      descrip9: "smile",
      descrip10: "Positive attitude",
      descrip11: "a firm commitment to innovation",
      descrip12: "And we've added some NEW things too",
      descrip13: "As well as manufacturing snacks",
      descrip14: "we also now make ",
      descrip15: "BISCUITS and SWEETS",
      descrip16: "What will we do over the next 50 years?",
      descrip17:
        "We will continue to work the only way we know how, with optimism and a big smile, for many more successful and exciting years with you."
    },
    noticias: {
      mostrando: "Displaying",
      resultados: "results",
      noresultados: "We have not published any news yet.<br>Come back later.",
      quebuscas: "What are you looking for?",
      producto: "PRODUCT",
      web: "WEBSITE",
      promocion: "PROMOTION",
      rsc: "CSR",
      novedades: "NEWS",
      familia: "FAMILY",
      tepuede: "You may be ",
      interesar: "interested...",
      masNoticias: "More news",
      compartir: "Share",
      cerrar: "Close"
    },
    nutririsi: {
      titulo: "Risi’s quality commitment",
      subtitulo: "Safety and <br>quality in all Risi products.",
      descrip1:
        "At Risi, S.A., <strong>our team works hard every day to make sure that our consumers can enjoy our delicious snacks whilst still maintaining a healthy lifestyle</strong>. That’s why all Risi’s production centres comply with IFS Food, a standard recognised by the Global Food Safety Initiative (GFSI) certifying the safety and quality of bulk and packaged food products.",
      descrip2:
        "Risi is firmly committed to maintaining high quality and environmental standards through our Quality, Food Safety and Environmental Policy.",
      descrip3: "<strong>Quality and Environmental Policy</strong>",
      descrip4:
        "Risi’s gluten-free snacks, crisps, sweets and biscuits are included in the Official List of the Spanish Federation of Coeliac Associations (FACE).",
      descrip5:
        "We have signed up to the Spanish government’s NAOS Strategy (Nutrition, Physical Activity and Prevention of Obesity).",
      descrip6: "We use only sunflower oil and high oleic sunflower oil.",
      descrip7:
        "We reuse waste products from our processes and transform them into animal feed.",
      descrip8:
        "We recycle our packaging and our waste sunflower oil is used to generate biodiesel.",
      descrip9:
        "We work to reduce food waste throughout the entire value chain.",
      descrip10:
        "At Risi, 100% of our cardboard boxes are made using recycled paper.",
      descrip11:
        "Thanks to the renewable energies used in 2024 in our production center in Madrid, we have avoided the emission of 670 Tn of CO2 into the atmosphere.",
      descrip12:
        "28% of the energy consumed at the Madrid plant in 2024 has come from solar energy.",
      descrip13:
        "We deliver training to all our employees about good environmental practices, and we also engage in awareness-raising activities with respect to food waste, energy saving and water saving.",
      descrip14:
        "At our factory in Seville, we managed to reduce our water consumption by 4.6% compared with 2021.",
      descrip15:
        "In 2022, our Seville factory consumed 3.6% less energy than in 2021.",
      descrip16:
        "Risi is committed to caring for the environment and actively participates in the conversation and restoration of forests with high ecological value.",
      descrip18:
        "At our Seville plant, energy consumption has been reduced in 2024, by 7% compared to 2023."
    },
    distribuidor: {
      localiza: "Find your nearest distributor",
      seleccionaProvincia: "Select a province",
      losentimos: "Sorry",
      actualmente: "There is currently no distributor in this province.",
      puedesContactar: "You can contact us ",
      aqui: "here",
      descargate: "Download",
      nuestro: "our",
      catalago: "catalogue",
      catalalogoSnacks: "Download Snacks Catalogue",
      catalalogoGalletas: "Download Biscuits Catalogue",
      catalalogoCaramelos: "Download Sweets Catalogue",
      estamosActualizando:
        "We are updating our catalogue.<br>It will be available soon.",
      superKiosco: "Super kiosk Risi!",
      vender: "Do you want to sell our products in your establishment?",
      escribenos:
        "Write to us and we will give you all the information you need.",
      general: {
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Customer Support:</p><p><a href='tel:900909013'>900 90 90 13</a> <strong>/</strong> <a href='mailto:pedidos@risi.es'>pedidos@risi.es</a></p>"
          },
          {
            img: "/static/img/aeroplane.svg",
            alt: "Icon-aeroplane",
            text:
              "<p>Exports:</p><p><a href='mailto:nballand@risi.es'>nballand@risi.es</a></p>"
          }
        ]
      }
    },
    faqs: {
      busqueda: "What are you looking for?"
    },
    pressroom: {
      press: "Press",
      room: "Room",
      titulo:
        "Write to us and we'll be happy to provide you with all the information you need",
      subtitulo:
        "If you work in the sector and need more information, you can submit a request using the form below.",
      descargate: "Download ",
      nuestros: "Our ",
      materiales: "Materials"
    },
    bannerRisiHoy: {
      titulo: "Would you like to know more?",
      subtitulo: "we'll tell you everything ",
      risiHoy: "at 'Risi Today'",
      ira: "go to Risi Today"
    },
    materialesPrensa: {
      materiales: "Materials",
      prensa: "Press",
      descarga: "Download our materials",
      descrip1:
        "If you work in the media, we have a range of corporate materials available for you to answer any questions you might have about RISI, its brands and its products."
    },
    politica_cookies: {
      descrip1:
        "<h3>1. SCOPE OF APPLICATION.</h3><p>In accordance with the provisions of article 22.2 of Law 34/2002, of 11 July, on Information Society and E-Commerce Services (LSSI-CE), RISI is obliged to inform about the cookies it uses and their purposes.</p><p>This website uses cookies and/or similar technologies that store and retrieve information when the User browses. Cookies allow a website to store and retrieve information about the browsing habits of a user or his/her device; which, depending on the information they contain and the way his/her device is used, can be used to identify the User.</p><p>Please click<a>HERE</a>if you wish to change the cookie options on this website.</p>",
      descrip2:
        "<h3>2. DEFINITION AND FUNCTIONS OF COOKIES.</h3><p>The information provided below outlines the different types of cookies:</p>",
      descrip3:
        "<table class='table'><tr><th class='odd'></th><th class='odd'></th><th class='odd'>TYPES OF COOKIES</th></tr><tr><th rowspan='2'>ACCORDING TO THE ENTITY MANAGING THEM</th><td>OWN COOKIES</td><td>These cookies are sent to the user's device from a computer or domain managed by the publisher and from which the service requested by the user is provided.</td></tr><tr><td>THIRD-PARTY COOKIES</td><td>These cookies are sent to the user's device from a computer or domain that is not managed by the publisher, but by another entity that processes the data obtained through the cookies.</td></tr><tr><th rowspan='2'>ACCORDING TO THE TIME THEY REMAIN ACTIVE</th><td>SESSION COOKIES</td><td>These cookies are designed to collect and store data while the user accesses a website. They are usually used to store information that only needs to be kept for the provision of the service requested by the user on a single occasion (for example, a list of products purchased) and disappear at the end of the session.</td></tr><tr><td>PERSISTENT COOKIES</td><td>The data of these cookies is stored in the user’s device and can be accessed and processed for a period defined by the party responsible for the cookie, which can range from a few minutes to several years.</td></tr><tr><th rowspan='5'>ACCORDING TO THEIR PURPOSE</th><td>TECHNICAL COOKIES</td><td>These cookies allow the user to browse a website, platform or application and use all the features.</td></tr><tr><td>PROFILING COOKIES</td><td>They allow the application of specific characteristics for the user's navigation on the website (e.g. language).</td></tr><tr><td>ANALYTICS COOKIES</td><td>These cookies allow the cookie administrators to track and analyze the behaviour of websites’ users to which they are linked, including the quantification of the impact of advertisements. The information collected through this type of cookie is used to measure the activity of the website, application or platform, in order to introduce improvements based on the analysis of the data used by users.</td></tr><tr><td>ADVERTISING COOKIES</td><td>They allow the publisher to include advertising space on the website, depending on the contents of the website.</td></tr><tr><td>BEHAVIOURAL ADVERTISING COOKIES</td><td>These cookies store informationabout user behaviour obtained via continuous observation of browsing habits, making it possible to develop a specific profile for showing advertising based on this.</td></tr></table>",
      descrip4:
        "<h3>3. INFORMATION ON THE TYPE OF COOKIES USED BY RISI.</h3><p>Below we provide detailed information about the cookies used on the Web site, their use and specific purpose, the retention periods, as well as International Data Transfers (if any).</p>",
      descrip5:
        "<table class='table'><tr><th class='odd2'>TYPE</th><th class='odd2'>COOKIE</th><th class='odd2'>PURPOSE</th><th class='odd2'>RETENTION</th></tr><tr><td>Session and persistent</td><td>-cookieyesID cky- consent cookieyes- necessary -cookieyes- functional -cookieyes- analytics -cookieyes- performance -cookieyes- advertisement</td><td>Designed to collect and store data while the user browses a website. They are usually used to store information that is only of interest for the provision of the service requested by the user on a single occasion (e.g. a list of products purchased) and expire at the end of a browser session.</td><td>1 year</td></tr><tr><td>Analytical Google analytics.</td><td>ga _gid</td><td>They allow the party responsible for them to monitor and analyze the behavior of users of the websites to which they are linked, including the quantification of the impact of advertisements. The information collected through this type of cookie is used to measure the activity of the website, application or platform, in order to make improvements based on the analysis of the data on the use made by users of the service.</td><td>1 year</td></tr><tr><td>Technical</td><td>_gat_UA- 139143569-1 _cfduid http</td><td>They allow the user to browse through a website and use the different options and services that exist on it, including those that the editor uses to allow the management and operation of the web page and to enable its functions and services, such as, for example, controlling traffic and data communication, identifying the session, and accessing parts with restricted access.</td><td>1 year</td></tr></table>",
      descrip6:
        "Please note that if you accept third-party cookies, you should delete them using your browser options or via the system provided by the third party.",
      descrip7:
        "<h3>4. COOKIE SETTINGS.</h3><p>You may set up cookies that are not strictly necessary for browsing through the settings panel HERE. Please note that if you reject the use of cookies, some of RISI's services may be affected.</p><p>Below, we provide links to various browsers through which you can modify your browser’s settings regarding the use of cookies:</p>",
      descrip8:
        "Webpage:<ul><li><strong>Firefox: </strong><a href='http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we' target='_blank'>http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></li><li><strong>Chrome: </strong><a href='http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647' target='_blank'>http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647</a></li><li><strong>Explorer: </strong><a href='http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-10' target='_blank'>http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-10</a></li><li><strong>Safari: </strong><a href='https://support.apple.com/kb/ph17191?locale=es_ES' target='_blank'>https://support.apple.com/kb/ph17191?locale=es_ES</a></li><li><strong>Opera: </strong><a href='https://help.opera.com/en/latest/web-preferences/#cookies' target='_blank'>https://help.opera.com/en/latest/web-preferences/#cookies</a></li></ul>",
      descrip9:
        "For more information on the processing of personal data, we recommend you to visit our <strong>“Privacy Policy”</strong> section.",
      descrip10: "<strong>Last update:</strong> November 2023"
    },
    aviso_legal: {
      descrip1:
        "In accordance with the provisions of Article 10 of Law 34/2002, of 11 July 2002, on Information Society and E-Commerce Services, it is hereby stated that these pages correspond to RISI, S.A., with Tax Identification Number A28194090, and registered office on Severo Ochoa 2, Pol. Ind. GITESA, 28814 Daganzo (Madrid).",
      descrip2: "Company Name: RISI S.A ",
      descrip3: "Tax Identification Number: A28194090<br>",
      descrip4:
        "Address: Severo Ochoa 2, Pol. Ind. GITESA, 28814 Daganzo (Madrid).",
      descrip5:
        'E-mail:&nbsp;<strong><a href="mailto:risi@risi.es">risi@risi.es</a></strong>',
      descrip6: "GENERAL TERMS OF USE",
      descrip7: "1. PURPOSE",
      descrip8:
        'The present General Terms of Use regulate the use of the website <a href="http://risi.es" target="_blanck">http://risi.es</a>, either under its current name or any other name under which it may appear in the future, ("Web Site"), of RISI, S.A., with Tax Identification Code A28194090, registered office on Severo Ochoa 2, Pol. Ind. GITESA, 28814 Daganzo (Madrid) and e-mail address <strong><a href="mailto:risi@risi.es">risi@risi.es</a></strong> (hereinafter "RISI"). This Website is aimed exclusively at natural persons residing in Spain. Users residing or domiciled in any other country which make use of this Website shall act under their own responsibility and must ensure that such access and/or use complies with applicable local regulations. By accessing and using this Website, you ("User") acknowledge that you have read and accepted these Terms of Use and agree to comply with all its terms and conditions. You, the User, further acknowledge and agree that any access to and use of this Web Site shall be subject to the Terms of Use in effect at the time of access to this Web Site. RISI reserves the right to modify these General Terms of Use at any time, as well as any other general or specific conditions which may be applicable. Likewise, RISI reserves the right to suspend, interrupt or cease to operate the Web Site at any time.',
      descrip9: "2. CONTENTS",
      descrip10:
        'Through this Website, RISI provides the User with access to various kinds of content, information and data belonging to RISI (hereinafter, the ""Content""). RISI reserves the right to modify the appearance, configuration and location of the Website at any time, including the Content and the corresponding General Terms and Conditions. RISI makes no guarantee that Content provided through the Website will be correct, complete or up to date under any circumstances. Where third-party Content has been published on the Website, RISI accepts no responsibility for the legality, reliability, utility, veracity, accuracy, completeness or timeliness of said Content. Under no circumstances will RISI accept liability for any damages as a result of (i) the potential infringement of third-party rights; (ii) the reliability, usefulness, veracity, accuracy, completeness or timeliness of third-party Content; (iii) the inadequacy for any purpose of Website Content or Content that fails to meet expectations; (iv) or any decisions or actions taken by the User based on Website Content. In any case, RISI reserves the right to withdraw or block access to any Content if it becomes aware that said Content is illegal or infringes the rights of third parties or if it is required to do so due to a legal ruling or government order.',
      descrip11: "3. ACCESS TO AND USE OF THE WEBSITE",
      descrip12:
        "Access to the Website shall be restricted to persons under 14 years of age. Notwithstanding the foregoing, access to certain contents and/or participation in RISI’s promotions is limited to adults and emancipated minors, as indicated in each particular case. In general, Users shall access the Web Site freely and free of charge. The User acknowledges and accepts that access to and use of the Web Site and/or the Contents included therein is performed freely and consciously, under his/her sole responsibility. RISI shall in no case be responsible for the use of the Web Site or the Contents by the Users and/or third parties, nor for any damages arising therefrom. The User undertakes to make an appropriate and lawful use of the Web Site and the Contents, in accordance with the applicable laws, the present General Terms of Use, widely accepted moral and ethical standards and public order. The User shall refrain from (i) unauthorized or fraudulent use of the Website and/or the Contents; (ii) accessing or attempting to access restricted resources on the Website; (iii) using the Website and/or the Contents for purposes that are illicit, illegal, contrary to the provisions of these General Terms of Use, to good faith and public order, harmful to the rights and third parties’ interests, or that may in any way damage, render useless or overload the Website or prevent the normal use or enjoyment of the Website; (iv) causing damage to the Website, or to the suppliers or third parties systems; (v) introducing or disseminating computer viruses or any other physical or logical systems that are likely to cause damage to the systems of RISI, its suppliers or third parties; (vi) attempting to access, use and/or manipulate the data of RISI, third party suppliers and other users; (vii) reproducing or copying, distributing, allowing access to the public by means of any form of public communication, transforming or modifying the Contents, unless authorized by the holder of the corresponding rights; (viii) deleting, concealing or manipulating the copyright notices and other data identifying the rights of RISI or third parties incorporated in the Contents;",
      descrip13:
        "(ix) obtaining or attempting to obtain the Contents by means or procedures other than those which are made available for this purpose or which have been expressly indicated on the web pages where the Contents are located or, in general, those which are normally used on the Internet which do not entail a risk of damage or disablement of the Website and/or the Contents.",
      descrip14:
        "4. ADDITIONAL TERMS FOR ACCESS TO AND USE OF RESTRICTED AREAS",
      descrip15:
        'In the event that any area of the Web Site has restricted and/or limited access, and without prejudice to the specific terms regulating its use, access to said area shall in all cases be subject to prior registration by the User by completing the corresponding form ("Registration Form"), provided to the User for such purpose. However, RISI reserves the right to freely accept or reject the User`s request for registration. The data entered by the User on the Registration Form must be accurate, up to date and truthful at all times. Access to and use of a specific area of the Web Site is subject to the provision of a password assigned to the User by RISI on completing the Registration Form, whereby access is deemed to have been granted exclusively to the User, who shall be liable in all cases for such access and use. The User shall be responsible at all times for the safekeeping of his/her password, assuming, thereby, any damages that may arise from improper use, or the transfer, disclosure or loss of the same. In the event of loss of the password or any other circumstance which entails the risk of access and/or use by unauthorized third parties, the User shall immediately notify RISI in order that the password may immediately be blocked and replaced. Nevertheless, any operations carried out prior to said notification shall be deemed to have been carried out by the User, who shall be responsible for and shall pay the costs and/or damages arising from any unauthorized access and/or use carried out prior to said notification.',
      descrip16: "5. INTELLECTUAL AND INDUSTRIAL PROPERTY RIGHTS",
      descrip17:
        "The User acknowledges and accepts that all intellectual and industrial property rights over the Contents and/or any other elements incorporated in the Website (including, without limitation, trademarks, logos, trade names, texts, images, graphics, designs, sounds, databases, software, flow charts, presentation, audio and video) are the intellectual property of RISI and/or third parties. The use of such elements, their reproduction, disclosure and/or distribution for commercial or lucrative purposes, as well as their modification, alteration or decompilation is strictly prohibited. Any other use or exploitation of any Contents and/or other elements included in the Web Site other than those expressly provided for herein shall be subject to prior authorization by RISI or the third party owner of the rights affected.",
      descrip18: "6. LINKS",
      descrip19:
        "The Web Site may include links and search tools that allow Users to access third party web sites. Such links and search tools are provided for reference purposes only. Notwithstanding, Users are advised to consult the terms of use and privacy policies of third party web sites accessed through links included on the Web Site. Although RISI previously reviews the content of the Web sites to which it establishes a link and only provides links to those Web sites which, to the best of its knowledge and belief, comply with the applicable law, RISI neither approves nor controls the contents of such Web sites and/or any modifications thereto. Furthermore, RISI expressly excludes all liability for any damage which may derive from the access, use or impossibility of use, by Users, of any Web site to which a link is established or the contents thereof. Without prejudice to the foregoing, RISI reserves the right to remove links to any Web site in the event that it is aware that the activities carried out on said Web site or the contents thereof are illegal or infringe third parties’ rights, or in the event that it is required by virtue of a court ruling or an administrative order.",
      descrip20: "7. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY",
      descrip21:
        "RISI does not guarantee the availability and permanence of the Web Site’s operation. Consequently, RISI shall in no case be liable for any damages that may arise from (i) the lack of availability or accessibility of the Web Site; (ii) interruption in the operation of the Web Site or computer faults, telephone breakdowns, disconnections, delays or blockages caused by deficiencies or overloads in telephone lines or data centers in the Internet or any other electronic systems, that may result during its operation; and (iii) other damages that may be caused by third parties through unauthorized interruptions beyond the control of RISI. RISI does not guarantee the absence of viruses or other elements on the Web Site introduced by third parties outside RISI which may produce alterations in the physical or logical systems of the Users or in the electronic documents and files stored in their systems. Consequently, RISI shall in no case be responsible for damages of any nature which may derive from the presence of viruses or other elements which may produce alterations in the hardware, software, documents or files of Users. RISI does not guarantee that unauthorized third parties cannot identify the pages of the Web site which the User visits, nor the conditions, characteristics and circumstances under which the User visits the Web site. Consequently, RISI shall in no case be responsible for any damages which may arise from such unauthorized access.",
      descrip22: "8. GOVERNING LAW AND JURISDICTION",
      descrip23:
        "The present Terms of Use, as well as the relationship between RISI and the User, shall be ruled and construed in accordance with the Spanish law. Each party to this agreement agrees to submit to the exclusive jurisdiction of the courts and tribunals of the place of residence of the User to hear, settle and/or determine any dispute, controversy or claim arising out of or in connection with these Terms of Use or the relationship between them."
    },
    politica_privacidad: {
      descrip1:
        "<h3>1. WHO ARE WE?</h3><p>RISI is a Spanish family company with almost fifty years of history, specializing in the manufacture and commercialization of snacks and appetizers.</p><p>RISI’s aim is to meet the needs and satisfy the expectations of consumers, based on brands of the highest quality with processes in constant improvement.</p>",
      descrip2:
        "<h3>2. WHO IS RESPONSIBLE FOR THE PROCESSING OF YOUR PERSONAL DATA?</h3><p>The personal data provided is processed by RISI SA (RISI), with tax number A28194090 and registered office located on Severo Ochoa 2, Ind. GITESA, 28814 Daganzo (Madrid), and e-mail:<a href='mailto:risi@risi.es' target='_blank'> risi@risi.es</a></p><p>The contact details of our Data Protection Delegate: <a href='mailto:dpd.cliente@conversia.es' target='_blank'> dpd.cliente@conversia.es</a> telephone <a href='tel:902877192' target='_blank'>902 877 192</a></p>",
      descrip3:
        "<h3>3. SCOPE OF APPLICATION.</h3><p>The aim of this Privacy Policy is to regulate the processing of the data of RISI’s website Users. Therefore, it is applicable to all those Users who browse and use the RISI website, request information through any channel enabled for this purpose (email, form, telephone, etc.), register for promotions and / or prize draws or interact with us.</p><p>It is also applicable to clients, suppliers and other related parties in their relationship with RISI.</p><p>The Data Subject declares to have previously read and understood this Privacy Policy, and voluntarily accepts it, without reservation, and exempts RISI from any misuse that may be made of the information sent through it.</p>",
      descrip4:
        "<h3>4. WHERE DO WE OBTAIN YOUR PERSONAL DATA?</h3><p>We collect your data through different channels:</p><h4>4.1. Information provided by you.</h4><p>We deal with personal information provided by you through the channels created for this purpose, such as the contact form provided on the web site and/or in our offices, email, telephone, WhatsApp, or interaction with us through social networks or by sharing our content. We also collect information when you participate in prize draws or promotions, marketing campaigns, newsletter subscriptions, or satisfaction surveys.</p><p>We also process your data when you wish to join the RISI team by sending us your application by e-mail: <a href='mailto:empleo@risi.es' target='_blank'> empleo@risi.es</a></p><h4>4.2. Information collected by RISI</h4><p>We and our third party service providers, such as analytics, social media and advertising partners, may use technologies that automatically (or passively) collect certain information when a User interacts online on the Site. We also use cookies, for which you should review our <strong><a href='https://risi.es/es/politica-de-cookies' target='_blank'>“Cookies Policy”</a></strong>.</p>",
      descrip5:
        "<h3>5. WHAT TYPE OF INFORMATION DO WE PROCESS?</h3><p>RISI may process the following type of information:</p><br><ul><li>Identifiers and contact information such as name, user name, e-mail address, mailing address, zip/post code, telephone number, gender, age, date of birth.</li><li>Proof of purchase, such as a grocery ticket or receipt, for a promotion or prize draw.</li><li>Any content produced and shared by the user on our websites, applications or social media pages.</li><li>Information about your use and navigation on our websites and applications; for example, the website you came from, the web pages you visit most often, the number of times you watch a video or interact with an image.</li><li>Information about previous participation in promotions such as prize draws or contests; e.g., type of promotion, associated brand.</li><li>Contact details and personal and professional information when you send us your application for a vacant position.</li></ul><p>RISI only processes sensitive or confidential personal data when strictly necessary and only with your prior consent.</p>",
      descrip6:
        "<h3>6. FOR WHAT PURPOSE AND ON WHAT LEGAL BASIS DO WE PROCESS YOUR PERSONAL DATA?</h3><p>RISI undertakes to process your personal data in accordance with the provisions of the applicable regulations and, in particular, for the following purposes: </p><ul><li><strong>On-site visitors.</strong>We collect your personal data when you visit any of our factories or facilities 'on site', in order to control the access passes or visits.</li><li><strong>Manage queries, claims, incidents and/or suggestions. </strong>Your data is processed for the purpose of administrative management of queries, complaints, incidents and/or suggestions sent through the corresponding channel (email, telephone, chat, WhatsApp, etc).</li><li><strong>Participation in prize draws and/or promotions. </strong>We hereby inform you that we may process your data to develop initiatives, contests, promotions and other similar activities and include your participation in them.</li><li><strong>Presentation of offers and/or promotions. Commercial communications. </strong>Your personal data may be processed in order to send you advertising related to RISI products through printed, electronic or telephonic means. Therefore, we shall determine which offers and news may be of more interest to you.</li><li><strong>Data collected through the web. </strong>The purpose of collecting this type of data is to provide a better experience when using the web.</li><li><strong>Candidate management. </strong>We collect personal and professional information, which you provide to us at<a href='mailto:empleo@risi.es' target='_blank'>empleo@risi.es</a>, in order to process potential candidates.</li></ul><p>The lawful basis for processing your data for the aforementioned purposes is the consent you have given us according to the specific purposes and pursuant to the provisions of art. 6.1 a) of the GDPR. Your personal data shall be kept for this purpose until you revoke your consent.</p><ul><li><strong>Customer data management. </strong>Your personal data is processed in order to provide the service and/or product contracted or offered, as certain personal information is necessary.</li><li><strong>Management of service providers. </strong>RISI processes the personal data of its suppliers strictly for the purpose of the completion of the contract.</li></ul><p>The lawful basis for the aforementioned purposes is the performance of a contract to which the data subject is party under the provisions of art. 6.1 b) of the General Data Protection Regulation (hereinafter 'GDPR').</p><ul><li><strong>Data management for compliance with legal and regulatory obligations. </strong>All data controllers are subject to the laws of the countries in which they operate, and are obliged to comply with them. These obligations include the provision, in certain circumstances, of personal data to judicial bodies, regulatory or supervisory bodies and law enforcement agencies.</li></ul><p>The lawful basis for processing your data for the aforementioned purposes is the compliance with the legal obligations to which the controller is subject, pursuant to the provisions of art. 6.1 c) of the GDPR.</p><ul><li><strong>Satisfaction surveys. </strong>We hereby inform you that we may use your data to conduct surveys in order to determine the interests and obtain information through Social Networks about the perception of our brand or products.</li><li><strong>Quality control management. </strong>Please be informed that we record interactions with consumers, such as emails, phone calls to the RISI helpline, for quality control purposes.</li></ul><p>The lawful basis for the processing of your data for the aforementioned purposes is the legitimate interest of the data subject, pursuant to the provisions of art. 6.1 d) of the GDPR.</p>",
      descrip7:
        "<h3>7. HOW LONG DO WE KEEP YOUR DATA?</h3><p>Your personal data is retained for the time necessary to fulfill the aforementioned purposes. Nevertheless, we limit access to your data to those persons who need to use it for the performance of their duties.</p><p>The period of retention of the data processed is based on business needs, so when unnecessary, they shall be kept properly blocked for the sole purpose of meeting the responsibilities of any kind that may arise.</p><ul><li><strong>Purposes related to the consent given.</strong>The data shall be kept until consent is revoked by the data subject and, at the most, for a period of four years after the express consent was obtained.</li><li><strong>Purposes related to the execution of a contract.</strong>The retention period for data concerning the management of any contractual obligation we have with you is ten years. We shall retain such data for the duration of the contract in addition to the ten following years in order to be able to respond to any subsequent queries or complaints.</li><li><strong>Purposes related to the fulfillment of legal obligations.</strong>Certain data must be kept for the periods required by the specific applicable regulations (tax, commercial, money laundering, etc.).</li><li><strong>Purposes related to RISI's legitimate interest.</strong>Certain data must be maintained for as long as necessary to fulfill RISI's interest.</li></ul>",
      descrip8:
        "<h3>8. WHO IS YOUR PERSONAL DATA COMMUNICATED TO?</h3><p>Your data is not communicated to third parties, unless expressly authorized or, in legally admissible cases, information shall only be provided to the Public Authorities such as: to the Tax Authorities for the fulfillment of tax obligations; to the competent Administrations, State Security Forces and Bodies, Judges and Courts and to the Spanish Data Protection Agency, in compliance with the legal obligations of the Data Controllers or in the case of conflicts related to consumer rights, data protection rights, intellectual or industrial property rights, or any other protected goods and/or rights. In addition to financial entities for the management of collections and payments.</p><p>Similarly, some entities subcontracted by RISI may have access to personal data and information as processors or sub-processors in order to provide us with necessary services. These service providers sign a contract that obligates them to use your personal information only for the provision of the services disclosed in this policy. This includes third parties that allow us to respond to your inquiries, call centers, provide consumer services, participate in our promotions, host our websites, deliver marketing communications and analyze information.</p>",
      descrip9:
        "<h3>9. INFORMATION SECURITY MEASURES.</h3><p>RISI, guarantees the proper use of the information, and in particular, the full confidentiality of personal data contained in our system, as well as full compliance with the obligations regarding the protection of personal data.</p><p>RISI has implemented the necessary technical and organizational security measures to guarantee the security of your personal data and to avoid its alteration, loss and treatment and/or unauthorized access; taking into account the state of the technology, the nature of the data stored and the risks to which they are exposed, whether from human action or from the physical or natural environment.</p><p>Furthermore, RISI is adhered to the<a>Code of Conduct on Data Protection in the Advertising Activity of AUTOCONTROL</a>accredited by the Spanish Data Protection Agency and is therefore linked to its out-of-court complaint handling system when related to data protection and advertising, available to data subjects at the website: <a href='https://www.autocontrol.es/servicios/reclamaciones-de-proteccion-datos-y-publicidad/usuarios/' target='_blank'>https://www.autocontrol.es/servicios/reclamaciones-de-proteccion-datos-y-publicidad/usuarios/</a>.</p><p>The code of conduct is accessible through the following link, where you can download it free of charge: <a href='https://www.autocontrol.es/wp-content/uploads/2023/10/codigo-de-conducta-proteccion-de-datosautocontrol.pdf' target='_blank'>https://www.autocontrol.es/wp-content/uploads/2023/10/codigo-de-conducta-proteccion-de-datosautocontrol.pdf</a></p>",
      descrip10:
        "<h3>10. WHAT ARE YOUR RIGHTS WHEN YOU PROVIDE US WITH PERSONAL INFORMATION?</h3><p>We inform you that, at any time, you can exercise your rights of access, rectification, erasure, portability, to object, and not to be subject to a decision based on automated processing and the limitations of processing by RISI.</p><h4>10.1 What are your rights as a Data Subject?</h4><ul><li>Right of access: you have the right to obtain confirmation as to whether RISI processes your personal data, as well as to access it.</li><li>Right of rectification: you may request the modification or rectification of personal data that is inaccurate.</li><li>Right of erasure: you may request the erasure of your personal data.</li><li>Right to limitation of processing: in certain circumstances, you may request the limitation of the processing of your data, in which case they shall only be kept for the exercise or defense of claims.</li><li>Right to object: you may object to the processing of your data for the purpose you specify.</li><li>Right to not be subject to automated individual decisions: you have the right to not be subject to a decision based solely on automated processing, including profiling, which is likely to produce legal effects or significantly affect you in a similar way.</li><li>Right to portability: if the website allows it, you may exercise the right to the portability of your data, in a structured, commonly used and machine-readable format, and to transmit it to another data controller.</li></ul><h4>10.2 How do I exercise my rights?</h4><p>Depending on the type of information we process about you, you may contact RISI or the suppliers we work with to process your data in connection with advertising campaigns, call centers, customer service or similar, for which we refer you to the information clause on data protection for the year in question.</p><p>The exercise of your rights shall be completely free of charge.</p><p>Opposition to a certain purpose or the revocation of the consents granted shall not affect the use you may make of the web, nor the lawfulness of the processing prior to the objection or revocation of consent.</p><p>The consents granted may be revoked by sending an e-mail to: <a href='mailto:risi@risi.es' target='_blank'>risi@risi.es</a>and/or by clicking on the unsubscribe link provided in this type of mailing, located in all of the communications received.</p><p><strong>Nevertheless, you must make the request indicating the exercise of your rights and the channel through which you wish to receive the response. Likewise, you must indicate the person exercising the right, attaching a copy of his/her identity document. Otherwise, we shall not be able to respond to your request with the minimum guarantees.</strong></p><p>Finally, if you consider that you have not obtained satisfaction in the exercise of your rights or you are not satisfied with the processing of your personal data, you may file a complaint with the Spanish Data Protection Agency through its website: <a href='mailto:www.aepd.es' target='_blank'>www.aepd.es</a>.</p>",
      descrip11:
        "<h3>11. MODIFICATIONS.</h3><p>We reserve the right to amend this Policy to adapt it to new laws and case laws. In the case of modifications RISI shall provide information in a timely manner.</p><p><strong>LAST UPDATE: September 2023.</strong></p>"
    },
    bases_legales_risi: {
      risketos: "BBLL RISKETOS NUEVO PACKAGING Y X-HOT",
      mios: "BBLL CASHBACK RISI MIOS HORNEADOS",
      pipas: "PIPAS PROMOTION T&Cs",
      menosAire: "#MENOSAIREMÁSDISFRUTE PROMOTION T&Cs",
      patatas: "IG PATATAS DRAW T&Cs",
      trikers: "TRIKERS PROMOTION T&Cs",
      fabs: "FABS PROMOTION T&Cs"
    },
    daganzo: {
      text1:
        "In our factory in Daganzo de Arriba (Madrid) we make Risi snacks and appetizers.",
      text2: "Certiicates",
      text3: "Environmental Policy"
    },
    promocionEspiral: "Enjoy our promotions",
    promocionCta: "See Legal Bases",
    promocionesList: [
      {
        img: "/static/img/banner-home/mios-es.jpg",
        url: "/static/pdf/bbll-promocion-mios.pdf"
      }
    ],
    newsletter: {
      popup: {
        title: "Join our newsletter and receive exclusive content",
        cta: "SUBSCRIBE"
      },
      banner: {
        title1: "Join our ",
        title1_1: "newsletter",
        title1_2: "and receive directly to your inbox",
        title2: "EXCLUSIVE CONTENT",
        title3: "SPECIAL DRAWS",
        title4: "AND MORE",
        tipoContactoLabel: "Type of contact",
        tipoContactoOptions: ["CONSUMER", "DISTRIBUTOR", "SELLER"],
        obligatorioFechaNacimiento: "The date of birth field is obligatory",
        msg_succes:
          "THANK YOU VERY MUCH! <br> Your subscription has been successfully completed.",
        msg_error: "It has not been possible to formalise the subscription."
      }
    }
  },
  fr: {
    enlaces: {
      home: "/",
      noticias: "actualites",
      noticia: "actualité",
      sala_de_prensa: "salle-de-presse",
      contacto: "contact",
      promociones: "promotion",
      distribuidores: "concessionnaires",
      promocion: "promotion",
      pressroom: "pressroom",
      faqs: "faqs",
      bases_legales: "base-juridique",
      trabaja_con_nosotros: "travaille-avec-nous",
      politica_privacidad: "politique-de-protection-des-données",
      politica_cookies: "politique-de-cookies",
      aviso_legal: "mentions-legales",
      snacks: "snacks",
      gusanitos: "snacks/gusanitos",
      palomitas: "snacks/palomitas",
      risketos: "snacks/risketos",
      mios: "snacks/mios",
      triskys: "snacks/triskys",
      matchBall: "snacks/match-ball",
      jummy: "snacks/jummy",
      otrosProductos: "snacks/autres-produits",
      surtis4u: "snacks/autres-produits/surtis",
      tejitas: "snacks/autres-produits/tejitas",
      buscalios: "snacks/autres-produits/buscalios",
      pajitas: "snacks/autres-produits/pajitas",
      trikers: "snacks/autres-produits/trikers",
      patatas: "chips",
      originales: "chips/originales",
      onduladas: "chips/onduladas",
      selectas: "chips/selectas",
      exportacion: "chips/exportacion",
      detodalavida: "chips/depuis-toujours",
      galletas: "biscuits",
      bsan: "biscuits/b-san",
      chocolate: "biscuits/b-san-0sucres-chocolat",
      maria: "biscuits/b-san-0sucres-maria",
      adultas: "biscuits/b-san-sans-gluten",
      desayuno: "biscuits/b-san-plus/sansgluten",
      infantiles: "biscuits/hello-kitty-doraemon",
      tradicionales: "biscuits/traditionnels",
      plus: "biscuits/b-san-plus/avecgluten",
      fabs: "biscuits/fabs",
      caramelos: "bonbons",
      azucares0: "bonbons/0-sucres",
      caramelosTradicionales: "bonbons/traditionnels",
      borges: "fruits-secs",
      frutossecos: "fruits-secs/fruits-secs",
      pipas: "fruits-secs/graines-de-tournesol",
      historia: "histoire",
      nutririsi: "nutririsi",
      quienessomos: "qui-sommes-nous",
      materialesprensa: "documents-de-presse",
      concursofulloftrickers: "fulloftrikersrandom",
      codigoconducta: "conformite-reglementaire/code-de-conduite",
      cartapresidente:
        "conformite-reglementaire/code-de-conduite/lettre-du-president",
      principiosgenerales:
        "conformite-reglementaire/code-de-conduite/principes-geenraux",
      risiempleados:
        "conformite-reglementaire/code-de-conduite/risi-et-ses-personnel",
      risiconsumidores:
        "conformite-reglementaire/code-de-conduite/risi-et-ses-consommateurs",
      risiproveedores:
        "conformite-reglementaire/code-de-conduite/risi-et-ses-fournisseurs",
      risisociedad: "conformite-reglementaire/code-de-conduite/risi-et-societe",
      daganzo:
        "conformite-reglementaire/code-de-conduite/risi-et-societe/risi-sa",
      loeches:
        "conformite-reglementaire/code-de-conduite/risi-et-societe/loeches",
      matarile:
        "conformite-reglementaire/code-de-conduite/risi-et-societe/matarile",
      cumplimientoetico:
        "conformite-reglementaire/code-de-conduite/conformite-et-canal-etique",
      bases_legales_risi: "base-juridique-risi",
      consultaComentario: "question-ou-commentaire",
      otro: "autre",
      mcdonals: "https://mcextreme.mcdonalds.es/",
      regulatory_compliance: "conformite-reglementaire",
      values: "conformite-reglementaire/valeurs",
      ethical_channel: "conformite-reglementaire/canal-ethique",
      sustainability: "conformite-reglementaire/engagements",
      seo: {
        home: {
          title: "Risi | Snacks, chips, biscuits, sucreries et noix",
          description:
            "Bienvenue à la maison des marques emblématiques telles que Gusanitos, Palomitas, Risketos, Triskys, Matchball, Pajitas, Tejitas... et bien d'autres encore!"
        },
        noticias: {
          title: "Risi | Nouvelles et promotions Risi",
          description:
            "Ne manquez pas nos dernières nouvelles et nos promotions amusantes."
        },
        noticia: {
          title: "Risi | Nouvelles et promotions Risi",
          description:
            "Ne manquez pas nos dernières nouvelles et nos promotions amusantes."
        },
        contacto: {
          title: "Risi | Contact",
          description:
            "Contactez-nous via notre formulaire de contact ou appelez-nous au 900 909 013, nous nous ferons un plaisir de vous aider !"
        },
        faqs: {
          title: "Questions fréquemment posées Risi",
          description:
            "Chez Risi, nous répondons à toutes les questions que vous vous posez sur nous et nos produits, afin que vous disposiez de toutes les informations dont vous avez besoin."
        },
        nutririsi: {
          title: "Risi | NutriRisi",
          description:
            "Nous nous engageons fermement en faveur de la qualité, de l'amélioration nutritionnelle et du respect de l'environnement. Découvrez l'engagement de Risi en faveur de la qualité !"
        },
        historia: {
          title: "Risi | Histoire",
          description:
            "Le vert de Gusanitos, le rouge de Palomitas, l'orange de Risketos... qui ne reconnaît pas ces couleurs ? Chez Risi, nous sommes à vos côtés depuis 1970. Découvrez notre histoire passionnante !"
        },
        pressroom: {
          title: "Risi | Salle de presse",
          description:
            "Vous êtes un professionnel de la presse et vous avez besoin d'informations sur Risi ? Dans notre salle de presse, vous trouverez toutes les informations dont vous avez besoin et une grande variété de matériel pour accompagner vos nouvelles."
        },
        distribuidores: {
          title: "Risi | Distributeurs",
          description:
            "Vous souhaitez vendre nos produits ? Accédez à notre carte virtuelle et contactez nos distributeurs régionaux."
        },
        snacks: {
          title: "Risi | Les meilleurs snacks et amuse-gueules Risi",
          description:
            "Vous trouverez les snacks les plus célèbres et les plus drôles à Risi, Gusanitos, Palomitas, Risketos, Matchball... Quelqu'un connaît-il quelqu'un qui a résisté à l'envie d'essayer les Risi Snacks ?"
        },
        otrosProductos: {
          familia: "snacks",
          title: "Risi | Produits",
          description:
            "Vers, Popcorn, Risketos, Triskys, Matchball, Pailles, Tejitas ... et bien plus encore !"
        },
        gusanitos: {
          familia: "snacks",
          title: "Risi | Les véritables Gusanitos",
          description:
            "Le plus célèbre, le plus délicieux et le plus irrésistible des en-cas cuits au four, avec lequel le plaisir est garanti. Qui peut dire non à un sac de Los Auténticos Gusanitos ?"
        },
        matchBall: {
          familia: "snacks",
          title: "Match Ball Risi : des boules légères pleines de saveur",
          description:
            "Les boules Risi Match Ball sont toujours délicieuses avec leur goût de fromage, mais vous serez également surpris par les nouvelles recettes : Ketchup, Barbecue et Mini format."
        },
        mios: {
          familia: "snacks",
          title: "Míos Risi : le snack le plus sophistiqué et le plus original",
          description:
            "Míos est un en-cas spécialement conçu pour les adultes et aux saveurs surprenantes : Maïs&Chia, Maïs&Epinard, Maïs&Oignon, Maïs&Oignon, Maïs&Chia, Maïs&Epinard, Maïs&Epinard, Maïs&Epinard, Maïs&Epinard, Maïs&Epinard."
        },
        palomitas: {
          familia: "snacks",
          title: "Risi | Le vrai pop-corn",
          description:
            "Le Popcorn Authentique est l'en-cas préféré pour profiter au maximum de vos films et de vos couvertures... assurez-vous de ne pas en manquer à la maison !"
        },
        risketos: {
          familia: "snacks",
          title: "Risi | Risketos",
          description:
            "Un en-cas irrésistible qui laisse sa marque. Super croquant, avec une saveur de fromage des plus irrésistibles. Délicieux et unique - salissez-vous les doigts avec Risketos !"
        },
        triskys: {
          familia: "snacks",
          title: "Risi | Triskys",
          description:
            "De délicieuses rondelles de maïs croustillantes et rondes qui vous feront revivre les meilleu"
        },
        jummy: {
          familia: "snacks",
          title: "Risi | Jummy",
          description:
            "Amusant et audacieux, c'est ça Jummy. La star qui est née pour rester et avec laquelle nous promettons de ne pas laisser indifférents les amateurs de ce qui est authentique et innovant. Est-ce que tu vas le manquer?"
        },
        exportacion: {
          familia: "patatas",
          title: "Risi | Chips RISI",
          description:
            "Chez Risi, nous fabriquons de bonnes frites depuis toujours, avec les meilleurs ingrédients et des saveurs authentiques. Découvrez nos pommes de terre Original, Wavy et Select !"
        },
        galletas: {
          title: "Risi | Biscuits BSAN et FABS",
          description:
            "De délicieux biscuits haut de gamme pour tous les goûts et tous les besoins : les biscuits BSAN, qui prennent soin de vous de manière globale, et nos biscuits FABS, aux saveurs les plus authentiques et les plus exclusives des meilleurs chocolats du monde."
        },
        bsan: {
          familia: "galletas",
          title: "Risi | Biscuits BSAN et FABS",
          description:
            "De délicieux biscuits de qualité supérieure pour tous les goûts et tous les besoins : les biscuits BSAN pour prendre soin de vous de manière holistique et nos biscuits FABS, aux saveurs les plus authentiques et les plus exclusives des meilleurs chocolats du monde."
        },
        chocolate: {
          familia: "galletas",
          title: "RISI | BSAN Biscuits 0% sucres ajoutés, chocolat",
          description:
            "Biscuits BSAN enrobés de délicieux chocolats : lait, noir et blanc. Et surtout, ils sont délicieux avec 0 % de sucre !"
        },
        maria: {
          familia: "galletas",
          title: "RISI | BSAN 0 % de sucres ajoutés Biscuits Maria",
          description:
            "Le traditionnel BSAN Maria type 0% de sucres, parfait pour un petit déjeuner sain. Aux graines de sésame ou à l'épeautre, que choisissez-vous ?"
        },
        adultas: {
          familia: "galletas",
          title: "Risi | BSAN Biscuits sans gluten pour adultes",
          description:
            "Délicieux biscuit BSAN sans gluten, enrobé de chocolat noir intense à 70% de cacao. Croquant et étonnamment savoureux."
        },
        desayuno: {
          familia: "galletas",
          title: "RISI | BSAN Biscuits pour enfants sans gluten",
          description:
            "De délicieux biscuits à base de farine de maïs et de riz qui raviront les petits à la maison avec leurs personnages préférés, HelloKitty et Doraemon ! Cadeau inclus."
        },
        infantiles: {
          familia: "galletas",
          title: "Virginias Infantiles : les meilleurs biscuits pour enfants",
          description:
            "Biscuits à base de maïs, sans gluten et sans lactose, en forme des personnages préférés des enfants : Hello Kitty et Doraemon."
        },
        tradicionales: {
          familia: "galletas",
          title:
            "Virginias traditionnels : le petit déjeuner idéal pour toute la famille",
          description:
            "Biscuits à haute teneur en céréales et en fibres, idéaux pour le petit-déjeuner en famille. Choisissez entre Super Maria 0% et Digestiva Chocolat."
        },
        plus: {
          familia: "galletas",
          title: "Virginias Infantiles : les meilleurs biscuits pour enfants",
          description:
            "Biscuits à base de maïs, sans gluten et sans lactose, en forme des personnages préférés des enfants : Hello Kitty et Doraemon."
        },
        fabs: {
          familia: "galletas",
          title: "RISI | FABS Biscuits",
          description:
            "Les premiers biscuits au goût authentique et exclusif des meilleurs chocolats du monde provenant de Tanzanie, du Vietnam et du Mexique."
        },
        caramelos: {
          title: "Risi : 0 % de sucres ou de Sucreries",
          description:
            "Chez RISI, nous disposons d'une grande variété de bonbons sans gluten. Des bonbons à 0 % de sucre et des bonbons au sucre, aux fruits, aux agrumes et au menthol, délicieux !"
        },
        azucares0: {
          familia: "caramelos",
          title: "RISI : Sucreries Sans Sucre",
          description:
            "Les meilleurs bonbons avec 0% de sucres ajoutés et sans gluten. Découvrez nos bonbons au jus de fruits et notre menthol Glassmint."
        },
        caramelosTradicionales: {
          familia: "caramelos",
          title: "Risi | Sucreries",
          description:
            "Les bonbons traditionnels avec le meilleur goût des meilleurs fruits. Délicieux !"
        },
        borges: {
          title: "Risi | Borges Fruits secs",
          description:
            "Des classiques incontournables dans votre garde-manger du leader des fruits secs : Borges by RISI. Découvrez nos délicieuses variétés de noix : noix, pistaches, cacahuètes... et bien sûr nos irrésistibles graines, pour commencer et ne pas s'arrêter.",
          familia: "frutos-secos"
        },
        frutossecos: {
          familia: "frutos-secos",
          title: "Risi | Borges Fruits secs",
          description:
            "Dégustez les noix Borges avec Risi : noix, pistaches, cacahuètes, noisettes, amandes et nos délicieux cocktails assortis."
        },
        pipas: {
          familia: "frutos-secos",
          title: "Risi | Nuts Graines de Tournesol",
          description:
            "Qui peut résister à de délicieuses pipes ? Vous avez le choix entre les pipes salées et les pipes à l'aguasal."
        },
        promociones: {
          title: "Risi | Promotions",
          description:
            "Chez Risi, nous aimons récompenser votre fidélité avec différentes promotions afin que vous puissiez profiter des meilleurs prix et avantages."
        },
        basesLegalesPromocion: {
          title: "Promotions des produits Risi",
          description:
            "Chez Risi, nous aimons récompenser votre fidélité avec différentes promotions afin que vous puissiez profiter des meilleurs prix et avantages."
        },
        codigoconducta: {
          title: "Risi - Code de conduite",
          description:
            "Risi se conforme à vous et, grâce à vous, nous nous conformons à tout le monde. Découvrez les principes généraux de notre code de conduite, sur lesquels nous basons notre développement commercial."
        },
        cartapresidente: {
          incodigoconducta: true,
          title: "Lettre du Président",
          description: ""
        },
        risiempleados: {
          incodigoconducta: true,
          title: "Risi et ses employés",
          description: ""
        },
        risiproveedores: {
          incodigoconducta: true,
          title: "Risi et ses fournisseurs",
          description: ""
        },
        risisociedad: {
          incodigoconducta: true,
          title: "Risi et la société",
          description: ""
        },
        daganzo: {
          title: "Risi et la société - Daganzo",
          description: ""
        },
        loeches: {
          title: "Risi et la société - Loeches",
          description: ""
        },
        patatas: {
          title: "Risi | Chips RISI",
          description:
            "Chez Risi, nous fabriquons de bonnes frites depuis toujours, avec les meilleurs ingrédients et des saveurs authentiques. Découvrez nos pommes de terre Original, Wavy et Select !"
        },
        originales: {
          familia: "patatas",
          title: "Patatas Originales",
          description: ""
        },
        onduladas: {
          familia: "patatas",
          title: "Patatas onduladas",
          description: ""
        },
        selectas: {
          familia: "patatas",
          title: "Patatas selectas",
          description: ""
        },
        detodalavida: {
          familia: "patatas",
          title: "De toda la vida",
          description: ""
        },
        matarile: {
          title: "Risi et la société- Matarile",
          description: ""
        },
        cumplimientoetico: {
          incodigoconducta: true,
          title: "Chaîne de conformité et d'éthique",
          description: ""
        },
        risiconsumidores: {
          incodigoconducta: true,
          title: "Risi et ses consommateurs",
          description: ""
        },
        principiosgenerales: {
          incodigoconducta: true,
          title: "Principes généraux",
          description: ""
        },
        materialesprensa: {
          title: "Matériel de presse",
          description: ""
        },
        concursofulloftrickers: {
          title: "Full of Trikers",
          description: ""
        },
        basesconcursofulloftrickers: {
          title: "Full of Trikers",
          description: ""
        },
        politica_privacidad: {
          title: "Protection des données Risi",
          description:
            "Chez Risi, nous garantissons la confidentialité et la protection de vos données."
        },
        politica_cookies: {
          title: "Politique de Cookies de Risi",
          description:
            "Découvrez tous les détails dans les informations relatives à notre politique en matière de cookies."
        },
        aviso_legal: {
          title: "Avis juridique de Risi",
          description: ""
        },
        bases_legales_risi: {
          title: "Risi Base juridique",
          description: ""
        },
        regulatory_compliance: {
          title: "Conformité normative"
        },
        values: {
          title: "Valeurs"
        },
        "ethical-channel": {
          title: "Canal éthique"
        },
        sustainability: {
          title: "Engagements"
        }
      }
    },
    header: {
      patatas: "Chips",
      snack: "Snacks",
      galletas: "Biscuits",
      caramelos: "Bonbons",
      tradicionales: "Traditionnels",
      frutosSecos: "Fruits Secs",
      pipas: "Graines de Tournesol",
      atencionCliente: "Service client",
      cartapresidente: "Lettre du president",
      principiosgenerales: "Principes geenraux",
      risiempleados: "Risi et ses personnel",
      risiconsumidores: "Risi et ses consommateurs",
      risiproveedores: "Risi et ses </br>fournisseurs",
      risisociedad: "Risi et </br> societe",
      risicumplimiento: "Conformite et canal de communication",
      inicio: "Accueil",
      sobre_risi: "Àpropos de Risi",
      historia: "Histoire",
      quienessomos: "Qui sommes-nous ?​",
      codigoconducta: "Code de conduite",
      conoceNuestraHistoria: "Découvrez notre histoire",
      hoyYSiempreContigo: "Aujoud`hui et tou jour savec vous",
      blogPlacerosofia: "BlogPlacerosofía",
      noticias: "Actualites",
      nutririsi: "NutriRisi",
      distribuidores: "Distributeurs",
      contacto: "Contact",
      siguenos: "Suivez nous",
      faqs: "Faqs"
    },
    vistas: {
      productos: "produits",
      snacks: "snacks",
      galletas: "biscuits",
      caramelos: "bonbons",
      promociones: "promotions",
      sobre_risi: "a propos de Risi",
      historia: "histoire",
      quienessomos: "Qui sommes-nous ?​",
      nutririsi: "nutririsi",
      noticias_risi: "nouvelles risi",
      faqs: "faqs",
      contacto: "contact",
      profesionales: "professionnels",
      distribuidores: "Distributeurs",
      press_room: "salle de presse ",
      legal: "juridique",
      politica_cookies: "politique de cookies",
      aviso_legal: "mentions légales",
      proteccion_datos: "Protection des donnees",
      bases_legales_risi: "base juridique risi",
      materialesprensa: "documents de presse",
      regulatory_compliance: "Conformité réglementaire",
      codigoconducta: "Code de conduite",
      values: "valeurs",
      ethical_channel: "Canal éthique",
      sustainability: "Engagements"
    },
    infoFooter: "©Risi 2024. Tous droits reserves",
    descubrir: "decouvrir",
    todosNuestrosSnacks: "Tous<span>nos snacks</span>",
    sinGluten: "Sans Gluten",
    sinFrutosCascara: "Sans fruits a coque",
    valorNutricional: "Valeur nutritionnelle",
    valorEnergetico: "Valeur energétique",
    hidratosCarbono: "Glucides",
    delosCualesAzucares: "Dont sucres",
    delosCualesPolialcoholes: "Dont polyols",
    grasas: "Graisses",
    saturadas: "Dont saturees",
    sal: "Sel",
    proteinas: "Proteines",
    fibraAlimentaria: "Fibre alimentaire",
    verIngredientes: "Voir les ingrédients",
    origen: "Origine",
    maridaje: "Jumelage",
    notasCata: "Notes de degustation",
    verAlegenos: "Voir allergenes",
    verCata: "Voir degustation <strong>par David Pallas</strong>",
    koala: "Koala",
    galletasCon: "Biscuits avec ",
    todosNuestrasGalletas: "tous<span>nos biscuits",
    sweetlover: "Amants de la douceur",
    todosNuestrosCaramelos: "Tous<span>nos bonbons</span>",
    saludablesDeliciosos: "Sain et delicieux",
    todosNuestrosFrutos: "Tous<span>nos fruits secs</span>",
    todosNuestrasPatatas: "Toutes<span>nos chips",
    conoce: "Decouvrez",
    nuestra: "notre",
    historiaText: "l`histoire",
    irAHistoria: "Consultez l`histoire ",
    vermas: "En savoir plus",
    descargar: "Telechargez",
    volver: "Retour",
    recetas: "Recettes",
    alaSarten: "a la poele",
    masCrujientes: "Maintenant plus croustillantes",
    masSabor: "Plus de saveur",
    sigueA: "Suivez",
    acercate: "",
    vernuestras: "Venez découvrir nos",
    promociones: "Promottions",
    todas: "Toutes",
    lasPromos: "Les promottions",
    regulatory_compliance: {
      modules: [
        {
          path: "enlaces.codigoconducta",
          title: "CODE DE CONDUITE",
          icon: "code-conduct.svg"
        },
        {
          path: "enlaces.values",
          title: "VALEURS",
          icon: "values.svg"
        },
        {
          action: true,
          title: "CANAL ÉTHIQUE",
          icon: "ethical.svg"
        },
        {
          path: "enlaces.sustainability",
          title: "Engagements",
          icon: "sustainability.svg"
        }
      ],
      ethical: {
        label: "CANAL ÉTICO",
        title: "POLÍTICA GENERAL DEL SISTEMA INTERNO DE INFORMACIÓN",
        objetive: "Objetivo:",
        descrip1:
          "Establecer el procedimiento a seguir en caso de detectar cualquier incidencia o comportamiento contrario a los valores de la compañía, a su código de conducta, infracción normativa o susceptible de generar responsabilidad penal.",
        introduction: "1. Introducción",
        descrip2:
          "La Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción (en adelante, Ley 2/2023) establece los elementos que integran el Sistema Interno de Información, entre ellos, el Procedimiento de Gestión de Informaciones, la Política del Sistema Interno de Información (la cual incorpora las garantías de protección a los informantes), y el Canal Ético de Información de RISI.",
        descrip3:
          "El Consejo de Administración de RISI, S.A. (en adelante, “RISI”), en su voluntad de cumplir con la legislación vigente en cada momento, aprueba y suscribe la presente Política (en adelante, la “Política”) como parte del Sistema Interno de Información implantado para todas las sociedades que forman parte de RISI.",
        descrip4:
          "De igual forma, se procede al nombramiento de un Responsable del Sistema Interno de Información.",
        subjective: "2. Ámbito subjetivo",
        descrip5:
          "Esta Política se aprueba con el fin de establecer los principios básicos del Sistema Interno de Información de RISI y, en concreto del Canal Ético, que está disponible para los siguientes informantes:",
        descrip6:
          "Miembros de los órganos de administración, directivos y empleados de las empresas que forman parte de RISI (incluyendo exempleados, trabajadores autónomos, en prácticas, en proceso de selección).",
        descrip7:
          "Empleados de proveedores, contratistas, subcontratistas o socios de negocio.",
        descrip8:
          "Todos aquellos terceros con los que RISI mantenga una relación profesional directa o indirecta.",
        descrip9:
          "Todos los sujetos incluidos están referidos a cualquiera de las filiales sobre las que, de forma directa o indirecta, RISI ejerza el control efectivo.",
        descrip10:
          "Las sociedades sobre las que RISI tenga control, en los términos del artículo 42.1 del Código de Comercio, (las “Entidades de RISI”), también se verán vinculadas por los principios éticos y normas establecidos en la presente Política. A RISI y las Entidades de RISI se les denominará, en lo sucesivo, “RISI” o la “Compañía”.",
        communication: "3. Definición de comunicación",
        descrip11:
          "La consulta se define como la solicitud de información para conocer la interpretación de los principios y directrices contenidos en el Código de Conducta y la normativa interna que nos es de aplicación.",
        descrip12:
          "La información o denuncia se define como una inquietud sobre un posible incumplimiento o comportamiento contrario a los valores y procedimientos de RISI comunicada de buena fe y conscientemente por un empleado o tercera parte a través del Canal Ético de RISI.",
        descrip13:
          "La Política pretende regular la forma en que se gestionan las informaciones recibidas sobre conductas que afecten a los profesionales o cualquier sociedad perteneciente a RISI y puedan suponer la comisión de un delito o infracción de la normativa de aplicación.",
        scopeMaterial:
          "4. Ámbito material del Sistema Interno de Información de RISI",
        descrip14:
          "A través del Canal Ético de RISI se podrán presentar consultas o denuncias referentes a la normativa de aplicación a la actividad de RISI.",
        descrip15: "En concreto, se podrán comunicar:",
        descrip16:
          "Consultas: se referirá al alcance y la aplicabilidad del Código Ético o de algún elemento del Sistema de Compliance en su conjunto.",
        descrip17:
          "Para realizar cualquier consulta en este sentido, RISI tiene habilitado el siguiente canal: <a href='mailto:consultacodigo@risi.es'>consultacodigo@risi.es</a>",
        descrip18:
          "Denuncias sobre posibles incumplimientos del Sistema: se referirá a cualquier incumplimiento de los elementos del Sistema de Compliance que comprende en este concepto todas las infracciones del Código Ético, de cualquier otro elemento del Sistema o de cualquier otra normativa interna, así como las infracciones de cualquier normativa externa, legislación o regulación integrante del ordenamiento jurídico que resulte de aplicación, incluyendo especialmente (pero no exclusivamente) las infracciones graves o muy graves de naturaleza administrativa o penal (con especial atención a las conductas corruptas) y de la normativa de defensa  de la competencia, por su especial gravedad y por el compromiso específico que RISI asume respecto a su cumplimiento.",
        descrip19:
          "En especial, se incluyen las materias referidas en la Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informan de infracciones normativas y de lucha contra la corrupción para cuyos casos se asegurará la aplicación de los principios y prescripciones en ella establecidos.",
        descrip20:
          "RISI ha habilitado el siguiente canal: <a href='mailto:canaletico@risi.es'>canaletico@risi.es</a> para presentar las comunicaciones sobre infracciones previstas en la presente Política.",
        descrip21:
          "Quedan excluidas del alcance del presente procedimiento las informaciones vinculadas a reclamaciones sobre conflictos interpersonales o que afecten únicamente al informante y a las personas a las que se refiera la comunicación.",
        descrip22:
          "El Órgano de Gobierno de RISI ha designado a la Responsable de Cumplimiento como Responsable del Sistema Interno de Información y, por tanto, para la gestión de las informaciones o denuncias a través del Canal Ético.",
        informant: "5. Derechos y Deberes del informante",
        descrip23:
          "El Órgano de Gobierno de RISI establece que el Canal Ético de RISI se rige de conformidad a los siguientes principios:",
        descrip24:
          "<strong>Principio de buena fe</strong>. Todos los integrantes de RISI y todas las terceras partes de conformidad con lo previsto en el ámbito subjetivo del Sistema Interno de Información, deben actuar de buena fe y no hacer acusaciones falsas al manifestar sus inquietudes. La buena fe consiste en dar información sin malicia, sin considerar el beneficio personal y considerando la información veraz de forma razonable y con los medios de que dispone. El denunciante que deliberadamente haga declaraciones falsas o engañosas o de mala fe, podrá ser objeto de acciones disciplinarias de conformidad con la legislación vigente.",
        descrip25:
          "<strong>Compromiso de no represalia</strong>. RISI establece formalmente que no tolerará represalias de ningún tipo cometidas sobre aquellas personas que hagan uso de los procedimientos establecidos para la comunicación de conductas irregulares.",
        descrip26:
          "<strong>Derecho a ser informado</strong>. El denunciante o informante tiene derecho de ser informado desde la presentación de la consulta o denuncia. A estos efectos recibirá acuse de recibo de la recepción de su denuncia en el plazo de siete (7) días naturales. Asimismo, pondrá en su conocimiento, la admisión o no de la misma, o, en su caso, la existencia de una investigación interna y de su resolución en el plazo de tres (3) meses desde la recepción de la comunicación, salvo casos de especial complejidad en que este plazo podrá ser ampliado otros tres meses.",
        descrip27:
          "<strong>Derecho a la protección de los datos personales</strong>. Según la normativa vigente los Datos Personales deberán ser protegidos y tratados conforme a la Ley 2/2023, de 20 de febrero reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y la normativa de protección de datos vigente. El denunciante tiene derecho a conservar el anonimato cuando presente una comunicación o denuncia debiendo ser protegido en dicho derecho.",
        descrip28:
          "<strong>Confidencialidad</strong>. Se adoptarán las medidas necesarias para preservar la identidad y garantizar la confidencialidad de los datos correspondientes a todas las personas afectadas por la información suministrada en las denuncias. En especial, en el caso de denuncias no anónimas, la identidad del denunciante deberá mantenerse confidencial en todas las etapas del proceso de investigación y resolución de la denuncia, por lo que no se divulgará a terceros ni, por tanto, a la persona denunciada, ni tampoco a los mandos directivos del denunciante. Sin perjuicio de lo anterior, los datos del denunciante y del resto de intervinientes podrán ser objeto de comunicación a terceros para la adecuada gestión de la investigación y a los Juzgados o Tribunales, Ministerio Fiscal, Fuerzas y Cuerpos de Seguridad del Estado y demás autoridades competentes cuando resulte necesario para la tramitación de los procedimientos judiciales que, en su caso, procedan como consecuencia de las investigaciones llevadas a cabo con motivo de las denuncias formuladas.",
        accused: "6. Derechos y deberes del denunciado",
        descrip29:
          "<strong>Derecho al honor, a la presunción de inocencia y de defensa</strong>. El derecho al honor de las personas es una de las máximas de actuación de RISI. En ese sentido, pondremos la mayor atención en velar por tales derechos, garantizando los derechos de las personas denunciadas a defenderse de cualesquiera acusaciones que se dirigieran contra ellas con las máximas garantías legales. La persona afectada podrá hacer uso de sus derechos de defensa y ser asistida por la representación legal que estime oportuna.",
        descrip30:
          "<strong>Derecho a ser informado</strong>. La persona denunciada será informada de la instrucción de un procedimiento de investigación por hechos ilícitos o ilegales que pudieran serle atribuidos. En el plazo más breve posible, se le comunicará los hechos objeto de investigación y se velará por el legítimo respeto a sus derechos de defensa y presunción de inocencia.",
        descrip31:
          "<strong>Derecho a la protección de los datos personales</strong>. Según la normativa vigente los Datos Personales deberán ser protegidos y tratados conforme a la Ley 2/2023, de 20 de febrero reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y normativa de protección de datos de aplicación. Se le informará de que sus datos han sido obtenidos a través del Canal Ético cuya finalidad consiste en investigar, tramitar y resolver las comunicaciones recibidas. Solo en caso de ser necesario, al objeto de la investigación, tramitación y/o resolución, la información podrá ser cedida a terceros en cumplimiento de las obligaciones legales oportunas.",
        descrip32:
          "<strong>Deber de confidencialidad y colaboración:</strong> Tiene obligación expresa de mantener la debida confidencialidad, a salvo de su derecho de defensa. La violación por el empleado de las prevenciones advertidas dará lugar, en su caso, a las correspondientes medidas disciplinarias, sin perjuicio de la presentación de la oportuna denuncia ante las Fuerzas y Cuerpos de Seguridad, Fiscalía o el juzgado de instrucción correspondiente.",
        channel: "Canal Ético de RISI",
        descrip33:
          "El Canal Ético de RISI es un medio seguro y confidencial que permite a los empleados y otras partes interesadas (con el alcance señalado en el apartado 2 de la presente Política) informar de conductas inapropiadas, irregularidades o cualquier otra situación que pueda suponer una infracción normativa de conformidad con lo previsto en la Ley 2/2023 y afectar negativamente la reputación de RISI.",
        descrip34:
          "El Canal Ético de Información de RISI permite la presentación de:",
        descrip35:
          "<strong>Comunicación escrita:</strong> a través de dirección de correo electrónico. ",
        descrip36:
          "<strong>Comunicación presencial:</strong> previa solicitud del informante que será atendida en el plazo de siete (7) días naturales. ",
        descrip37:
          "Las comunicaciones o informaciones de acuerdo con el ámbito de aplicación de esta Política también se podrán remitir a la Autoridad Independiente de Protección del Informante y a las autoridades u órganos autonómicos correspondientes, a través de sus respectivos canales habilitados para estos efectos. De igual forma, se podrán comunicar dichos hechos a las autoridades creadas al efecto por los organismos y autoridades de cualquier otro país de la Unión Europea.",
        protection: "Protección de datos de carácter personal",
        descrip38:
          "Los datos suministrados a través del Canal Ético de Información de RISI se utilizarán con el fin de gestionar las comunicaciones relacionadas con dicho canal, así como para realizar las investigaciones necesarias, impulsar la gestión y determinar si se ha producido alguna infracción o delito.",
        descrip39:
          "El acceso al Canal Ético de Información de RISI y a los datos en él contenidos está limitado exclusivamente al Responsable del Sistema Interno de Información de RISI, el equipo gestor asignado al mismo, al responsable de RRHH u órgano designado para la imposición de medidas disciplinarias, Responsable Legal, los encargados de tratamiento que eventualmente se designen y el DPO de la entidad. No obstante, el Responsable del Sistema Interno de Información podrá comunicar los datos a terceros, cuando resulte necesario para la tramitación de los procedimientos administrativos o judiciales que, en su caso, procedan.",
        descrip40:
          "Todo ello de conformidad con lo previsto en la Política de Privacidad del Canal Ético de RISI.",
        "btn-accept": "ACCEPTER ET CONTINUER",
        descrip41:
          "Le Canal Éthique est le canal de communication que RISI met à disposition pour:",
        queries: "<strong>Des doutes ou des questions</strong>",
        descrip42:
          "Soulever des doutes ou poser des questions concernant l'application du Code de Conduite et des autres règles de conduite internes de RISI. Vous pouvez également contacter directement votre manager régional ou le responsable de la conformité en envoyant vos questions via l'adresse e-mail suivante: <a href='mailto:consultacodigo@risi.es'>consultacodigo@risi.es</a>",
        violations: "<strong>Violations ou non-conformités</strong>",
        descrip43:
          "Signaler toute infraction ou non-respect du code de conduite et des autres règles de conduite internes à RISI. Pour envoyer votre demande, veuillez contacter directement votre manager régional de secteur ou le responsable de la conformité en envoyant vos questions à l'adresse e-mail suivante: <a href='mailto:canaletico@risi.es'>canaletico@risi.es</a>, ou en remplissant le formulaire ci-dessous:"
      }
    },
    contacto: {
      titulo: "Contact",
      subtitulo: "Ce sont nos coordonnées.",
      gracias: "Merci de votre participation <br>et bonne chance !",
      enviado: "Envoyé !<br>Nous vous contacterons dans les plus brefs délais",
      enviando: "Un instant !<br>Nous l'envoyons",
      revisa: "S'il vous plaît,<br> vérifier tous les champs",
      puedesEnviar: "Parfait !<br>Vous pouvez l'envoyer maintenant :)",
      options: [
        {
          title: "Je suis intéressé à vendre des produits Risi.",
          link: "distribuidores"
        },
        {
          title: "J'ai une question ou une plainte concernant vos produits.",
          link: "contacto",
          param: "consultaComentario"
        },
        {
          title: "Travaille avec nous.",
          link: "contacto",
          param: "trabaja_con_nosotros"
        },
        {
          title: "Autres questions, commentaires ou suggestions.",
          link: "contacto",
          param: "otro"
        }
      ],
      "question-ou-commentaire": {
        title: "ENVOYEZ-NOUS VOTRE DEMANDE SUR NOS PRODUITS.",
        type: "4",
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Attention au client:</p><p><a href='tel:900831000'>900 83 10 00</a></p>"
          },
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p>"
          }
        ]
      },
      "travaille-avec-nous": {
        megaTitle: "Travaille avec nous",
        title: "ENVOYEZ-NOUS VOS DONNÉES ET INFORMATIONS.",
        type: "5",
        contacts: [
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:empleo@risi.es'>empleo@risi.es</a></p>"
          }
        ]
      },
      autre: {
        title: "Envoyez-nous VOS QUESTIONS, COMMENTAIRES OU SUGGESTIONS",
        type: "0",
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Autres requêtes:</p><p><a href='tel:900831000'>900 83 10 00</a></p>"
          },
          {
            img: "/static/img/mail.svg",
            alt: "Icon-mail",
            text:
              "<p>Email:</p><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p>"
          }
        ]
      },
      hoja: [
        {
          content:
            "<img class='icon' src='/static/img/location.svg' alt='Icon-location'><p><strong>Polígono industrial Gitesa</strong></p><p>c/ Severo Ochoa, 2 Daganzo de Arriba 28814 - Madrid</p>"
        },
        {
          title: "Clients et distributeurs:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:900909013'>900 909 013</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:pedidos@risi.es'>pedidos@risi.es</a></p></div>"
        },
        {
          title: "Consommateur:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:900831000'>900 831 000</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:atencionalconsumidor@risi.es'>atencionalconsumidor@risi.es</a></p></div>"
        },
        {
          title: "Emploi:",
          content:
            "<div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:empleo@risi.es'>empleo@risi.es</a></p></div>"
        },
        {
          title: "Autres requêtes:",
          content:
            "<div><img class='icon' src='/static/img/tlf.svg' alt='Icon-location'><p><a href='tel:918782110'>918 782 110</a></p></div><div><img class='icon' src='/static/img/mail.svg' alt='Icon-location'><p><a href='mailto:risi@risi.es'>risi@risi.es</a></p></div>"
        }
      ]
    },
    patatas: {
      ySiNosVamos: "et si on",
      fuera: "sortait",
      detodalavida: {
        titulo: "Depuis toujours",
        enrisillevamos: "Chez Risi",
        haciendoPat: "nous élaborons de délicieuses chips ",
        en1970: "Nous avons ouvert notre",
        dePatatas: "de chips à Madrid",
        nuestrasRecetas: "Nos recettes sont",
        deSiempre: "toujours les mêmes, élaborées",
        yahoraMejores: "et maintenant encore meilleures avec \r\n",
        rompemosReglas:
          "<strong>Nous savons que cela vous agace de constater que les sacs de chips contiennent de l'air, mais il est important de savoir que l'air contenu dans les sacs est indispensable pour maintenir la fraîcheur et la qualité des pommes de terre et éviter qu'elles ne se retrouvent en miettes, car il s'agit d'un produit fragile.</strong>",
        disfrutarBolsa: "afin que vous puissiez apprécier",
        bolsaLlena:
          "70 % de notre sac est rempli de chips. Vous n'y croyez pas ? Nous vous le garantissons ! C'est l'une des principales priorités et mesures de qualité de notre usine.",
        reducirPlasti: "Réduire l'utilisation de plastique",
        consiguiendImpacto:
          "Nous avons un impact positif sur l'environnement en n'utilisant que le strict nécessaire à la dégustation des meilleures chips.\n."
      },
      originales: {
        titulo: "Las Originales"
      },
      onduladas: {
        titulo: "Las onduladas"
      },
      selectas: {
        titulo: "Selectas"
      },
      exportacion: {
        titulo: "Exportación",
        subtitulo:
          "Nos recettes à la poêle. <br> Maintenant plus croustillantes et délicieuses!"
      }
    },
    snacks: {
      gusanitos: {
        titulo: "Gusanitos",
        subtitulo:
          "Les authentiques Gusanitos!<br>Le plus délicieux des en-cas cuits au four, encore meilleur lorsqu'il est partagé.",
        yummy1: "Maïs 🌽, huile de tournesol 🌻, sel et beaucoup d' 💚",
        yummy2: "Donnez-lui un bain de sauce!"
      },
      palomitas: {
        titulo: "Palomitas",
        subtitulo:
          "Le popcorn authentique!<br>Classiques, sucrés ou au caramel, il y en a pour tous les goûts...<br>Lequel préférez- vous?",
        yummy1: "Les plus classiques",
        yummy2: "Deux saveurs  ",
        yummy3: "qui se marient",
        yummy4: "à",
        yummy5: "merveille",
        yummy6: "mmmm...",
        yummy7: "Choco...",
        yummy8: "À s'en lécher<br>les babines !",
        newflavor: "Nouvelle Saveur"
      },
      risketos: {
        titulo: "Risketos",
        subtitulo:
          "Délicieux apéritifs très, très, très croustillants! C'est la bataille Risketera choisissez les vôtres !",
        yummy1: "Succès garanti!",
        yummy2: "Découvrez<br>notre<br> nouveau goût!"
      },
      mios: {
        titulo: "Mios",
        subtitulo:
          "Un snack adulte et sophistiqué pour un apéritif plein de saveur.",
        yummy1: "Nouveaux!",
        yummy2: "Avec une touche unique",
        yummy3: "Laissez-vous emporter par les nouvelles saveurs",
        yummy4: "Délicieux hexagones de maïs",
        yummy5: "Ingrédients naturels!"
      },
      triskys: {
        titulo: "Triskys",
        subtitulo:
          "De délicieux petits anneaux de <br>maïs, très, très croustillants !",
        yummy1: "Avec le goût de toujours",
        yummy2: "Une touche unique",
        yummy3: "Avec la saveur de toujours",
        yummy4: "Avez-vous essayé la saveur JAMBON?"
      },
      matchBall: {
        titulo: "MatchBall ",
        subtitulo:
          "Les boulettes les plus savoureuses ! Goût de fromage, ketchup ou barbecue, à vous de choisir!",
        yummy1: "De véritables boulettes de fromage",
        yummy2: "Nouveau format de l'emballage á votre<br>bouche"
      },
      jummy: {
        titulo: "Jummy ",
        subtitulo:
          "Amusant et audacieux, c'est ça Jummy.<br> La star qui est née pour rester et avec laquelle nous promettons de ne pas laisser indifférents les amateurs de ce qui est authentique et innovant.<br> Est-ce que tu vas le manquer?"
      },
      otrosProductos: {
        titulo: "D'autres produits",
        yummy1: "Fajitas<br>de maïs<br>à saveur <br>de BBQ",
        yummy2: "Toute la saveur <br>du fromage qui <br>fond en bouche.",
        yummy3: "Nos<br>meilleurs produits<br>dans un seul sachet",
        yummy4: "Le Snack<br>de pommes de terre"
      }
    },
    galletas: {
      bsan0: {
        titulo: "B-SAN 0% SUCRES",
        subtitulo:
          "Délicieux biscuits de blé à l'avoine et à l'orge, entièrement recouverts de chocolat et sans sucres ajoutés<br>Vers une vie plus saine!",
        subtituloMaria:
          "Biscuits pour le petit déjeuner délicieux et sains, sans sucres ajoutés.    \n<br>Pour une vie plus saine!",
        banadas: "RECOUVERTS",
        maria: "MARÍA",
        yummy1: "0% sucres ajoutés",
        yummy2: "Avec sésame!",
        yummy3: "Source de fibres"
      },
      bsan0SinGluten: {
        titulo: "B-SAN sans gluten",
        subtitulo: "Un délicieux biscuit sans gluten recouvert de chocolat noir"
      },
      bsanPlus: {
        titulo: "B-SAN PLUS",
        subtitulo:
          "Des biscuits délicieux et amusants pour les enfants.<br>Avec des céréales et des vitamines.",
        yummy1: "AVEC GLUTEN",
        yummy2: "SANS GLUTEN",
        yummy3: "Sans lactose!"
      },
      bsanDesayuno: {
        titulo: "B-SAN PLUS",
        subtitulo:
          "Des biscuits délicieux et amusants pour les enfants.<br>Sans gluten, elaborés avec du maïs et riche en vitamines.",
        yummy1: "Faible teneur en sel!"
      },
      fabs: {
        subtitulo:
          "Sentez la paix de la nature où <strong>notre cacao de Tanzanie, du Vietnam et du Mexique</strong> a été cultivé tout en savourant le goût des meilleurs chocolats du monde avec FABS ORIGIN.",
        yummy1: "Chocolat intense !",
        yummy2: "CONNAÎTRE A",
        yummy3: "VOYAGE AUX ORIGINES DU CHOCOLAT AVEC DAVID PALLÀS"
      }
    },
    caramelos: {
      azucares0: {
        titulo: "0% sucres ajoutés",
        subtitulo: "De délicieux bonbons sans sucres ajoutés et sans gluten !",
        yummy1: "Avec du jus de fruits",
        yummy2: "Un doux moment",
        yummy3: "Rafraichissants!"
      },
      tradicionales: {
        titulo: "Tradicionales",
        subtitulo:
          "Les bonbons traditionnels agrémentés du goût des meilleurs fruits.",
        yummy1: "Tout simplement délicieux!",
        yummy2: "Bonbons aux fruits",
        yummy3: "Goût<br>intense"
      }
    },
    frutosSecos: {
      frutosSecos: {
        subtitulo:
          "Pour profiter de l'instant présent...¡avec élégance!<br>Les meilleurs ingrédients pour un en-cas sain et délicieux.",
        yummy1: "Un classique qui ne manque jamais!",
        yummy2: "Comme c'est croustillant!",
        yummy3: "Toute énergie!",
        yummy4: "A déguster en salade!",
        yummy5: "Croustillant, croustillant!",
        yummy6: "Soigneusement sélectionnés pour vous!"
      },
      pipas: {
        subtitulo: "Qui peut résister à de délicieuses graines de tournesol?",
        yummy1: "Vous ne pourrez plus vous arrêter",
        yummy2: "Délicieuses et savoureuses"
      }
    },
    formulario: {
      nombre: "Prénom",
      apellidos: "Nom",
      email: "E-mail",
      mensaje: "Message",
      asunto: "Sujet",
      medioComunicacion: "Moyen de communication",
      he_leido: "J'ai lu et accepté ",
      y_acepto: "la politique de confidentialité",
      enviar: "Envoyer",
      enviado: "Envoyé",
      telefono: "Téléphone",
      provincia: "Province",
      localidad: "Localité",
      calle: "Adresse postale (Rue, numéro et ville)",
      cp: "Code postal",
      cv: "Joindre un CV",
      fecha_nacimiento: "Date de naissance",
      documentation: "Joindre des documents",
      publicidad:
        "J'accepte l'envoi de communications commerciales sur les produits et services du groupe Risi ainsi que le traitement automatisé pour pouvoir optimiser et personnaliser lesdites offres."
    },
    meses: [
      "Janvier ",
      "Février ",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août ",
      "Septembre ",
      "Octobre ",
      "Novembre ",
      "Décembre "
    ],
    productos: {
      "gusanitos-tradicionales": {
        family: "gusanitos",
        type: "left",
        titulo: "Gusanitos Originales",
        packs: "18g, 35g, 85g, 105g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "<strong>Les authentiques Gusanitos!</strong> Les traditionnels, qui plaisent tant aux enfants qu'aux adultes. ",
        introDos:
          "En-cas cuit au four sans colorants ni conservateurs.<br>Qui peut dire non à un paquet de Gusanitos?",
        introMovil:
          "<strong>Les authentiques Gusanitos!</strong> Les traditionnels, qui plaisent tant aux enfants qu'aux adultes. ",
        ingredientes:
          "Semoule de maïs, huile de tournesol (17,4 %), sel et arôme naturel. <u>Peut contenir des protéines de lait.</u>. Peut contenir de la <u>moutarde</u>",
        cantidadValor: "100g",
        hashtag: "#GusanitoOriginal",
        energia: "1.965kJ, 467kcal",
        hidratos: "71,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "17,4 g",
        saturadas: "2,2 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,6 g",
        mostrarSinLactosa: "1"
      },
      "gusanitos-ketchup": {
        family: "gusanitos",
        type: "left",
        titulo: "Gusanitos Kétchup",
        cantidadValor: "100g",
        hashtag: "#GusanitosKétchup",
        intro:
          "Une <strong>délicieuse saveur de ketchup</strong> envahit nos mythiques Gusanitos, vous allez adorer. ",
        introDos: "Sans conservateurs et sans colorants artificiels.",
        introMovil:
          "Une <strong>délicieuse saveur de ketchup</strong> envahit nos mythiques Gusanitos, vous allez adorer.",
        ingredientes:
          "Semoule de maïs, huile de tournesol (18,4 %), arôme de ketchup [sucre, extrait de levure, fructose, tomate, oignon et ail en poudre, arôme, acidifiant (acide citrique et malique), paprika et colorant (extrait de paprika)], et sel. <u>Peut contenir des protéines de lait.</u>. Peut contenir de la <u>moutarde</u>",
        packs: "35g, 85g, 105g",
        energia: "2.065kJ, 492kcal",
        hidratos: "67,7 g",
        azucares: "5,4 g",
        grasas: "22 g",
        polialcoholes: "",
        saturadas: "2,8 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "5,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "palomitas-original": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Original",
        cantidadValor: "100g",
        hashtag: "#PalomitasOriginal",
        intro:
          "Le goût <strong>original tels qu'on l'a toujours connu</strong>, notre saveur la plus classique. Impossible de résister au goût du beurre !",
        introDos: "",
        introMovil:
          "Le goût <strong>original tels qu'on l'a toujours connu</strong>, notre saveur la plus classique. Impossible de résister au goût du beurre !",
        ingredientes:
          "Semoule de maïs, huile de tournesol (18,6 %), arôme de <u>beurre</u> [substances aromatiques, <u>lactose</u>, dextrose, sucre, <u>lactosérum</u>, maltodextrine, amidon modifié et exhausteur de goût (E-621)] et sel. Peut contenir de la <u>moutarde</u>. ",
        packs: "35g, 90g, 105g",
        energia: "1.990kJ, 474kcal",
        hidratos: "71 g",
        azucares: "1,5 g",
        grasas: "18,6 g",
        saturadas: "2,4 g",
        fibra: "",
        polialcoholes: "",
        sal: "1,8 g",
        proteinas: "5,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "palomitas-ketchup-mostaza": {
        family: "palomitas",
        type: "right",
        titulo: "Palomitas Kétchup & Mostaza",
        cantidadValor: "100g",
        hashtag: "#PalomitasKétchup&Mostaza",
        intro:
          "Le mélange, ça vous tente? <strong>Le popcorn le plus apprécie de tous.</strong>. ",
        introDos: " <br>Avec deux saveurs qui se marient à merveille.",
        introMovil:
          "Le mélange, ça vous tente? <strong>Le popcorn le plus populaire.</strong>.",
        ingredientes:
          "Semoule de maïs, huile de tournesol (17,1 %), arôme de ketchup-<u>moutarde</u> [substances aromatiques (contient de la <u>moutarde</u>), sucre, sel, maltodextrine, extrait de levure, fructose, tomate, oignon et ail en poudre, acidifiant (acide citrique et malique), exhausteur de goût (E-621), dextrose, colorants (extrait de paprika et curcumine) et miel]. Peut contenir des <u>protéines de lait</u>. ",
        packs: "35g, 90g, 105g",
        energia: "1.977kJ, 470kcal",
        hidratos: "73 g",
        azucares: "2,9 g ",
        grasas: "17,1 g",
        polialcoholes: "",
        saturadas: "2,1 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "6,1 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "palomitas-pizza": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Pizza",
        cantidadValor: "100g",
        hashtag: "#PalomitasPizza",
        intro:
          "Si vous êtes un fan de pizzas et que vous êtes aussi un fan du pop-corn classique, <br> c'est le snack qu'il vous faut! ",
        introDos: "Le pop-corn <strong>au goût d'Italie.</strong>",
        introMovil:
          "Si vous êtes un fan de pizzas et que vous êtes aussi un fan du pop-corn classique, <br> c'est le snack qu'il vous faut! ",
        ingredientes:
          "Semoule de maïs, huile de tournesol (22,7 %), arôme de pizza [arôme (contient du <u>lait</u>), maltodextrine, sucre, exhausteurs de goût (E-621 et E-635), colorant (extrait de paprika) et acidulant (acide citrique et malique)] et sel. Peut contenir de la <u>moutarde</u>. ",
        packs: "35g, 90g",
        energia: "1.882kJ, 450kcal",
        hidratos: "55,5 g",
        azucares: "4,4 g",
        polialcoholes: "",
        grasas: "22,7 g",
        saturadas: "2,7 g",
        fibra: "",
        sal: "1,8 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "palomitas-chocolate-blanco": {
        family: "palomitas",
        type: "right",
        titulo: "Palomitas Bombón Blanco",
        cantidadValor: "100g",
        hashtag: "#Palomitaschocoblanco",
        intro:
          "Pour ceux qui ne peuvent pas vivre sans chocolat... notre version de Popcorn recouverte",
        introDos:
          " de <strong>délicieux chocolat blanc.</strong><br>Une combinaison des plus spéciales!",
        introMovil:
          "Pour ceux qui ne peuvent pas vivre sans chocolat... notre version de Popcorn recouverte.",
        ingredientes:
          "Sucre, graisse de palmiste hydrogénée, semoule de maïs, <u>lactosérum</u> en poudre, <u>lait</u> écrémé en poudre, émulsifiant (lécithine de <u>soja</u>) et arômes (lait et\n  vanilline). Peut contenir des <u>fruits à coque (amande et noisette).</u> ",
        packs: "30g, 80g",
        energia: "2.365kJ, 567kcal",
        hidratos: "62,2 g",
        polialcoholes: "",
        azucares: "46,0 g",
        grasas: "33,8 g",
        saturadas: "31,0 g",
        fibra: "",
        sal: "0,3 g",
        proteinas: "2,4 g",
        hasFrutosSecos: "1"
      },
      "palomitas-caramelo": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Caramelo",
        cantidadValor: "100g",
        hashtag: "#PalomitasCaramelo",
        intro:
          "Parfait pour les plus gourmands! Notre édition de pop-corn la plus \n<strong>sucrée</strong>.",
        introDos: "Vous allez les adorer !",
        introMovil:
          "Parfait pour les plus gourmands! Notre édition de pop-corn la plus \n<strong>sucrée</strong>.",
        ingredientes:
          "Sucre, semoule de maïs, sirop de glucose, huile de tournesol (14,6 %), <u>beurre</u>, lécithine de tournesol, caramel et sel. Contient du <u>lait et des dérivés</u>. Peut contenir <u>des fruits à coque (amande et noisette) et du soja</u> ",
        packs: "30g, 80g",
        energia: "1.799kJ, 428kcal",
        hidratos: "70,7 g",
        polialcoholes: "",
        azucares: "47,6 g",
        grasas: "14,6 g",
        saturadas: "3,2 g",
        fibra: "",
        sal: "0,6 g",
        proteinas: "2,4 g",
        hasFrutosSecos: "1"
      },
      "palomitas-chocolate": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Choco",
        cantidadValor: "100g",
        hashtag: "#PalomitasChoco",
        intro:
          "Notre version sucrée recouverte d'un <strong>délicieux chocolat</strong>. ",
        introDos: "",
        introMovil:
          "Notre version sucrée recouverte d'un <strong>délicieux chocolat</strong>.",
        ingredientes:
          "Sucre, semoule de maïs, graisse de palme hydrogénée, cacao en poudre dégraissé, émulsifiant (lécithine de tournesol) et arôme (vanilline). Peut contenir du <u>lait, du soja et des fruits à coque (amande et noisette).</u>",
        packs: "30g, 80g, 100g",
        energia: "2.260kJ, 542kcal",
        hidratos: "56,6 g",
        polialcoholes: "",
        azucares: "41,4 g",
        grasas: "33,1 g",
        saturadas: "30,5 g",
        fibra: "",
        sal: "0,06 g",
        proteinas: "4,3 g",
        hasFrutosSecos: "1"
      },
      "palomitas-bacon-cheese": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Bacon & Cheese",
        cantidadValor: "100g",
        hashtag: "#PalomitasBacon&Cheese",
        intro: "Notre version saveur  <strong>bacon et fromage</strong>.",
        introDos: "",
        introMovil: "Notre version saveur  <strong>bacon et fromage</strong>.",
        ingredientes:
          "Semoule de maïs, huile de tournesol (24,8%), arôme de bacon y <u>fromage</u> [arôme, arôme de fumée, colorant (extrait de paprika et curcumine)]. Contient <u>des protéines de lait</u>. Peut contenir de la <u>moutarde</u>. ",
        packs: "30g, 90g",
        energia: "2.237kJ, 534kcal",
        hidratos: "72 g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "24,8 g",
        saturadas: "3 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "5,6 g",
        hasFrutosSecos: "0"
      },
      "mios-tomillo-limon": {
        family: "mios",
        type: "left",
        titulo: "Horneados con un toque de Tomillo&Limón",
        cantidadValor: "100g",
        hashtag: "#MiosTomilloyLimón",
        intro:
          "Ils contiennent des protéines provenant de pois chiches entiers, des vitamines et des minéraux provenant d' <strong>épinards</strong> et d' <strong>oignons</strong>, ainsi que le pouvoir antioxydant du citron.",
        introDos:
          "Végans, délicieux et parfaits pour grignoter entre les repas!",
        introMovil:
          "Végans, délicieux et parfaits pour grignoter entre les repas!",
        ingredientes:
          "Semoule de maïs, farine complète de lentille, farine de riz, huile de tournesol, farine complète de pois chiche (9 %), arôme (substances aromatiques, maltodextrine, sel, sucre, citron et thym en poudre), oignon (0,9 %) et épinards déshydratés (0,5 %). \nPeut contenir du <u>lait et des dérivés et de la moutarde</u>.",
        packs: "95g",
        energia: "2.014kJ, 481kcal",
        hidratos: "60,0 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "20,6 g",
        saturadas: "2,6 g",
        fibra: "5,5 g",
        sal: "0,87 g",
        proteinas: "11,1 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-sal-pimienta": {
        family: "mios",
        type: "left",
        titulo: "Horneados con un toque de Sal Ahumada & Pimienta",
        cantidadValor: "100g",
        hashtag: "#HorneadosSalyPimienta",
        intro:
          "Mios! Cuits au four avec une touche de sel fumé et de poivre noir,  contiennent les fibres des lentilles, l'énergie du riz et les  antioxydants du maïs. ",
        introDos:
          "Végans, délicieux et parfaits pour grignoter entre les repas!",
        introMovil: "Végans et délicieux!",
        ingredientes:
          "Semoule de maïs (49 %), farine complète de lentille (19 %), farine de riz (19 %), huile de tournesol, farine complète de pois chiches, arôme (substances aromatiques, maltodextrine, sucre et sel fumé), poivre et colorant (extrait de paprika). Peut contenir du <u>lait et des dérivés et de la moutarde</u>.",
        packs: "95g",
        energia: "2.006kJ, 478kcal",
        hidratos: "62,0 g",
        polialcoholes: "",
        azucares: "3 g",
        grasas: "19,5 g",
        saturadas: "2,5 g",
        fibra: "5,2 g",
        sal: "0,61 g",
        proteinas: "11,0 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-chia": {
        family: "mios",
        type: "left",
        titulo: "Chips de Maíz & Chía",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyChía",
        intro:
          "Apéritif de maïs frit avec l'un des super-aliments les plus appréciés, les <strong>graines de chía</strong> ",
        introDos:
          "et un soupçon de <strong>sel de mer.</strong><br>Avec des ingrédients naturels!",
        introMovil:
          "Apéritif de maïs frit avec l'un des super-aliments les plus appréciés, les <strong>semillas de chía</strong> ",
        ingredientes:
          "Maïs (70 %), huile de tournesol à haute teneur en huile (24 %), graines de chia (3%) et sel de mer.",
        packs: "40g, 150g",
        energia: "2.154kJ, 515kcal",
        hidratos: "64,4 g",
        polialcoholes: "",
        azucares: "1,3 g",
        grasas: "24 g",
        saturadas: "2,4 g",
        fibra: "6,0 g",
        sal: "0,9 g",
        proteinas: "7,4 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-espinacas": {
        family: "mios",
        type: "right",
        titulo: "Chips de Maíz & Espinacas",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyEspinacas",
        intro:
          "Envie de découvrir une saveur unique ? Délicieux apéritif au maïs frit.",
        introDos:
          "<strong>Avec des épinards et du poivre rose !</strong> Et avec des ingrédients naturels !",
        introMovil:
          "Envie de découvrir une saveur unique ? Délicieux apéritif au maïs frit <strong>aux épinards</strong>.",
        ingredientes:
          "Maïs (64 %), huile de tournesol à haute teneur en huile (25%), épinards séchés (2%) et arôme poivre [sel marin, poivre rose, noir et blanc moulu (0,4%), sucre et arôme].",
        packs: "150g",
        energia: "2.257kJ, 540kcal",
        hidratos: "61,1 g",
        azucares: "1,7 g",
        polialcoholes: "",
        grasas: "28,2 g",
        saturadas: "2,8 g",
        fibra: "7,7 g",
        sal: "1,2 g",
        proteinas: "6,8 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-boletus": {
        family: "mios",
        type: "right",
        titulo: "Chips de Maíz&Boletus",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyBoletus",
        intro:
          "Envie de découvrir une saveur unique ? Délicieux apéritif au maïs frit au goût d'oignon caramélisé.",
        introDos: "",
        introMovil:
          "Envie de découvrir une saveur unique ? Délicieux apéritif au maïs frit au goût d'oignon caramélisé.",
        ingredientes:
          "Maïs (68%), huile de tournesol à haute teneur en huile (23,5%), arôme (substances aromatisantes, maltodextrine, sel, saccharose et fructose) et boletus edulis séché (2%).",
        packs: "150g",
        energia: "2.087kJ, 499kcal",
        hidratos: "58,4 g",
        azucares: "2,2 g",
        polialcoholes: "",
        grasas: "25 g",
        saturadas: "2,5 g",
        fibra: "5,1 g",
        sal: "1,2 g",
        proteinas: "7,6 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-cebolla": {
        family: "mios",
        type: "left",
        titulo: "Chips de Maíz & Cebolla",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyCebolla",
        intro:
          "Une saveur <strong>délicieuse et sophistiquée</strong> pour apprécier un apéritif savoureux \n\n    ",
        introDos:
          "et comme toutes les variétés de Mios!... <br>Uniquement avec des ingrédients naturels!",
        introMovil:
          "Une saveur <strong>délicieuse et sophistiquée</strong> pour apprécier un apéritif savoureux.",
        ingredientes:
          "Maïs (65 %), huile de tournesol riche en acide oléique (23,7 %), oignon déshydraté (3 %), vinaigre balsamique de Modène (0,02 %) et oignon.",
        packs: "40g, 150g",
        energia: "2.191kJ, 524kcal",
        hidratos: " 61,9 g",
        polialcoholes: "",
        azucares: "3,7 g",
        grasas: " 26,5 g",
        saturadas: "2,7 g",
        fibra: "6,0 g",
        sal: " 1,2 g",
        proteinas: " 6,5 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-queso": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Cheese",
        cantidadValor: "100g",
        hashtag: "#MatchBallCheese",
        intro:
          "De délicieuses boulettes au bon goût de fromage...mmm... <strong>Beaucoup de fromage!</strong>",
        introDos: "",
        introMovil:
          "De délicieuses boulettes au bon goût de fromage...mmm... <strong>Beaucoup de fromage!</strong>",
        ingredientes:
          "Semoule de maïs, huile de tournesol (23,4 %), arôme de <u>fromage</u> [arôme, maltodextrine, <u>lactose</u>, <u>lactosérum</u>, exhausteurs de goût (E-621 et E-635) et acidifiant (acide citrique)], sucre et sel. Contient du <u>lait et des dérivés</u>. Peut contenir de la <u>moutarde</u>.",
        packs: "30g, 105g",
        energia: "1.963kJ, 468kcal",
        hidratos: "64,7 g",
        polialcoholes: "",
        azucares: "8,2 g",
        grasas: "20,9 g",
        saturadas: "2,6 g",
        fibra: "",
        sal: "2,0 g",
        proteinas: "5,3 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "match-ball-ketchup": {
        family: "match-ball",
        type: "right",
        titulo: "MatchBall Kétchup",
        cantidadValor: "100g",
        hashtag: "#MatchBallKétchup",
        intro:
          "Si vous aimez le ketchup...Ces MatchBall sont faites pour vous. ",
        introDos: "Les boulettes de toujours au goût de ketchup.</strong>.",
        introMovil:
          "Si vous aimez le ketchup... ce sont certainement vos MatchBall.",
        ingredientes:
          "Semoule de maïs, huile de tournesol (22, 4 %), arôme de ketchup (sel, fructose, poudre de tomate, arôme, acidifiants (acide citrique et acide malique), poudre d'oignon et d'ail, paprika et colorant (extrait de paprika)) et sucre. Peut contenir des <u>protéines de lait</u> ",
        packs: "30g, 105g",
        energia: "2044kJ, 487kcal",
        hidratos: "70,6 g",
        polialcoholes: "",
        azucares: "12,5 g",
        grasas: "20,2 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,0 g",
        proteinas: "5,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-barbacoa": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Barbacoa",
        cantidadValor: "100g",
        hashtag: "#MatchBallBarbacoa",
        intro:
          "Vous aimez les grillades et le goût <strong>du barbecue</strong>?",
        introDos: " <br>Ces MatchBalls sont faites pour vous...Delicieux!",
        introMovil:
          "Vous aimez les grillades et le goût du barbecue <strong>du barbecue</strong>?",
        ingredientes:
          "Semoule de maïs, huile de tournesol (23, 5 %), arôme de sauce barbecue (sel, maltodextrine, amidon de maïs, dextrose, arômes, oignon et ail en poudre, acidifiant (acide citrique), arôme de fumée et colorant (extrait de paprika)) et sucre. Peut contenir des <u>protéines de lait</u>.",
        packs: "30g, 105g",
        energia: "2057kJ, 491kcal",
        hidratos: "68 g",
        polialcoholes: "",
        azucares: "10,8 g",
        grasas: "22,2 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,3 g",
        proteinas: "4,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-minis": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Minis 27g",
        cantidadValor: "100g",
        hashtag: "#MatchBallMinis",
        intro:
          "En format mini tout en ayant le goût des grandes et avec beaucoup de fromage bien sûr.",
        introDos:
          "<br>Encore mieux... Avec le nouveau format, elles passent et c'est vraiment génial! <strong>directement de l'emballage à votre bouche.</strong>",
        introMovil:
          "En format mini tout en ayant le goût des grandes et avec beaucoup de fromage bien sûr.",
        ingredientes:
          "Gruau de maïs, huile de tournesol (22,8%), arôme de <u>fromage</u> [arôme, maltodextrine, <u>lactose</u>, <u>lactosérum</u>, exhausteurs de goût (E-621 et E-635) et acidifiant (acide citrique)], sucre et sel. Peut contenir de la <u>moutarde</u>.",
        packs: "27g",
        energia: "2.097kJ, 500kcal",
        hidratos: "66,2 g",
        polialcoholes: "",
        azucares: "11 g",
        grasas: "24 g",
        saturadas: "3,1 g",
        fibra: "",
        sal: " 1,6 g",
        proteinas: "4,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      jummy: {
        family: "jummy",
        type: "left",
        titulo: "Jummy",
        cantidadValor: "100g",
        hashtag: "#Jummy",
        intro: "<strong>Une étoile est née !</strong>",
        introDos: " <br>Produit d'apéritif doré au four saveur beurre.",
        introMovil: "Produit d'apéritif doré au four saveur beurre.",
        ingredientes:
          "Semoule de maïs (68%), huile de tournesol, arôme de beurre [substances aromatisantes, maltodextrine, lactosérum (lait), sel, sucre, acidifiant (acide citrique), exhausteurs de goût (E-621 et E-635)]. <u>Peut contenir du soja.</u>",
        packs: "90g, 100g",
        energia: "1.968kJ, 469kcal",
        hidratos: "67,7 g",
        polialcoholes: "",
        azucares: "3,5 g",
        grasas: "19 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: " 1,9 g",
        proteinas: "5,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "risketos-original": {
        family: "risketos",
        type: "left",
        titulo: "Risketos Original",
        cantidadValor: "100g",
        hashtag: "#RisketosOriginal",
        intro:
          "Pour les amateurs de Risketos authentiques, avec la <strong>saveur originale</strong>.",
        introDos:
          " Croustillant et avec le goût caractéristique du <u>fromage</u>.",
        introMovil:
          "Pour les amateurs de Risketos authentiques, avec la <strong>saveur originale</strong>.",
        ingredientes:
          "Semoule de maïs, huile de tournesol riche en acide oléique (26,5 %), huile de tournesol (9 %), arôme de <u>queso</u> [arôme (contient du <u>lait</u>), exhausteur de goût (glutamate monosodique) et colorant (extrait de paprika)], sel et émulsifiant (E-471). ",
        packs: "40g, 80g, 120g, 135g, 250g (XXL)",
        energia: "2.317kJ, 556kcal",
        hidratos: "53,5 g",
        azucares: "2,3 g",
        polialcoholes: "",
        grasas: "35,5 g",
        saturadas: "3,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,5 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "risketos-xhot": {
        family: "risketos",
        type: "left",
        titulo: "Risketos XtraHot",
        cantidadValor: "100g",
        hashtag: "#RisketosXtraHot",
        intro:
          "Les Risketos pour ceux qui aiment prendre des risques. Tout aussi croustillants, mais avec un regard différent. Ultrapiquants et super-savoureux.",
        introDos: "",
        introMovil:
          "Les Risketos pour ceux qui aiment prendre des risques. Tout aussi croustillants, mais avec un regard différent. Ultrapiquants et super-savoureux",
        ingredientes:
          "Semoule de maïs, huile de tournesol à haute teneur en huile (26,5 %), huile de tournesol (9 %), arôme de <u>fromage</u> épicé [arôme (contient du <u>lait</u>) et colorant (extrait de paprika)], sel et émulsifiant (E-471). Peut contenir du <u>soja.</u>  \n",
        packs: "40g, 120g, 135g",
        energia: "2.366kJ, 567Kcal",
        hidratos: "55,4 g",
        polialcoholes: "",
        azucares: "2,8 g",
        grasas: "36 g",
        saturadas: "3,7 g",
        fibra: "",
        sal: "0,7 g",
        proteinas: "4,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "triskys-original": {
        family: "triskys",
        type: "left",
        titulo: "Triskys Original",
        cantidadValor: "100g",
        hashtag: "#TriskysOriginal",
        intro:
          "Les Triskys de toujours, les authentiques apéritifs au maïs, <strong>croquants et ronds</strong> au goût originel.",
        introDos: "",
        introMovil:
          "Les Triskys de toujours, les authentiques biscuits apéritifs au maïs, <strong>croquants et ronds</strong> au goût originel.",
        ingredientes:
          "Semoule de maïs, huile de tournesol riche en acide oléique (20 %), amidon de maïs, sel, poudre à lever (bicarbonate de sodium), émulsifiant (E-471), acidifiant (acide citrique), régulateur d'acidité (E-526) et saveur. Peut contenir des <u>lait et soja</u>.",
        packs: "20g, 35g, 85g, 115g, 135g",
        energia: "1.961kJ, 467kcal",
        hidratos: "67,1 g",
        polialcoholes: "",
        azucares: "0,4 g",
        grasas: "20 g",
        saturadas: "1,8 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "4,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "triskys-jamon": {
        family: "triskys",
        type: "right",
        titulo: "Triskys Jamón",
        cantidadValor: "100g",
        hashtag: "#TriskysJamón",
        intro: "<strong>Saveur savoureuse</strong> \n",
        introDos:
          "avec une touche unique qui ne vous laissera pas indifférent.",
        introMovil:
          "<strong>Saveur savoureuse</strong> avec une touche unique qui ne vous laissera pas indifférent.",
        ingredientes:
          "Semoule de maïs, huile de tournesol riche en acide oléique (20%), amidon de maïs, sel, arômes [arôme, arôme de fumée, <u>lactosérum</u>, exhausteur de goût (E-621), colorant (extrait de paprika), maltodextrine], poudre à lever (bicarbonate de sodium), émulsifiant (E-471), acidifiant (acide citrique) et régulateur d'acidité (E-526). Peut contenir du <u>soja</u>.",
        packs: "35g",
        energia: "1.944kJ, 463kcal",
        hidratos: " 65,9g",
        polialcoholes: "",
        azucares: "1,8 g",
        grasas: " 20 g",
        saturadas: "1,7 g",
        fibra: "",
        sal: " 2,5g",
        proteinas: "4,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "triskys-barbacoa": {
        family: "triskys",
        type: "left",
        titulo: "Triskys Barbacoa",
        cantidadValor: "100g",
        hashtag: "#TriskysBarbacoa",
        intro:
          "La nouveauté de la maison, une nouvelle saveur pour vos Triskys ",
        introDos:
          "<strong>le bon goût d'une grillade authentique et croustillante. </strong>.",
        introMovil:
          "<strong>le bon goût d'une grillade authentique et croustillante. </strong> allez à vos Triskys.",
        ingredientes:
          "Semoule de maïs, huile de tournesol riche en acide oléique (20,3 %), amidon de maïs, sel, arôme de sauce barbecue [arôme, sucre, maltodextrine, épices, exhausteur de goût (E-621) et édulcorant (E-954)], poudre à lever (bicarbonate de sodium), émulsifiant (E-471), acidifiant (acide citrique) et régulateur d'acidité (E-526). Peut contenir des <u>lait et soja</u>.",
        packs: "115g, 135g",
        energia: "1.967kJ, 469kcal",
        hidratos: "65,4 g",
        polialcoholes: "",
        azucares: "2,8 g",
        grasas: "21 g",
        saturadas: "1,8 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "4,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      buscalios: {
        family: "otros-productos",
        type: "left",
        titulo: "Buscalios",
        cantidadValor: "100g",
        hashtag: "#Buscalios",
        intro:
          "Délicieuses et croustillantes fajitas de maïs au goût de barbecue intense.",
        introDos:
          " <br>Ce sont les Buscalíos de Risi. <strong>Découvrez le vrai goût de l'Ouest!</strong>  ",
        introMovil:
          "Délicieuses et croustillantes fajitas de maïs au goût de barbecue intense.",
        ingredientes:
          "Maïs, huile de tournesol riche en acide oléique (23 %), arôme barbecue [arôme, arôme de fumée, sucre, sel, maltodextrine, dextrose, exhausteurs de goût (E-621 et E-635), amidon, acidifiant (acide citrique) et colorant (extrait de paprika)].",
        packs: "35g, 140g",
        energia: "2.102kJ, 502kcal",
        hidratos: "64,4 g",
        polialcoholes: "",
        azucares: "3,4 g",
        grasas: "24,1 g",
        saturadas: "2,4 g",
        fibra: "",
        sal: "1,6 g",
        proteinas: "6,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "clasicas-originales": {
        family: "otros-productos",
        type: "left",
        titulo: "Clásicas Originales",
        cantidadValor: "125g",
        hashtag: "#PatatasClásicasRisi",
        intro: "Nos chips <strong> classiques salées</strong>.",
        introDos: " <br>Les chips les plus croustillantes du monde!",
        introMovil: "Nos chips <strong> classiques salées</strong>.",
        ingredientes:
          "Pommes de terre, huile de tournesol (31 %) et sel. Peut contenir des <u>protéines de lait</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.328kJ, 558kcal",
        hidratos: "54,1 g",
        polialcoholes: "",
        azucares: "1,0 g",
        grasas: "34,8 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-originales": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Originales",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasRisi",
        intro: "Nos chips <strong> classiques ondulées et salées</strong>.",
        introDos: " <br> Découvrez toutes nos variétés de saveurs!",
        introMovil:
          "Nos chips <strong> classiques ondulées et salées</strong>.",
        ingredientes:
          "Pommes de terre, huile de tournesol (32,1 %) et sel. Peut contenir des <u>protéines de lait</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.206kJ, 529kcal",
        hidratos: "54,5 g",
        polialcoholes: "",
        azucares: "0,8 g",
        grasas: "32,1 g",
        saturadas: "3,9 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "5,4 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-campesinas": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Campesinas",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasCampesinas",
        intro:
          "Nos chips ondulées <strong>campagnardes</strong>, la saveur la plus rustique.",
        introDos: "",
        introMovil:
          "Nos chips ondulées <strong>campagnardes</strong>, la saveur la plus rustique.",
        ingredientes:
          "Pommes de terre, huile de tournesol (34,5 %), arôme campagnarde [arôme, arôme de fumée, sucre, sel (1,2 %), exhausteurs de goût (E-621 et E-635), colorant (extrait de paprika) et tomate en poudre (0,1 %)]. Peut contenir des <u>proteína de leche</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.288kJ, 549kcal",
        hidratos: "53,5 g",
        polialcoholes: "",
        azucares: "1,6 g",
        grasas: "34,5 g",
        saturadas: "4,3 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-jamon": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Jamón",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasJamón",
        intro: "Nos chips ondulées <strong>au goût de jambon serrano</strong>.",
        introDos: "",
        introMovil:
          "Nos chips ondulées <strong>au goût de jambon serrano</strong>.",
        ingredientes:
          "Pommes de terre, huile de tournesol (32,2 %), arôme jambon [arôme, arôme de fumée, maltodextrine, sucre, sel et acidifiant (acide citrique)]. Peut contenir des <u>protéines de lait</u>.",
        packs: "30g, 50g, 125g",
        energia: "2.338kJ, 561kcal",
        hidratos: "50,4 g",
        polialcoholes: "",
        azucares: "1,6 g",
        grasas: "37,7 g",
        saturadas: "4,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-cheese-onion": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Cheese & Onion",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasCheeseOnion",
        intro:
          "Notre version savoureuse avec du <strong>fromage et de l'oignon</strong>.   ",
        introDos: "",
        introMovil:
          "Notre version savoureuse avec du <strong>fromage et de l'oignon</strong>.",
        ingredientes:
          "Pommes de terre, huile de tournesol (34,4 %), <u>fromage</u> et oignon [arôme, épices, <u>lactosérum</u>, sel, sucre et exhausteurs de goût (E-621 et E-635)].",
        packs: "125g",
        energia: "2.285kJ, 548kcal",
        hidratos: "51,6 g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "35,2 g",
        saturadas: "4,2 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,2 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "onduladas-vinagreta": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Vinagreta",
        cantidadValor: "125g",
        hashtag: "#PatatasOnduladasVinagreta",
        intro:
          "Ne manquez pas la saveur <strong>unique de la vinaigrette</strong> sur vos chips ondulées.",
        introDos: "",
        introMovil:
          "Ne manquez pas la saveur <strong>unique de la vinaigrette</strong> sur vos chips ondulées.",
        ingredientes:
          "Pommes de terre, huile de tournesol (30,4 %), arôme de vinaigre et de sel. Peut contenir des <u>protéines de lait</u>.",
        packs: "125g",
        energia: "2.188kJ, 525kcal",
        hidratos: "51,7 g",
        azucares: "1,0 g",
        polialcoholes: "",
        grasas: "33,6 g",
        saturadas: "4,0 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "3,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      toscana: {
        family: "otros-productos",
        type: "left",
        titulo: "Clásicas Toscana",
        cantidadValor: "125g",
        hashtag: "#PatatasClásicasToscana",
        intro: "Chips lisses <strong>au goût Toscane</strong>.",
        introDos: "",
        introMovil: "Chips lisses <strong>au goût Toscane</strong>.",
        ingredientes:
          "Pommes de terre, huile de tournesol (30 %), arôme Toscane [sucre, sel, fibres de pois, poudre de tomate, maltodextrine, arômes, poudre d'oignon, dextrose, persil, paprika, ail en poudre, acidifiant (acide citrique), colorant (extrait de paprika), graisse de noix de coco, poivre de Cayenne et poivre noir]. Peut contenir des <u>protéines de lait.</u>",
        packs: "125g",
        energia: "2.144kJ, 513kcal",
        hidratos: "53,8 g",
        polialcoholes: "",
        azucares: "1,5 g",
        grasas: "30g",
        saturadas: "3,5 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      tejitas: {
        family: "otros-productos",
        type: "left",
        titulo: "Tejitas",
        cantidadValor: "100g",
        hashtag: "#TejitasRisi",
        intro:
          "Les légendaires Tejitas, avec <strong>une saveur de fromage</strong> qui fondent dans la bouche.",
        introDos: "",
        introMovil:
          "Les légendaires Tejitas, avec <strong>une saveur de fromage</strong> qui fond dans la bouche.",
        ingredientes:
          "Semoule de maïs, huile de tournesol (22 %), arôme de fromage [arôme, maltrodextrine, <u>lactose</u>, sucre, <u>lactosérum</u>, exhausteurs de goût (E-621 et E-635), acidifiant (acide citrique)] et sel. Peut contenir de la <u>moutarde.</u>",
        packs: "35g, 100g",
        energia: "2.202kJ, 526kcal",
        hidratos: "65,6 g",
        polialcoholes: "",
        azucares: "4,1 g",
        grasas: "26,7 g",
        saturadas: "4,6 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      surtis4u: {
        family: "otros-productos",
        type: "left",
        titulo: "Surtis",
        cantidadValor: "100g",
        hashtag: "#Surtis",
        intro:
          "Notre mélange le plus original, découvrez <strong>nos meilleurs produits dans un seul et même sachet.</strong>. ",
        introDos: "",
        introMovil:
          "Notre mélange le plus original, découvrez <strong>nos meilleurs produits</strong>. ",
        ingredientes:
          "Maïs, huile de tournesol (27 %), sauce barbecue et arômes de <u>fromage</u> [arôme (contient du <u>lait</u>), arôme de fumée, sucre, arôme, exhausteur de goût (glutamate monosodique) et colorant (extrait de paprika)], amidon de maïs, sel, poudre à lever (bicarbonate de sodium), émulsifiant (mono- et diglycérides d'acides gras), acidifiant (acide citrique) et régulateur d'acidité (hydroxyde de calcium).",
        packs: "37g, 110g",
        energia: "2.209kJ, 528kcal",
        hidratos: "60,6 g",
        polialcoholes: "",
        azucares: "1,0 g",
        grasas: "29,1 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      pajitas: {
        family: "otros-productos",
        type: "left",
        titulo: "Pajitas",
        cantidadValor: "100g",
        hashtag: "#PajitasdeRisi",
        intro: "Vous voulez du croustillant? Vous voulez du savoureux?",
        introDos:
          " <br>Alors les Pajitas de Risi, salées à point, sont faites pour vous! <br><strong>Choisissez avec ou sans ketchup!</strong>",
        introMovil: "Alors les Pajitas de Risi, salées à point. ",
        ingredientes:
          "Fécule de pomme de terre (52 %), huile de tournesol riche en acide oléique (19 %), pomme de terre déshydratée (13 %), amidon de pomme de terre modifié (6 %), arôme de pomme de terre [arôme, maltodextrine, amidon et exhausteurs de goût (E-621 et E-635)], sel et émulsifiant (E-471). Peut contenir des <u>protéines de lait</u>.",
        packs: "20g, 100g",
        energia: "2.059kJ, 491kcal",
        hidratos: "69,8 g",
        polialcoholes: "",
        azucares: "1,2 g",
        grasas: "22,7 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "1,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "pajitas-ketchup": {
        family: "otros-productos",
        type: "left",
        titulo: "Pajitas Kétchup",
        cantidadValor: "100g",
        hashtag: "#PajitasDeKétchupRisi",
        intro:
          "Les légendaires, croustillantes <strong>et au ketchup</strong>.     ",
        introDos: "",
        introMovil:
          "Las mí­ticas y crujientes con <strong>sabor Kétchup</strong>.",
        ingredientes:
          "Fécule de pomme de terre ((51 %), huile de tournesol riche en acide oléique (20 %), pomme de terre déshydratée (13 %), amidon de pomme de terre modifié (6 %), arôme de ketchup (sucre, extrait de levure, fructose, tomate, oignon et ail en poudre, arôme, acidifiant (acide citrique et malique), paprika), sel et émulsifiant (E-471), et colorant (extrait de paprika). Peut contenir des <u>protéines de lait</u>.",
        packs: "20g, 100g",
        energia: "2.012kJ, 480kcal",
        hidratos: "64,1 g",
        polialcoholes: "",
        azucares: "2,0 g",
        grasas: "22,9 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "4,4 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      trikers: {
        family: "otros-productos",
        type: "left",
        titulo: "Trikers",
        cantidadValor: "45g y 100g",
        hashtag: "#TrikersRisi",
        intro:
          "Délicieux apéritif au goût authentique Tex Mex. Sans gluten et sans colorants artificiels, pour une saveur authentique! ",
        introDos: "Ne résistez pas...",
        introMovil:
          "Délicieux apéritif au goût authentique Tex Mex. Ne résistez pas...",
        ingredientes:
          "Maïs, huile de tournesol riche en acide oléique (27,8 %), arôme tex mex [maltodextrine, dextrose, sel, amidon de maïs, extraits de levure, oignon, tomate et ail en poudre, arômes, graisse de coco, chlorure de potassium, acidifiants (acide citrique, acide lactique et lactate de calcium), colorants (extrait de paprika et E-160b) et poivre de cayenne] et paprika. Peut contenir des <u>protéines de lait</u>.    ",
        packs: "45g, 110g, 180g",
        energia: "2166kJ, 518kcal",
        hidratos: "60,8 g",
        polialcoholes: "",
        azucares: "2,1 g",
        grasas: "27,8 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "espelta-integral": {
        family: "desayuno",
        type: "left",
        titulo: "BSAN 0% Espelta",
        packs: "480g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinLactosa: "1",
        bajoSal: "1",
        intro:
          "De délicieux biscuits <strong>sans sucre, fins et savoureux</strong>.      ",
        introDos:
          " <br>Avec de l'épeautre, une céréale millénaire, à la saveur intense et très nutritive.",
        introMovil:
          "De délicieux biscuits <strong>sans sucre, fins et savoureux</strong>.",
        ingredientes:
          "Farine intégrale <u>blé du type épeautre</u> (67%), édulcorants (maltitol et sirop de maltitol),  huile de aceite de tournesol riche en acide oléique, fécule de pomme de terre, farine <u>de malt d'orge</u> (2%), poudres à lever (carbonate acide d'ammonium et\n  carbonate acide de sodium), farine de <u>blé</u> avec son (1%), arômes, émulsifiant (lécithine de tournesol), colorant (E-150d) et conservateur (<u>metabisulphite</u> de potassium). Peut contenir des traces de <u>soja</u>, de protéines de <u>lait et de sésame</u>   ",
        cantidadValor: "100g",
        hashtag: "#BSanEspeltaIntegral",
        energia: "1.782 kJ, 425 kcal",
        hidratos: "63,9 g",
        polialcoholes: "15 g",
        azucares: "1,0 g",
        grasas: "16,0 g",
        saturadas: "1,4 g",
        fibra: "6,6 g",
        sal: "0,19g",
        proteinas: "9,2 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      integral: {
        family: "desayuno",
        type: "left",
        titulo: "BSAN 0% au sésame",
        packs: "160g y 480g",
        hasIntegral: "1",
        bajoAzucares: "1",
        bajosal: "1",
        intro:
          "Exquis <strong>0% de sucre, biscuits complets au calcium et au sésame</strong>.",
        introDos: "",
        introMovil:
          "Exquis <strong>0% de sucre, biscuits complets au calcium et au sésame</strong>.",
        ingredientes:
          "Farine de <u>blé</u> (48 %), édulcorants (maltitol, sirop de maltitol), farine de <u>blé</u> avec son (16 %), huile de tournesol à haute teneur en acide oléique, poudres à lever (acide carbonate d'ammonium et carbonate acide de sodium), <u>sésame</u> (2,5%), amidon de pomme de terre, farine de malt d'<strong>ORGE</strong> (1,9%), carbonate de calcium, arôme, émulsifiant (lécithine de tournesol), colorant (E -150d), conservateur (<strong>metabisulphite de potassium</strong>). Peut contenir des traces de protéines de <u>soja</u> et de <u>lait</u>. <strong>RECOMMANDATIONS</strong>: Une consommation excessive peut produire des effets laxatifs.",
        cantidadValor: "100g",
        hashtag: "#BSanConSésamo",
        energia: "1.848 kJ, 441 kcal",
        hidratos: "68,0 g",
        polialcoholes: "16,1 g",
        azucares: "3,0 g",
        grasas: "17,2 g",
        saturadas: "1,6 g",
        fibra: "3,6 g",
        sal: "0,19 g",
        proteinas: "8,2 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      supermaria: {
        family: "tradicionales",
        type: "left",
        titulo: "Súper María 0%",
        packs: "432g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        sinhuevo: "1",
        intro: "Les María d'une vie, plus délicieux que jamais.",
        introDos: " <br><strong>Enriquecidas con sésamo</strong>.",
        introMovil: "Les María d'une vie, <u>enrichi de sésame</u>.",
        ingredientes:
          "<u><strong>farine de blé</u></strong>, farine de <u><strong>blé</u></strong> avec son, farine de blé (22%), huile de tournesol riche en acide oléique, édulcorant (maltitol), graines de <u>sésame</u> (3%), concentré de jus de pomme, amidon de pomme de terre, poudres à lever (carbonates de sodium et carbonates d'ammonium), émulsifiant (lécithine de tournesol), arôme, conservateur (<u><strong>métabisulfite de potassium</u></strong>). Peut contenir des traces de <u><strong>lait et de protéines de soja</u></strong>.",
        cantidadValor: "100g",
        hashtag: "#VirginiaSúperMaría",
        energia: "1.976 kJ, 472 kcal",
        hidratos: "65,0g",
        polialcoholes: "",
        azucares: "2,9 g",
        grasas: "22,0 g",
        saturadas: "3,4 g",
        fibra: "3,6 g",
        sal: "0,21g",
        proteinas: "7,4 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1"
      },
      "bsan-singluten-infantil": {
        family: "tradicionales",
        type: "right",
        titulo: "BSAN Plus+ Adventure Sin Gluten",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Des biscuits amusants et nutritifs pour le goûter des enfants, avec du maïs, du riz, 5 vitamines et sans huile de palme. Ils sont également certifiés par la Fédération espagnole des associations cœliaques (FACE).",
        introDos: "",
        introMovil:
          "Des biscuits amusants et nutritifs pour le goûter des enfants, avec du maïs, du riz, 5 vitamines et sans huile de palme. Ils sont également certifiés par la Fédération espagnole des associations cœliaques (FACE).",
        ingredientes:
          "Amidon de maïs (28,3 %), farine de riz (21,7 %), sucre, huile de tournesol riche enacide oléique, amidon de pomme de terre, protéines de riz, sucre liquide inverti, épaississants (gomme de guar et gomme de xanthane), dextrose, humidifiant (sorbitol), arômes, poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium), émulsifiant (lécithine de tournesol), conservateur (méthabisulfite de potassium) et vitamines [acide pantothénique (B5), thiamine (B1), vitamine A, acide folique (B9) et vitamine D]. Peut  contenir des <strong> fruits à coque</strong>.\n\n    \n\n    ",
        cantidadValor: "100g",
        hashtag: "#BSAN+SinGluten",
        energia: "1.928 kJ, 459 kcal",
        hidratos: "73,7 g",
        azucares: "17 g",
        polialcoholes: "",
        grasas: "16 g",
        saturadas: "1,4 g",
        fibra: "2,4 g",
        sal: "0,08 g",
        proteinas: "4,2 g",
        ocultarSinGluten: "0",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "bsan-singluten-chocolate-infantil": {
        family: "tradicionales",
        type: "right",
        titulo: "BSAN Plus+ Adventure Chocolate Sin Gluten",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "De délicieux biscuits nutritifs idéaux pour le goûter, avec du chocolat, du maïs, du riz, 5 vitamines et sans huile de palme. Ils sont également certifiés par la Fédération espagnole des associations cœliaques (FACE).",
        introDos: "",
        introMovil:
          "De délicieux biscuits nutritifs idéaux pour le goûter, avec du chocolat, du maïs, du riz, 5 vitamines et sans huile de palme. Ils sont également certifiés par la Fédération espagnole des associations cœliaques (FACE).",
        ingredientes:
          " Amidon de maïs (28,3%), farine de riz (21,7%), sucre, huile de tournesol riche en acide oléique, édulcorants (maltitol et acésulfame K), amidon de pomme de terre, <u>lait</u> entier en poudre, beurre de cacao, pâte de cacao, protéine de riz, sucre inverti liquide, épaississants (gomme guar et gomme xanthane), dextrose, humectant (sorbitol), arômes, émulsifiants (lécithine de tournesol et <u>soja</u>) poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium) , conservateur (<strong>metabisulphite de potassium</strong>) et vitamines [acide pantothénique (B5), thiamine (B1), vitamine A, acide folique (B9) et vitamine D].Peut contenir des traces de <strong>fruits à coque.</strong>",
        cantidadValor: "100g",
        hashtag: "#BSAN+SinGlutenChocolate",
        energia: "1.978 kJ, 471 kcal",
        hidratos: "70,9 g",
        polialcoholes: "",
        azucares: "18,6 g",
        grasas: "18,0 g",
        saturadas: "5,5 g",
        fibra: "2,8 g",
        sal: "0,08 g",
        proteinas: "5,0 g",
        ocultarSinGluten: "0",
        mostrarSinLactosa: "0",
        hasFrutosSecos: "1"
      },
      "bsan-plus-infantil": {
        family: "plus",
        type: "right",
        titulo: "BSAN Plus+ Adventure",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "Biscuits amusants et nutritifs pour le goûter des enfants, avec des céréales, 5 vitamines et sans huile de palme.",
        introDos: " ",
        introMovil:
          "Biscuits amusants et nutritifs pour le goûter des enfants, avec des céréales, 5 vitamines et sans huile de palme.",
        ingredientes:
          "Farines de céréales (64 %) (farine de </u>blé</u>, farine de son de <u>blé</u>, farine <u>d'avione</u>, farine de malt <u>d'orge</u>), sucre, huile de tournesol riche en acide oléique, poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium), arômes, sel, émulsifiant (lécithine de tournesol), colorant (E-150d) et vitamines [acide pantothénique (B5), thiamine (B1), vitamine A, acide folique (B9) et vitamine D]. Peut contenir des traces de SOJA, de protéines de <u>lait, de fruits à coque, de sésame et de sulfites</u>.",
        cantidadValor: "100g",
        hashtag: "#BSAN+",
        energia: "2.029 kJ, 484 kcal",
        hidratos: "68,0 g",
        azucares: "21,8 g",
        polialcoholes: "",
        grasas: "20,0 g",
        saturadas: "1,9 g",
        fibra: "2,6 g",
        sal: "1,24 g",
        proteinas: "6,6 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "bsan-plus-chocolate-infantil": {
        family: "plus",
        type: "right",
        titulo: "BSAN\n  Plus+ Adventure Chocolate",
        packs: "160g",
        hasIntegral: "1",
        bajoAzucares: "1",
        intro:
          "De délicieux biscuits nutritifs, parfaits pour le goûter, avec du chocolat, des céréales, 5 vitamines et sans huile de palme.",
        introDos: " ",
        introMovil:
          "De délicieux biscuits nutritifs, parfaits pour le goûter, avec du chocolat, des céréales, 5 vitamines et sans huile de palme.",
        ingredientes:
          "Farines de céréales (52%) (farine de <u>blé</u>, farine de son de <u>blé</u>, farine <u>d'avione</u> colorant (E-150d), colorant (E-150d), farine de malt <u>d'orge</u>), sucre, huile de tournesol riche en acide oléique, édulcorants (maltitol et acésulfame K), poudre de <u>lait entier</u>, beurre de cacao, pâte de cacao, poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium), arômes, sel, émulsifiants (lécithines de tournesol et de <u>soja</u>), colorant (E-150d), et vitamines [acide pantothénique (B5), thiamine (B1), vitamine A, acide folique (B9) et vitamine D]. Peut contenir des traces de <u>fruits à coque, de sésame et sulfites</u>.\n\n    \n\n    ",
        cantidadValor: "100g",
        hashtag: "#BSAN+Chocolate",
        energia: "1.958 kJ, 466 kcal",
        hidratos: "67,3 g",
        polialcoholes: "",
        azucares: "18,6 g",
        grasas: "18,0 g",
        saturadas: "5,1 g",
        fibra: "2,9 g",
        sal: "0,64 g",
        proteinas: "7,4 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "singluten-digestive": {
        family: "adultas",
        type: "center",
        titulo: "BSAN Sin Gluten Digestive",
        packs: "140g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Biscuit recouvert d'un délicieux et intense chocolat noir, <strong>70% de cacao</strong>.",
        introDos: "",
        introMovil:
          "Biscuit digestif recouvert d'un délicieux et intense chocolat noir, <strong>70% de cacao</strong>.",
        ingredientes:
          "Amidon de maïs, farine de riz, pâte de cacao, sucre, édulcorants (maltitol, lactitol et acésulfame K), huile de tournesol riche en acide oléique, beurre de cacao, farine de lin, fécule de pomme de terre, poudre de cacao dégraissée, sucre inverti liquide, protéines de riz, épaississants (gomme de guar et gomme de xanthane), dextrose, humectant (sorbitol), arômes, poudres à lever (carbonate d'hydrogène d'ammonium et carbonate d'hydrogène de sodium), émulsifiant (lécithines de tournesol et de <u>soja</u>), conservateur (<u>metabisulphite</u> de potassium). <strong>RECOMMANDATIONS</strong>: une consommation excessive peut entraîner des effets laxatifs. Peut contenir des traces de protéines de <u>lait, de fruits à coque et de sésame</u>.\n\n    \n\n    ",
        cantidadValor: "100g",
        hashtag: "#BsanDigestiveChocolate",
        energia: "2070 kJ, 494 kcal",
        hidratos: "60,2 g",
        polialcoholes: "7,8g",
        azucares: "16,5 g",
        grasas: "23,0 g",
        saturadas: "7,0 g",
        fibra: "7,5 g",
        sal: "0,08 g",
        proteinas: "6,9 g",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "cacao-intenso": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Cacao intense",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "Le plaisir d’un biscuit totalement <strong>enrobé de chocolat intense 70% de cacao</strong>. Il y a-t-il quelque chose de meilleur pour un amoureux du chocolat?",
        introDos: "",
        introMovil:
          "Le plaisir d’un biscuit totalement <strong>enrobé de chocolat intense 70% de cacao</strong>. Il y a-t-il quelque chose de meilleur pour un amoureux du chocolat?",
        ingredientes:
          "Pâte de cacao, farine de <u>blé</u> (24,8 %), édulcorants (maltitol, sirop de maltitol, lactitol et acésulfame K), farine de <u>blé</u> avec son (8,2 %), beurre de cacao, beurre (contient du <u>lait</u>), poudre de cacao dégraissée, farine d'AVOINE (1,5%), farine de malt <u>d'orge</u> (1%), fécule de pomme de terre, huile de tournesol à haute teneur en acide oléique, poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium), arômes, émulsifiants (lécithines de <u>soja</u> et de tournesol), fibres végétales, conservateur (<u>metabisulphite</u> de potassium) et vitamines [acide pantothénique (B5), thiamine (B1), vitamine A, acide folique (B9) et vitamine D]. Peut contenir des traces de <u>fruits à coque et de sésame</u>.\n<strong>RECOMMANDATIONS</strong>: une consommation excessive peut entraîner des effets laxatifs.",
        cantidadValor: "80g, 120g",
        hashtag: "#BSAN_0%CacaoIntenso",
        energia: "2.501 kJ, 600 kcal",
        hidratos: "51,0 g",
        polialcoholes: "21,1 g",
        azucares: "4,0 g",
        grasas: "32,4 g",
        saturadas: "15,7 g",
        fibra: "6,8 g",
        sal: "0,1g",
        proteinas: "8,3 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "fabs-vietnam": {
        name: "VIETNAM",
        family: "fabs-vietnam",
        type: "right",
        titulo: "Fabs Origins Vietnam",
        packs: "160g",
        intro:
          "Ce <strong>chocolat est le plus raffiné</strong> de notre gamme, puisque seulement 0,1 % du cacao mondial provient du Vietnam. Goût acide particulier et délicieux grâce au faible PH du sol.",
        introDos: "",
        introMovil:
          "Ce <strong>chocolat est le plus raffiné</strong> de notre gamme, puisque seulement 0,1 % du cacao mondial provient du Vietnam. Goût acide particulier et délicieux grâce au faible PH du sol.",
        ingredientes:
          "Farine de <u>blé</u>, pâte de cacao, sucre, beurre (contient du <u>lait</u>), beurre de cacao, fibres végétales, sel, poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium), émulsifiant (lécithine de tournesol) et arômes.\nPeut contenir des traces de <u>fruits à coque, de sésame et de sulfites</u>.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsVietnam",
        energia: "2.144 kJ, 513 kcal",
        hidratos: "54,2 g",
        polialcoholes: "",
        azucares: "21,8 g",
        grasas: "29,0 g",
        saturadas: "17,0 g",
        fibra: "6,7 g",
        sal: "0,4 g",
        proteinas: "8,8 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video: "https://www.youtube.com/watch?v=HReSXTH-ZPg&ab_channel=Risi",
        origen: {
          title: "ORIGINE",
          text:
            "Il est fabriqué à partir de fèves de cacao exceptionnelles, appelées Trinitarios, qui proviennent principalement de la région du delta du Mékong. Le goût acidulé particulier et délicieux de ce cacao est dû à la faible teneur en PH de cette région.",
          img: "mapa-vietnam.png"
        },
        maridaje: {
          title: "JUMELAGE",
          text:
            "Pour un accord parfait, accompagnez ce chocolat d'un vin Malbec, pour un goût plus sucré, de fruits comme la poire ou la banane, qui adoucissent la saveur sans la neutraliser, ou de menthe, qui apporte cette fraîcheur qui s'associe si bien à la chaleur du chocolat noir.",
          img: "hoja-vietnam.png"
        },
        notas_cata: {
          img: "cata-vietnam-fr.png"
        }
      },
      "fabs-mexico": {
        name: "MÉXICO",
        family: "fabs-mexico",
        type: "right",
        titulo: "Fabs Origins México",
        packs: "150g",
        intro:
          "Avec du cacao en provenance du Mexique, ce biscuit se caractérise par un goût onctueux et délicieux qui ne laissera indifférents ni les <strong>amateurs de chocolat au lait</strong>, ni les <strong>amoureux de biscuits</strong> croquants.",
        introDos: "",
        introMovil:
          "Avec du cacao en provenance du Mexique, ce biscuit se caractérise par un goût onctueux et délicieux qui ne laissera indifférents ni les <strong>amateurs de chocolat au lait</strong>, ni les <strong>amoureux de biscuits</strong> croquants.",
        ingredientes:
          "Farine de <u>blé</u>, sucre, pâte de cacao, <u> ait</u> entier en poudre, beurre de cacao, beurre (contient du <u>lait</u>), émulsifiants (lécithines de tournesol et <u>soja</u>), fibres végétales, sel, poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium) et arômes.Peut contenir des traces de <u>fruits à coque, de sésame et de sulfites</u>.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsMéxico",
        energia: "2.148 kJ, 513 kcal",
        hidratos: "59,3 g",
        polialcoholes: "",
        azucares: "28,6 g",
        grasas: "27,0 g",
        saturadas: "14,9 g",
        fibra: "4,0 g",
        sal: "0,43g",
        proteinas: "8,3 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video: "https://www.youtube.com/watch?v=oJs1TfT-QSY&ab_channel=Risi",
        origen: {
          title: "ORIGINE",
          text:
            "Ce cacao exceptionnel provient des plantations du chaud golfe du Mexique et est aussi riche en qualité qu'en histoire : il était déjà cultivé par les Aztèques, les Mayas et les Toltèques.",
          img: "mapa-mexico.png"
        },
        maridaje: {
          title: "JUMELAGE",
          text:
            "Pour un mariage parfait, associez ce chocolat à un vin doux, qui complétera la saveur grâce à son arôme fruité ; à du caramel, pour renforcer la douceur du chocolat ; ou à des épices telles que la cannelle ou le curry, pour rehausser l'expérience gustative.",
          img: "hoja-mexico.png"
        },
        notas_cata: {
          img: "cata-mexico-fr.png"
        }
      },
      "fabs-tanzania": {
        name: "TANZANIA",
        family: "fabs-tanzania",
        type: "right",
        titulo: "Fabs Origins Tanzania",
        packs: "150g",
        intro:
          "Le chocolat contenu dans ce biscuit, issu de fèves de cacao Criollo et Trinitario, a voyagé depuis les meilleurs champs de Tanzanie pour créer une <strong>expérience exquise</strong> grâce au <strong>cacao le plus intense</strong>.",
        introDos: "",
        introMovil:
          "Le chocolat contenu dans ce biscuit, issu de fèves de cacao Criollo et Trinitario, a voyagé depuis les meilleurs champs de Tanzanie pour créer une <strong>expérience exquise</strong> grâce au <strong>cacao le plus intense</strong>.",
        ingredientes:
          "Pâte de cacao, farine de <u>blé</u>, sucre, beurre (contient du <u>lait</u>), beurre de cacao, fibres végétales, sel, poudre à lever (carbonate acide d'ammonium et carbonate acide de sodium), émulsifiant (lécithine de tournesol) et arômes.\n<br>Peut contenir des traces de <u>fruits à coque, de soja, de sésame et de sulfites</u>.",
        cantidadValor: "100g",
        hashtag: "#FabsOriginsTanzania",
        energia: "2.154 kJ, 515 kcal",
        hidratos: "54,8 g",
        polialcoholes: "",
        azucares: "18,4 g",
        grasas: "29,0 g",
        saturadas: "17,9 g",
        fibra: "6,7 g",
        sal: "0,4 g",
        proteinas: "8,8 g",
        hasFrutosSecos: "1",
        ocultarSinGluten: "1",
        video:
          "https://www.youtube.com/watch?v=vEWlbRaaOBg&t=1s&ab_channel=Risi",
        origen: {
          title: "ORIGINE",
          text:
            "Soutenu par le Kilimandjaro et entouré par les Grands Lacs africains, le mélange tropical de températures élevées et de saisons des pluies crée le climat idéal pour les plantations de cacao de Tanzanie.",
          img: "mapa-tanzania.png"
        },
        maridaje: {
          title: "JUMELAGE",
          text:
            "Pour un mariage parfait, associez ce chocolat à des fruits tels que la noix de coco et la framboise, pour compléter la touche acide par la fraîcheur de ces aliments ; à de l'huile de truffe, pour une expérience encore plus complexe ; ou à de la cannelle, pour adoucir le goût amer par sa douceur.",
          img: "hoja-tanzania.png"
        },
        notas_cata: {
          img: "cata-tanzania-fr.png"
        }
      },
      "maria-sesamo": {
        family: "mariasesamo",
        type: "left",
        titulo: "BSAN 0% Sésamo",
        packs: "480g",
        hasIntegral: "0",
        bajoSal: "1",
        sinLactosa: "1",
        intro:
          "Biscuits exquis sans sucre <strong>avec des graines de sésame</strong>, riches en matières grasses de bonne qualité, en protéines d'origine végétale et en calcium.",
        introDos: "",
        introMovil:
          "Biscuits exquis à 0 % de sucre, <strong>aux graines de sésame</strong>, riches en graisses saines, en protéines d'origine végétale et en calcium.",
        ingredientes:
          "Farine de <u>blé</u> (48 %), édulcorants (maltitol, sirop de maltitol), farine de <u>blé</u> avec son (16 %), huile de tournesol à haute teneur en acide oléique, poudres à lever (acide carbonate d'ammonium et carbonate acide de sodium), <u>sésame</u> (2,5%), amidon de pomme de terre, farine de malt d'<strong>ORGE</strong> (1,9%), carbonate de calcium, arôme, émulsifiant (lécithine de tournesol), colorant (E -150d), conservateur (<u>metabisulphite de potassium</strong>). <br>Peut contenir des traces de protéines de <u>soja</u> et de <u>lait</u>. <br><strong>RECOMMANDATIONS</strong>: Une consommation excessive peut produire des effets laxatifs.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%conSésamo",
        energia: "1.848 kJ, 441 kcal",
        hidratos: "68,0 g",
        polialcoholes: "16,1 g",
        azucares: "3,0 g",
        grasas: "17,2 g",
        saturadas: "1,6 g",
        fibra: "3,6 g",
        sal: "0,19g",
        proteinas: "8,2 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "maria-espelta": {
        family: "mariasesamo",
        type: "left",
        titulo: "BSAN 0% Espelta",
        packs: "480g",
        hasIntegral: "0",
        bajoSal: "1",
        sinLactosa: "1",
        intro:
          "Délicieux biscuits sans sucres, élaborés à base <strong>d'épeautre</strong>, une céréale millénaire à la saveur intense et très nutritive.",
        introDos: " ",
        introMovil:
          "Délicieux biscuits sans sucres, élaborés à base <strong>d'épeautre</strong>, une céréale millénaire à la saveur intense et très nutritive.",
        ingredientes:
          "Farine de <u>blé du type épeautre</u> (67 %), édulcorants (maltitol et sirop de maltitol), huile de tournesol riche en acide oléique, fécule de pomme de terre, farine de malt <u>d'orge</u> (2 %), poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium), farine de <u>blé</u> avec son (1 %), arômes, émulsifiant (lécithine de tournesol), colorant (E-150d) et conservateur (<u>metabisulphite</u> de potassium).\nPeut contenir des traces de <u>soja</u>, de protéines de </trong>lait</strong> et de <u>sésame</u>.\n<br><strong>RECOMMANDATIONS</strong> : une consommation excessive peut entraîner des effets laxatifs.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%EspeltaIntegral",
        energia: "1782 kJ, 425 kcal",
        hidratos: "63,9 g",
        polialcoholes: "15,0 g",
        azucares: "1,0 g",
        grasas: "16,0 g",
        saturadas: "1,4 g",
        fibra: "6,6 g",
        sal: "0,19g",
        proteinas: "9,2 g"
      },
      "chocolate-con-leche": {
        family: "chocolate",
        type: "left",
        titulo: "0% BSAN Chocolat au Lait",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "Le plaisir d’un biscuit enrobé de <strong>chocolat au lait</strong>.",
        introDos: "",
        introMovil:
          "Le plaisir d’un biscuit enrobé de <strong>chocolat au lait</strong>.",
        ingredientes:
          "Édulcorants (maltitol, sirop de maltitol et acésulfame K), farine u blé (u,6 %), poudre de <u>lait entier</u>, beurre de cacao, farine de <u>blé</u> avec son (8,2 %), pâte de cacao, beurre (contient du lait), farine <u>d'avione</u> (1,5 %), farine de malt d'orge (1 %), fécule de pomme de terre, poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium), huile de tournesol riche en acide oléique, arômes, émulsifiants (lécithines de SOJA et de tournesol), fibres végétales, conservateur (metabisulphite de potassium) et vitamines [acide pantothénique (B5), thiamine (B1), vitamine A, acide folique (B9) et vitamine D]. Peut contenir des traces de ug>fruits à coque et de sésame<ug>. <strong>RECOMMANDATIONS</strong>: une consommation excessive peut entraîner des effets laxatifs.",
        cantidadValor: "80g, 120g",
        hashtag: "#BSAN_0%ChocolateConLeche",
        energia: "2.478 kJ, 593 kcal",
        hidratos: "59,0 g",
        polialcoholes: "31 g",
        azucares: "5,2 g",
        grasas: "27,3 g",
        saturadas: "12,9 g",
        fibra: "3,4 g",
        sal: "0,18g",
        proteinas: "7,5 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-blanco": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Chocolat Blanc",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "Le plaisir d’un biscuit enrobé <strong>d’un doux chocolat blanc</strong>.",
        introDos: "",
        introMovil:
          "Le plaisir d’un biscuit enrobé <strong>d’un doux chocolat blanc</strong>.",
        ingredientes:
          "Édulcorants (maltitol, sirop de maltitol et acésulfame K), farine de <u>blé</u> (24,5 %), beurre de cacao, poudre de <u>lait entier</u>, farine de <u>blé</u> avec son (8,2 %), beurre (contient du <u>lait</u>), farine <u>d'avione</u> (1,5 %), poudre à lever (carbonate acide d'ammonium et carbonate acide de sodium), farine de malt <u>d'orge</u> (1 %), fécule de pomme de terre, poudre de cacao dégraissée, huile de tournesol riche en acide oléique, arômes, émulsifiants (lécithines de <u>soja</u> et de tournesol), fibres végétales, conservateur (<u>metabisulphite</u> de potassium) et vitamines [acide pantothénique (B5), thiamine (B1), vitamine A, acide folique (B9) et vitamine D)]. Peut contenir des traces de <u>fruits à coque et de sésame</u>.\n<strong>RECOMMANDATIONS</strong>: une consommation excessive peut entraîner des effets laxatifs.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%ChocolateBlanco",
        energia: "2.457 kJ, 591 kcal",
        hidratos: "66,0 g",
        polialcoholes: "33 g",
        azucares: "6,1 g",
        grasas: "24,0 g",
        saturadas: "13,9 g",
        fibra: "1,8 g",
        sal: "0,23g",
        proteinas: "7,0 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-naranja": {
        family: "chocolate",
        type: "left",
        titulo: "BSAN 0% Chocolat Orange",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinhuevo: "1",
        chocolatelovers: "1",
        intro:
          "Découvre une saveur très spéciale. Un biscuit au blé avec de l’avoine et du son, enrobé de <strong>chocolat à l'orange.</strong>",
        introDos: " ",
        introMovil:
          "Découvre une saveur très spéciale. Un biscuit au blé avec de l’avoine et du son, enrobé de <strong>chocolat à l'orange.</strong>",
        ingredientes:
          "Farine de <u>blé</u> (24,6 %), pâte de cacao, édulcorants (maltitol, sirop de maltitol, lactitol et acésulfame K), farine de <u>blé</u> avec son (8,2 %), beurre de cacao, beurre (contient du <u>lait</u>), poudre de cacao dégraissée, farine d'AVOINE (1,5%), farine de malt <u>d'orge</u> (1 %), fécule de pomme de terre, poudres à lever (carbonate acide d'ammonium et carbonate acide de sodium), huile de tournesol à haute teneur en acide oléique, poudre de <u>lait entier</u>, arômes, émulsifiants (lécithines de SOJA et de tournesol), fibres végétales, conservateur (<u>metabisulphite</u> de potassium), poudre de jus d'orange (0,04 %), vitamines [acide pantothénique (B5), thiamine (B1), vitamine A, acide folique (B9) et vitamine D] et huile essentielle d'orange (0,01%) Peut contenir des traces de <u>fruits à coque et de sésame</u>. <strong>RECOMMANDATIONS</strong> : une consommation excessive peut entraîner des effets laxatifs.",
        cantidadValor: "100g",
        hashtag: "#BSAN_0%ChocolateNaranja",
        energia: "2.375 kJ, 569 kcal",
        hidratos: "52 g",
        polialcoholes: "23,2 g",
        azucares: "3,1 g",
        grasas: "28,4 g",
        saturadas: "15,7 g",
        fibra: "8,3 g",
        sal: "0,13g",
        proteinas: "8,3 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "mix-melon-sandia": {
        family: "0-azucares",
        type: "left",
        titulo: "Mélange Melon et Pastèque 0%",
        packs: "110g",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "Bonbons mous sans sucre au goût de melon et de pastèque avec édulcorants.",
        introDos: " ",
        introMovil:
          "Bonbons mous sans sucre au goût de melon et de pastèque avec édulcorants.",
        ingredientes:
          "Édulcorants (maltitol, mannitol, sorbitol, glycosides de stéviol), dextrine, graisse végétale de coco, gélatine bovine, acidifiant (acide citrique), émulsifiant (E 471) et arômes (pastèque 0,01 % et melon 0,01 %).\nUne consommation excessive peut entraîner des effets laxatifs.",
        hashtag: "#MixMelón&Sandía",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "mix-frutos-rojos": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Frutos Rojos",
        packs: "70g, 110g, 1Kg",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Bonbons à mâcher aux édulcorants blancs aux saveurs de fraise, de myrtille et de cerise.",
        introDos: "",
        introMovil:
          "Bonbons à mâcher aux édulcorants blancs aux saveurs de fraise, de myrtille et de cerise.",
        ingredientes:
          "Édulcorants (maltitol, mannitol, sorbitol, glycosides de stéviol), dextrine, graisse végétale de coco, gélatine bovine, acidifiant (acide citrique), émulsifiant (E 471) et arômes (fraise 0,01 %, myrtille 0,01 % et cerise 0,01 %).\nUne consommation excessive peut entraîner des effets laxatifs.",
        hashtag: "#MixFrutosRojos",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "mix-5-frutas": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix 5 Frutas",
        packs: "70g, 110g, 1Kg",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Bonbons blancs à mâcher aux édulcorants aux saveurs d'ananas, d'orange, de fraise, de citron et de cerise.",
        introDos: "",
        introMovil:
          "Bonbons blancs à mâcher aux édulcorants aux saveurs d'ananas, d'orange, de fraise, de citron et de cerise.",
        ingredientes:
          "Édulcorants (maltitol, mannitol, sorbitol, glycosides de stéviol), dextrine, graisse végétale de coco, gélatine bovine, acidifiant (acide citrique), émulsifiant (E 471) et arômes (orange 0,01 %, citron 0,01 %, fraise 0,01 %, cerise 0,01% et ananas 0,01 %).\nGoûts fraise et cerise (uniquement en formats 500 g et 1 kg).\nUne consommation excessive peut entraîner des effets laxatifs.",
        hashtag: "#Mix5Frutas",
        energia: "1.097 kJ, 263 kcal",
        hidratos: "86g",
        azucares: "0g",
        polialcoholes: "79g",
        grasas: "5,1g",
        saturadas: "4,3",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      citricos: {
        family: "citrico",
        type: "left",
        titulo: "Agrumes 0%",
        hasFrutosSecos: "1",
        packs: "110g",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Bonbons sans sucre au goût d'orange et de citron avec édulcorants.",
        introDos: "",
        introMovil:
          "Bonbons sans sucre au goût d'orange et de citron avec édulcorants.",
        ingredientes:
          " <strong>Bonbons au citron</strong>: Édulcorant (sirop de maltitol), acide citrique, arôme naturel de citron (0,6 %), colorant naturel curcumine. <strong>Bonbons à l'orange</strong>: édulcorant (sirop de maltitol), acide citrique, arôme naturel d'orange (0,7%), colorant naturel bêta-carotène orange, colorant naturel bêta-carotène jaune.\nPeut contenir des traces de <u>lait, de soja, de fruits à coque</u>. Une consommation excessive peut entraîner des effets laxatifs.",
        hashtag: "#RisiCítricos",
        energia: "975 kJ, 234 kcal",
        hidratos: "97,5g",
        azucares: "0g",
        polialcoholes: "97,5g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "0g",
        sal: "0g",
        proteinas: "0g"
      },
      stevia: {
        family: "citrico",
        type: "left",
        titulo: "FruitSin Stevia",
        packs: "110g",
        hasFrutosSecos: "1",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Bonbons durs avec édulcorants (cerise, citron, fraise et orange).",
        introDos: "",
        introMovil:
          "Bonbons durs avec édulcorants (cerise, citron, fraise et orange).",
        ingredientes:
          "Édulcorants (isomalt, glycoside de stéviol 0,05%), acidifiant (acide citrique), arômes (cerise 0,5%, citron 0,5%, fraise 0,5%, orange 0,5%) et colorants (E 150d, carmin et carotènes). <br>Une consommation excessive peut avoir des effets laxatifs. ",
        hashtag: "#RisiFruitSinStevia",
        energia: "1001 kJ, 240 kcal",
        hidratos: "98,9g",
        azucares: "0,15",
        polialcoholes: "99,6g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "0,86g",
        sal: "0g",
        proteinas: "0g"
      },
      balsamicos: {
        family: "balsamicos",
        type: "left",
        titulo: "Glassmins 0%",
        packs: "105g, 500g, 1Kg",
        hasFrutosSecos: "1",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "Bonbons sans sucre au goût de menthe avec édulcorants.",
        introDos: "",
        introMovil: "Bonbons sans sucre au goût de menthe avec édulcorants.",
        ingredientes:
          "Édulcorant (sirop de maltilol), menthol (0,3 %), colorant E-131, essence d'eucalyptus et édulcorant (E950).<br>\nPeut contenir des traces de <u>lait, de soja, de fruits à coque</u>. Une consommation excessive peut entraîner des effets laxatifs.",
        hashtag: "#RisiGlassmins",
        energia: "968 kJ, 232 kcal",
        hidratos: "96,8g",
        azucares: "0g",
        polialcoholes: "96.8g",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "mix-variado": {
        family: "0-azucares",
        type: "left",
        titulo: "Mélange de fruits assortis",
        packs: "150g, 500g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        sinlactosa: "1",
        intro:
          "Bonbons mous aromatisés au citron, ananas, orange, fraise et banane.",
        introDos: "",
        introMovil:
          "Bonbons mous aromatisés au citron, ananas, orange, fraise et banane.",
        ingredientes:
          "Sirop de glucose, sucre, dextrine, graisse végétale de coco, gélatine bovine, arômes (orange 0,01 %, citron 0,01 %, fraise 0,01 %, ananas 0,0 1% et banane 0,01 %), acidifiant (acide citrique), émulsifiant (E 471) et colorants (curcuma, carmin, carotènes).\nGoût ananas (uniquement en formats 500 g et 1 kg).",
        hashtag: "#MixFrutasDelSol",
        energia: "1476 kJ, 377 kcal",
        hidratos: "88g",
        azucares: "82g",
        grasas: "2,7g",
        polialcoholes: "",
        saturadas: "2,3g",
        fibra: "",
        sal: "0g",
        proteinas: "0,5g"
      },
      "azucares-gajos": {
        family: "citrico",
        type: "left",
        titulo: "Coins",
        packs: "70g, 150g, 500g, 1Kg",
        hasFrutosSecos: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "Bonbons aromatisés à l'orange et au citron.",
        introDos: "",
        introMovil: "Bonbons aromatisés à l'orange et au citron.",
        ingredientes:
          "<strong>Bonbons à l'orange</strong>: sirop de glucose, sucre, acide citrique, arôme d'orange (0,6%), colorant naturel bêta-carotène jaune et colorant naturel bêta-carotène orange. <strong>Bonbons au citron</strong>: sirop de glucose, sucre, acide citrique, arôme de citron (0,5 %) et colorant naturel curcumine. Peut contenir des traces de <u> lait, de soja, de fruits à coque</u> ",
        hashtag: "#FrutasDelSolGajos",
        energia: "1.652 kJ, 389 kcal",
        hidratos: "97,2g",
        polialcoholes: "",
        azucares: "49,6",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      doble: {
        family: "citrico",
        type: "left",
        titulo: "Dooble",
        packs: "70g, 150g, 500g, 1Kg",
        hasFrutosSecos: "1",
        hasGluten: "0",
        sinlactosa: "0",
        intro: "Bonbons doubles au goût de banane, de fraise ou d'ananas.",
        introDos: "",
        introMovil: "Bonbons doubles au goût de banane, de fraise ou d'ananas.",
        ingredientes:
          "<strong> Bonbons à l'ananas</strong> : sirop de glucose, sucre, acide citrique, arôme d'ananas (0,4 %) et colorant naturel curcumine. <strong>Bonbons à la banane</strong> : sirop de glucose, sucre, arôme de banane (1 %), acide citrique et colorant naturel curcumine. <strong> Bonbons à la fraise</strong> : sirop de glucose, sucre, arôme de fraise (1,6 %), acide citrique, et colorant naturel anthocyanine.",
        hashtag: "#FrutasDelSolDooble",
        energia: "1.652 kJ, 389 kcal",
        hidratos: "97,2g",
        polialcoholes: "",
        azucares: "49,6",
        grasas: "0g",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "frutas-acidas": {
        family: "citrico",
        type: "left",
        titulo: "Fruits acides",
        packs: "150g",
        hasFrutosSecos: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Bonbons aromatisés au citron, à l'orange, à la pomme et à la fraise.",
        introDos: "",
        introMovil:
          "Bonbons aromatisés au citron, à l'orange, à la pomme et à la fraise.",
        ingredientes:
          "<strong>Bonbons au citron</strong>: sirop de glucose, sucre, acide citrique, arôme de citron (0,4 %) et colorant naturel curcumine. <strong>Bonbons aux pommes</strong>: sirop de glucose, sucre, acide citrique, arôme de pomme (0,8 %), colorant naturel curcumine et colorant naturel chlorophylle. <strong>Bonbons à l'orange</strong>: sirop de glucose, sucre, acide citrique, arôme d'orange (0,6%), colorant naturel bêta-carotène jaune et colorant naturel bêta-carotène orange. <strong>Bonbons à la fraise</strong>: sirop de glucose, sucre, acide citrique, arôme de fraise (1,9%), colorant naturel anthocyanine et colorant naturel bêta-carotène orange.\nPeut contenir des traces de <u>lait, de soja et de fruits à coque</u>.",
        hashtag: "#FrutasDelSolÁcidas",
        energia: "1.650 kJ, 388 kcal",
        hidratos: "97,05g",
        azucares: "36,1g",
        grasas: "0g",
        polialcoholes: "",
        saturadas: "0g",
        fibra: "",
        sal: "0g",
        proteinas: "0g"
      },
      "nueces-en-grano": {
        family: "frutos-secos",
        type: "left",
        titulo: "Nueces en grano",
        packs: "50g, 90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Les noix décortiquées et les cerneaux de noix, l'un des fruits à coque par excellence. ",
        introDos:
          "Saines et savoureuses. Un aliment indispensable à avoir dans ses placards.",
        introMovil:
          "Les noix décortiquées et les cerneaux de noix, l'un des fruits à coque par excellence.",
        ingredientes:
          "Cerneaux de <u>noix </u>de Californie. Contient des noix. Peut contenir des traces de cacahuète et d'autres <u>fruits à coque.</u>. \n\n    ",
        cantidadValor: "100g",
        hashtag: "#NuecesEnGrano",
        energia: "2.745 kJ, 666 kcal",
        hidratos: "2,5 g",
        polialcoholes: "",
        azucares: "1,8 g",
        grasas: "64 g",
        saturadas: "6,3 g",
        fibra: "",
        sal: "<0,01 g",
        proteinas: "16 g",
        mostrarSinLactosa: "1"
      },
      "pistachos-tostados": {
        family: "frutos-secos",
        type: "left",
        titulo: "Pistachos tostados y al punto de sal",
        packs: "50g 80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Pistaches, l'un des fruits secs préférés des petits et des grands. Torréfiées et avec une touche de sel. ",
        introDos:
          "Incorporez-les dans vos recettes ou utilisez-les comme en-cas, c'est vous qui décidez!",
        introMovil:
          "Pistaches, l'un des fruits secs préférés des petits et des grands. Torréfiées et avec une touche de sel. ",
        ingredientes:
          "Cerneaux de noix de Californie. Contient des noix. Peut contenir des traces de <u>cacahuète</u> et d'autres <u>fruits à coque</u>.",
        cantidadValor: "100g",
        hashtag: "#PistachosTostados",
        energia: "2.565 kJ, 620 kcal",
        hidratos: "6,4 g",
        polialcoholes: "",
        azucares: "6,4 g",
        grasas: "52 g",
        saturadas: "6,5 g",
        fibra: "",
        sal: "1,3 g",
        proteinas: "26 g",
        mostrarSinLactosa: "1"
      },
      "cacahuetes-fritos": {
        family: "frutos-secos",
        type: "left",
        titulo: "Cacahuetes fritos y salados",
        packs: "80g, 110g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Sans cacahuètes, un film ou une série n'auraient pas la même intérêt. ",
        introDos:
          "Grillées, croustillantes et savoureuses grâce à la juste dose de sel. Un ingrédient indispensable à toujours avoir dans ses placards.",
        introMovil:
          "Sans cacahuètes, un film ou une série n'auraient pas la même intérêt.",
        ingredientes:
          "<u>Cacahuète</u> sans peau, huile végétale de tournesol et sel. Contient des cacahuètes. Peut contenir des traces de <u>fruits secs</u>.",
        cantidadValor: "100g",
        hashtag: "#CacahuetesFritos",
        energia: "2.617 kJ, 632 kcal",
        hidratos: "8,2 g",
        polialcoholes: "",
        azucares: "4,2 g",
        grasas: "53 g",
        saturadas: "8,7 g",
        fibra: "",
        sal: "0,96 g",
        proteinas: "27 g",
        mostrarSinLactosa: "1"
      },
      "anacardos-fritos": {
        family: "frutos-secos",
        type: "left",
        titulo: "Anacardos fritos y salados",
        packs: "55g, 80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Savourez un en-cas délicieux et sain, parfait pour grignoter entre les repas.",
        introDos: " ",
        introMovil:
          "Savourez un en-cas délicieux et sain, parfait pour grignoter entre les repas.",
        ingredientes:
          "<u>Noix de cajou</u>, huile végétale de tournesol et sel. Contient de la <u>noix de cajou</u>. Peut contenir des traces de cacahuète et d'autres <u>fruits à coque</u>. ",
        cantidadValor: "100g",
        hashtag: "#AnacardosFritos",
        energia: "2.552 kJ, 615 kcal",
        hidratos: "26 g",
        polialcoholes: "",
        azucares: "5,1 g",
        grasas: "48 g",
        saturadas: "9,5 g",
        fibra: "",
        sal: "0,07 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "avellanas-tostadas": {
        family: "frutos-secos",
        type: "left",
        titulo: "Avellanas tostadas",
        packs: "80g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Savourez les délicieuses noisettes comme collation et comme garniture croustillante parfaite pour vos desserts.",
        introDos: "",
        introMovil:
          "Savourez les délicieuses noisettes comme collation et comme garniture croustillante parfaite pour vos desserts.",
        ingredientes:
          "<u>Noisette</u> en grains. Contient de la <u>noisette</u>. Peut contenir des traces de <u>cacahuètes</u> et autres <u>noix</u>.",
        cantidadValor: "100g",
        hashtag: "#AvellanasTostadas",
        energia: "2.910 kJ, 706 kcal",
        hidratos: "2,7 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "67 g",
        saturadas: "5,5 g",
        fibra: "",
        sal: "0,03 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "almendras-fritas": {
        family: "frutos-secos",
        type: "left",
        titulo: "Almendras fritas y saladas",
        packs: "55g, 90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Les amandes frites et salées, une touche croquante et salée parfaite pour égayer n'importe quel moment. Et elles sont encore meilleures si vous les partagez!",
        introDos:
          " Grillées et croustillantes grâce à leur procédé de fabrication. Un incontournable en cuisine!",
        introMovil:
          "Si vous pensez aux noix, vous pensez sûrement aux amandes. L'une des noix les plus classiques.",
        ingredientes:
          "<u>Amande</u> sans peau, huile végétale de tournesol et sel. Contient de <u>l'amande</u>. Peut contenir des traces de cacahuète et d'autres <u>fruits à coque</u>.",
        cantidadValor: "100g",
        hashtag: "#AlmendrasFritas",
        energia: "2.526 kJ, 611 kcal",
        hidratos: "52 g",
        azucares: "4,3 g",
        polialcoholes: "",
        grasas: "52 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "0,80 g",
        proteinas: "25 g",
        mostrarSinLactosa: "1"
      },
      "mix-frito": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix frito",
        packs: "70g, 100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "Le mélange classique, celui qui ne fait jamais défaut.   ",
        introDos: "Appréciez sa variété de saveurs et de textures !",
        introMovil: "Le mélange classique, celui qui ne fait jamais défaut.",
        ingredientes:
          "Maïs frit et salé, <u>cacahuètes</u> frites et salées sans peau, <u>cacahuètes</u> frites et salées avec peau, pois chiches frits et salés, haricots frits et salés, huile végétale de tournesol et sel. Contient des cacahuètes. Peut contenir des traces de <u>fruits secs à coque</u>. ",
        cantidadValor: "100g",
        hashtag: "#MixFrito",
        energia: "1.814kJ, 436 kcal",
        hidratos: "30 g",
        azucares: "2,5 g",
        polialcoholes: "",
        grasas: "28 g",
        saturadas: "4 g",
        fibra: "",
        sal: "1,5 g",
        proteinas: "14 g",
        mostrarSinLactosa: "1"
      },
      "mix-bbq": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix barbacoa",
        packs: "80g, 100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Parfait pour ceux qui cherchent à combiner en une seule bouchée la texture   ",
        introDos:
          "et les propriétés des fruits secs au goût intense du barbecue.",
        introMovil:
          "Parfait pour ceux qui cherchent à combiner en une seule bouchée la texture   ",
        ingredientes:
          "<u>Cacahuètes</u> frites et salées (cacahuètes avec peau, cacahuètes sans peau, huile végétale de tournesol, sel), produit apéritif cuit au four goût barbecue (semoule de maïs, semoule de riz, sucre, huile végétale de tournesol, arôme barbecue, (arômes, arôme de fumée, maltodextrine, sel, exhausteurs de goût : E-621 et E-631), maïs frit goût barbecue (maïs, huile végétale de tournesol, sel, assaisonnement barbecue, (herbes, maltodextrine, épices, tomate séchée, sel, arôme de fumée), exhausteur de goût E-621), cacahuètes enrobées goût barbecue (cacahuètes, farine de maïs, sel, sucre, amidon de maïs modifié, amidon de maïs, huile végétale de tournesol, assaisonnement barbecue (maltodextrine, épices, tomate séchée, sel, arôme de fumée), exhausteur de goût E-621.\nContient des <u>cacahuètes</u>. Peut contenir des <u>fruits à coque</u>.",
        cantidadValor: "100g",
        hashtag: "#MixBBQ",
        energia: "2.150kJ, 518 kcal",
        hidratos: "25 g",
        azucares: "4 g",
        polialcoholes: "",
        grasas: "37 g",
        saturadas: "5,8 g",
        fibra: "",
        sal: "1,7 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "mix-picante": {
        family: "frutos-secos",
        type: "left",
        titulo: "Mix picante",
        packs: "90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "Mélange d'arachides frites et salées,",
        introDos:
          "de maïs frit et de produit apéritif cuit au four goût chili.",
        introMovil: "Mélange d'arachides frites et salées,",
        ingredientes:
          "<u>Arachides</u> frites et salées (arachides avec peau, arachides sans peau, huile végétale de tournesol et sel), maïs frit goût chili (maïs, huile végétale de tournesol, condiment à base de chili (maltodextrine, oignon, poivre, tomate séchée, ail, paprika, piment de Cayenne, sel), sel, huile de paprika (colorant (extrait de paprika)), exhausteur de goût (E-621)) et produit apéritif cuit au four goût chili (semoule de maïs, semoule de riz, huile végétale de tournesol, sucre, arôme chili (arômes, exhausteurs de goût (E-621, E-631, E-627), colorant (extrait de paprika)) et sel.",
        cantidadValor: "100g",
        hashtag: "#MixPicante",
        energia: "2.159kJ, 517 kcal",
        hidratos: "44 g",
        azucares: "3,6 g",
        polialcoholes: "",
        grasas: "30 g",
        saturadas: "4,1 g",
        fibra: "5,7 g",
        sal: "1,9 g",
        proteinas: "15 g",
        mostrarSinLactosa: "1"
      },
      "avellanas-tostadas-1kg": {
        family: "frutos-secos-1kg",
        type: "left",
        titulo: "Avellanas tostadas",
        packs: "1kg",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro: "Savourez les délicieuses noisettes en collation,",
        introDos:
          " como el topping crujiente y dulce perfecto para tus postres.",
        introMovil: "Savourez les délicieuses noisettes en collation,",
        ingredientes:
          "<u>Avellana</u> con piel. Contiene <u>Avellana</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#AvellanaTostada",
        energia: "2.910 kJ, 706 kcal",
        hidratos: "2,7 g",
        polialcoholes: "",
        azucares: "2,4 g",
        grasas: "67 g",
        saturadas: "5,5 g",
        fibra: "",
        sal: "0,03 g",
        proteinas: "18 g",
        mostrarSinLactosa: "1"
      },
      "pipas-saladas": {
        family: "pipas",
        type: "left",
        titulo: "Pipas Saladas",
        packs: "40g, 90g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Graines de tournesol salées, les plus classiques. Lorsque l'on commence, on ne s'arrête plus.",
        introDos: "",
        introMovil:
          "Graines de tournesol salées, les plus classiques. Lorsque l'on commence, on ne s'arrête plus.",
        ingredientes:
          "Graines de tournesol, sel et farine de riz. Peut contenir des traces de <u>cacahuète</u> et d'autres <u>fruits à coque</u>. ",
        cantidadValor: "100g",
        hashtag: "#PipasSaladas",
        energia: "2.561kJ, 619 kcal",
        polialcoholes: "",
        hidratos: "3,3 g",
        azucares: "3,3 g",
        grasas: "52 g",
        saturadas: "6,4 g",
        fibra: "11 g",
        sal: "7,1 g",
        proteinas: "29 g",
        mostrarSinLactosa: "1"
      },
      "pipas-aguasal": {
        family: "pipas",
        type: "left",
        titulo: "Pipas Aguasal",
        packs: "90g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "À tout moment et en tout lieu, vous pouvez déguster les graines de tournesol Aguasal.",
        introDos: "On commence?",
        introMovil:
          "À tout moment et en tout lieu, vous pouvez déguster les graines de tournesol Aguasal.",
        ingredientes:
          "Graines de tournesol, sel et farine de riz. Peut contenir des traces de <u>cacahuète</u> et d'autres <u>fruits à coque</u>.",
        cantidadValor: "100g",
        hashtag: "#PipasAguasal",
        energia: "2.589kJ, 626 kcal",
        hidratos: "4,8 g",
        azucares: "3,1 g",
        grasas: "52 g",
        saturadas: "6,7 g",
        polialcoholes: "",
        fibra: "9,2 g",
        sal: "2,3 g",
        proteinas: "30 g",
        mostrarSinLactosa: "1"
      },
      "mix-antiox": {
        family: "mix-antiox",
        type: "left",
        titulo: "Mix Antiox",
        packs: "100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "La combinación rica en antioxidantes perfecta para tus ensaladas:",
        introDos:
          " California, almendras, pistachos, pasas, pipas de girasol y arándanos. ¡ A disfrutar!",
        introMovil:
          "La combinación rica en antioxidantes perfecta para tus ensaladas.",
        ingredientes:
          "<u>Almendras</u> peladas crudas, semillas de girasol peladas crudas, trozos de <u>nueces</u>, arándanos desecados (arándanos, azúcar, aceite vegetal de girasol), uvas pasas sin semilla (pasas y aceite vegetal de girasol) y <u>pistachos</u> en grano crudos. Puede contener <u>cacahuetes</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#MixAntiox",
        energia: "2.297kJ, 554 kcal",
        hidratos: "24 g",
        azucares: "24 g",
        polialcoholes: "",
        grasas: "42 g",
        saturadas: "4,2 g",
        fibra: "",
        sal: "0,01 g",
        proteinas: "17 g",
        mostrarSinLactosa: "1"
      },
      "mix-equilibrio": {
        family: "mix-equilibrio",
        type: "left",
        titulo: "Mix Equilibrio",
        packs: "100g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Si buscas un picoteo sano, sabroso y 100% saludable, el Mix Equilibrio es la opción perfecta para ti.",
        introDos: "",
        introMovil:
          "Si buscas un picoteo sano, sabroso y 100% saludable, el Mix Equilibrio es la opción perfecta para ti.",
        ingredientes:
          "<u>Avellanas</u> crudas peladas, <u>almendras</u> crudas peladas, <u>nueces pecanas</u> en grano crudas, trozos de <u>nueces</u>. Contiene <u>avellanas, almendras, pecanas y nueces</u>. Puede contener trazas de <u>cacahuete</u> y otros <u>frutos de cáscara</u>.",
        cantidadValor: "100g",
        hashtag: "#MixEquilibrio",
        energia: "2.781kJ, 674 kcal",
        hidratos: "3,1 g",
        azucares: "2,9 g",
        polialcoholes: "",
        grasas: "64 g",
        saturadas: "5,6 g",
        fibra: "",
        sal: "0 g",
        proteinas: "16 g",
        mostrarSinLactosa: "1"
      },
      "patata-sal-al-punto": {
        family: "patata-sal-al-punto",
        type: "left",
        titulo: "Sal al punto",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Les chips à l'ancienne, toutes simples, avec la quantité parfaite de sel. Elles sont si <strong>irrésistibles</strong> que si vous y goutez, vous <strong>ne pourrez plus vous arrêter</strong>.",
        introDos: "",
        introMovil:
          "Les chips à l'ancienne, toutes simples, avec la quantité parfaite de sel. Elles sont si <strong>irrésistibles</strong> que si vous y goutez, vous <strong>ne pourrez plus vous arrêter</strong>.",
        ingredientes:
          "Pommes de terre, huile de tournesol (26 %) et sel (1,4 %). Peut contenir des protéines de <u>lait</u>. ",
        cantidadValor: "125g",
        hashtag: "#SalAlPunto",
        energia: "2.002kJ, 479 kcal",
        hidratos: "54,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        mostrarSinLactosa: "1"
      },
      campesinas: {
        family: "campesinas",
        type: "left",
        titulo: "Campesinas",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "De délicieuses chips avec une <strong>touche aromatique d'herbes</strong> rappelant la fraîcheur et l'authenticité de la campagne.",
        introDos: "",
        introMovil:
          "De délicieuses chips avec une <strong>touche aromatique d'herbes</strong> rappelant la fraîcheur et l'authenticité de la campagne.",
        ingredientes:
          "Pommes de terre, huile de tournesol (26%), arôme campagnard [sucre, sel, dextrose, exhausteurs de goût (E-621 et E-635), oignon, persil, tomate et ail en poudre, extrait de levure, acidifiants (acide malique et acide citrique), colorant (extrait de paprika) et arôme de fumée]. Peut contenir des <u>protéines de lait</u>.",
        cantidadValor: "125g",
        hashtag: "#Campesinas",
        energia: "1.974kJ, 472 kcal",
        hidratos: "53,5 g",
        azucares: "1,6 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "6 g",
        mostrarSinLactosa: "1"
      },
      vinagreta: {
        family: "vinagreta",
        type: "left",
        titulo: "Vinagreta",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Les chips les plus savoureuses avec une saveur intense de <strong>vinaigrette</strong> et une touche de sel. Les véritables amateurs de saveurs gourmandes ne pourront pas y résister.",
        introDos: "",
        introMovil:
          "Les chips les plus savoureuses avec une saveur intense de <strong>vinaigrette</strong> et une touche de sel. Les véritables amateurs de saveurs gourmandes ne pourront pas y résister.",
        ingredientes:
          "Pommes de terre, huile de tournesol (26 %), arôme de vinaigre et sel [arômes, sel (1,4 %), sucre, maltodextrine et acidifiants (acide citrique et acide malique)]. Peut contenir des <u>protéines de lait</u>.",
        cantidadValor: "125g",
        hashtag: "#Vinagreta",
        energia: "1.907kJ, 456 kcal",
        hidratos: "51,7 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "3,9 g",
        mostrarSinLactosa: "1"
      },
      "jamon-onduladas": {
        family: "jamon-onduladas",
        type: "left",
        titulo: "Jamón",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "1",
        intro:
          "Qui peut résister à une chips ondulée et croustillante au bon goût de jambon? <strong>Vous allez adorer la saveur intense</strong> de ces délicieuses chips légendaires.",

        introDos: "",
        introMovil:
          "Qui peut résister à une chips ondulée et croustillante au bon goût de jambon? ",
        ingredientes:
          "Pommes de terre, huile de tournesol (25 %), arôme de jambon [maltodextrine, sel, arôme, arôme de fumée et acidifiant (acide malique)]. Peut contenir des <u>protéines de lait</u>. ",
        cantidadValor: "125g",
        hashtag: "#Jamón",
        energia: "2.048kJ, 490 kcal",
        hidratos: "57,5 g",
        azucares: "0,5 g",
        polialcoholes: "",
        grasas: "25 g",
        saturadas: "3,2 g",
        fibra: "",
        sal: "1,6 g",
        proteinas: "6,4 g",
        mostrarSinLactosa: "1"
      },
      "originales-onduladas": {
        family: "originales-onduladas",
        type: "left",
        titulo: "Originales",
        packs: "125g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Les chips les plus croustillantes et les plus intenses, agrémentées de la parfaite touche de sel. Ondulées et <strong>irrésistiblement crunchy</strong>.",
        introDos: "",
        introMovil:
          "Les chips les plus croustillantes et les plus intenses, agrémentées de la parfaite touche de sel. Ondulées et <strong>irrésistiblement crunchy</strong>.",
        ingredientes:
          "Pommes, de terre, huile de tournesol (32,1 %) et sel (1,4 %). Peut contenir des <u>protéines de lait</u>",
        cantidadValor: "125g",
        hashtag: "#Originales",
        energia: "2.206kJ, 529 kcal",
        hidratos: "54,5 g",
        azucares: "0,8 g",
        polialcoholes: "",
        grasas: "32,1 g",
        saturadas: "3,9 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "5,4 g",
        mostrarSinLactosa: "1"
      },
      "sour-cream-onion": {
        family: "sour-cream-onion",
        type: "left",
        titulo: "Sour Cream & Onion",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Pour les amateurs de la saveur intense de la <strong>crème aigre et de l'oignon</strong>, voici cette recette très spéciale sur une base de chips naturelle, croustillante et surprenante.",
        introDos: "",
        introMovil:
          "Pour les amateurs de la saveur intense de la <strong>crème aigre et de l'oignon</strong>, voici cette recette très spéciale sur une base de chips naturelle, croustillante et surprenante.",
        ingredientes:
          "Pommes de terre, huile de tournesol (26 %), arôme crème acidifiée et oignon [arômes, farine de riz, sel, sucre, maltodextrine, acidifiants (acide citrique et acide malique) et régulateur d'acidité (E-327)]. Peut contenir des </u>protéines de lait</u>",
        cantidadValor: "125g",
        hashtag: "#SourCreamOnion",
        energia: "2.082kJ, 498 kcal",
        hidratos: "57,4 g",
        azucares: "1,7 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,5 g",
        proteinas: "6,2 g",
        mostrarSinLactosa: "1"
      },
      "york-queso": {
        family: "york-queso",
        type: "left",
        titulo: "York&Queso",
        packs: "40g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Il n'y a pas de meilleure combinaison au monde que des chips croustillantes au <strong>jambon et au fromage</strong>. Oooohhhhhhhhhhh",
        introDos: "",
        introMovil:
          "Il n'y a pas de meilleure combinaison au monde que des chips croustillantes au <strong>jambon et au fromage</strong>. Oooohhhhhhhhhhh",
        ingredientes:
          "Pommes de terre, huile de tournesol (26 %), arôme jambon et fromage [arôme (contient du lait), arôme de fumée, sel, maltodextrine, sucre et colorant (extrait de paprika)]. ",
        cantidadValor: "125g",
        hashtag: "#YorkQueso",
        energia: "2.090kJ, 500 kcal",
        hidratos: "58 g",
        azucares: "2,9 g",
        polialcoholes: "",
        grasas: "26 g",
        saturadas: "3,3 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,3 g",
        mostrarSinLactosa: "1"
      },
      "selectas-clasicas": {
        family: "selectas-clasicas",
        type: "left",
        titulo: "Selectas Clásicas",
        packs: "100g, 125g, 150g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "Les chips les plus traditionnelles, soigneusement préparées à la poêle. Un authentique <strong>goût original et traditionnel</strong> en une seule bouchée.",
        introDos: "",
        introMovil:
          "Les chips les plus traditionnelles, soigneusement préparées à la poêle. Un authentique <strong>goût original et traditionnel</strong> en une seule bouchée.",
        ingredientes:
          "Pommes de terre, huile de tournesol (30 %) et sel. Peut contenir des <u>protéines de lait</u>.",
        cantidadValor: "125g",
        hashtag: "#SelectasClásicas",
        energia: "2.328kJ, 558 kcal",
        hidratos: "54,1 g",
        azucares: "1 g",
        polialcoholes: "",
        grasas: "34,8 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        mostrarSinLactosa: "0"
      }
    },
    historia: {
      inicio: "Accueil",
      nuestra: "Notre",
      historia: "histoire",
      descrip1:
        "Le rouge des Palomitas, le vert des Gusanitos et le blanc des Risketos... Quel enfant né entre les années 70 et aujourd'hui ne reconnaît pas ces couleurs?",
      descrip2:
        "Nous vous racontons comment tout a commencé .... Voici notre histoire.",
      yummy1970: "Spécialiste du grignotage <brdepuis 1970",
      nuestros: "Nos",
      origenes: "origines",
      descrip3:
        "La nature entrepreneuriale de la famille Gómez-Cuétara a conduit à l'acquisition de l'entreprise Chips Ibérica S.A., située à Torrejón de Ardoz, en 1970.",
      descrip4:
        "L'usine a été rénovée et modernisée pour se consacrer exclusivement à la fabrication de chips, qui constituaient à l'époque le principal apéritif connu en Espagne.",
      unaSonrisa: "Un sourire pour affronter les",
      momentos: "moments difficiles!",
      descrip5:
        "En 1975, tous les espoirs placés dans ce projet naissant ont été réduits à néant par un incendie qui a totalement détruit l'usine et toutes ses machines.",
      plantarCara: "Pour faire face à l'adversité!",
      descrip6:
        " La force et l'optimisme de la famille fondatrice lui ont permis de ne pas baisser les bras en cette période difficile. Au contraire ! C'est à ce moment-là qu'elle a décidé de transférer l'usine de Torrejón de Ardoz à Daganzo de Arriba. Mais ce n'est pas tout! L'entreprise a également décidé d'étendre la production de chips aux snacks et aux apéritifs au maïs.",
      yAhoraSi: "Et maintenant, voici Risi!",
      descrip7:
        "Les marques les plus célèbres de Risi voient le jour : Gusanitos, Palomitas, Pajitas, Triskys et Risketos. Toujours accompagnées de l'un des éléments les plus précieux et les plus reconnaissables de la marque à ce jour, son logo, l'enfant au sourire éternel. ",
      risiLogo: "Risi Logo",
      descrip8: "Comment l'entreprise est-elle passée de l'usine de",
      descrip9: "chips à la production de produits apéritifs ?",
      descrip10:
        "Tout cela a été rendu possible en intégrant la technique de l'extrusion du maïs. Une technique qui permet de donner différentes formes à la matière première au moyen de la pression et de la température.",
      epocaDorada: "Un âge d'or !",
      descrip11:
        "Entre les années 80 et 90, Risi était connu et admiré par tous les enfants espagnols.",
      descrip12:
        "Qui ne se souvient pas d'avoir vu des sacs Risi dans les cartables, sur les terrains de jeux, dans les parcs, dans les magasins et les kiosques du quartier, et à tous les anniversaires ?",
      descrip13: "Nous abordons les problèmes avec le sourire",
      descrip14:
        "Malgré le succès des en-cas et leur grande acceptation par le public, de nouveaux problèmes surviennent dans l'entreprise et entraînent sa fermeture pendant un an.",
      descrip15:
        "Cependant, chez Risi, le sourire est toujours au rendez-vous et, après sa fermeture, l'entreprise a été reprise par un grand entrepreneur, Juan Gómez-Cuétara, qui, grâce à sa vision, à ses efforts et à une équipe d'excellents collaborateurs, est parvenu à redresser la situation. Après des années de travail acharné, d'engagement et de dévouement, Risi est devenue l'une des principales entreprises du secteur. ",
      nuevoCambio: "Un grand changement!",
      estrenamos: "Nous ouvrons une nouvelle",
      fabrica: "usine!",
      descrip16:
        "Sous la direction de Juan Gómez-Cuétara et de la nouvelle équipe de collaborateurs, Risi atteint son record historique de ventes. Compte tenu du succès de nos produits, il est nécessaire de construire de nouvelles installations dotées des technologies les plus récentes et d'un espace suffisant pour répondre à la forte demande.",
      descrip17:
        "Risi acquiert une usine de chips dans la ville de Loeches, en Espagne. Afin de renforcer la gamme, les chips classiques sont complétées par des chips ondulées et des chips classiques cuites à la poêle.",
      descrip18:
        "Un changement de génération s'opère, Juan et Marta Gómez-Cuétara prenant la direction de l'entreprise et entamant une période passionnante de professionnalisation et de croissance.",
      descrip19:
        "Risi célèbre son 40e anniversaire avec une augmentation des ventes de 7 %.",
      descrip20:
        "Pour Risi, cette année a été très importante, car c'est à ce moment là que nous avons décidé de révolutionner notre activité. L'entreprise a lancé deux nouvelles catégories : les biscuits et les bonbons.",
      hoyYSiempreContigo: "AUJOURD'HUI ET TOUJOURS AVEC VOUS",
      cumplimos50: "Nous fêtons no 50 ans à vos côtés!",
      celebralo: "Fêtez-les avec nous!",
      viajamosFabs:
        " <strong>Nous voyageons au Mexique, en Tanzanie et au Vietnam avec FABS ORIGIN!</strong><br> . <br> ¡En Risi, seguimos innovando! ",
      presentamos:
        "Nous vous présentons les (nouvelles) chips traditionnelles, celles de Risi!",
      descrip21:
        "Ces délicieuses chips que nous fabriquons depuis 1970, nous les fabriquons encore aujourd'hui avec le même amour et les mêmes recettes depuis toujours. Parce que chez Risi, nous n'avons pas de secrets ni de formules magiques, nous faisons simplement de bonnes chips, avec les meilleurs ingrédients et des saveurs authentiques.",
      slide2:
        "RISI dispose d'une vaste flotte de véhicules de transport lourds et légers dans toute l'Espagne afin de garantir que ses produits atteignent toutes les parties de la péninsule ibérique. ",
      slide2_1:
        "Les CHIPS sont transportées jusqu'au réseau national de distributeurs de RISI, d'où elles sont acheminées vers les magasins, les bars, les cafés, etc.",
      slide2_2:
        "Le matin, lorsque le soleil se lève à l'horizon, l'activité commerciale de RISI fait vibrer les entrepôts.",
      forLittle: "Nous lançons une gamme pour les plus petits de la maison:",
      descrip22:
        "Le nouveau BSAN PLUS+, avec une image plus drôle que jamais et un nouveau compagnon d'aventure, Nikoala. Ils ont un profil nutritionnel idéal pour les snacks puisqu'ils sont élaborés à base de céréales, enrichis de 5 vitamines et sans huile de palme, et ils sont également présentés en 4 sachets individuels pratiques à emporter."
    },
    risihoy: {
      especialistas: "Spécialiste des snacks et des apéritifs",
      subtitulo:
        "Nous sommes une entreprise familiale espagnole avec plus de 50 ans d'histoire, spécialisée dans la fabrication de snacks et de produits apéritifs.",
      descrip1:
        "<strong>Forts de notre passion et de notre dévouement</strong>, nous fabriquons actuellement plus de 250 millions de sachets de <strong>produits apéritifs</strong>, déclinés en plus de 60 présentations, dont les emblématiques <strong>Gusanitos, Palomitas, Risketos, Triskys</strong> et le plus adulte d'entre eux, <strong>Míos!</strong>",
      "descrip1-1":
        "Mais bien sûr, nous disposons de bien d'autres produits.... Découvrez tous nos apéritifs et snacks !",
      "descrip1-2":
        "De plus, la famille des snacks et apéritifs a été rejointe <strong>à partir de 2019 par les biscuits et les bonbons</strong>.",
      descubre: "Découvrez nos produits",
      nuestrosValores: "NOS VALEURS",
      descrip2:
        "Depuis plus de 50 ans d'histoire, la fidélité à nos valeurs fondamentales nous a permis de devenir aujourd'hui une marque de premier plan dans notre secteur.",
      equipo: "ÉQUIPE",
      descrip3:
        "Nous entendons promouvoir une <strong> entreprise</strong>  composée de personnes qui développent leur potentiel en contribuant à l'objectif commun et en collaborant pour l'atteindre, les <strong>intérêts de l'entreprise</strong> étant alignés sur ceux de l'individu.",
      simplificacion: "SIMPLIFICATION",
      descrip4:
        "Nous entendons promouvoir une entreprise où les choses sont faciles et où les processus, <strong>les informations et les activités sont rationalisés</strong>, sans perte de temps ni complications inutiles.",
      felicidad: "BONHEUR",
      descrip5:
        "Queremos una organización en la que <strong>se respire buen ambiente</strong> tanto colectivo como individual, con personas comunicativas, positivas y sonrientes que disfruten en el  trabajo y con el resto de personas de la empresa. \nNous entendons promouvoir une entreprise dans laquelle <strong>règne une bonne ambiance</strong> collective et individuelle, avec des personnes communicatives, positives et souriantes qui aiment leur travail et apprécient les autres membres de l'entreprise.",
      integridad: "INTÉGRITÉ",
      descrip6:
        "Nous entendons promouvoir une entreprise composée de personnes <strong>dotées de valeurs</strong> solides et profondes, désireuses de se développer et d'aider leurs collègues et l'organisation à se développer, dans un contexte où la personne est au centre des préoccupations.",
      liderazgo: "LEADERSHIP INDIVIDUEL",
      descrip7:
        "Nous entendons promouvoir une entreprise composée de personnes capables de faire bouger les choses. <strong>Des personnes qui réalisent pleinement leur potentiel</strong>  individuel dans un contexte de travail d'équipe."
    },
    bannerRsc: {
      titulo: "Engagement",
      subtitulo:
        "Chez RISI, nous travaillons pour offrir des moments de bonheur, conscients que ces moments ne dureront pas s'ils ne sont pas basés sur le respect de l'environnement et des personnes, en particulier de nos employés et des consommateurs. Avec cet objectif, nous développons un engagement ferme en faveur de la durabilité, qui repose sur trois lignes d'action : <strong>les engagements environnementaux, l'engagement envers les personnes et la bonne gouvernance<strong>.",
      descrip1:
        "Notre déclaration d'information non financière détaille nos objectifs de développement durable et les progrès réalisés au cours de la dernière année.",
      informeRsc: "RAPPORT EINF 2023"
    },
    codigoconducta: {
      titulo: "Code de<br>Conduite",
      subtitulo:
        "Risi respecte les règles avec vous, et grâce à vous, nous les respectons toutes.",
      download: "Télécharger le code de conduite",
      cartapresidente: {
        titulo: "LETTRE",
        descrip1: "Chers tous et toutes,",
        descrip2:
          "Notre entreprise existe depuis 50 ans. En 1970, nous nous sommes engagés sur la voie passionnante qui nous a conduits à ce que nous sommes aujourd'hui. Au fil des ans, nous avons grandi, nous avons évolué et nous avons renforcé l'identité de notre entreprise.",
        descrip3:
          "La <strong>Mission et la Vision</strong> sont au cœur de notre vie professionnelle, mais cela ne suffirait pas si nous n'y ajoutions pas les <strong>Valeurs</strong>, qui sont la culture de notre entreprise, notre cœur et notre ADN, qui doivent régir notre façon de faire aujourd'hui et nous aider à transformer l'avenir.",
        descrip4:
          "Cet effort doit s'accompagner d'un <strong>code de conduite</strong> qui porte notre organisation au plus haut niveau et la prépare à répondre aux exigences législatives, à défendre les droits de l'homme et à être compétitive dans un avenir en mutation. Ce code devra guider toutes nos actions, tant en interne que dans nos relations avec nos consommateurs, nos clients, nos fournisseurs et la société.",
        descrip5:
          "Je vous encourage à le lire, à réfléchir à son contenu et à l'intégrer à votre vie quotidienne. La somme des comportements de tous les membres de l'entreprise est une responsabilité commune, et nous comptons sur vous pour nous aider à la mettre en pratique.",
        descrip6:
          "Il ne me reste plus qu'à remercier toutes les personnes qui, au cours de ces 50 années, ont permis à Risi de devenir une grande entreprise.",
        descrip7: "Cordialement,"
      },
      principiosgenerales: {
        titulo: "Principios<br>generales",
        subtitulo: "Transformando<br>el futuro con valores",
        vision: "Vision",
        descrip1:
          "Développer une entreprise basée sur les marques et devenir des acteurs de premier plan du marché national de l'achat <strong>«impulsif»</strong>. \n\n    \n\n    ",
        mision: "Mission",
        descrip2:
          "Nous réaliserons une <strong>croissance organique</strong> supérieure au marché qui nous fera gagner des parts de marché de manière durable/rentable.",
        descrip3:
          "La réalisation sera basée sur la connaissance de nos clients/canaux et consommateurs, valorisant les marques, le trade marketing, la visibilité et la diffusion.",
        descrip4:
          "Nous <strong>développerons un système de distribution</strong> dans le canal impulsif qui nous permettra d'atteindre efficacement le plus grand nombre de clients et de points de vente.",
        descrip5:
          "L'apport de l'innovation et des nouvelles activités contribuera à la croissance de l'entreprise au-delà des activités traditionnelles.",
        alcance: "Portée",
        descrip6:
          "Compte tenu de l'environnement réglementaire actuel, le Conseil d'Administration de Risi a décidé d'élaborer ce Code de Conduite dans le but de maintenir et de promouvoir les normes éthiques les plus élevées dans le développement de l'activité commerciale de la Société.",
        descrip7:
          "Ce document est destiné à servir de guide pour les actions de tous les employés, gestionnaires et administrateurs, inspirant la prise de décision quotidienne et l'activité quotidienne de Risi.",
        descrip8:
          "Le Code de Conduite est obligatoire pour les organes directeurs de Risi, tant les dirigeants que les salariés, quelle que soit leur fonction et leur situation géographique et pour l'ensemble des activités ou opérations sur titres que nous menons. Cette valeur ajoutée doit également nous servir de guide dans nos relations avec les partenaires et les tiers.",
        descrip9:
          "A cet égard, le Conseil d'Administration de Risi a convenu de nommer un Compliance Officer qui sera chargé, entre autres fonctions, d'assurer le déploiement, l'aide et la compréhension de tous les collaborateurs, ainsi que la vérification périodique du respect effectif du Code de Conduire."
      },
      risiempleados: {
        titulo: "Risi et ses<br>personnel",
        comportamientos: "COMPORTEMENTS",
        descrip1:
          "L'entreprise s'engage à <strong>prévenir et à corriger</strong> toute manifestation ou conduite qui pourrait être considérée comme violente, harcelante sous quelque forme que ce soit, discriminatoire ou intimidante, et à <strong>veiller à ce que les droits</strong> de toutes les personnes qui travaillent chez RISI soient respectés.",
        descrip2:
          "Pour leur part, le personnel et la direction de RISI s'engagent à prévenir et à signaler tout comportement de ce type et à maintenir un environnement de travail propice à l'épanouissement professionnel de l'ensemble du personnel. C'est pourquoi le respect de nos valeurs doit guider nos actions : leadership individuel, intégrité, bonheur, simplification et travail d'équipe.",
        confidencialidad: "CONFIDENTIALITÉ",
        descrip3:
          "RISI s'engage à <strong>respecter le caractère réservé et confidentiel</strong> des informations personnelles fournies dans le cadre de ses relations et à ne pas les divulguer, dans le strict respect de la réglementation applicable.",
        descrip4:
          "Toutes les personnes qui, en raison de leur activité, ont accès à des informations confidentielles de la société ou de collaborateurs tiers, s'engagent à maintenir la plus grande confidentialité et le secret à leur égard.",
        usomedios: "L'UTILISATION DES SUPPORTS INFORMATIQUES",
        descrip5:
          "RISI met à la disposition de son personnel et de sa direction les moyens nécessaires à l'exercice de leurs activités, ainsi que les mécanismes permettant de les sauvegarder de manière adéquate.",
        descrip6:
          "Le personnel et les cadres de l'entreprise s'engagent à utiliser les supports appartenant à RISI de manière responsable et à des fins professionnelles. Toutefois, ils <strong>peuvent les utiliser à des fins non professionnelles</strong>, avec modération, sachant <strong>qu'il n'existe aucune obligation de confidentialité des ressources informatiques mises à disposition par l'entreprise</strong>, et que toute utilisation peut être enregistrée dans les bases de données appartenant à l'entreprise, sous réserve d'un contrôle par RISI toujours conformément à la loi applicable et aux garanties prévues par le règlement intérieur, en respectant dans tous les cas les droits fondamentaux du personnel.",
        descrip7:
          "De même, aucun programme ou application portant atteinte à des droits de quelque nature que ce soit, susceptible d'endommager ces ressources ou pouvant être utilisé à des fins illicites ne peut être installé ou utilisé.",
        conflictosIntereses: "CONFLITS D'INTÉRÊTS",
        descrip8:
          "Le personnel et la direction de RISI doivent <strong>protéger les intérêts de l'entreprise</strong> et veiller à sa bonne réputation, en évitant d'agir contre ses intérêts.",
        descrip9:
          "Si une personne employée par Risi s'engage dans une activité ou une transaction dans laquelle elle pourrait avoir un intérêt personnel, elle doit en informer le responsable de secteur ou le responsable de la conformité pour connaître la marche à suivre.",
        comunicacion: "COMMUNIC ATION EXTERNE",
        descrip10:
          "Les déclarations publiques sur RISI ou en son nom, tant dans les médias traditionnels que sur les réseaux sociaux, peuvent influencer l'image de l'entreprise et ses relations avec la société. C'est pourquoi nous disposons de procédures et de services de gestion et toute action à cet égard ne peut être effectuée que <strong> par les personnes expressément habilitées à le faire</strong>.",
        derechosLaborales: "Respect des droits du travail",
        descrip11:
          "Risi s'engage à respecter les droits du travail de ses employés et à fournir un environnement de travail sûr et sécurisé pour toutes et tous.",
        descrip12:
          "Cet engagement comprend des conditions de travail sûres pour celles et ceux qui visitent nos installations afin d'atteindre les normes de qualité les plus élevées.",
        descrip13:
          "Tous les employés doivent se conformer aux lois, règlements et politiques en matière de santé et de sécurité au travail et signaler toute situation présentant un risque grave pour la santé et la sécurité des travailleurs.",
        descrip14:
          "De même, chez Risi, nous respectons les droits de négociation collective et la liberté d'association des employés.",
        derechosHumanos: "Respect des droits de l'homme",
        descrip15:
          "Risi respecte les droits de l'homme et interdit tout comportement allant à leur encontre.",
        descrip16:
          "C'est pourquoi nous encourageons tous ceux qui travaillent dans le cadre de leurs activités à adopter un comportement équitable et approprié afin de protéger les droits de l'homme et de ne pas se rendre complices de violations des droits de l'homme.",
        discriminacion: "Non-discrimination",
        descrip17:
          "Risi considère ses employés comme son atout le plus précieux et se préoccupe de la promotion d'une culture diversifiée et inclusive, basée sur un environnement de travail ouvert et stimulant.",
        descrip18:
          "Nous nous engageons à offrir à nos employés un environnement de travail équitable et éthique, une politique de rémunération basée sur les performances et des systèmes d'évaluation et de promotion équitables, objectifs et non discriminatoires."
      },
      risiconsumidores: {
        titulo: "Risi et ses<br>consommateurs",
        descrip1:
          "Nos consommateurs sont la base de notre existence. C'est pourquoi notre priorité est de répondre à leurs attentes concernant les piliers de produits sûrs, frais et de la plus haute qualité.",
        descrip2:
          "RISI travaille dans le cadre de la gestion de la qualité et de la sécurité alimentaire afin d'améliorer constamment les produits et les processus de fabrication, d'éviter les erreurs <strong>et de les corriger, et de continuer à améliorer la sécurité, la qualité et l'innovation de nos produits</strong>.",
        descrip3:
          "À cette fin, <strong>nous nous engageons à faire auditer et certifier</strong> notre système de qualité et de sécurité alimentaire par des organismes externes agréés.",
        descrip4:
          "Risi s'engage à communiquer de manière éthique et responsable, tant en matière de publicité que d'étiquetage. De ce fait, et compte tenu des besoins particuliers de nos plus jeunes consommateurs, nous adhérons volontairement aux codes <strong>PAOS (Réglementation de la publicité sur les aliments et les boissons destinée aux mineurs, prévention de l'obésité et de la santé) et NAOS (Nutrition, activité physique et prévention de l'obésité)</strong> du ministère espagnol, en soumettant notre publicité au contrôle externe et indépendant <strong>d'AUTOCONTRÔLE</strong>.",
        descrip5:
          "De même, nous mettons à la disposition de nos consommateurs <strong>différents canaux de communication</strong> pour le traitement de toute demande ou plainte dans un souci de proximité et d'amélioration continue.",
        descrip6: "Voici nos coordonnées"
      },
      risiproveedores: {
        titulo: "RISI ET SES CLIENTS ET <br>FOURNISSEURS",
        descrip1:
          "Dans le cadre de ses <strong>relations avec ses clients</strong>, RISI s'engage à travailler selon des règles de stratégie de marché partagée, de transparence, d'information et de protection.",
        descrip2:
          "La RISI appliquera des critères d'objectivité, de transparence et d'impartialité lors du choix des <strong>fournisseurs et prestataires</strong>, en évitant les conflits d'intérêts ou le favoritisme au moment de la sélection.",
        descrip3:
          "<strong>L'engagement en faveur de la qualité des produits et des services</strong> régira les relations de RISI avec ses clients et ses fournisseurs.",
        descrip4:
          "RISI considère les clients et les fournisseurs comme des maillons essentiels au développement de son activité. C'est pourquoi nous traiterons toujours les personnes avec respect, nous respecterons rigoureusement les engagements pris en termes de qualité des produits et des services, ainsi que tout autre engagement contractuel, et nous déploierons nos valeurs d'entreprise dans les relations. Nous nous efforcerons de convaincre les clients et les fournisseurs de mettre en œuvre les avantages de ce code."
      },
      risisociedad: {
        titulo: "Risi et<br>societe",
        medioAmbiente: "ENVIRONNEMENT",
        descrip0:
          "Chez RISI, nous sommes pleinement conscients de notre <strong>responsabilité à l'égard de l'environnement</strong> et, par conséquent, l'application de mesures garantissant un respect maximal de celui-ci est une priorité, ce qui nous permet de redoubler d'efforts pour parvenir à la durabilité environnementale dans toutes nos activités. Nous appliquons des mesures de sécurité dans le cadre de nos activités afin d'éviter toute atteinte à l'environnement.",
        descrip1:
          "Dans cette optique, nous nous engageons à soumettre notre système environnemental à l'audit et à la certification d'organismes externes accrédités.",
        mercados: "MARCHÉS",
        descrip2:
          "RISI s'engage à exercer une <strong>concurrence loyale sur les marchés</strong>, conformément à sa valeur d'intégrité, à promouvoir la libre concurrence au profit du consommateur et à éviter tout comportement contraire à la législation applicable en matière de concurrence.",
        infoFinanciera: "INFORMATION FINANCIÈRE ET FISCALE",
        descrip3:
          "RISI garantit la <strong>réalité et la transparence</strong> maximale des informations financières de l'entreprise, conformément aux principes comptables définis dans les normes nationales et internationales.",
        descrip4:
          "En outre, le personnel et la direction de l'entreprise s'engagent à\nrespecter les règles internes de RISI en matière de facturation, de paiement et de remboursement.",
        descrip5:
          "RISI est consciente de la responsabilité qui lui incombe de respecter ses <strong>obligations en matière de fiscalité et de sécurité sociale</strong>. Par conséquent, dans le cadre de ses activités, RISI, son personnel et sa direction se conformeront toujours aux lois applicables.",
        prevencion:
          "PRÉVENTION DE LA CORRUPTION ET AUTRES COMPORTEMENTS ILLÉGAUX",
        descrip6:
          "RISI limite la remise et la réception des cadeaux, en interdisant ceux qui ont pour objet la <strong>corruption</strong> ou qui prétendent influencer la personne qui les reçoit pour qu'elle prenne des décisions qui compromettent son impartialité et son bon jugement.",
        descrip7:
          "À cet égard, il n'est pas permis de remettre des cadeaux, des dons, des avantages personnels ou des compensations financières à des fonctionnaires et employés publics, à des dirigeants de partis politiques, à des fonctionnaires ou à des candidats à de tels postes.",
        descrip8:
          "Nous coopérerons également avec toute la diligence requise avec toutes les autorités compétentes qui nous le demandent dans l'exercice de leurs fonctions.",
        entorno: "ENVIRONNEMENT PROCHE",
        descrip9:
          "Risi s'efforcera d'avoir un impact positif sur les milieux géographiques dans lesquels elle opère, en collaborant de manière désintéressée à certaines initiatives visant à améliorer le voisinage et l'environnement."
      },
      risicumplimiento: {
        titulo: "Conformite<br>et canal de comunication",
        descrip1:
          "Le contenu du présent <strong>Code de Conduite est obligatoire</strong> pour les administrateurs, la direction, le personnel et toutes les personnes qui collaborent avec RISI.",
        descrip2:
          "Les comportements contraires aux principes figurant dans le <strong>Code de conduite</strong>, ainsi que dans les autres règles internes en vigueur dans l'entreprise, <strong>pourront donner lieu à l'ouverture des procédures disciplinaires</strong> correspondantes et, le cas échéant, à l'application du régime de sanctions correspondant, en fonction de la gravité de l'infraction et dans le cadre juridique applicable, conformément au Statut des travailleurs et aux Conventions collectives en vigueur. ",
        descrip3:
          "Tous les administrateurs, la direction, le personnel et les personnes qui collaborent avec RISI <strong>doivent signaler au Responsable de la conformité toute conduite inappropriée</strong> ou irrégulière susceptible d'enfreindre le contenu du présent Code ou les règles internes de l'entreprise, qu'elle soit bénéfique ou préjudiciable à RISI.",
        descrip4:
          "Un canal éthique a été mis en place à cet effet, accessible à l'adresse e-mail suivante:  <a>canaletico@risi.es</a>.",
        descrip5:
          "Les plaintes doivent respecter le principe de bonne foi et décrire les détails des événements qui se sont produits. Il n'y aura pas de représailles de quelque nature que ce soit contre les informateurs, tout en respectant les garanties de la partie adverse.",
        descrip6:
          "RISI s'engage à traiter ces données dans le plus strict respect de la législation en la matière."
      }
    },
    hoycontigo: {
      titulo: "Nous existons depuis plus de 50 ans...",
      subtitulo: "Découvrez notre histoire!",
      descrip1: "Depuis tout ce temps, il y a des choses qui n'ont pas changé",
      descrip2: "NOTRE ADN ",
      descrip3: "EFFORT",
      descrip4: "ENGAGEMENT",
      descrip5: "ENTHOUSIASME",
      descrip6: "POSITIVITÉ",
      descrip7: "AVOIR",
      descrip8: "TOUJOURS ",
      descrip9: "LE SOURIRE",
      descrip10: "L' ATTITUDE POSITIVE",
      descrip11: "NOUS MISONS SUR L'INNOVATION",
      descrip12: "Et encore d'autre NOUVEAUTÉS",
      descrip13: "En plus des snacks,",
      descrip14: "des BISCUITS et des BONBONS ",
      descrip15: "sont également produits",
      descrip16: "QU'ALLONS-NOUS FAIRE AU COURS DES 50 PROCHAINES ANNÉES ?",
      descrip17:
        "Nous continuerons à travailler de la meilleure façon possible, avec optimisme et   un grand sourire, pour poursuivre notre croissance année après année avec vous."
    },
    noticias: {
      mostrando: "Affichage",
      resultados: "résultats",
      noresultados:
        "Nous n'avons pas encore publié de nouvelles.<br>Revenez plus tard",
      quebuscas: "Que cherchez-vous ?",
      producto: "PRODUIT",
      web: "site wEB",
      promocion: "PROMOTION ",
      rsc: "rso",
      novedades: "NOUVEAUTÉS",
      familia: "FAMILLE",
      tepuede: "Te puede",
      interesar: "Interesar...",
      masNoticias: "Más noticias",
      compartir: "Compartir",
      cerrar: "Cerrar"
    },
    nutririsi: {
      titulo: "L'ENGAGEMENT QUALITÉ DE RISI",
      subtitulo: "Sécurité et <br>qualité dans tous les produits Risi.",
      descrip1:
        "<strong>Toute l'équipe de Risi S.A., travaille chaque jour pour que les consommateurs puissent profiter de nos snacks sans devoir renoncer à un mode de vie sain</strong>. C'est pourquoi Risi respecte dans tous ses centres de production la norme <strong>IFS Food</strong>, une norme de sécurité alimentaire reconnue par la Global Food Safety Initiative (GFSI) qui se concentre sur la sécurité et la qualité alimentaire de tous les produits transformés emballés ou en vrac.",
      descrip2:
        "Risi s'engage en faveur de la qualité et de l'environnement en appliquant les lignes directrices définies dans la Politique en matière de qualité, de sécurité alimentaire et d'environnement.",
      descrip3: "<strong>Politique de qualité et d'environnement</strong>",
      descrip4:
        "Les snacks, chips, bonbons et biscuits sans gluten de Risi figurent sur la liste officielle de la Fédération espagnole des associations cœliaques (FACE).",
      descrip5:
        "Nous sommes engagés en faveur de la stratégie NAOS (nutrition, activité physique  et prévention de l'obésité).",
      descrip6:
        "Nous utilisons uniquement de l'huile de tournesol et de l'huile de tournesol à haute teneur oléique.",
      descrip7:
        "Nousrevalorisons les sous-produits de nos processus et les transformons en produits destinés à l'alimentation animale.",
      descrip8:
        "Nous recyclons les emballages et notre résidu d'huile végétale est utilisé pour générer du biodiesel.",
      descrip9:
        "Nous travaillons à réduire le gaspillage alimentaire tout au long de la chaîne de valeur. ",
      descrip10:
        "Chez Risi, 100 % des cartons sont fabriqués à partir de papier recyclé.",
      descrip11:
        "Grâce aux énergies renouvelables utilisées en 2024 dans notre centre de production de Madrid, nous avons évité l'émission de 670 Tn de CO2 dans l'atmosphère.",
      descrip12:
        "28 % de l’énergie consommée par l’usine de Madrid en 2024 provient de l’énergie solaire.",
      descrip13:
        "Nous formons tout notre personnel aux bonnes pratiques environnementales et travaillons à la sensibilisation au gaspillage alimentaire, aux économies d'énergie et à l'eau.",
      descrip14:
        "Dans notre usine de Séville, nous avons réduit la consommation d'eau de 4,6 % par rapport à celle consommée en 2021.",
      descrip15:
        "En 2022, la consommation d'énergie de l'usine de Séville a été de 3,6% inférieure à celle consommée en 2021.",
      descrip16:
        "Risi collabore à la préservation de l'environnement et participe à la conservation et à la restauration de forêts de haute valeur écologique.",
      descrip18:
        "Dans notre usine de Séville, la consommation d'énergie a été réduite en 2024, de 7 % par rapport à 2023."
    },
    distribuidor: {
      localiza: "Localiza tu distribuidor más cercana",
      seleccionaProvincia: "Selecciona una provincia",
      losentimos: "Lo sentimos",
      actualmente: "Actualmente no hay distribuidor en esta provincia.",
      puedesContactar: "Puedes contactar con nosotros",
      aqui: "aquí",
      descargate: "TÉLÉCHARGER",
      nuestro: "NOTRE",
      catalago: "CATALOGUE",
      catalalogoSnacks: "TÉLÉCHARGER LE CATALOGUE DES SNACKS ICI",
      catalalogoGalletas: "TÉLÉCHARGER LE CATALOGUE DES BISCUITS ICI ",
      catalalogoCaramelos: "TÉLÉCHARGER LE CATALOGUE DES BONBONS ICI",
      estamosActualizando:
        "Nous mettons à jour notre catalogue.<br> Il sera bientôt disponible",
      superKiosco: "Super kiosque Risi!",
      vender: "Vous souhaitez vendre nos produits dans votre établissement?",
      escribenos: "Écrivez-nous et nous vous donnerons toutes les informations",
      general: {
        contacts: [
          {
            img: "/static/img/tlf.svg",
            alt: "Icon-location",
            text:
              "<p>Attention au client:</p><p><a href='tel:900909013'>900 90 90 13</a> <strong>/</strong> <a href='mailto:pedidos@risi.es'>pedidos@risi.es</a></p>"
          },
          {
            img: "/static/img/aeroplane.svg",
            alt: "Icon-aeroplane",
            text:
              "<p>Exportations:</p><p><a href='mailto:nballand@risi.es'>nballand@risi.es</a></p>"
          }
        ]
      }
    },
    faqs: {
      busqueda: "Que cherchez-vous ?"
    },
    pressroom: {
      press: "SALLE",
      room: "DE PRESSE",
      titulo: "Écrivez-nous et nous vous donnerons toutes les informations",
      subtitulo:
        "Si vous êtes un professionnel du secteur et que vous avez besoin d'informations, vous pouvez nous contacter via ce formulaire",
      descargate: "TÉLÉCHARGER ",
      nuestros: "NOS",
      materiales: "MATÉRIAUX"
    },
    bannerRisiHoy: {
      titulo: "ENVIE D'EN SAVOIR PLUS ?",
      subtitulo: "NOUS VOUS EN PARLONS  ",
      risiHoy: "AUJOURD'HUI",
      ira: "CHEZ RISI"
    },
    materialesPrensa: {
      materiales: "DOSSIERS",
      prensa: "DE PRESSE",
      descarga: "TÉLÉCHARGEZ NOS MATÉRIAUX",
      descrip1:
        "Si vous êtes un professionnel des médias, nous mettons à votre disposition une sélection de dossiers d'entreprise qui aident, soutiennent et renforcent tous les contenus liés à Risi, ses marques et ses produits."
    },
    politica_cookies: {
      descrip1:
        "<h3>1. DOMAINE D'APPLICATION.</h3><p>Conformément aux dispositions de l'article 22.2 de la Loi 34/2002 du 11 juillet sur les Services de la société de l'information et du commerce électronique (LSSI-CE) en vigueur, RISI doit respecter l'obligation d'information sur les cookies qu'elle utilise et leurs finalités.</p><p>Ce site Web utilise des cookies et/ou des technologies similaires qui stockent et récupèrent des informations lorsque l'Utilisateur navigue. Les cookies permettent, entre autres, à un site Web ou à une plateforme de stocker et de récupérer des informations sur les habitudes de navigation d'un Utilisateur ou de son dispositif et, en fonction des informations qu'il contient et de la manière dont il l’utilise, ils peuvent servir à reconnaître l’Utilisateur.</p><p>L'Utilisateur peut modifier le paramétrage personnalisé <a>ICI</a></p>",
      descrip2:
        "<h3>2. DÉFINITION ET FONCTIONS DES COOKIES.</h3><p>Les informations que nous vous fournissons ci-dessous vous aideront à comprendre les différents types de cookies:</p>",
      descrip3:
        "<table class='table'><tr><th class='odd'></th><th class='odd'></th><th class='odd'>TYPES DE COOKIES</th></tr><tr><th rowspan='2'>SELON L'ENTITÉ QUI LES GÈRE</th><td>COOKIES PROPRES</td><td>Ce sont ceux qui sont envoyés au terminal de l'utilisateur depuis un dispositif ou un domaine géré par l'éditeur lui-même et à partir desquels est fourni le service demandé par l'utilisateur.</td></tr><tr><td>COOKIES DE TIERS</td><td>Ce sont ceux qui sont envoyés au terminal de l'utilisateur depuis un dispositif ou un domaine qui n'est pas géré par l'éditeur, mais par une autre entité qui traite les données obtenues via les cookies.</td></tr><tr><th rowspan='2'>SELON LA PÉRIODE DE TEMPS PENDANT LEQUEL ILS RESTENT ACTIVÉS</th><td>COOKIES DE SESSION</td><td>Ce sont ceux conçus pour collecter et stocker des données pendant que l'utilisateur accède à un site Web. Ils sont généralement utilisés pour stocker des informations qu'il est intéressant de conserver uniquement pour la prestation du service demandé par l'utilisateur en une seule occasion (par exemple, une liste de produits achetés) et qui disparaissent à la fin de la session.</td></tr><tr><td>COOKIES PERSISTANTS</td><td>Ce sont ceux dans lesquels les données sont encore stockées dans le terminal et peuvent être consultées et traitées pendant une durée définie par le responsable du cookie, qui peut aller de quelques minutes à plusieurs années.</td></tr><tr><th rowspan='5'>SELON LEUR OBJECTIF</th><td>COOKIES TECHNIQUES</td><td>Ce sont ceux qui permettent à l'utilisateur de naviguer sur un site Web, une plateforme ou une application et d'utiliser les différentes options ou services qui s’y trouvent.</td></tr><tr><td>COOKIES DE PERSONNALISATION</td><td>Ils permettent d'appliquer ses propres caractéristiques à la navigation de l'utilisateur sur le site Internet (par exemple la langue).</td></tr><tr><td>COOKIES D’ANALYSE</td><td>Ce sont ceux qui permettent à leur responsable de suivre et d'analyser le comportement des utilisateurs des sites Web auxquels ils sont liés, y compris la quantification des impacts des publicités. Les informations collectées via ce type de cookies sont utilisées pour mesurer l'activité des sites Web, des applications ou des plateformes, afin d'introduire des améliorations basées sur l'analyse des données d'utilisation effectuée par les utilisateurs du service.</td></tr><tr><td>COOKIES PUBLICITAIRES</td><td>Ils permettent à l'éditeur d'inclure des espaces publicitaires sur le site Web, en fonction du contenu du site même.</td></tr><tr><td>COOKIES DE PUBLICITÉ COMPORTAMENTALE</td><td>Ce sont ceux qui stockent des informations sur le comportement des utilisateurs obtenues grâce à l'observation continue de leurs habitudes de navigation, ce qui permet de développer un profil spécifique pour afficher des publicités basées sur celui-ci.</td></tr></table>",
      descrip4:
        "<h3>3. INFORMATIONS SUR LE TYPE DE COOKIES UTILISÉS PAR RISI.</h3><p>RISI informe plus en détail sur les cookies utilisés par ses propriétaires, l'utilisation ou la finalité spécifique, les délais de conservation, ainsi que les Transferts internationaux de données (le cas échéant) et chacun d'eux utilisés sur le site Web.</p>",
      descrip5:
        "<table class='table'><tr><th class='odd2'>TYPE</th><th class='odd2'>COOKIE</th><th class='odd2'>OBJECTIF</th><th class='odd2'>CONSERVATION</th></tr><tr><td>Session et persistants</td><td>-cookieyesID cky- consent -cookieyes- necessary -cookieyes- functional -cookieyes- analytics -cookieyes- performance -cookieyes- advertisement</td><td>Ils sont conçus pour collecter et stocker des données pendant que l'utilisateur accède à un site Web. Ils sont généralement utilisés pour stocker des informations qu’il est uniquement intéressant de conserver pour la prestation du service demandé par l'utilisateur en une seule occasion (par exemple, une liste de produits achetés) et ils disparaissent à la fin de la session.</td><td>1 an</td></tr><tr><td>Analytiques Google analytics.</td><td>ga_gid</td><td>Ils permettent à leur responsable de surveiller et d'analyser le comportement des utilisateurs des sites Web auxquels ils sont liés, y compris la quantification des impacts des publicités. Les informations collectées via ce type de cookies sont utilisées pour mesurer l'activité des sites Web, des applications ou des plateformes, afin d'introduire des améliorations basées sur l'analyse des données d'utilisation des utilisateurs du service.</td><td>1 an</td></tr><tr><td>Techniques</td><td>_gat_UA-139143569-1_cfduid http</td><td>Ils permettent à l'utilisateur de naviguer sur un site Web, et d'utiliser les différentes options ou services qui s’y trouvent, y compris ceux que l'éditeur utilise pour permettre la gestion et l'exploitation du site Web et permettre ses fonctions et services, tels que le contrôle du trafic et la communication de données, l'identification de session, l'accès aux parties d'accès restreint.</td><td>1 an</td></tr></table>",
      descrip6:
        "Veuillez noter que si vous acceptez les cookies de tiers, vous devrez les supprimer des options du navigateur ou du système proposé par le tiers lui-même.",
      descrip7:
        "<h3>4. PARAMÉTRAGE DES COOKIES.</h3><p>Vous pouvez paramétrer les cookies qui ne sont pas strictement nécessaires à la navigation via le panneau de configuration ICI. Sachez que si vous refusez l'utilisation de cookies, certains services de RISI pourront être affectés.</p><p>Ci-dessous, nous fournissons des liens vers différents navigateurs, grâce auxquels vous pouvez modifier les paramètres de votre navigateur concernant l'utilisation des cookies :</p>",
      descrip8:
        "Site web :<ul><li><strong>Firefox depuis ce lien: </strong><a href='http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we' target='_blank'>http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></li><li><strong>Chrome depuis ce lien: </strong><a href='http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647' target='_blank'>http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647</a></li><li><strong>Explorer depuis ce lien: </strong><a href='http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-10' target='_blank'>http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-10</a></li><li><strong>Safari depuis ce lien: </strong><a href='https://support.apple.com/kb/ph17191?locale=es_ES' target='_blank'>https://support.apple.com/kb/ph17191?locale=es_ES</a></li><li><strong>Opera depuis ce lien: </strong><a href='https://help.opera.com/en/latest/web-preferences/#cookies' target='_blank'>https://help.opera.com/en/latest/web-preferences/#cookies</a></li></ul>",
      descrip9:
        "Pour en savoir plus sur le traitement des données personnelles, nous vous recommandons de visiter notre rubrique <strong>“Politique de confidentialité”</strong>.",
      descrip10: "<strong>Dernière mise à jour:</strong> novembre 2023"
    },
    aviso_legal: {
      descrip1:
        "Conformément aux dispositions de l'article 10 de la Loi 34/2002 du 11 juillet sur les Services de la société de l'information et du commerce électronique, il est précisé que ces pages correspondent à RISI, S.A., avec NIF (numéro fiscal) A28194090, et qui est sise à Severo Ochoa, 2. Pol. Ind. GITESA. 28814 Daganzo (Madrid).",
      descrip2: "Raison sociale: RISI, S.A",
      descrip3: "NIF: A28194090<br>",
      descrip4:
        "Adresse: Severo Ochoa, 2. Pol. Ind. GITESA. 28814 Daganzo (Madrid).",
      descrip5:
        'Courrier électronique:&nbsp;<strong><a href="mailto:risi@risi.es">risi@risi.es</a></strong>',
      descrip6: "CONDITIONS GÉNÉRALES D'UTILISATION",
      descrip7: "1. OBJET",
      descrip8:
        "Les présentes Conditions Générales d'Utilisation régissent l'utilisation du site Web http://risi.es, que ce soit sous son nom actuel, ou bien sous tout autre nom sous lequel il pourrait apparaître à l’avenir, (« Site Web ») de RISI, S.A., avec NIF A28194090, sise à Severo Ochoa, Pol. Ind. GITESA. 28814 Daganzo (Madrid) et adresse de courrier électronique risi@risi.es (ci-après dénommée « RISI »). Ce site Web s'adresse exclusivement aux personnes physiques résidant en Espagne. Les utilisateurs qui résident ou sont domiciliés dans tout autre pays et qui décident d'accéder et/ou d'utiliser ce site Web le feront sous leur propre responsabilité et à leurs risques et périls et devront s'assurer que cet accès et/ou utilisation est conforme à la législation locale applicable. En accédant et en utilisant ce site Web, vous (« Utilisateur ») reconnaissez avoir lu et accepté les présentes Conditions générales d'utilisation et acceptez de vous conformer à tous ses termes et conditions. De même, l'Utilisateur reconnaît et accepte que l'accès et l'utilisation de ce Site Web seront soumis aux Conditions générales d'utilisation en vigueur au moment où il y accède. RISI se réserve le droit de modifier à tout moment les présentes Conditions générales d'utilisation, ainsi que toutes les autres conditions générales ou particulières qui pourraient être applicables. De même, RISI se réserve le droit de suspendre, d'interrompre ou de cesser l'exploitation du site Web à tout moment.",
      descrip9: "2. CONTENUS",
      descrip10:
        "Via le site Web, RISI permet aux Utilisateurs d'accéder à différents contenus, différentes informations et données fournis par RISI (ci-après dénommés les « Contenus »). RISI se réserve le droit de modifier à tout moment la présentation, la configuration et la localisation du site Web, et/ou les Contenus, ainsi que les conditions d'accès et d'utilisation correspondantes. RISI ne garantit pas que les Contenus fournis via le site Web seront dans tous les cas corrects, complets ou mis à jour. Avec l'inclusion de Contenus tiers sur le site Web, RISI n'en devient pas l'éditeur et ne garantit donc ni n'est responsable de la légalité, de la fiabilité, de l'utilité, de la véracité, de l'exactitude, de l'exhaustivité et de l'actualité desdits Contenus. En aucun cas RISI ne sera responsable des dommages et préjudices pouvant découler de (i) la violation éventuelle des droits de tiers, de la fiabilité, de l'utilité, de la véracité, de l'exactitude, de l'exhaustivité et/ou de l'actualité des Contenus fournis par des tiers ; (ii) l'inadéquation à quelque fin que ce soit et la déception face aux attentes générées par les Contenus ; (iii) les décisions ou actions prises par l'Utilisateur faisant confiance auxdits Contenus. Sans préjudice de ce qui précède, RISI se réserve le droit de supprimer et/ou de bloquer l'accès à tous les Contenus dans le cas où elle a effectivement connaissance que lesdits Contenus sont illégaux ou portent atteinte aux droits de tiers, ou dans le cas où elle est tenue de le faire en vertu d’une résolution judiciaire ou d’une ordonnance administrative.",
      descrip11: "3. ACCÈS ET UTILISATION DU SITE WEB",
      descrip12:
        "L'accès au site Web sera limité aux personnes de plus de 14 ans. Nonobstant ce qui précède, l'accès à certains contenus et/ou la participation aux promotions de RISI peuvent être limités aux adultes ou aux mineurs émancipés, comme indiqué dans chaque cas. De manière générale, les Utilisateurs peuvent accéder au site Web librement et gratuitement. L'Utilisateur reconnaît et accepte que l'accès et l'utilisation du site Web et/ou des Contenus qui y sont inclus s'effectuent librement et consciemment, sous sa responsabilité exclusive. RISI ne sera en aucun cas responsable de l'utilisation faite par les Utilisateurs et/ou des tiers du site Web ou des Contenus, ni des dommages et préjudices qui pourraient en découler. L'Utilisateur s'engage à faire un usage approprié et licite du site Web et des Contenus, conformément à la législation applicable, aux présentes Conditions générales d'utilisation, la morale généralement admise, aux bonnes mœurs et à l'ordre public. L'Utilisateur devra s'abstenir (i) de faire une utilisation non autorisée ou frauduleuse du site Web et/ou du Contenu ; (ii) d’accéder ou tenter d'accéder aux ressources restreintes du site Web ; (iii) d’utiliser le site Web et/ou les Contenus à des fins ou effets illicites ou illégaux, contraires aux dispositions des présentes Conditions générales d'utilisation, de bonne foi et à l'ordre public, préjudiciables aux droits et intérêts de tiers, ou qui de quelque manière que ce soit, pourrait endommager, désactiver ou surcharger le site Web ou empêcher l'utilisation ou la jouissance normale du site Web ; (iv) de causer des dommages au site Web ou aux systèmes de ses fournisseurs ou de tiers ; (v) d’introduire ou de propager des virus informatiques ou tout autre système physique ou logique susceptible de causer des dommages aux systèmes de RISI, de ses fournisseurs ou de tiers, (vi) tenter d'accéder, d'utiliser et/ou de manipuler les données de RISI, de tiers les fournisseurs et autres utilisateurs ; (vii) de reproduire ou copier, distribuer, permettre l'accès du public à travers toute forme de communication publique, transformer ou modifier les Contenus, sauf autorisation du propriétaire des droits correspondants ou si cela est légalement autorisé ; (viii) de supprimer, cacher ou manipuler les notes de droits d'auteur et autres données identifiant les droits de RISI ou de tiers incorporés dans les Contenus ;",
      descrip13:
        " (ix) d’obtenir ou tenter d'obtenir les Contenus par des moyens ou procédures autres que ceux qui, le cas échéant, ont été mis à sa disposition à cet effet ou ont été expressément indiqués sur les pages Web où se trouvent les Contenus ou, en général, ceux qui sont couramment utilisés sur Internet, car ils n'entraînent pas de risque d'endommagement ou de désactivation du Site et/ou des Contenus.",
      descrip14:
        "4. CONDITIONS SUPPLÉMENTAIRES D'ACCÈS ET\nD'UTILISATION DES ZONES D'ACCÈS RESTREINTS",
      descrip15:
        "Dans le cas où une zone du Site Web aurait un accès restreint et/ou limité, et sans préjudice des conditions spécifiques qui régissent son utilisation, l'accès à ladite zone sera soumis dans tous les cas à l'inscription préalable de l'Utilisateur en complétant le formulaire correspondant (« Formulaire d'inscription »), qui sera préalablement fourni à l'Utilisateur. RISI se réserve le droit d'accepter ou de refuser librement la demande d'inscription de l'Utilisateur. Les données saisies par l'Utilisateur dans le Formulaire d'inscription doivent être à tout moment exactes, actuelles et véridiques. Dans ce cas, l'accès et l'utilisation de la zone spécifique du Site pourront être soumis à un mot de passe attribué à l'Utilisateur par RISI lors du remplissage du Formulaire d'inscription et l'accès sera réputé avoir été effectué par ledit Utilisateur, qui répondra dans tous les cas de cet accès et de cette utilisation. L'Utilisateur sera responsable à tout moment de la conservation de son mot de passe, assumant par conséquent tous les dommages et préjudices pouvant découler de son utilisation inappropriée, ainsi que de son transfert, de sa divulgation ou de sa perte. En cas d'oubli du mot de passe ou de toute autre circonstance présentant un risque d'accès et/ou d'utilisation par des tiers non autorisés, l'Utilisateur en informera immédiatement RISI afin qu'elle puisse immédiatement le bloquer et le remplacer. Dans tous les cas, toutes les opérations effectuées avant ladite communication seront considérées comme effectuées par l'Utilisateur, qui sera responsable et paiera les dépenses et/ou dommages résultant de tout accès et/ou utilisation non autorisés effectués avant ladite communication.",
      descrip16: "5. DROITS DE PROPRIÉTÉ INTELLECTUELLE ET INDUSTRIELLE",
      descrip17:
        "L'Utilisateur reconnaît et accepte que tous les droits de propriété intellectuelle et industrielle sur les Contenus et/ou tout autre élément inséré dans le site Internet (notamment, sans limitation, les marques, logos, noms commerciaux, textes, images, graphismes, designs, sons, bases de données, logiciels, organigrammes, présentation, audio et vidéo), appartiennent à RISI et/ou à des tiers. L'utilisation de ces éléments, leur reproduction, communication et/ou distribution à des fins commerciales ou lucratives, ainsi que leur modification, altération ou décompilation, sont strictement interdites. Toute autre utilisation ou exploitation de tout Contenu et/ou autres éléments inclus dans le site Web autre que ceux expressément prévus seront soumis à l'autorisation préalable de RISI ou du tiers titulaire des droits concernés.",
      descrip18: "6. LIENS",
      descrip19:
        "Le Site Web peut inclure des liens et des outils de recherche permettant aux Utilisateurs d'accéder à des sites Web tiers. Ces liens et outils de recherche sont fournis uniquement à titre de référence. Dans tous les cas, il est recommandé aux Utilisateurs de consulter les termes et conditions d’utilisation et les politiques de confidentialité des sites Web de tiers auxquels ils accèdent via les liens inclus sur le Site. Bien que RISI examine préalablement le contenu des sites Web vers lesquels elle établit un lien et fournisse uniquement des liens vers les sites Web qui, à sa connaissance, sont conformes à la législation applicable, RISI n'approuve ni ne contrôle le contenu de ces sites Web et/ou toute modification de celui-ci exclut expressément toute responsabilité pour tout dommage pouvant résulter de l'accès, de l'utilisation ou de l'impossibilité d'utilisation, par les Utilisateurs, de tout site Internet vers lequel un lien a été établi ou de son contenu. Sans préjudice de ce qui précède, RISI se réserve le droit de supprimer les liens vers tout site Web dans le cas où elle a effectivement connaissance que les activités menées sur ledit site Web ou son contenu sont illégales ou portent atteinte aux droits de tiers, ou dans le cas où elle est tenue de le faire en vertu d’une décision judiciaire ou d’une ordonnance administrative.",
      descrip20: "7. EXCLUSION DE GARANTIES ET RESPONSABILITÉ",
      descrip21:
        "RISI ne garantit pas la disponibilité et la continuité de fonctionnement du site Web. Par conséquent, RISI ne sera en aucun cas responsable des dommages et préjudices pouvant découler (i) du manque de disponibilité ou d'accessibilité du site Web ; (ii) de l’interruption du fonctionnement du site Web ou des pannes informatiques, pannes téléphoniques, déconnexions, retards ou blocages causés par des déficiences ou des surcharges des lignes téléphoniques, des centres de données, du système Internet ou d'autres systèmes électroniques, produits au cours de son fonctionnement ; et (iii) d'autres dommages qui pourraient être causés par des tiers à travers des intromissions non autorisées échappant au contrôle de RISI. RISI ne garantit pas l'absence de virus ou d'autres éléments sur le Site introduits par des tiers autres que RISI qui pourraient provoquer des altérations dans les systèmes physiques ou logiques des Utilisateurs ou dans les documents électroniques et fichiers stockés dans leurs systèmes. Par conséquent, RISI ne sera en aucun cas responsable des dommages et préjudices de toute nature pouvant résulter de la présence de virus ou d'autres éléments susceptibles de provoquer des altérations dans les systèmes physiques ou logiques, les documents électroniques ou les fichiers des Utilisateurs. RISI ne garantit pas que des tiers non autorisés ne puissent connaître les pages du site Web que l'Utilisateur visite, ni les conditions, caractéristiques et circonstances dans lesquelles l'Utilisateur visite le site Web. Par conséquent, RISI ne sera en aucun cas responsable des dommages pouvant découler cde cet accès non autorisé.",
      descrip22: "8. LOI APPLICABLE ET JURIDICTION",
      descrip23:
        "Ces Conditions d'utilisation, ainsi que la relation entre RISI et l'Utilisateur, seront régies et interprétées conformément à la loi espagnole. Les parties conviennent de se soumettre à la compétence exclusive des cours et tribunaux du lieu de résidence de l'Utilisateur pour la résolution de toute controverse relative aux présentes Conditions d'utilisation ou aux relations entre elles."
    },
    politica_privacidad: {
      descrip1:
        "<h3>1. QUI SOMMES-NOUS ?</h3><p>RISI est une entreprise familiale espagnole avec près de cinquante ans d'histoire, spécialisée dans la fabrication et la commercialisation de snacks et d'apéritifs.</p><p>L'objectif et le but de l'existence de RISI est de répondre aux besoins et de satisfaire les attentes des consommateurs, en s'appuyant sur des marques de la plus haute qualité et des processus en constante amélioration.</p>",
      descrip2:
        "<h3>2. QUI EST RESPONSABLE DU TRAITEMENT DE VOS DONNÉES PERSONNELLES ?</h3><p>Les données personnelles que vous fournissez seront traitées par RISI SA (RISI), avec NIF A28194090 et sise Severo Ochoa, 2. Pol. Ind. GITESA. 28814 Daganzo (Madrid)., et courrier électronique:<a href='mailto:risi@risi.es' target='_blank'>risi@risi.es</a></p><p>Les coordonnées de notre Délégué à la protection des données sont les suivantes:<a href='mailto:dpd.cliente@conversia.es' target='_blank'>dpd.cliente@conversia.es</a>et le numéro de téléphone:<a href='tel:902877192' target='_blank'>902 877 192</a></p>",
      descrip3:
        "<h3>3. DOMAINE D’APPLICATION.</h3><p>La présente Politique de Confidentialité a pour objectif de réglementer le traitement des données effectué sur les données des Utilisateurs du site Web de RISI. Par conséquent, elle sera applicable à tout Utilisateur qui navigue et utilise le site Web de RISI, demande des informations via quelconque canal habilité à cet effet (courrier électronique, formulaire, numéro de téléphone, etc.), qui s’enregistre et s’inscrit à des promotions et/ou tirages au sort ou interagit avec nous.</p><p>Elle s'applique également aux clients, fournisseurs et autres personnalités liées dans leurs relations avec RISI.</p><p>L'Intéressé déclare avoir préalablement lu et compris la présente Politique de confidentialité, l'accepter volontairement, sans aucune réserve, et exonérer RISI de toute utilisation abusive qui pourrait être faite des informations envoyées à travers elle.</p>",
      descrip4:
        "<h3>4. D’OÙ OBTENONS-NOUS VOS DONNÉES PERSONNELLES ?</h3><p>Nous collectons vos données via différents canaux:</p><h4>4.1. Information fournie par vous.</h4><p>Nous traitons les informations personnelles que vous nous fournissez via les canaux créés à cet effet, tels que le formulaire de contact fourni sur le site Web et/ou dans nos bureaux, par courrier électronique, par téléphone, WhatsApp, ou si vous interagissez avec nous via les réseaux sociaux ou partagez notre contenu. De même, nous collectons des informations lorsque vous participez à des tirages au sort ou à des promotions, à des campagnes marketing, à des abonnements à des newsletters ou à des enquêtes de satisfaction.</p><p>Nous traitons également vos données lorsque vous souhaitez faire partie de l’équipe de RISI en nous envoyant votre candidature par courrier électronique:<a href='mailto:empleo@risi.es' target='_blank'>empleo@risi.es</a></p><h4>4.2. Information collectée par RISI</h4><p>Nos fournisseurs de services de tiers et nous, en tant que partenaires d'analyse, de réseaux sociaux et de publicité, pouvons utiliser des technologies qui collectent automatiquement (ou passivement) certaines informations lorsqu'un Utilisateur interagit en ligne sur le site Web. Nous utilisons également des cookies, mais pour cela, veuillez consulter notre<strong><a href='https://risi.es/es/politica-de-cookies' target='_blank'>“Politique de Cookies”</a></strong>.</p>",
      descrip5:
        "<h3>5. QUEL TYPE D'INFORMATIONS TRAITONS-NOUS ?</h3><p>RISI, pourrait traiter le type d’information suivante:</p><br><ul><li>Les identifiants et coordonnées comme le nom, le nom d’utilisateur, l’adresse de courrier électronique, l’adresse postale, le code postal, le numéro de téléphone, le sexe, l’âge, la date de naissance.</li><li>Une preuve d'achat, comme un ticket de supermarché ou un reçu, pour une promotion ou un tirage au sort.</li><li>Tout contenu produit et partagé par l'utilisateur sur nos sites Web, applications ou pages de réseaux sociaux.</li><li>Les informations sur votre utilisation et votre navigation sur nos sites Web et applications ; par exemple, le site Web d'où vous venez, les pages Web que vous visitez le plus, le nombre de fois que vous regardez une vidéo ou interagissez avec une image.</li><li>Les informations sur votre participation antérieure à des promotions telles que des tirages au sort ou des concours ; par exemple, le type de promotion, la marque associée.</li><li>Vos coordonnées et informations personnelles et professionnelles lorsque vous nous adressez votre candidature à un poste vacant.</li></ul><p>RISI ne traitera les données personnelles sensibles ou confidentielles que lorsque cela est strictement nécessaire et uniquement avec votre consentement préalable.</p>",
      descrip6:
        "<h3>6. DANS QUEL BUT ET AVEC QUELLE BASE JURIDIQUE TRAITONS-NOUS VOS DONNÉES PERSONNELLES ?</h3><p>RISI, s'engage à traiter vos données personnelles conformément aux dispositions de la réglementation applicable et notamment dans les buts suivants :</p><ul><li><strong>Visiteurs sur place.</strong>Nous collecterons vos données personnelles lorsque vous visiterez l’une de nos usines ou installations « sur place », afin de contrôler les laissez-passer ou les visites.</li><li><strong>Gérer les consultations, plaintes, incidents et/ou suggestions, consultations.</strong>Nous traiterons vos données dans le but de gérer administrativement les consultations, plaintes, incidents et/ou suggestions envoyés via le canal correspondant (courrier électronique, téléphone, chat, WhatsApp, etc.).</li><li><strong>Participation à des tirages au sort et/ou promotions.</strong>Nous vous informons que nous pouvons traiter vos données pour développer des initiatives, des concours, des promotions et d'autres activités similaires et permettre votre participation à ceux-ci.</li><li><strong>Présentation d’offres et/ou promotions. Communications commerciales.</strong>Vos données personnelles seront traitées dans le but de vous envoyer, par des moyens imprimés, électroniques et téléphoniques, de la publicité liée aux produits RISI. Par conséquent, nous déterminerons les offres et les nouveautés qui pourraient le plus vous intéresser.</li><li><strong>Données collectées via le Web.</strong>Le but de la collecte de ce type de données est de vous offrir une meilleure expérience lors de l’utilisation du site Web.</li><li><strong>Gestion de candidats.</strong>Nous collectons les informations personnelles et professionnelles que vous nous fournissez au courrier électronique<a href='mailto:empleo@risi.es' target='_blank'>empleo@risi.es</a>afin de traiter les éventuels candidats.</li></ul><p>La base juridique pour le traitement de vos données aux fins susmentionnées est le consentement que vous nous avez donné selon les finalités spécifiques et en vertu des dispositions de l'art. 6.1 a) du RGPD. Vos données personnelles seront conservées à cette fin jusqu'à ce que vous révoquiez votre consentement.</p><ul><li><strong>Gestion des données des clients.</strong>Les données personnelles seront traitées dans le but de vous fournir le service et/ou le produit contracté ou proposé, certaines informations personnelles étant considérées comme nécessaires à cet effet.</li><li><strong>Gestion des fournisseurs de services.</strong>RISI traitera les données personnelles de ses fournisseurs dans le seul but de l'exécution du contrat.</li></ul><p>La base juridique aux fins mentionnées ci-dessus est pour l'exécution d'un contrat dont l'intéressé fait partie en vertu des dispositions de l'art. 6.1 b) du Règlement général sur la protection des données (ci-après dénommé « RGPD »).</p><ul><li><strong>Gestion des données pour respecter les obligations légales et réglementaires.</strong>Tous les responsables du traitement des données sont soumis aux lois des pays dans lesquels ils développent leur activité et sont tenus de s'y conformer. Ces obligations incluent entre autres la transmission, dans certaines circonstances, de données personnelles aux organes judiciaires, aux organes de régulation ou de contrôle et aux organes et forces de sécurité de l'État.</li></ul><p>La base juridique du traitement de vos données aux fins susmentionnées est le respect des obligations légales applicables au responsable du traitement, en vertu des dispositions de l'art. 6.1 c) du RGPD.</p><ul><li><strong>Enquêtes de satisfaction.</strong>Nous vous informons que nous pouvons traiter vos données pour réaliser des enquêtes dans le but de connaître vos intérêts et d'obtenir des informations via les Réseaux sociaux sur la perception de notre marque ou de nos produits.</li><li><strong>Gestion de contrôle de la qualité.</strong>Nous vous informons que nous enregistrons les interactions avec les consommateurs, telles que les courriers électroniques, les appels téléphoniques à la ligne d'assistance RISI, pour le contrôle qualité.</li></ul><p>La base juridique pour le traitement de vos données aux fins susmentionnées est l'intérêt légitime applicable au responsable du traitement, en vertu des dispositions de l'art. 6.1 d) du RGPD.</p>",
      descrip7:
        "<h3>7. COMBIEN DE TEMPS CONSERVERONS-NOUS VOS DONNÉES ?</h3><p>Vos données personnelles seront conservées pendant la durée nécessaire à la réalisation des fins susmentionnées. Dans tous les cas, nous limitons l'accès à vos données aux seules personnes qui en ont besoin pour exercer leurs fonctions.</p><p>La durée de conservation des informations traitées est basée sur les besoins de l'entreprise, de sorte que lorsqu'elles ne seront pas nécessaires, elles seront dûment bloquées dans le seul but de faire face aux responsabilités de toute nature qui pourraient survenir.</p><ul><li><strong>Finalités liées au consentement donné.</strong>Les données seront conservées jusqu'à la révocation du consentement par l'intéressé et, au maximum, pendant une période de quatre ans à compter de l'obtention du consentement express.</li><li><strong>Finalités liées à l’exécution d’un contrat.</strong>Au cours de la durée de conservation pour la gestion de toute obligation contractuelle que nous avons envers vous, nous conserverons ces données pendant la durée de validité du contrat et pendant les dix années suivantes, afin de pouvoir répondre à d'éventuelles questions ou réclamations par la suite.</li><li><strong>Finalités liées au respect des obligations légales.</strong>Certaines informations doivent être conservées pendant les durées requises par la réglementation spécifique applicable (fiscale, commerciale, anti-blanchiment d’argent, etc.).</li><li><strong>Finalités liées à l’intérêt légitime de RISI.</strong>Certaines informations devront être conservées pendant les durées nécessaires dans le respect des intérêts de RISI.</li></ul>",
      descrip8:
        "<h3>8. À QUELS DESTINATAIRES VOS DONNÉES PERSONNELLES SERONT-ELLES COMMUNIQUÉES ?</h3><p>Vos données ne seront pas communiquées à des tiers, sauf autorisation expresse ou, dans les cas légalement admissibles, des informations seront fournies aux autorités publiques telles que : les autorités fiscales, pour le respect des obligations fiscales ; aux administrations compétentes, aux forces et corps de sécurité de l'État, aux juges et aux tribunaux et à l'Agence espagnole de protection des données, dans le respect des obligations légales des responsables du traitement ou en cas de conflits liés aux droits des consommateurs, au droit à la protection des données, au droit à la propriété intellectuelle et industrielle, ou avec tout autre bien et/ou droit protégé. Ainsi qu'aux organismes financiers pour la gestion des encaissements et des paiements.</p><p>De même, certaines entités sous-traitées par RISI pourraient accéder aux données et informations personnelles en tant que chargés ou sous-traitants du traitement pour nous fournir le service nécessaire. Ces prestataires de services signent un contrat qui les oblige à utiliser vos informations personnelles uniquement pour la prestation des services signalés dans cette politique. Cela inclut les tiers qui nous permettent de répondre à vos demandes, le call center, fournir des services aux consommateurs, de participer à nos promotions, d'héberger nos sites Web, de fournir des communications marketing et d'analyser les informations.</p>",
      descrip9:
        "<h3>9. MESURES DE SÉCURITÉ DE L’INFORMATION.</h3><p>RISI garantit la bonne utilisation des informations, et notamment la totale confidentialité des données personnelles contenues dans notre système, ainsi que le plein respect des obligations en matière de protection des données personnelles.</p><p>RISI a pris les mesures de sécurité techniques et organisationnelles nécessaires pour garantir la sécurité de vos données personnelles et empêcher leurs altération, perte et traitement et/ou accès non autorisés, en tenant compte de l'état de la technologie, de la nature des données stockées et des risques auxquels ils sont exposés, qu'ils proviennent de l'action humaine ou du milieu physique ou naturel.</p><p>De même, nous vous informons que RISI adhère au Code de conduite en matière de protection des données en matière d’Activité publicitaire d'AUTOCONTRÔLE, accréditée par l'Agence espagnole de protection des données et elle est donc liée à son système de traitement extrajudiciaire des réclamations lorsqu'elles sont liées à la protection des données et à la publicité, à la disposition des parties intéressées sur le site Web<a href='https://www.autocontrol.es/servicios/reclamaciones-de-proteccion-datos-y-publicidad/usuarios/' target='_blank'>https://www.autocontrol.es/servicios/reclamaciones-de-proteccion-datos-y-publicidad/usuarios/</a>.</p><p>Le code de conduite est accessible à partir du lien suivant, où il peut être téléchargé gratuitement:<a href='https://www.autocontrol.es/wp-content/uploads/2023/10/codigo-de-conducta-proteccion-de-datosautocontrol.pdf' target='_blank'>https://www.autocontrol.es/wp-content/uploads/2023/10/codigo-de-conducta-proteccion-de-datosautocontrol.pdf</a>.</p>",
      descrip10:
        "<h3>10. QUELS SONT VOS DROITS LORSQUE VOUS NOUS FOURNISSEZ DES INFORMATIONS PERSONNELLES ?</h3><p>Nous vous informons qu'à tout moment, vous pouvez exercer vos droits d'accès, de rectification, d'opposition, de suppression, de portabilité, ne pas faire l'objet de décisions automatisées et de limitation de traitement auprès de RISI.</p><h4>10.1 En quoi consistent vos droits en tant que personne concernée ?</h4><ul><li>Droit d’accès : vous avez le droit d'obtenir la confirmation que RISI traite vos données personnelles, ainsi que d'y accéder.</li><li>Droit de rectification : vous pouvez demander la modification ou la rectification des données personnelles inexactes.</li><li>Droit de suppression : vous pouvez demander la suppression de vos données personnelles.</li>Droit de limitation du traitement : dans certaines circonstances, vous pouvez demander la limitation du traitement de vos données, auquel cas celles-ci ne seront conservées que pour l'exercice ou la défense de réclamations.<li>Droit d’opposition : vous pouvez vous opposer au traitement de vos données pour la finalité que vous avez indiquée.</li><li>Droit de ne pas faire l'objet de décisions individuelles automatisées : vous avez le droit de ne pas faire l'objet d'une décision basée uniquement sur un traitement automatisé, y compris le profilage, susceptible de produire des effets juridiques ou de vous affecter significativement de façon similaire.</li><li>Droit de portabilité : si le site Web le permet, vous pouvez exercer le droit à la portabilité de vos données, dans un format structuré, d’usage commun et lecture mécanique, et les transmettre à un autre responsable du traitement.</li></ul><h4>10.2 Comment exercer mes droits ?</h4><p>En fonction du type d'informations que nous traitons à votre sujet, vous pouvez vous adresser à RISI ou les fournisseurs avec lesquels nous travaillons pour traiter vos données dans le cadre de campagnes publicitaires, du call center, du service client ou similaire ; à cet effet, nous vous suggérons de faire attention à la clause d'information sur la protection des données de la campagne en question.</p><p>L'exercice de vos droits sera totalement gratuit.</p><p>L'opposition à une certaine finalité ou la révocation des consentements accordés n'affectera pas l'utilisation qui peut être faite du site Web, ni la légalité du traitement avant l'opposition ou la révocation du consentement.</p><p>Les consentements accordés pourront être révoqués en envoyant un email à :<a href='mailto:risi@risi.es' target='_blank'>risi@risi.es</a>et/ou dans le lien mis à votre disposition pour vous désinscrire, dans ce type d'envoi situé dans chacune des communications reçues.</p><p><strong>Dans tous les cas, vous devrez faire la demande en indiquant l'exercice du droit et le canal par lequel vous souhaitez recevoir la réponse. De même, la personne exerçant le droit devra être indiquée, en joignant une copie de la pièce d'identité. Dans le cas contraire, votre demande ne pourra pas être satisfaite avec les garanties minimales.</strong></p><p>Enfin, si vous estimez que vous n'avez pas obtenu satisfaction dans l'exercice de vos droits ou que vous n'êtes pas satisfait du traitement effectué quant à vos données personnelles, vous pouvez déposer une réclamation auprès de l'Agence espagnole de protection des données via son site Web<a href='mailto:www.aepd.es' target='_blank'>www.aepd.es</a>.</p>",
      descrip11:
        "<h3>11. MODIFICATIONS.</h3><p>Nous nous réservons le droit de modifier cette Politique pour l'adapter aux nouveautés législatives ou jurisprudentielles. Dans le cas où des changements surviendraient dans celle-ci, RISI vous en informera en temps opportun.</p><p><strong>DERNIÈRE MISE À JOUR : septembre 2023.</strong></p>"
    },
    bases_legales_risi: {
      risketos: "BBLL RISKETOS NOUVEL EMBALLAGE ET X-HOT",
      mios: "BBLL REMISE EN ARGENT RISI MIOS HORNEADOS",
      pipas: "BBLL PROMOTION GRAINES DE TOURNESOL",
      menosAire: "BBLL PROMOTION #MENOSAIREMÁSDISFRUTE",
      patatas: "BBLL TIRAGE AU SORT CHIPS IG",
      trikers: "BBLL PROMOTION TRIKERS",
      fabs: "BBLL PROMOTION FABS"
    },
    daganzo: {
      text1:
        "Dans notre usine de Daganzo de Arriba (Madrid), nous fabriquons des snacks et des apéritifs Risi.",
      text2: "Certificats",
      text3: "Politique environnementale"
    },
    promocionEspiral: "Profitez de nos promotions",
    promocionCta: "Voir les bases légales",
    promocionesList: [
      {
        img: "/static/img/banner-home/mios-es.jpg",
        url: "/static/pdf/bbll-promocion-mios.pdf"
      }
    ],
    newsletter: {
      popup: {
        title:
          "Inscrivez-vous à notre lettre d'information et recevez des informations exclusives",
        cta: "S'INSCRIRE"
      },
      banner: {
        title1: "Inscrivez-vous à notre",
        title1_1: "lettre d'information ",
        title1_2:
          "et recevez-la directement dans votre boîte aux lettres électronique.",
        title2: "CONTENU EXCLUSIF",
        title3: "TIRAGES SPÉCIAUX",
        title4: "ET PLUS",
        tipoContactoLabel: "Type de contact",
        tipoContactoOptions: ["CONSOMMATEUR", "DISTRIBUTEUR", "VENDEUR"],
        obligatorioFechaNacimiento:
          "Le champ de la date de naissance est obligatoire",
        msg_succes:
          "MERCI BEAUCOUP! <br> Votre abonnement a été finalisé avec succès.",
        msg_error: "Il n'a pas été possible d'officialiser la souscription."
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/translations/index.js